import { katTranslator } from '../../shared/i18n';

export const strings = {
  'dg-cancel': {
    'en-US': 'Cancel',
    'ar-AE': 'إلغاء',
    'bn-IN': 'বাতিল করুন',
    'de-DE': 'Abbrechen',
    'es-ES': 'Cancelar',
    'es-MX': 'Cancelar',
    'fr-BE': 'Annuler',
    'fr-CA': 'Annuler',
    'fr-FR': 'Annuler',
    'gu-IN': 'રદ કરો',
    'hi-IN': 'कैंसल करें',
    'it-IT': 'Annulla',
    'ja-JP': 'キャンセル',
    'kn-IN': 'ರದ್ದು ಮಾಡಿ',
    'ko-KR': '취소',
    'ml-IN': 'റദ്ദാക്കുക',
    'mr-IN': 'रद्द करा',
    'nl-BE': 'Annuleren',
    'nl-NL': 'Annuleren',
    'pl-PL': 'Anuluj',
    'pt-BR': 'Cancelar',
    'pt-PT': 'Cancelar',
    'sv-SE': 'Avbryt',
    'ta-IN': 'கேன்சல் செய்',
    'te-IN': 'రద్దు చేయండి',
    'th-TH': 'ยกเลิก',
    'tr-TR': 'İptal et',
    'vi-VN': 'Hủy',
    'zh-CN': '取消',
    'zh-TW': '取消',
  },
  'dg-save': {
    'en-US': 'Save',
    'ar-AE': 'حفظ',
    'bn-IN': 'সেভ করুন',
    'de-DE': 'Speichern',
    'es-ES': 'Guardar',
    'es-MX': 'Guardar',
    'fr-BE': 'Enregistrer',
    'fr-CA': 'Enregistrer',
    'fr-FR': 'Enregistrer',
    'gu-IN': 'સેવ કરો',
    'hi-IN': 'सेव करें',
    'it-IT': 'Salva',
    'ja-JP': '保存',
    'kn-IN': 'ಉಳಿಸಿ',
    'ko-KR': '저장',
    'ml-IN': 'സേവ് ചെയ്യുക',
    'mr-IN': 'सेव्‍ह करा',
    'nl-BE': 'Opslaan',
    'nl-NL': 'Opslaan',
    'pl-PL': 'Zapisz',
    'pt-BR': 'Salvar',
    'pt-PT': 'Guardar',
    'sv-SE': 'Spara',
    'ta-IN': 'சேமி',
    'te-IN': 'సేవ్ చేయి',
    'th-TH': 'บันทึก',
    'tr-TR': 'Kaydet',
    'vi-VN': 'Lưu',
    'zh-CN': '保存',
    'zh-TW': '儲存',
  },
  'dg-selected': {
    'en-US': 'selected',
    'ar-AE': 'تم التحديد',
    'bn-IN': 'নির্বাচিত',
    'de-DE': 'ausgewählt',
    'es-ES': 'seleccionado(s)',
    'es-MX': 'seleccionados',
    'fr-BE': 'sélectionné',
    'fr-CA': 'sélectionné',
    'fr-FR': 'sélectionné',
    'gu-IN': 'પસંદ કરેલ',
    'hi-IN': 'चुना गया',
    'it-IT': 'selezionato',
    'ja-JP': '選択済み',
    'kn-IN': 'ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ',
    'ko-KR': '선택됨',
    'ml-IN': 'തിരഞ്ഞെടുത്തത്',
    'mr-IN': 'निवडलेले',
    'nl-BE': 'geselecteerd',
    'nl-NL': 'geselecteerd',
    'pl-PL': 'wybrano',
    'pt-BR': 'selecionado',
    'pt-PT': 'selecionado',
    'sv-SE': 'valt',
    'ta-IN': 'தேர்ந்தெடுக்கப்பட்டது',
    'te-IN': 'ఎంచుకున్నారు',
    'th-TH': 'เลือกแล้ว',
    'tr-TR': 'seçildi',
    'vi-VN': 'đã chọn',
    'zh-CN': '已选择',
    'zh-TW': '已選取',
  },
  'dg-close': {
    'en-US': 'close',
    'ar-AE': 'إغلاق',
    'bn-IN': 'বন্ধ করুন',
    'de-DE': 'Schließen',
    'en-GB': 'Close',
    'es-ES': 'cerrar',
    'es-MX': 'cerrar',
    'fr-BE': 'fermer',
    'fr-CA': 'fermer',
    'fr-FR': 'fermer',
    'gu-IN': 'બંધ કરો',
    'hi-IN': 'बंद करें',
    'it-IT': 'chiudi',
    'ja-JP': '閉じる',
    'kn-IN': 'ಮುಚ್ಚಿ',
    'ko-KR': '닫기',
    'ml-IN': 'അടയ്ക്കുക',
    'mr-IN': 'बंद करा',
    'nl-BE': 'sluiten',
    'nl-NL': 'sluiten',
    'pl-PL': 'zamknij',
    'pt-BR': 'fechar',
    'pt-PT': 'fechar',
    'sv-SE': 'stäng',
    'ta-IN': 'மூடு',
    'te-IN': 'మూసివేయి',
    'th-TH': 'ปิด',
    'tr-TR': 'kapat',
    'vi-VN': 'đóng',
    'zh-CN': '关闭',
    'zh-TW': '關閉',
  },
  'dg-results': {
    'en-US': 'results',
    'ar-AE': 'النتائج',
    'bn-IN': 'ফলাফলসমূহ',
    'de-DE': 'Ergebnisse',
    'en-CA': 'Results',
    'es-ES': 'resultados',
    'es-MX': 'resultados',
    'fr-BE': 'résultats',
    'fr-CA': 'résultats',
    'fr-FR': 'résultats',
    'gu-IN': 'પરિણામો',
    'hi-IN': 'नतीजे',
    'it-IT': 'risultati',
    'ja-JP': '結果',
    'kn-IN': 'ಫಲಿತಾಂಶಗಳು',
    'ko-KR': '개 결과',
    'ml-IN': 'ഫലങ്ങൾ',
    'mr-IN': 'परिणाम',
    'nl-BE': 'resultaten',
    'nl-NL': 'resultaten',
    'pl-PL': 'wyniki',
    'pt-BR': 'resultados',
    'pt-PT': 'resultados',
    'sv-SE': 'resultat',
    'ta-IN': 'முடிவுகள்',
    'te-IN': 'ఫలితాలు',
    'th-TH': 'ผลลัพธ์',
    'tr-TR': 'sonuç',
    'vi-VN': 'kết quả',
    'zh-CN': '个结果',
    'zh-TW': '結果',
  },
  'dg-hidden': {
    'en-US': 'hidden',
    'ar-AE': 'مخفية',
    'bn-IN': 'লুকানো',
    'de-DE': 'ausgeblendet',
    'es-ES': 'oculto',
    'es-MX': 'oculto',
    'fr-BE': 'masqué',
    'fr-CA': 'caché',
    'fr-FR': 'masqué',
    'gu-IN': 'છુપાવેલ',
    'hi-IN': 'छिपा हुआ',
    'it-IT': 'Nascosto',
    'ja-JP': '非表示',
    'kn-IN': 'ಮರೆಮಾಡಲಾಗಿದೆ',
    'ko-KR': '숨김',
    'ml-IN': 'മറച്ചിരിക്കുന്നു',
    'mr-IN': 'लपविलेले',
    'nl-BE': 'verborgen',
    'nl-NL': 'verborgen',
    'pl-PL': 'ukryto',
    'pt-BR': 'oculto',
    'pt-PT': 'oculto',
    'sv-SE': 'dolda',
    'ta-IN': 'மறைக்கப்பட்டது',
    'te-IN': 'దాచివని',
    'th-TH': 'ซ่อน',
    'tr-TR': 'gizli',
    'vi-VN': 'bị ẩn',
    'zh-CN': '已隐藏',
    'zh-TW': '隱藏',
  },
  'dg-clear-filters': {
    'en-US': 'Clear all filters',
    'ar-AE': 'مسح كل عوامل التصفية',
    'bn-IN': 'সকল ফিল্টার মুছে ফেলুন',
    'de-DE': 'Alle Filter entfernen',
    'es-ES': 'Borrar todos los filtros',
    'es-MX': 'Borrar todos los filtros',
    'fr-BE': 'Effacer tous les filtres',
    'fr-CA': 'Effacer tous les filtres',
    'fr-FR': 'Effacer tous les filtres',
    'gu-IN': 'તમામ ફિલ્ટર્સ દૂર કરો',
    'hi-IN': 'सभी फ़िल्टर हटाएं',
    'it-IT': 'Annulla tutti i filtri',
    'ja-JP': 'すべてのフィルターを解除',
    'kn-IN': 'ಎಲ್ಲಾ ಫಿಲ್ಟರ್‌ಗಳನ್ನು ಕ್ಲಿಯರ್ ಮಾಡಿ',
    'ko-KR': '모든 필터 지우기',
    'ml-IN': 'എല്ലാ ഫിൽട്ടറുകളും മായ്ക്കുക',
    'mr-IN': 'सर्व फिल्टर साफ करा',
    'nl-BE': 'Alle filters wissen',
    'nl-NL': 'Alle filters wissen',
    'pl-PL': 'Wyczyść wszystkie filtry',
    'pt-BR': 'Limpar todos os filtros',
    'pt-PT': 'Limpar todos os filtros',
    'sv-SE': 'Rensa alla filter',
    'ta-IN': 'அனைத்து ஃபில்ட்டர்களையும் அழி',
    'te-IN': 'అన్ని ఫిల్టర్‌లను క్లియర్ చేయండి',
    'th-TH': 'ล้างตัวกรองทั้งหมด',
    'tr-TR': 'Tüm filtreleri temizle',
    'vi-VN': 'Xóa tất cả bộ lọc',
    'zh-CN': '清除所有筛选条件',
    'zh-TW': '清除所有篩選條件',
  },
  'dg-all': {
    'en-US': 'All',
    'ar-AE': 'الكل',
    'bn-IN': 'সব',
    'de-DE': 'Alle',
    'es-ES': 'Todo',
    'es-MX': 'Todos',
    'fr-BE': 'Tout',
    'fr-CA': 'Tout',
    'fr-FR': 'Tous',
    'gu-IN': 'તમામ',
    'hi-IN': 'सभी',
    'it-IT': 'Tutti',
    'ja-JP': 'すべて',
    'kn-IN': 'ಎಲ್ಲಾ',
    'ko-KR': '전체',
    'ml-IN': 'എല്ലാം',
    'mr-IN': 'सर्व',
    'nl-BE': 'Alle',
    'nl-NL': 'Alle',
    'pl-PL': 'Wszystko',
    'pt-BR': 'Todas',
    'pt-PT': 'Todas',
    'sv-SE': 'Alla',
    'ta-IN': 'அனைத்தும்',
    'te-IN': 'అన్నీ',
    'th-TH': 'ทั้งหมด',
    'tr-TR': 'Tümü',
    'vi-VN': 'Tất cả',
    'zh-CN': '全部',
    'zh-TW': '全部',
  },
  'dg-search': {
    'en-US': 'Search',
    'ar-AE': 'بحث',
    'bn-IN': 'অনুসন্ধান করুন',
    'de-DE': 'Suchen',
    'es-ES': 'Buscar',
    'es-MX': 'Buscar',
    'fr-BE': 'Rechercher',
    'fr-CA': 'Rechercher',
    'fr-FR': 'Rechercher',
    'gu-IN': 'શોધો',
    'hi-IN': 'सर्च करें',
    'it-IT': 'Cerca',
    'ja-JP': '検索',
    'kn-IN': 'ಸರ್ಚ್ ಮಾಡಿ',
    'ko-KR': '검색',
    'ml-IN': 'തിരയുക',
    'mr-IN': 'शोधा',
    'nl-BE': 'Zoeken',
    'nl-NL': 'Zoeken',
    'pl-PL': 'Szukaj',
    'pt-BR': 'Pesquisar',
    'pt-PT': 'Pesquisar',
    'sv-SE': 'Sök',
    'ta-IN': 'சர்ச்',
    'te-IN': 'వెతకండి',
    'th-TH': 'ค้นหา',
    'tr-TR': 'Ara',
    'vi-VN': 'Tìm kiếm',
    'zh-CN': '搜索',
    'zh-TW': '搜尋',
  },
  'dg-edit': {
    'en-US': 'Edit',
    'ar-AE': 'تعديل',
    'bn-IN': 'সম্পাদনা করুন',
    'de-DE': 'Bearbeiten',
    'es-ES': 'Modificar',
    'es-MX': 'Modificar',
    'fr-BE': 'Modifier',
    'fr-CA': 'Modifier',
    'fr-FR': 'Modifier',
    'gu-IN': 'એડિટ કરો',
    'hi-IN': 'बदलाव करें',
    'it-IT': 'Modifica',
    'ja-JP': '編集',
    'kn-IN': 'ಎಡಿಟ್ ಮಾಡಿ',
    'ko-KR': '편집',
    'ml-IN': 'എഡിറ്റ് ചെയ്യുക',
    'mr-IN': 'संपादित करा',
    'nl-BE': 'Bewerken',
    'nl-NL': 'Bewerken',
    'pl-PL': 'Edytuj',
    'pt-BR': 'Editar',
    'pt-PT': 'Editar',
    'sv-SE': 'Redigera',
    'ta-IN': 'திருத்து',
    'te-IN': 'ఎడిట్ చేయండి',
    'th-TH': 'แก้ไข',
    'tr-TR': 'Düzenle',
    'vi-VN': 'Chỉnh sửa',
    'zh-CN': '编辑',
    'zh-TW': '編輯',
  },
  'dg-loading': {
    'en-US': 'Loading...',
    'ar-AE': 'جارٍ التحميل...',
    'bn-IN': 'লোড করা হচ্ছে...',
    'de-DE': 'Wird geladen...',
    'en-GB': 'Loading…',
    'es-ES': 'Cargando...',
    'es-MX': 'Cargando…',
    'fr-BE': 'Chargement...',
    'fr-CA': 'Chargement en cours...',
    'fr-FR': 'Chargement...',
    'gu-IN': 'લોડ થઈ રહ્યું છે...',
    'hi-IN': 'लोड हो रहा है...',
    'it-IT': 'Caricamento in corso...',
    'ja-JP': '読み込み中...',
    'kn-IN': 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    'ko-KR': '로드 중...',
    'ml-IN': 'ലോഡ് ചെയ്യുന്നു...',
    'mr-IN': 'लोड करत आहे...',
    'nl-BE': 'Bezig met laden...',
    'nl-NL': 'Bezig met laden...',
    'pl-PL': 'Wczytywanie...',
    'pt-BR': 'Carregando...',
    'pt-PT': 'A carregar...',
    'sv-SE': 'Laddar ...',
    'ta-IN': 'ஏற்றுகிறது...',
    'te-IN': 'లోడ్ అవుతోంది...',
    'th-TH': 'กำลังโหลด...',
    'tr-TR': 'Yükleniyor...',
    'vi-VN': 'Đang tải...',
    'zh-CN': '正在加载…',
    'zh-TW': '載入中...',
  },
  'dg-no-data': {
    'en-US': 'No data is available.',
    'ar-AE': 'لا تتوفر أي بيانات.',
    'bn-IN': 'কোনো তথ্য পাওয়া যায়নি।',
    'de-DE': 'Keine Daten verfügbar.',
    'es-ES': 'No hay datos disponibles.',
    'es-MX': 'No hay datos disponibles.',
    'fr-BE': 'Aucune donnée n’est disponible.',
    'fr-CA': 'Aucune donnée n’est disponible.',
    'fr-FR': 'Aucune donnée n’est disponible.',
    'gu-IN': 'કોઈ ડેટા ઉપલબ્ધ નથી.',
    'hi-IN': 'कोई डेटा उपलब्ध नहीं है.',
    'it-IT': 'Nessun dato disponibile.',
    'ja-JP': '利用可能なデータがありません。',
    'kn-IN': 'ಯಾವುದೇ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ.',
    'ko-KR': '사용 가능한 데이터가 없습니다.',
    'ml-IN': 'ഡാറ്റ ലഭ്യമല്ല.',
    'mr-IN': 'कोणताही डेटा उपलब्ध नाही.',
    'nl-BE': 'Geen gegevens beschikbaar.',
    'nl-NL': 'Er zijn geen gegevens beschikbaar.',
    'pl-PL': 'Brak dostępnych danych',
    'pt-BR': 'Não há dados disponíveis.',
    'pt-PT': 'Não existem dados disponíveis.',
    'sv-SE': 'Inga data är tillgängliga.',
    'ta-IN': 'தரவு எதுவும் கிடைக்கவில்லை.',
    'te-IN': 'డేటా అందుబాటులో లేదు.',
    'th-TH': 'ไม่มีข้อมูล',
    'tr-TR': 'Veri yok.',
    'vi-VN': 'Không có sẵn dữ liệu.',
    'zh-CN': '无可用数据。',
    'zh-TW': '沒有可用的資料。',
  },
  'dg-no-search-results': {
    'en-US': 'Your search did not return any results.',
    'ar-AE': 'لم يحقق بحثك أيّ نتائج.',
    'bn-IN': 'আপনার অনুসন্ধানে কোনও ফলাফল পাওয়া যায়নি।',
    'de-DE': 'Für Ihre Suche wurden keine Ergebnisse gefunden.',
    'es-ES': 'La búsqueda no ha dado resultados.',
    'es-MX': 'La búsqueda no dio resultados.',
    'fr-BE': 'Aucun résultat n’a été trouvé pour votre recherche.',
    'fr-CA': 'Votre recherche n’a donné aucun résultat.',
    'fr-FR': 'Votre recherche n’a pas abouti.',
    'gu-IN': 'તમારા સર્ચે કોઈ પરિણામો આપ્યા નથી.',
    'hi-IN': 'आपकी सर्च से कोई नतीजा नहीं मिला.',
    'it-IT': 'La ricerca non ha prodotto alcun risultato.',
    'ja-JP': '検索結果が見つかりませんでした。',
    'kn-IN': 'ನಿಮ್ಮ ಹುಡುಕಾಟಕ್ಕೆ ಯಾವುದೇ ಫಲಿತಾಂಶ ಕಂಡುಬರಲಿಲ್ಲ.',
    'ko-KR': '검색 결과가 없습니다.',
    'ml-IN': 'നിങ്ങളുടെ തിരയലിന് ഫലങ്ങളൊന്നും ലഭിച്ചിട്ടില്ല.',
    'mr-IN': 'तुमच्या शोधामुळे कोणतेही परिणाम मिळाले नाहीत.',
    'nl-BE': 'Je zoekopdracht heeft geen resultaten opgeleverd.',
    'nl-NL': 'Je zoekopdracht heeft geen resultaten opgeleverd.',
    'pl-PL': 'Wyszukiwanie nie zwróciło żadnych wyników.',
    'pt-BR': 'A pesquisa não retornou resultados.',
    'pt-PT': 'A sua pesquisa não devolveu nenhum resultado.',
    'sv-SE': 'Sökningen gav inga resultat.',
    'ta-IN': 'உங்கள் சர்ச் எந்த முடிவுகளுடனும் பொருந்தவில்லை.',
    'te-IN': 'మీ శోధన ఎటువంటి ఫలితాలను అందించలేదు.',
    'th-TH': 'การค้นหาไม่แสดงผลลัพธ์ใดๆ',
    'tr-TR': 'Aramanız sonuç getirmedi.',
    'vi-VN': 'Không có kết quả cho tìm kiếm của bạn.',
    'zh-CN': '您的搜索未返回任何结果。',
    'zh-TW': '您的搜尋沒有傳回任何結果。',
  },
  'dg-all-filters': {
    'en-US': 'All filters',
    'ar-AE': 'كل عوامل التصفية',
    'bn-IN': 'সকল ফিল্টার',
    'de-DE': 'Alle Filter',
    'es-ES': 'Todos los filtros',
    'es-MX': 'Todos los filtros',
    'fr-BE': 'Tous les filtres',
    'fr-CA': 'Tous les filtres',
    'fr-FR': 'Tous les filtres',
    'gu-IN': 'બધા ફિલ્ટર્સ',
    'hi-IN': 'सभी फ़िल्टर',
    'it-IT': 'Tutti i filtri',
    'ja-JP': 'すべてのフィルター',
    'kn-IN': 'ಎಲ್ಲಾ ಫಿಲ್ಟರ್‌ಗಳು',
    'ko-KR': '모든 필터',
    'ml-IN': 'എല്ലാ ഫിൽട്ടറുകളും',
    'mr-IN': 'सर्व फिल्टर',
    'nl-BE': 'Alle filters',
    'nl-NL': 'Alle filters',
    'pl-PL': 'Wszystkie filtry',
    'pt-BR': 'Todos os filtros',
    'pt-PT': 'Todos os filtros',
    'sv-SE': 'Alla filter',
    'ta-IN': 'அனைத்து ஃபில்ட்டர்கள்',
    'te-IN': 'అన్ని ఫిల్టర్‌లు',
    'th-TH': 'ตัวกรองทั้งหมด',
    'tr-TR': 'Tüm filtreler',
    'vi-VN': 'Tất cả bộ lọc',
    'zh-CN': '所有筛选条件',
    'zh-TW': '所有篩選條件',
  },
  'dg-bulk-edit': {
    'en-US': 'Bulk Edit',
    'ar-AE': 'تعديل بطريقة مجمعة',
    'bn-IN': 'প্রভূত পরিমাণে সম্পাদনা করুন',
    'de-DE': 'Massenbearbeitung',
    'en-AU': 'Bulk edit',
    'en-CA': 'Bulk edit',
    'en-GB': 'Bulk edit',
    'en-SG': 'Bulk edit',
    'es-ES': 'Modificar en bloque',
    'es-MX': 'Editar en lote',
    'fr-BE': 'Modification par lots',
    'fr-CA': 'Modification en masse',
    'fr-FR': 'Modification par lot',
    'gu-IN': 'બલ્ક એડિટ',
    'hi-IN': 'बल्क में बदलाव करें',
    'it-IT': 'Modifica simultanea',
    'ja-JP': '一括編集',
    'kn-IN': 'ದೊಡ್ಡ ಪ್ರಮಾಣದಲ್ಲಿ ಎಡಿಟ್ ಮಾಡಿ',
    'ko-KR': '대량 편집',
    'ml-IN': 'ബൾക്ക് എഡിറ്റ്',
    'mr-IN': 'मोठ्या प्रमाणात संपादित करा',
    'nl-BE': 'Bulk bewerken',
    'nl-NL': 'In bulk bewerken',
    'pl-PL': 'Edytuj wiele naraz',
    'pt-BR': 'Alterar em massa',
    'pt-PT': 'Edição em massa',
    'sv-SE': 'Redigera i bulk',
    'ta-IN': 'மொத்தமாகத் திருத்து',
    'te-IN': 'బల్క్ సవరణ',
    'th-TH': 'แก้ไขเป็นจำนวนมาก',
    'tr-TR': 'Toplu düzenle',
    'vi-VN': 'Chỉnh sửa hàng loạt',
    'zh-CN': '批量编辑',
    'zh-TW': '批次編輯',
  },
  'dg-action-column': {
    'en-US': 'Action',
    'ar-AE': 'العملية',
    'bn-IN': 'পদক্ষেপ',
    'de-DE': 'Aktion',
    'es-ES': 'Acción',
    'es-MX': 'Acción',
    'gu-IN': 'ક્રિયા',
    'hi-IN': 'कार्रवाई',
    'it-IT': 'Azione',
    'ja-JP': 'アクション',
    'kn-IN': 'ಕ್ರಿಯೆ',
    'ko-KR': '조치',
    'ml-IN': 'നടപടി',
    'mr-IN': 'ॲक्शन',
    'nl-BE': 'Actie',
    'nl-NL': 'Actie',
    'pl-PL': 'Działanie',
    'pt-BR': 'Ação',
    'pt-PT': 'Ação',
    'sv-SE': 'Åtgärd',
    'ta-IN': 'செயல்',
    'te-IN': 'చర్య',
    'th-TH': 'การดำเนินการ',
    'tr-TR': 'Eylem',
    'vi-VN': 'Thao tác',
    'zh-CN': '操作',
    'zh-TW': '動作',
  },
  'dg-select-row': {
    'en-US': 'select a row',
    'ar-AE': 'تحديد صف',
    'bn-IN': 'একটি সারি নির্বাচন করুন',
    'de-DE': 'Zeile auswählen',
    'es-ES': 'seleccionar una fila',
    'es-MX': 'seleccionar una fila',
    'fr-BE': 'sélectionner une ligne',
    'fr-CA': 'sélectionner une ligne',
    'fr-FR': 'sélectionner une ligne',
    'gu-IN': 'એક પંક્તિ પસંદ કરો',
    'hi-IN': 'कोई पंक्ति चुनें',
    'it-IT': 'seleziona una riga',
    'ja-JP': '行を選択',
    'kn-IN': 'ಸಾಲನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    'ko-KR': '행 선택',
    'ml-IN': 'ഒരു വരി തിരഞ്ഞെടുക്കുക',
    'mr-IN': 'एक पंक्ती निवडा',
    'nl-BE': 'selecteer een rij',
    'nl-NL': 'selecteer een rij',
    'pl-PL': 'wybierz wiersz',
    'pt-BR': 'selecionar uma linha',
    'pt-PT': 'selecionar uma linha',
    'sv-SE': 'välj en rad',
    'ta-IN': 'ஒரு வரிசையைத் தேர்ந்தெடுக்கவும்',
    'te-IN': 'అడ్డు వరుసను ఎంచుకోండి',
    'th-TH': 'เลือกแถว',
    'tr-TR': 'bir satır seçin',
    'vi-VN': 'chọn một hàng',
    'zh-CN': '选择一行',
    'zh-TW': '選取一列',
  },
  'dg-additional-filter': {
    'en-US': 'Additional filters',
    'ar-AE': 'عوامل التصفية الإضافية',
    'bn-IN': 'অতিরিক্ত ফিল্টার',
    'de-DE': 'Zusätzliche Filter',
    'es-ES': 'Más filtros',
    'es-MX': 'Filtros adicionales',
    'fr-BE': 'Filtres supplémentaires',
    'fr-CA': 'Filtres supplémentaires',
    'fr-FR': 'Filtres supplémentaires',
    'gu-IN': 'વધારાના ફિલ્ટર્સ',
    'hi-IN': 'अतिरिक्त फ़िल्टर',
    'it-IT': 'Altri filtri',
    'ja-JP': 'その他のフィルター',
    'kn-IN': 'ಹೆಚ್ಚುವರಿ ಫಿಲ್ಟರ್ ಗಳು',
    'ko-KR': '추가 필터',
    'ml-IN': 'കൂടുതൽ ഫിൽട്ടറുകൾ',
    'mr-IN': 'अतिरिक्त फिल्टर्स',
    'nl-BE': 'Aanvullende filters',
    'nl-NL': 'Aanvullende filters',
    'pl-PL': 'Dodatkowe filtry',
    'pt-BR': 'Filtros adicionais',
    'pt-PT': 'Filtros adicionais',
    'sv-SE': 'Ytterligare filter',
    'ta-IN': 'கூடுதல் ஃபில்ட்டர்கள்',
    'te-IN': 'అదనపు ఫిల్టర్‌లు',
    'th-TH': 'ตัวกรองเพิ่มเติม',
    'tr-TR': 'Diğer filtreler',
    'vi-VN': 'Bộ lọc bổ sung',
    'zh-CN': '更多筛选条件',
    'zh-TW': '其他篩選條件',
  },
  'dg-results-per-page': {
    'en-US': 'Results per page',
    'ar-AE': 'النتائج لكل صفحة',
    'bn-IN': 'পৃষ্ঠা প্রতি ফলাফল',
    'de-DE': 'Ergebnisse pro Seite',
    'es-ES': 'Resultados por página',
    'es-MX': 'Resultados por página',
    'fr-BE': 'Résultats par page',
    'fr-CA': 'Résultats par page',
    'fr-FR': 'Résultats par page',
    'gu-IN': 'પેજ દીઠ પરિણામો',
    'hi-IN': 'हर पेज पर नतीजे',
    'it-IT': 'Risultati per pagina',
    'ja-JP': '1ページに表示する件数',
    'kn-IN': 'ಪ್ರತಿ ಪುಟಕ್ಕೆ ಫಲಿತಾಂಶಗಳು',
    'ko-KR': '페이지당 결과',
    'ml-IN': 'ഓരോ പേജിലുമുള്ള ഫലങ്ങൾ',
    'mr-IN': 'परिणाम प्रति पृष्ठ',
    'nl-BE': 'Resultaten per pagina',
    'nl-NL': 'Resultaten per pagina',
    'pl-PL': 'Liczba wyników na stronę',
    'pt-BR': 'Resultados por página',
    'pt-PT': 'Resultados por página',
    'sv-SE': 'Resultat per sida',
    'ta-IN': 'ஒரு பக்கத்திற்கான முடிவுகள்',
    'te-IN': 'ప్రతి పేజీ ఫలితాలు',
    'th-TH': 'ผลการค้นหาต่อหน้า',
    'tr-TR': 'Sayfa başına sonuç',
    'vi-VN': 'Kết quả mỗi trang',
    'zh-CN': '每页显示的结果数',
    'zh-TW': '每頁顯示結果數',
  },
  'dg-go-to-page': {
    'en-US': 'Go to page',
    'ar-AE': 'الانتقال إلى الصفحة',
    'bn-IN': 'এই পৃষ্ঠায় যান',
    'de-DE': 'Gehe zu Seite',
    'es-ES': 'Ir a la página',
    'es-MX': 'Ir a la página',
    'fr-BE': 'Aller à la page',
    'fr-CA': 'Aller à la page',
    'fr-FR': 'Aller à la page',
    'gu-IN': 'પેજ પર જાઓ',
    'hi-IN': 'पेज पर जाएं',
    'it-IT': 'Vai a pagina',
    'ja-JP': 'ページに移動',
    'kn-IN': 'ಪುಟಕ್ಕೆ ಹೋಗಿ',
    'ko-KR': '페이지로 이동',
    'ml-IN': 'പേജിലേക്ക് പോകുക',
    'mr-IN': 'पृष्ठावर जा',
    'nl-BE': 'Ga naar pagina',
    'nl-NL': 'Ga naar pagina',
    'pl-PL': 'Przejdź do strony',
    'pt-BR': 'Ir para a página',
    'pt-PT': 'Aceder à página',
    'sv-SE': 'Gå till sida',
    'ta-IN': 'பக்கத்திற்குச் செல்லவும்',
    'te-IN': 'పేజీకి వెళ్లండి',
    'th-TH': 'ไปที่หน้า',
    'tr-TR': 'Sayfaya git',
    'vi-VN': 'Truy cập trang',
    'zh-CN': '转至页面',
    'zh-TW': '前往頁面',
  },
  'dg-page-number': {
    'en-US': 'page number',
    'ar-AE': 'رقم الصفحة',
    'bn-IN': 'পৃষ্ঠার সংখ্যা',
    'de-DE': 'Seitennummer',
    'es-ES': 'número de página',
    'es-MX': 'número de página',
    'fr-BE': 'numéro de page',
    'fr-CA': 'numéro de page',
    'fr-FR': 'numéro de page',
    'gu-IN': 'પેજ નંબર',
    'hi-IN': 'पेज नंबर',
    'it-IT': 'numero di pagina',
    'ja-JP': 'ページ番号',
    'kn-IN': 'ಪುಟ ಸಂಖ್ಯೆ',
    'ko-KR': '페이지 번호',
    'ml-IN': 'പേജ് നമ്പർ',
    'mr-IN': 'पृष्ठ क्रमांक',
    'nl-BE': 'paginanummer',
    'nl-NL': 'paginanummer',
    'pl-PL': 'numer strony',
    'pt-BR': 'número da página',
    'pt-PT': 'número da página',
    'sv-SE': 'sidnummer',
    'ta-IN': 'பக்க எண்',
    'te-IN': 'పేజీ నంబర్',
    'th-TH': 'เลขหน้า',
    'tr-TR': 'sayfa numarası',
    'vi-VN': 'số trang',
    'zh-CN': '页码',
    'zh-TW': '頁碼',
  },
  'ag-selectAll': {
    'en-US': '(Select All)',
    'ar-AE': '(تحديد الكل)',
    'bn-IN': '(সব নির্বাচন করুন)',
    'de-DE': '(Alle auswählen)',
    'en-AU': '(Select all)',
    'en-ZA': '(Select all)',
    'es-ES': '(Seleccionar todo)',
    'es-MX': '(Seleccionar todo)',
    'fr-BE': '(Tout sélectionner)',
    'fr-CA': '(Sélectionner tout)',
    'fr-FR': '(Tout sélectionner)',
    'gu-IN': '(બધું પસંદ કરો)',
    'hi-IN': '(सभी चुनें)',
    'it-IT': '(Seleziona tutto)',
    'ja-JP': '（すべて選択）',
    'kn-IN': '(ಎಲ್ಲವನ್ನೂ ಆಯ್ಕೆಮಾಡಿ)',
    'ko-KR': '(모두 선택)',
    'ml-IN': '(എല്ലാം തിരഞ്ഞെടുക്കുക)',
    'mr-IN': '(सर्व निवडा)',
    'nl-BE': '(Alles selecteren)',
    'nl-NL': '(Alles selecteren)',
    'pl-PL': '(Wybierz wszystkie)',
    'pt-BR': '(Selecionar tudo)',
    'pt-PT': '(Selecionar tudo)',
    'sv-SE': '(Välj alla)',
    'ta-IN': '(அனைத்தையும் தேர்ந்தெடுக்கவும்)',
    'te-IN': '(అన్నీ ఎంచుకోండి)',
    'th-TH': '(เลือกทั้งหมด)',
    'tr-TR': '(Tümünü seç)',
    'vi-VN': '(Chọn tất cả)',
    'zh-CN': '（全选）',
    'zh-TW': '(全選)',
  },
  'ag-selectAllSearchResults': {
    'en-US': '(Select All Search Results)',
    'ar-AE': '(تحديد كل نتائج البحث)',
    'bn-IN': '(সকল সার্চের ফলাফল নির্বাচন করুন)',
    'de-DE': '(Alle Suchergebnisse auswählen)',
    'en-AU': '(Select all search results)',
    'en-GB': '(Select all search results)',
    'en-ZA': '(Select all search results)',
    'es-ES': '(Seleccionar todos los resultados de búsqueda)',
    'es-MX': '(Seleccionar todos los resultados de búsqueda)',
    'fr-BE': '(Sélectionner tous les résultats de recherche)',
    'fr-CA': '(Sélectionner tous les résultats de recherche)',
    'fr-FR': '(Sélectionner tous les résultats de recherche)',
    'gu-IN': '(બધા શોધ પરિણામો પસંદ કરો)',
    'hi-IN': '(सभी सर्च नतीजे चुनें)',
    'it-IT': '(Seleziona tutti i risultati della ricerca)',
    'ja-JP': '（すべての検索結果を選択）',
    'kn-IN': '(ಎಲ್ಲ ಹುಡುಕಾಟ ಫಲಿತಾಂಶಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ)',
    'ko-KR': '(모든 검색 결과 선택)',
    'ml-IN': '(എല്ലാ തിരയൽ ഫലങ്ങളും തിരഞ്ഞെടുക്കുക)',
    'mr-IN': '(सर्व शोध परिणाम निवडा)',
    'nl-BE': '(Selecteer alle zoekresultaten)',
    'nl-NL': '(Alle zoekresultaten selecteren)',
    'pl-PL': '(Wybierz wszystkie wyniki wyszukiwania)',
    'pt-BR': '(Selecionar todos os resultados de pesquisa)',
    'pt-PT': '(Selecionar todos os resultados da pesquisa)',
    'sv-SE': '(Välj alla sökresultat)',
    'ta-IN': '(அனைத்து சர்ச் முடிவுகளையும் தேர்ந்தெடுக்கவும்)',
    'te-IN': '(అన్ని శోధన ఫలితాలను ఎంచుకోండి)',
    'th-TH': '(เลือกผลการค้นหาทั้งหมด)',
    'tr-TR': '(Tüm arama sonuçlarını seç)',
    'vi-VN': '(Chọn tất cả kết quả tìm kiếm)',
    'zh-CN': '（选择所有搜索结果）',
    'zh-TW': '(選取所有搜尋結果)',
  },
  'ag-searchOoo': {
    'en-US': 'Search...',
    'ar-AE': 'البحث...',
    'bn-IN': 'সার্চ করুন...',
    'de-DE': 'Suchen …',
    'es-ES': 'Buscar...',
    'es-MX': 'Buscar...',
    'fr-BE': 'Rechercher...',
    'fr-CA': 'Rechercher...',
    'fr-FR': 'Rechercher...',
    'gu-IN': 'સર્ચ કરો...',
    'hi-IN': 'सर्च करें...',
    'it-IT': 'Cerca...',
    'ja-JP': '検索',
    'kn-IN': 'ಹುಡುಕಾಟ...',
    'ko-KR': '검색...',
    'ml-IN': 'തിരയുക...',
    'mr-IN': 'शोधा...',
    'nl-BE': 'Zoeken...',
    'nl-NL': 'Zoeken...',
    'pl-PL': 'Szukaj...',
    'pt-BR': 'Pesquisar…',
    'pt-PT': 'Pesquisar...',
    'sv-SE': 'Sök ...',
    'ta-IN': 'சர்ச்...',
    'te-IN': 'సెర్చ్ చేయండి...',
    'th-TH': 'ค้นหา...',
    'tr-TR': 'Ara...',
    'vi-VN': 'Tìm kiếm...',
    'zh-CN': '搜索...',
    'zh-TW': '搜尋...',
  },
  'ag-blanks': {
    'en-US': '(Blanks)',
    'ar-AE': '(الفراغات)',
    'bn-IN': '(ফাঁকা স্থান)',
    'de-DE': '(Leerzeichen)',
    'es-ES': '(En blanco)',
    'es-MX': '(En blanco)',
    'fr-BE': '(Vides)',
    'fr-CA': '(Vides)',
    'fr-FR': '(Vides)',
    'gu-IN': '(ખાલી)',
    'hi-IN': '(ब्लैंक)',
    'it-IT': '(Vuoto)',
    'ja-JP': '（空包）',
    'kn-IN': '(ಖಾಲಿ)',
    'ko-KR': '(공백)',
    'ml-IN': '(ശൂന്യമായവ)',
    'mr-IN': '(रिकामे)',
    'nl-BE': '(Leeg)',
    'nl-NL': '(Lege)',
    'pl-PL': '(Puste miejsca)',
    'pt-BR': '(Em branco)',
    'pt-PT': '(Em branco)',
    'sv-SE': '(Tomma)',
    'ta-IN': '(பிளாங்குகள்)',
    'te-IN': '(ఖాళీలు)',
    'th-TH': '(ว่างเปล่า)',
    'tr-TR': '(Boşluklar)',
    'vi-VN': '(Chỗ trống)',
    'zh-CN': '（空）',
    'zh-TW': '(空白)',
  },
  'ag-noMatches': {
    'en-US': 'No matches',
    'ar-AE': 'لا توجد تطابقات',
    'bn-IN': 'কোনও মিল নেই',
    'de-DE': 'Keine Treffer',
    'es-ES': 'No hay coincidencias',
    'es-MX': 'No hay coincidencias',
    'fr-BE': 'Aucune correspondance',
    'fr-CA': 'Pas de correspondances',
    'fr-FR': 'Aucune correspondance',
    'gu-IN': 'કોઈ મેચ નથી',
    'hi-IN': 'कोई मैच नहीं है',
    'it-IT': 'Nessuna corrispondenza',
    'ja-JP': '一致なし',
    'kn-IN': 'ಮ್ಯಾಚ್‌ಗಳು ಇಲ್ಲ',
    'ko-KR': '일치 항목 없음',
    'ml-IN': 'പൊരുത്തങ്ങൾ ഇല്ല',
    'mr-IN': 'जुळणारे काही नाही',
    'nl-BE': 'Geen overeenkomsten',
    'nl-NL': 'Geen overeenkomsten',
    'pl-PL': 'Brak dopasowań',
    'pt-BR': 'Sem correspondência',
    'pt-PT': 'Sem correspondências',
    'sv-SE': 'Inga matchningar',
    'ta-IN': 'பொருத்தங்கள் இல்லை',
    'te-IN': 'మ్యాచ్‌లు ఏవీ లేవు',
    'th-TH': 'ไม่พบรายการที่ตรงกัน',
    'tr-TR': 'Eşleşme yok',
    'vi-VN': 'Không tìm thấy kết quả trùng khớp',
    'zh-CN': '无匹配',
    'zh-TW': '沒有符合項目',
  },
  'ag-filterOoo': {
    'en-US': 'Filter...',
    'ar-AE': 'تصفية...',
    'bn-IN': 'ফিল্টার...',
    'de-DE': 'Filtern …',
    'es-ES': 'Filtrar...',
    'es-MX': 'Filtrar...',
    'fr-BE': 'Filtre...',
    'fr-CA': 'Filtrer...',
    'fr-FR': 'Filtrer...',
    'gu-IN': 'ફિલ્ટર...',
    'hi-IN': 'फ़िल्टर करें...',
    'it-IT': 'Filtra...',
    'ja-JP': 'フィルター',
    'kn-IN': 'ಫಿಲ್ಟರ್...',
    'ko-KR': '필터...',
    'ml-IN': 'ഫിൽട്ടർ ചെയ്യുക...',
    'mr-IN': 'फिल्टर...',
    'nl-BE': 'Filteren...',
    'nl-NL': 'Filteren...',
    'pl-PL': 'Filtruj...',
    'pt-BR': 'Filtrar…',
    'pt-PT': 'Filtrar...',
    'sv-SE': 'Filtrera ...',
    'ta-IN': 'வடிகட்டி...',
    'te-IN': 'ఫిల్టర్ చేయండి...',
    'th-TH': 'ตัวกรอง...',
    'tr-TR': 'Filtrele...',
    'vi-VN': 'Bộ lọc...',
    'zh-CN': '筛选...',
    'zh-TW': '篩選條件...',
  },
  'ag-equals': {
    'en-US': 'Equals',
    'ar-AE': 'يساوي',
    'bn-IN': 'সমান',
    'de-DE': 'Gleich',
    'es-ES': 'Es igual',
    'es-MX': 'Iguales',
    'fr-BE': 'Égal à',
    'fr-CA': 'Équivaut',
    'fr-FR': 'Égal à',
    'gu-IN': 'બરાબર',
    'hi-IN': 'बराबर',
    'it-IT': 'Uguale a',
    'ja-JP': '等しい',
    'kn-IN': 'ಸಮಾನ',
    'ko-KR': '다음과 같음',
    'ml-IN': 'തുല്യമാണ്',
    'mr-IN': 'समान',
    'nl-BE': 'Gelijk aan',
    'nl-NL': 'Gelijk aan',
    'pl-PL': 'Równe',
    'pt-BR': 'Igual a',
    'pt-PT': 'Igual a',
    'sv-SE': 'Lika med',
    'ta-IN': 'சமமானது',
    'te-IN': 'సమానమైనవి',
    'th-TH': 'เท่ากับ',
    'tr-TR': 'Eşit',
    'vi-VN': 'Bằng',
    'zh-CN': '等于',
    'zh-TW': '等於',
  },
  'ag-notEqual': {
    'en-US': 'Not equal',
    'ar-AE': 'غير متكافئ',
    'bn-IN': 'সমান নয়',
    'de-DE': 'Ungleich',
    'es-ES': 'No es igual',
    'es-MX': 'No es igual',
    'fr-BE': 'Inégal',
    'fr-CA': 'N’est pas égal',
    'fr-FR': 'Différent de',
    'gu-IN': 'સમાન નથી',
    'hi-IN': 'बराबर नहीं है',
    'it-IT': 'Non uguale',
    'ja-JP': '等しくない',
    'kn-IN': 'ಸಮಾನವಾಗಿಲ್ಲ',
    'ko-KR': '다음과 같지 않음',
    'ml-IN': 'തുല്യമല്ല',
    'mr-IN': 'बरोबरीचे नाही',
    'nl-BE': 'Niet gelijk',
    'nl-NL': 'Niet gelijk',
    'pl-PL': 'Nie równe',
    'pt-BR': 'Não é igual',
    'pt-PT': 'Não é igual',
    'sv-SE': 'Inte lika med',
    'ta-IN': 'சமமில்லாதவை',
    'te-IN': 'సమానమైనది కాదు',
    'th-TH': 'ไม่เท่ากับ',
    'tr-TR': 'Eşit değil',
    'vi-VN': 'Không bằng nhau',
    'zh-CN': '不等于',
    'zh-TW': '不等於',
  },
  'ag-blank': {
    'en-US': 'Blank',
    'ar-AE': 'فارغ',
    'bn-IN': 'ফাঁকা',
    'de-DE': 'Leer',
    'es-ES': 'En blanco',
    'es-MX': 'En blanco',
    'fr-BE': 'Vide',
    'fr-CA': 'Vide',
    'fr-FR': 'Vide',
    'gu-IN': 'ખાલી',
    'hi-IN': 'ब्लैंक',
    'it-IT': 'Vuoto',
    'ja-JP': '空白',
    'kn-IN': 'ಖಾಲಿ',
    'ko-KR': '공백',
    'ml-IN': 'ശൂന്യം',
    'mr-IN': 'रिक्त',
    'nl-BE': 'Leeg',
    'nl-NL': 'Blanco',
    'pl-PL': 'Puste',
    'pt-BR': 'Em branco',
    'pt-PT': 'Em branco',
    'sv-SE': 'Tom',
    'ta-IN': 'வெற்று',
    'te-IN': 'ఖాళీగా ఉంది',
    'th-TH': 'ว่างเปล่า',
    'tr-TR': 'Boş',
    'vi-VN': 'Trống',
    'zh-CN': '留空',
    'zh-TW': '空白',
  },
  'ag-notBlank': {
    'en-US': 'Not blank',
    'ar-AE': 'غير فارغ',
    'bn-IN': 'ফাঁকা নয়',
    'de-DE': 'Nicht leer',
    'es-ES': 'No está en blanco',
    'es-MX': 'No está en blanco',
    'fr-BE': 'Non vide',
    'fr-CA': 'Non vide',
    'fr-FR': 'Non vierge',
    'gu-IN': 'ખાલી નથી',
    'hi-IN': 'ब्लैंक नहीं है',
    'it-IT': 'Non vuoto',
    'ja-JP': '空白でない',
    'kn-IN': 'ಖಾಲಿ ಇಲ್ಲ',
    'ko-KR': '공백 아님',
    'ml-IN': 'ശൂന്യമല്ല',
    'mr-IN': 'रिकामे नाही',
    'nl-BE': 'Niet leeg',
    'nl-NL': 'Niet leeg',
    'pl-PL': 'Nie puste',
    'pt-BR': 'Não está em branco',
    'pt-PT': 'Não em branco',
    'sv-SE': 'Inte tom',
    'ta-IN': 'பிளாங்காக இல்லை',
    'te-IN': 'ఖాళీగా లేదు',
    'th-TH': 'ไม่ว่างเปล่า',
    'tr-TR': 'Boş değil',
    'vi-VN': 'Không để trống',
    'zh-CN': '不留空',
    'zh-TW': '非空白',
  },
  'ag-empty': {
    'en-US': 'Choose One',
    'ar-AE': 'تحديد اختيار واحد',
    'bn-IN': 'একটি বেছে নিন',
    'de-DE': 'Eins auswählen',
    'en-AU': 'Choose one',
    'en-GB': 'Choose one',
    'en-ZA': 'Choose one',
    'es-ES': 'Elige una opción',
    'es-MX': 'Selecciona una opción',
    'fr-BE': 'Choisir un élément',
    'fr-CA': 'Choisir un',
    'fr-FR': 'Choisissez-en un',
    'gu-IN': 'કોઈ એક પસંદ કરો',
    'hi-IN': 'एक चुनें',
    'it-IT': 'Scegli uno',
    'ja-JP': '1つ選択',
    'kn-IN': 'ಒಂದನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    'ko-KR': '1개 선택',
    'ml-IN': 'ഒന്ന് തിരഞ്ഞെടുക്കുക',
    'mr-IN': 'एक निवडा',
    'nl-BE': 'Kies er één',
    'nl-NL': 'Kies er één',
    'pl-PL': 'Wybierz jeden',
    'pt-BR': 'Escolha uma opção',
    'pt-PT': 'Escolha um',
    'sv-SE': 'Välj en',
    'ta-IN': 'ஒன்றைத் தேர்ந்தெடுக்கவும்',
    'te-IN': 'ఒకదాన్ని ఎంచుకోండి',
    'th-TH': 'เลือกหนึ่งรายการ',
    'tr-TR': 'Birini seçin',
    'vi-VN': 'Chọn một',
    'zh-CN': '选择一项',
    'zh-TW': '選擇一個',
  },
  'ag-lessThan': {
    'en-US': 'Less than',
    'ar-AE': 'أقل من',
    'bn-IN': 'এর চেয়ে কম',
    'de-DE': 'Weniger als',
    'es-ES': 'Menos de',
    'es-MX': 'Menos de',
    'fr-BE': 'Inférieur à',
    'fr-CA': 'Moins de',
    'fr-FR': 'Moins de',
    'gu-IN': 'આનાથી ઓછી',
    'hi-IN': 'इससे कम',
    'it-IT': 'Meno di',
    'ja-JP': '次未満',
    'kn-IN': 'ಕಡಿಮೆ',
    'ko-KR': '다음 미만',
    'ml-IN': 'ഇതിനെക്കാൾ കുറവ്',
    'mr-IN': 'याहून कमी',
    'nl-BE': 'Minder dan',
    'nl-NL': 'Minder dan',
    'pl-PL': 'Mniejsze niż',
    'pt-BR': 'Menos de',
    'pt-PT': 'Inferior a',
    'sv-SE': 'Mindre än',
    'ta-IN': 'இதைவிடக் குறைவாக',
    'te-IN': 'దీని కంటే తక్కువ',
    'th-TH': 'น้อยกว่า',
    'tr-TR': 'Şundan daha az:',
    'vi-VN': 'Ít hơn',
    'zh-CN': '小于',
    'zh-TW': '小於',
  },
  'ag-greaterThan': {
    'en-US': 'Greater than',
    'ar-AE': 'أكثر من',
    'bn-IN': 'এর চেয়ে বেশি',
    'de-DE': 'Mehr als',
    'es-ES': 'Más de',
    'es-MX': 'Más de',
    'fr-BE': 'Supérieur à',
    'fr-CA': 'Plus grand que',
    'fr-FR': 'Supérieur à',
    'gu-IN': 'કરતાં વધારે',
    'hi-IN': 'इससे ज़्यादा',
    'it-IT': 'Maggiore di',
    'ja-JP': '以下の値より大きい',
    'kn-IN': 'ಇದಕ್ಕಿಂತ ಹೆಚ್ಚು',
    'ko-KR': '다음 초과',
    'ml-IN': 'ഇതിനേക്കാൾ വലുത്',
    'mr-IN': 'पेक्षा अधिक',
    'nl-BE': 'Hoger dan',
    'nl-NL': 'Meer dan',
    'pl-PL': 'Większe niż',
    'pt-BR': 'Superior a',
    'pt-PT': 'Superior a',
    'sv-SE': 'Större än',
    'ta-IN': 'இதை விட அதிகம்',
    'te-IN': 'కంటే ఎక్కువ',
    'th-TH': 'มากกว่า',
    'tr-TR': 'Şundan fazla:',
    'vi-VN': 'Lớn hơn',
    'zh-CN': '大于',
    'zh-TW': '大於',
  },
  'ag-lessThanOrEqual': {
    'en-US': 'Less than or equal',
    'ar-AE': 'أقل من أو يساوي',
    'bn-IN': 'কম বা সমান',
    'de-DE': 'Kleiner oder gleich',
    'es-ES': 'Inferior o igual',
    'es-MX': 'Menor o igual',
    'fr-BE': 'Inférieur ou égal à',
    'fr-CA': 'Inférieur ou égal',
    'fr-FR': 'Inférieur ou égal à',
    'gu-IN': 'કરતાં ઓછી અથવા સમાન',
    'hi-IN': 'इससे कम या इसके बराबर',
    'it-IT': 'Minore o uguale',
    'ja-JP': '次と等しいか小さい',
    'kn-IN': 'ಇದಕ್ಕಿಂತ ಕಡಿಮೆ ಅಥವಾ ಸಮಾನ',
    'ko-KR': '다음 이하',
    'ml-IN': 'ഇതിനേക്കാൾ കുറവോ ഇതിന് തുല്യമോ',
    'mr-IN': 'यापेक्षा कमी किंवा तेवढेच',
    'nl-BE': 'Minder dan of gelijk',
    'nl-NL': 'Minder dan of gelijk aan',
    'pl-PL': 'Mniejsze lub równe',
    'pt-BR': 'Menor ou igual',
    'pt-PT': 'Menor ou igual',
    'sv-SE': 'Under eller lika med',
    'ta-IN': 'குறைவாகவோ சமமாகவோ',
    'te-IN': 'కంటే తక్కువ లేదా సమానం',
    'th-TH': 'น้อยกว่าหรือเท่ากับ',
    'tr-TR': 'Daha az veya eşit',
    'vi-VN': 'Nhỏ hơn hoặc bằng',
    'zh-CN': '小于或等于',
    'zh-TW': '小於或等於',
  },
  'ag-greaterThanOrEqual': {
    'en-US': 'Greater than or equal',
    'ar-AE': 'أكبر من أو يساوي',
    'bn-IN': 'এর চেয়ে বড় বা সমান',
    'de-DE': 'Größer oder gleich',
    'es-ES': 'Igual o superior',
    'es-MX': 'Mayor o igual',
    'fr-BE': 'Supérieur ou égal à',
    'fr-CA': 'Supérieur ou égal',
    'fr-FR': 'Supérieur ou égal à',
    'gu-IN': 'આના કરતાં વધારે અથવા સમાન',
    'hi-IN': 'इससे ज़्यादा या इसके बराबर',
    'it-IT': 'uguale o maggiore',
    'ja-JP': '次と等しいか大きい\n',
    'kn-IN': 'ಇದಕ್ಕಿಂತ ದೊಡ್ಡದು ಅಥವಾ ಸಮಾನ',
    'ko-KR': '다음 이상',
    'ml-IN': 'ഇതിനേക്കാൾ വലുതോ ഇതിന് തുല്യമോ',
    'mr-IN': 'यापेक्षा मोठे किंवा तेवढेच',
    'nl-BE': 'Hoger dan of gelijk',
    'nl-NL': 'Meer dan of gelijk aan',
    'pl-PL': 'Większe lub równe',
    'pt-BR': 'Igual ou superior',
    'pt-PT': 'Maior ou igual',
    'sv-SE': 'Över eller lika med',
    'ta-IN': 'அதிகமாகவோ அல்லது சமமாகவோ',
    'te-IN': 'కంటే ఎక్కువ లేదా సమానం',
    'th-TH': 'มากกว่าหรือเท่ากับ',
    'tr-TR': 'Daha yüksek veya eşit',
    'vi-VN': 'Lớn hơn hoặc bằng',
    'zh-CN': '大于或等于',
    'zh-TW': '大於或等於',
  },
  'ag-inRange': {
    'en-US': 'In range',
    'ar-AE': 'في النطاق',
    'bn-IN': 'সীমার মধ্যে',
    'de-DE': 'Im Bereich',
    'es-ES': 'Intervalo',
    'es-MX': 'En el rango',
    'fr-BE': 'Dans la plage',
    'fr-CA': 'Dans l’intervalle',
    'fr-FR': 'Dans la plage',
    'gu-IN': 'રેન્જમાં',
    'hi-IN': 'रेंज में',
    'it-IT': "Nell'intervallo",
    'ja-JP': '範囲内',
    'kn-IN': 'ವ್ಯಾಪ್ತಿಯಲ್ಲಿ',
    'ko-KR': '범위 내',
    'ml-IN': 'പരിധിയിൽ',
    'mr-IN': 'रेंजमध्ये',
    'nl-BE': 'Binnen bereik',
    'nl-NL': 'Binnen bereik',
    'pl-PL': 'W zakresie',
    'pt-BR': 'No intervalo',
    'pt-PT': 'No intervalo',
    'sv-SE': 'Inom intervallet',
    'ta-IN': 'ரேஞ்சில்',
    'te-IN': 'పరిధిలో ఉంది',
    'th-TH': 'อยู่ในช่วง',
    'tr-TR': 'Aralık içinde',
    'vi-VN': 'Trong phạm vi',
    'zh-CN': '介于',
    'zh-TW': '在範圍內',
  },
  'ag-inRangeStart': {
    'en-US': 'from',
    'ar-AE': 'من',
    'bn-IN': 'থেকে',
    'de-DE': 'von',
    'es-ES': 'desde',
    'es-MX': 'desde',
    'fr-BE': 'de',
    'fr-CA': 'à partir de',
    'fr-FR': 'de',
    'gu-IN': 'અહીંથી',
    'hi-IN': 'इससे',
    'it-IT': 'da',
    'ja-JP': '開始日',
    'kn-IN': 'ಇಂದ',
    'ko-KR': '다음에서',
    'ml-IN': 'ഇതിൽ നിന്ന്',
    'mr-IN': 'कडून',
    'nl-BE': 'van',
    'nl-NL': 'van',
    'pl-PL': 'od',
    'pt-BR': 'de',
    'pt-PT': 'de',
    'sv-SE': 'från',
    'ta-IN': 'இதிலிருந்து',
    'te-IN': 'దీని నుండి',
    'th-TH': 'ตั้งแต่',
    'tr-TR': 'başlangıç:',
    'vi-VN': 'từ',
    'zh-CN': '从',
    'zh-TW': '從',
  },
  'ag-inRangeEnd': {
    'en-US': 'to',
    'ar-AE': 'إلى',
    'bn-IN': 'পর্যন্ত',
    'de-DE': 'bis',
    'es-ES': 'hasta',
    'es-MX': 'hasta',
    'fr-BE': 'à',
    'fr-CA': 'à',
    'fr-FR': 'par',
    'gu-IN': 'પ્રતિ',
    'hi-IN': 'से',
    'it-IT': 'a',
    'ja-JP': '終了日',
    'kn-IN': 'ಗೆ',
    'ko-KR': '다음까지',
    'ml-IN': 'ഇതിലേക്ക്',
    'mr-IN': 'प्रति',
    'nl-BE': 'tot',
    'nl-NL': 'aan',
    'pl-PL': 'do',
    'pt-BR': 'a',
    'pt-PT': 'para',
    'sv-SE': 'till',
    'ta-IN': 'இதுவரை',
    'te-IN': 'దీనికి',
    'th-TH': 'ถึง',
    'tr-TR': 'bitiş:',
    'vi-VN': 'đến',
    'zh-CN': '至',
    'zh-TW': '至',
  },
  'ag-contains': {
    'en-US': 'Contains',
    'ar-AE': 'يحتوي على',
    'bn-IN': 'উপস্থিত আছে',
    'de-DE': 'Enthält',
    'es-ES': 'Contiene',
    'es-MX': 'Contiene',
    'fr-BE': 'Contient',
    'fr-CA': 'Contient',
    'fr-FR': 'Contient',
    'gu-IN': 'સમાવે છે',
    'hi-IN': 'इसमें शामिल हैं',
    'it-IT': 'Contiene',
    'ja-JP': '次を含む',
    'kn-IN': 'ಒಳಗೊಂಡಿದೆ',
    'ko-KR': '다음 포함',
    'ml-IN': 'അടങ്ങിയിരിക്കുന്നു',
    'mr-IN': 'समाविष्ट आहे',
    'nl-BE': 'Bevat',
    'nl-NL': 'Bevat',
    'pl-PL': 'Zawiera',
    'pt-BR': 'Contém',
    'pt-PT': 'Contém',
    'sv-SE': 'Innehåller',
    'ta-IN': 'இவை உள்ளது',
    'te-IN': 'కలిగి ఉన్నది',
    'th-TH': 'ประกอบด้วย',
    'tr-TR': 'İçeriği:',
    'vi-VN': 'Chứa',
    'zh-CN': '包含',
    'zh-TW': '包含',
  },
  'ag-notContains': {
    'en-US': 'Not contains',
    'ar-AE': 'لا يحتوي على',
    'bn-IN': 'উপস্থিত নেই',
    'de-DE': 'Enthält nicht',
    'es-ES': 'No contiene',
    'es-MX': 'No contiene',
    'fr-BE': 'Ne contient pas',
    'fr-CA': 'Ne contient pas',
    'fr-FR': 'Ne contient pas',
    'gu-IN': 'સમાવેશ નથી',
    'hi-IN': 'इसमें शामिल नहीं है',
    'it-IT': 'Non contiene',
    'ja-JP': '含まれない',
    'kn-IN': 'ಒಳಗೊಂಡಿಲ್ಲ',
    'ko-KR': '다음 미포함',
    'ml-IN': 'അടങ്ങിയിരിക്കുന്നില്ല',
    'mr-IN': 'हे समाविष्ट नाही',
    'nl-BE': 'Bevat niet',
    'nl-NL': 'Bevat niet',
    'pl-PL': 'Nie zawiera',
    'pt-BR': 'Não contém',
    'pt-PT': 'Não contém',
    'sv-SE': 'Innehåller inte',
    'ta-IN': 'இவை இல்லை',
    'te-IN': 'కలిగి ఉండనివి',
    'th-TH': 'ไม่มี',
    'tr-TR': 'Şunu içermez:',
    'vi-VN': 'Không chứa',
    'zh-CN': '不包含',
    'zh-TW': '不包含',
  },
  'ag-startsWith': {
    'en-US': 'Starts with',
    'ar-AE': 'يبدأ بـ',
    'bn-IN': 'এর সাথে আরম্ভ হয়',
    'de-DE': 'Beginnt mit',
    'es-ES': 'Empieza por',
    'es-MX': 'Comienza por',
    'fr-BE': 'Commence par',
    'fr-CA': 'Commence par',
    'fr-FR': 'Commence par',
    'gu-IN': 'આ સાથે શરૂ થાય છે',
    'hi-IN': 'इसे शुरू होता है',
    'it-IT': 'Inizia con',
    'ja-JP': '次の語句で始まる',
    'kn-IN': 'ಇದರೊಂದಿಗೆ ಪ್ರಾರಂಭವಾಗುತ್ತದೆ',
    'ko-KR': '시작',
    'ml-IN': 'ഇതിൽ തുടങ്ങുന്നു',
    'mr-IN': 'यासह सुरू होते',
    'nl-BE': 'Begint met',
    'nl-NL': 'Begint met',
    'pl-PL': 'Zaczyna się od',
    'pt-BR': 'Começa com',
    'pt-PT': 'Começa com',
    'sv-SE': 'Börjar med',
    'ta-IN': 'இதோடு தொடங்குகிறது',
    'te-IN': 'దీనితో ప్రారంభమయ్యేది',
    'th-TH': 'เริ่มต้นด้วย',
    'tr-TR': 'Şunla başlar:',
    'vi-VN': 'Bắt đầu bằng',
    'zh-CN': '开头为',
    'zh-TW': '開始於',
  },
  'ag-endsWith': {
    'en-US': 'Ends with',
    'ar-AE': 'ينتهي بـ',
    'bn-IN': 'এর সাথে শেষ হয়',
    'de-DE': 'Endet auf',
    'es-ES': 'Finaliza con',
    'es-MX': 'Termina con',
    'fr-BE': 'Se termine par',
    'fr-CA': 'Se termine par',
    'fr-FR': 'Se termine par',
    'gu-IN': 'સાથે સમાપ્ત થાય છે',
    'hi-IN': 'इससे खत्म होता है',
    'it-IT': 'Termina con',
    'ja-JP': '次の語句で終わる',
    'kn-IN': 'ಇದರೊಂದಿಗೆ ಕೊನೆಗೊಳ್ಳುತ್ತದೆ',
    'ko-KR': '종료',
    'ml-IN': 'ഇതിൽ അവസാനിക്കുന്നു',
    'mr-IN': 'यासह संपते',
    'nl-BE': 'Eindigt op',
    'nl-NL': 'Eindigt op',
    'pl-PL': 'Kończy się na',
    'pt-BR': 'Termina em',
    'pt-PT': 'Termina com',
    'sv-SE': 'Slutar med',
    'ta-IN': 'இதோடு முடிவடைகிறது',
    'te-IN': 'దీనితో ముగిసేది',
    'th-TH': 'ลงท้ายด้วย',
    'tr-TR': 'Bitiş:',
    'vi-VN': 'Kết thúc bằng',
    'zh-CN': '末尾为',
    'zh-TW': '結束於',
  },
  'ag-dateFormatOoo': {
    'en-US': 'yyyy-mm-dd',
    'ar-AE': 'يوم-شهر-سنة',
    'de-DE': 'JJJJ-MM-TT',
    'es-ES': 'aaaa-mm-dd',
    'es-MX': 'aaaa-mm-dd',
    'fr-BE': 'aaaa-mm-jj',
    'fr-CA': 'aaaa–mm–jj',
    'fr-FR': 'aaaa-mm-jj',
    'it-IT': 'aaaa-mm-gg',
    'nl-BE': 'dd-mm-jjjj',
    'nl-NL': 'jjjj-mm-dd',
    'pl-PL': 'rrrr-mm-dd',
    'pt-BR': 'dd-mm-aaaa',
    'pt-PT': 'aaaa-mm-dd',
    'sv-SE': 'ååååå-mm-dd',
    'th-TH': 'ปปปป-ดด-วว',
    'tr-TR': 'gg-aa-yyyy',
  },
  'ag-andCondition': {
    'en-US': 'AND',
    'ar-AE': 'و',
    'bn-IN': 'এবং',
    'de-DE': 'UND',
    'es-ES': 'Y',
    'es-MX': 'Y',
    'fr-BE': 'ET',
    'fr-CA': 'ET',
    'fr-FR': 'ET',
    'gu-IN': 'અને',
    'hi-IN': 'और',
    'it-IT': 'E',
    'ja-JP': 'および',
    'kn-IN': 'ಮತ್ತು',
    'ko-KR': '및',
    'ml-IN': 'ഒപ്പം',
    'mr-IN': 'आणि',
    'nl-BE': 'EN',
    'nl-NL': 'EN',
    'pl-PL': 'ORAZ',
    'pt-BR': 'E',
    'pt-PT': 'E',
    'sv-SE': 'OCH',
    'te-IN': 'మరియు',
    'th-TH': 'และ',
    'tr-TR': 've',
    'vi-VN': 'VÀ',
    'zh-CN': '与',
    'zh-TW': '以及',
  },
  'ag-orCondition': {
    'en-US': 'OR',
    'ar-AE': 'أو',
    'bn-IN': 'অথবা',
    'de-DE': 'ODER',
    'es-ES': 'O',
    'es-MX': 'O bien:',
    'fr-BE': 'OU',
    'fr-CA': 'OU',
    'fr-FR': 'OU',
    'gu-IN': 'અથવા',
    'hi-IN': 'या',
    'it-IT': 'OPPURE',
    'ja-JP': 'または',
    'kn-IN': 'ಅಥವಾ',
    'ko-KR': '또는',
    'ml-IN': 'അല്ലെങ്കിൽ',
    'mr-IN': 'किंवा',
    'nl-BE': 'OF',
    'nl-NL': 'OF',
    'pl-PL': 'LUB',
    'pt-BR': 'OU',
    'pt-PT': 'OU',
    'sv-SE': 'ELLER',
    'ta-IN': 'அல்லது',
    'te-IN': 'లేదా',
    'th-TH': 'หรือ',
    'tr-TR': 'VEYA',
    'vi-VN': 'HOẶC',
    'zh-CN': '或者',
    'zh-TW': '或者',
  },
  'ag-applyFilter': {
    'en-US': 'Apply',
    'ar-AE': 'تطبيق',
    'bn-IN': 'প্রয়োগ করুন',
    'de-DE': 'Anwenden',
    'es-ES': 'Aplicar',
    'es-MX': 'Aplicar',
    'fr-BE': 'Appliquer',
    'fr-CA': 'Appliquer',
    'fr-FR': 'Appliquer',
    'gu-IN': 'લાગુ કરો',
    'hi-IN': 'लागू करें',
    'it-IT': 'Applica',
    'ja-JP': '適用',
    'kn-IN': 'ಅನ್ವಯಿಸಿ',
    'ko-KR': '적용',
    'ml-IN': 'ബാധകമാക്കുക',
    'mr-IN': 'लागू करा',
    'nl-BE': 'Toepassen',
    'nl-NL': 'Toepassen',
    'pl-PL': 'Zastosuj',
    'pt-BR': 'Aplicar',
    'pt-PT': 'Aplicar',
    'sv-SE': 'Tillämpa',
    'ta-IN': 'பயன்படுத்து',
    'te-IN': 'వర్తింపజేయండి',
    'th-TH': 'ปรับใช้',
    'tr-TR': 'Uygula',
    'vi-VN': 'Áp dụng',
    'zh-CN': '应用',
    'zh-TW': '套用',
  },
  'ag-resetFilter': {
    'en-US': 'Reset',
    'ar-AE': 'إعادة التعيين',
    'bn-IN': 'রিসেট করুন',
    'de-DE': 'Zurücksetzen',
    'es-ES': 'Restablecer',
    'es-MX': 'Restablecer',
    'fr-BE': 'Réinitialiser',
    'fr-CA': 'Réinitialiser',
    'fr-FR': 'Réinitialiser',
    'gu-IN': 'રીસેટ કરો',
    'hi-IN': 'रीसेट करें',
    'it-IT': 'Ripristina',
    'ja-JP': 'リセット',
    'kn-IN': 'ರಿಸೆಟ್ ಮಾಡಿ',
    'ko-KR': '재설정',
    'ml-IN': 'പുനഃസജ്ജമാക്കുക',
    'mr-IN': 'रीसेट करा',
    'nl-BE': 'Opnieuw instellen',
    'nl-NL': 'Opnieuw instellen',
    'pl-PL': 'Zresetuj',
    'pt-BR': 'Redefinir',
    'pt-PT': 'Repor',
    'sv-SE': 'Återställ',
    'ta-IN': 'மீட்டமை',
    'te-IN': 'రీసెట్ చేయండి',
    'th-TH': 'รีเซ็ต',
    'tr-TR': 'Sıfırla',
    'vi-VN': 'Đặt lại',
    'zh-CN': '重置',
    'zh-TW': '重設',
  },
  'ag-clearFilter': {
    'en-US': 'Clear',
    'ar-AE': 'مسح',
    'bn-IN': 'মুছে ফেলুন',
    'de-DE': 'Löschen',
    'es-ES': 'Borrar',
    'es-MX': 'Borrar',
    'fr-BE': 'Effacer',
    'fr-CA': 'Effacer',
    'fr-FR': 'Transparente',
    'gu-IN': 'સાફ કરો',
    'hi-IN': 'हटाएं',
    'it-IT': 'Cancella',
    'ja-JP': '取り消す',
    'kn-IN': 'ಕ್ಲಿಯರ್ ಮಾಡಿ',
    'ko-KR': '지우기',
    'ml-IN': 'മായ്ക്കുക',
    'mr-IN': 'साफ करा',
    'nl-BE': 'Wissen',
    'nl-NL': 'Wissen',
    'pl-PL': 'Wyczyść',
    'pt-BR': 'Limpar',
    'pt-PT': 'Limpar',
    'sv-SE': 'Rensa',
    'ta-IN': 'அழி',
    'te-IN': 'క్లియర్ చేయండి',
    'th-TH': 'ล้าง',
    'tr-TR': 'Temizle',
    'vi-VN': 'Rõ ràng',
    'zh-CN': '清除',
    'zh-TW': '清除',
  },
  'ag-cancelFilter': {
    'en-US': 'Cancel',
    'ar-AE': 'إلغاء',
    'bn-IN': 'বাতিল',
    'de-DE': 'Abbrechen',
    'es-ES': 'Cancelar',
    'es-MX': 'Cancelar',
    'fr-BE': 'Annuler',
    'fr-CA': 'Annuler',
    'fr-FR': 'Annuler',
    'gu-IN': 'કેન્સલ કરો',
    'hi-IN': 'कैंसल करें',
    'it-IT': 'Annulla',
    'ja-JP': 'キャンセル',
    'kn-IN': 'ಕ್ಯಾನ್ಸಲ್ ಮಾಡಿ',
    'ko-KR': '취소',
    'ml-IN': 'റദ്ദാക്കുക',
    'mr-IN': 'रद्द करा',
    'nl-BE': 'Annuleren',
    'nl-NL': 'Annuleren',
    'pl-PL': 'Anuluj',
    'pt-BR': 'Cancelar',
    'pt-PT': 'Cancelar',
    'sv-SE': 'Avbryt',
    'ta-IN': 'கேன்சல் செய்யவும்',
    'te-IN': 'రద్దు చేయి',
    'th-TH': 'ยกเลิก',
    'tr-TR': 'İptal et',
    'vi-VN': 'Hủy',
    'zh-CN': '取消',
    'zh-TW': '取消',
  },
  'ag-textFilter': {
    'en-US': 'Text Filter',
    'ar-AE': 'عامل تصفية النص',
    'bn-IN': 'টেক্সট ফিল্টার',
    'de-DE': 'Textfilter',
    'en-AU': 'Text filter',
    'en-GB': 'Text filter',
    'en-ZA': 'Text filter',
    'es-ES': 'Filtro de texto',
    'es-MX': 'Filtro de texto',
    'fr-BE': 'Filtre de texte',
    'fr-CA': 'Filtre de texte',
    'fr-FR': 'Filtre de texte',
    'gu-IN': 'ટેક્સ્ટ ફિલ્ટર',
    'hi-IN': 'टेक्स्ट फ़िल्टर',
    'it-IT': 'Filtro testo',
    'ja-JP': 'テキストフィルタ',
    'kn-IN': 'ಪಠ್ಯ ಫಿಲ್ಟರ್',
    'ko-KR': '텍스트 필터',
    'ml-IN': 'ടെക്സ്റ്റ് ഫിൽട്ടർ',
    'mr-IN': 'टेक्स्ट फिल्टर',
    'nl-BE': 'Tekstfilter',
    'nl-NL': 'Tekstfilter',
    'pl-PL': 'Filtr tekstu',
    'pt-BR': 'Filtro de texto',
    'pt-PT': 'Filtro de texto',
    'sv-SE': 'Textfilter',
    'ta-IN': 'உரை ஃபில்டர்',
    'te-IN': 'టెక్స్ట్ ఫిల్టర్',
    'th-TH': 'ตัวกรองข้อความ',
    'tr-TR': 'Metin filtresi',
    'vi-VN': 'Bộ lọc văn bản',
    'zh-CN': '文本筛选条件',
    'zh-TW': '文字篩選條件',
  },
  'ag-numberFilter': {
    'en-US': 'Number Filter',
    'ar-AE': 'عامل تصفية الأرقام',
    'bn-IN': 'সংখ্যার ফিল্টার',
    'de-DE': 'Zahlenfilter',
    'en-AU': 'Number filter',
    'en-GB': 'Number filter',
    'en-ZA': 'Number filter',
    'es-ES': 'Filtro numérico',
    'es-MX': 'Filtro numérico',
    'fr-BE': 'Filtre numérique',
    'fr-CA': 'Filtre de nombre',
    'fr-FR': 'Filtre numérique',
    'gu-IN': 'ફિલ્ટર સંખ્યા',
    'hi-IN': 'नंबर फ़िल्टर',
    'it-IT': 'Filtro numeri',
    'ja-JP': '数値フィルタ',
    'kn-IN': 'ಸಂಖ್ಯೆ ಫಿಲ್ಟರ್',
    'ko-KR': '숫자 필터',
    'ml-IN': 'നമ്പർ ഫിൽട്ടർ',
    'mr-IN': 'नंबर फिल्टर',
    'nl-BE': 'Nummerfilter',
    'nl-NL': 'Nummerfilter',
    'pl-PL': 'Filtr liczby',
    'pt-BR': 'Filtro de números',
    'pt-PT': 'Filtro do número',
    'sv-SE': 'Nummerfilter',
    'ta-IN': 'நம்பர் ஃபில்ட்டர்',
    'te-IN': 'సంఖ్య ఫిల్టర్',
    'th-TH': 'ตัวกรองตัวเลข',
    'tr-TR': 'Sayı filtresi',
    'vi-VN': 'Lọc số',
    'zh-CN': '数字筛选条件',
    'zh-TW': '數字篩選條件',
  },
  'ag-dateFilter': {
    'en-US': 'Date Filter',
    'ar-AE': 'عامل تصفية التاريخ',
    'bn-IN': 'তারিখের ফিল্টার',
    'de-DE': 'Datumsfilter',
    'en-AU': 'Date filter',
    'en-GB': 'Date filter',
    'en-ZA': 'Date filter',
    'es-ES': 'Filtro de fecha',
    'es-MX': 'Filtro de fecha',
    'fr-BE': 'Filtre de date',
    'fr-CA': 'Filtre de date',
    'fr-FR': 'Filtre de date',
    'gu-IN': 'તારીખ ફિલ્ટર કરો',
    'hi-IN': 'तारीख का फ़िल्टर',
    'it-IT': 'Filtro data',
    'ja-JP': '日付フィルタ',
    'kn-IN': 'ದಿನಾಂಕ ಫಿಲ್ಟರ್',
    'ko-KR': '날짜 필터',
    'ml-IN': 'തീയതി ഫിൽട്ടർ',
    'mr-IN': 'तारीख फिल्टर',
    'nl-BE': 'Datumfilter',
    'nl-NL': 'Datumfilter',
    'pl-PL': 'Filtr daty',
    'pt-BR': 'Filtro de data',
    'pt-PT': 'Filtro de data',
    'sv-SE': 'Datumfilter',
    'ta-IN': 'தேதி வடிகட்டி',
    'te-IN': 'తేదీ ఫిల్టర్',
    'th-TH': 'ตัวกรองวันที่',
    'tr-TR': 'Tarih filtresi',
    'vi-VN': 'Bộ lọc ngày',
    'zh-CN': '日期筛选条件',
    'zh-TW': '日期篩選條件',
  },
  'ag-setFilter': {
    'en-US': 'Set Filter',
    'ar-AE': 'تعيين عامل التصفية',
    'bn-IN': 'ফিল্টার সেট করুন',
    'de-DE': 'Filter festlegen',
    'en-AU': 'Set filter',
    'en-GB': 'Set filter',
    'en-ZA': 'Set filter',
    'es-ES': 'Establecer filtro',
    'es-MX': 'Establecer filtro',
    'fr-BE': 'Définir le filtre',
    'fr-CA': 'Définir le filtre',
    'fr-FR': 'Définir le filtre',
    'gu-IN': 'ફિલ્ટર સેટ કરો',
    'hi-IN': 'फ़िल्टर सेट करें',
    'it-IT': 'Imposta filtro',
    'ja-JP': 'フィルターを設定',
    'kn-IN': 'ಫಿಲ್ಟರ್ ಸೆಟ್',
    'ko-KR': '필터 설정',
    'ml-IN': 'ഫിൽട്ടർ സജ്ജമാക്കുക',
    'mr-IN': 'फिल्टर सेट करा',
    'nl-BE': 'Filter instellen',
    'nl-NL': 'Filter instellen',
    'pl-PL': 'Ustaw filtr',
    'pt-BR': 'Definir filtro',
    'pt-PT': 'Definir filtro',
    'sv-SE': 'Ange filter',
    'ta-IN': 'வடிகட்டியை அமைக்கவும்',
    'te-IN': 'ఫిల్టర్‌ను సెట్ చేయండి',
    'th-TH': 'ตั้งค่าตัวกรอง',
    'tr-TR': 'Filtreyi ayarla',
    'vi-VN': 'Đặt bộ lọc',
    'zh-CN': '设置筛选条件',
    'zh-TW': '設定篩選條件',
  },
  'ag-columns': {
    'en-US': 'Columns',
    'ar-AE': 'الأعمدة',
    'bn-IN': 'কলাম',
    'de-DE': 'Spalten',
    'es-ES': 'Columnas',
    'es-MX': 'Columnas',
    'fr-BE': 'Colonnes',
    'fr-CA': 'Colonnes',
    'fr-FR': 'Colonnes',
    'gu-IN': 'કોલમ',
    'hi-IN': 'कॉलम',
    'it-IT': 'Colonne',
    'ja-JP': '列',
    'kn-IN': 'ಕಾಲಮ್‌ಗಳು',
    'ko-KR': '열',
    'ml-IN': 'കോളങ്ങൾ',
    'mr-IN': 'स्तंभ',
    'nl-BE': 'Kolommen',
    'nl-NL': 'Kolommen',
    'pl-PL': 'Kolumny',
    'pt-BR': 'Colunas',
    'pt-PT': 'Colunas',
    'sv-SE': 'Kolumner',
    'ta-IN': 'நெடுவரிசைகள்',
    'te-IN': 'నిలువు వరుసలు',
    'th-TH': 'คอลัมน์',
    'tr-TR': 'Sütunlar',
    'vi-VN': 'Cột',
    'zh-CN': '列',
    'zh-TW': '資料欄',
  },
  'ag-filters': {
    'en-US': 'Filters',
    'ar-AE': 'عوامل التصفية',
    'bn-IN': 'ফিল্টার',
    'de-DE': 'Filter',
    'es-ES': 'Filtros',
    'es-MX': 'Filtros',
    'fr-BE': 'Filtres',
    'fr-CA': 'Filtres',
    'fr-FR': 'Filtres',
    'gu-IN': 'ફિલ્ટર્સ',
    'hi-IN': 'फ़िल्टर',
    'it-IT': 'Filtri',
    'ja-JP': 'フィルター',
    'kn-IN': 'ಫಿಲ್ಟರ್‌ಗಳು',
    'ko-KR': '필터',
    'ml-IN': 'ഫിൽട്ടറുകൾ',
    'mr-IN': 'फिल्टर्स',
    'pl-PL': 'Filtry',
    'pt-BR': 'Filtros',
    'pt-PT': 'Filtros',
    'sv-SE': 'Filter',
    'ta-IN': 'வடிகட்டிகள்',
    'te-IN': 'ఫిల్టర్‌లు',
    'th-TH': 'ตัวกรอง',
    'tr-TR': 'Filtreler',
    'vi-VN': 'Bộ lọc',
    'zh-CN': '筛选条件',
    'zh-TW': '篩選條件',
  },
  'ag-pivotMode': {
    'en-US': 'Pivot Mode',
    'ar-AE': 'الوضع المحوري',
    'bn-IN': 'পিভট মোড',
    'de-DE': 'Pivot-Modus',
    'en-AU': 'Pivot mode',
    'en-GB': 'Pivot mode',
    'es-ES': 'Modo dinámico',
    'es-MX': 'Modo dinámico',
    'fr-BE': 'Mode croisé dynamique',
    'fr-CA': 'Mode pivot',
    'fr-FR': 'Mode croisé dynamique',
    'gu-IN': 'પિવોટ મોડ',
    'hi-IN': 'पिवट मोड',
    'it-IT': 'Modalità pivot',
    'ja-JP': 'ピボットモード',
    'kn-IN': 'ಪಿವೋಟ್ ಮೋಡ್',
    'ko-KR': '피벗 모드',
    'ml-IN': 'പിവറ്റ് മോഡ്',
    'mr-IN': 'पायव्होट मोड',
    'nl-BE': 'Draaimodus',
    'nl-NL': 'Draaimodus',
    'pl-PL': 'Tryb przestawny',
    'pt-BR': 'Modo de tabela dinâmica',
    'pt-PT': 'Modo dinâmico',
    'sv-SE': 'Pivotläge',
    'ta-IN': 'பிவோட் பயன்முறை',
    'te-IN': 'పివోట్ మోడ్',
    'th-TH': 'โหมด Pivot',
    'tr-TR': 'Pivot modu',
    'vi-VN': 'Chế độ Pivot',
    'zh-CN': '透视模式',
    'zh-TW': '樞紐模式',
  },
  'ag-groups': {
    'en-US': 'Row Groups',
    'ar-AE': 'مجموعات الصف',
    'bn-IN': 'সারির গ্রুপ',
    'de-DE': 'Zeilengruppen',
    'en-AU': 'Row groups',
    'en-GB': 'Row groups',
    'en-ZA': 'Row groups',
    'es-ES': 'Grupos de fila',
    'es-MX': 'Grupos de filas',
    'fr-BE': 'Groupes de lignes',
    'fr-CA': 'Groupes de rangées',
    'fr-FR': 'Groupes de lignes',
    'gu-IN': 'પંક્તિ ગ્રૂપ',
    'hi-IN': 'पंक्ति के ग्रुप',
    'it-IT': 'Gruppi di riga',
    'ja-JP': '行グループ',
    'kn-IN': 'ಸಾಲು ಗುಂಪುಗಳು',
    'ko-KR': '행 그룹',
    'ml-IN': 'റോ ഗ്രൂപ്പുകൾ',
    'mr-IN': 'ओळींचे ग्रुप',
    'nl-BE': 'Rijgroepen',
    'nl-NL': 'Rijgroepen',
    'pl-PL': 'Grupy wierszy',
    'pt-BR': 'Grupos de linhas',
    'pt-PT': 'Grupos de linhas',
    'sv-SE': 'Radgrupper',
    'ta-IN': 'வரிசை குரூப்கள்',
    'te-IN': 'అడ్డు వరుస గ్రూప్‌లు',
    'th-TH': 'กลุ่มแถว',
    'tr-TR': 'Satır grupları',
    'vi-VN': 'Nhóm hàng',
    'zh-CN': '行组',
    'zh-TW': '列群組',
  },
  'ag-rowGroupColumnsEmptyMessage': {
    'en-US': 'Drag here to set row groups',
    'ar-AE': 'اسحب هنا لتعيين مجموعات الصفوف',
    'bn-IN': 'সারির গ্রুপ নির্ধারণ করতে এখানে টেনে আনুন',
    'de-DE': 'Zum Festlegen von Zeilengruppen hierher ziehen',
    'es-ES': 'Arrastra aquí para establecer grupos de filas',
    'es-MX': 'Arrastra aquí para configurar grupos de filas',
    'fr-BE': 'Faire glisser ici pour définir des groupes de lignes',
    'fr-CA': 'Faites glisser ici pour définir les groupes de rangées',
    'fr-FR': 'Faire glisser ici pour définir des groupes de lignes',
    'gu-IN': 'પંક્તિ ગ્રૂપ સુયોજિત કરવા માટે અહીં ખેંચો',
    'hi-IN': 'पंक्ति के ग्रुप सेट करने के लिए यहां ड्रैग करें',
    'it-IT': 'Trascina qui per impostare i gruppi di riga',
    'ja-JP': 'ここにドラッグして行グループを設定',
    'kn-IN': 'ಸಾಲು ಗುಂಪುಗಳನ್ನು ಹೊಂದಿಸಲು ಇಲ್ಲಿ ಎಳೆಯಿರಿ',
    'ko-KR': '행 그룹을 설정하려면 여기로 드래그',
    'ml-IN': 'റോ ഗ്രൂപ്പുകൾ സജ്ജമാക്കാൻ ഇവിടെ വലിച്ചിടുക',
    'mr-IN': 'ओळींचे ग्रुप सेट करण्यासाठी येथे ड्रॅग करा',
    'nl-BE': 'Sleep hier om rijgroepen in te stellen',
    'nl-NL': 'Sleep naar hier om rijgroepen in te stellen',
    'pl-PL': 'Przeciągnij tutaj, aby ustawić grupy wierszy',
    'pt-BR': 'Arraste aqui para definir grupos de linhas',
    'pt-PT': 'Arraste para aqui para definir grupos de linhas',
    'sv-SE': 'Dra hit för att ange radgrupper',
    'ta-IN': 'வரிசைக் குழுக்களை அமைக்க இங்கே இழுக்கவும்',
    'te-IN': 'అడ్డు వరుస గ్రూప్‌లను సెట్ చేయడానికి ఇక్కడికి లాగండి',
    'th-TH': 'ลากมาที่นี่เพื่อตั้งค่ากลุ่มแถว',
    'tr-TR': 'Satır gruplarını ayarlamak için buraya sürükleyin',
    'vi-VN': 'Kéo vào đây để đặt nhóm hàng',
    'zh-CN': '拖至此处设置行组',
    'zh-TW': '拖曳至此處以設定列群組',
  },
  'ag-values': {
    'en-US': 'Values',
    'ar-AE': 'القيم',
    'bn-IN': 'মান',
    'de-DE': 'Werte',
    'es-ES': 'Valores',
    'es-MX': 'Valores',
    'fr-BE': 'Valeurs',
    'fr-CA': 'Valeurs',
    'fr-FR': 'Valeurs',
    'gu-IN': 'મૂલ્યો',
    'hi-IN': 'वैल्यू',
    'it-IT': 'Valori',
    'ja-JP': '値',
    'kn-IN': 'ಮೌಲ್ಯಗಳು',
    'ko-KR': '값',
    'ml-IN': 'മൂല്യങ്ങൾ',
    'mr-IN': 'व्हॅल्यू',
    'nl-BE': 'Waarden',
    'nl-NL': 'Waarden',
    'pl-PL': 'Wartości',
    'pt-BR': 'Valores',
    'pt-PT': 'Valores',
    'sv-SE': 'Värden',
    'ta-IN': 'வேல்யூக்கள்',
    'te-IN': 'విలువలు',
    'th-TH': 'ค่า',
    'tr-TR': 'Değerler',
    'vi-VN': 'Giá trị',
    'zh-CN': '值',
    'zh-TW': '值',
  },
  'ag-valueColumnsEmptyMessage': {
    'en-US': 'Drag here to aggregate',
    'ar-AE': 'اسحب هنا للتجميع',
    'bn-IN': 'একত্র করতে এখানে টেনে আনুন',
    'de-DE': 'Zum Aggregieren hierher ziehen',
    'es-ES': 'Arrastra aquí para añadir',
    'es-MX': 'Arrastra aquí para agregar',
    'fr-BE': 'Faire glisser ici pour grouper',
    'fr-CA': 'Faites glisser ici pour regrouper',
    'fr-FR': 'Faire glisser ici pour regrouper',
    'gu-IN': 'એકંદર માટે અહીં ખેંચો',
    'hi-IN': 'कुल करने के लिए यहां ड्रैग करें',
    'it-IT': 'Trascina qui per aggregare',
    'ja-JP': 'ここにドラッグして集約',
    'kn-IN': 'ಒಟ್ಟುಗೂಡಿಸಲು ಇಲ್ಲಿ ಎಳೆಯಿರಿ',
    'ko-KR': '집계하려면 여기로 드래그',
    'ml-IN': 'സമാഹരിക്കാൻ ഇവിടെ വലിച്ചിടുക',
    'mr-IN': 'बेरीज करण्यासाठी येथे ड्रॅग करा',
    'nl-BE': 'Sleep hier om samen te voegen',
    'nl-NL': 'Sleep naar hier om samen te voegen',
    'pl-PL': 'Przeciągnij tutaj, aby zagregować',
    'pt-BR': 'Arraste aqui para agregar',
    'pt-PT': 'Arraste aqui para agregar',
    'sv-SE': 'Dra hit för att sammanställa',
    'ta-IN': 'ஒருங்கிணைக்க இங்கே இழுக்கவும்',
    'te-IN': 'సమగ్రపరచడానికి ఇక్కడికి లాగండి',
    'th-TH': 'ลากมาที่นี่เพื่อรวม',
    'tr-TR': 'Toplamak için buraya sürükleyin',
    'vi-VN': 'Kéo vào đây để tổng hợp',
    'zh-CN': '拖至此处进行汇总',
    'zh-TW': '拖曳至此處以彙總',
  },
  'ag-pivots': {
    'en-US': 'Column Labels',
    'ar-AE': 'ملصقات الأعمدة',
    'bn-IN': 'কলামের লেবেল',
    'de-DE': 'Spaltenbezeichnungen',
    'en-AU': 'Column labels',
    'en-GB': 'Column labels',
    'en-ZA': 'Column labels',
    'es-ES': 'Etiquetas de columna',
    'es-MX': 'Etiquetas de columnas',
    'fr-BE': 'Étiquettes de colonne',
    'fr-CA': 'Étiquettes de colonne',
    'fr-FR': 'Étiquettes de colonne',
    'gu-IN': 'કોલમ લેબલ્સ',
    'hi-IN': 'कॉलम लेबल',
    'it-IT': 'Etichette colonne',
    'ja-JP': '列ラベル',
    'kn-IN': 'ಕಾಲಂ ಲೇಬಲ್‌ಗಳು',
    'ko-KR': '열 라벨',
    'ml-IN': 'കോളം ലേബലുകൾ',
    'mr-IN': 'स्तंभ लेबल',
    'nl-BE': 'Kolometiketten',
    'nl-NL': 'Kolomlabels',
    'pl-PL': 'Etykiety kolumn',
    'pt-BR': 'Etiquetas de coluna',
    'pt-PT': 'Etiquetas de coluna',
    'sv-SE': 'Kolumnetiketter',
    'ta-IN': 'நெடுவரிசை லேபிள்கள்',
    'te-IN': 'కాలమ్ లేబుల్‌లు',
    'th-TH': 'ฉลากคอลัมน์',
    'tr-TR': 'Sütun etiketleri',
    'vi-VN': 'Nhãn cột',
    'zh-CN': '列标签',
    'zh-TW': '資料欄標籤',
  },
  'ag-pivotColumnsEmptyMessage': {
    'en-US': 'Drag here to set column labels',
    'ar-AE': 'اسحب هنا لتعيين ملصقات الأعمدة',
    'bn-IN': 'কলাম লেবেল নির্ধারণ করতে এখানে টেনে আনুন',
    'de-DE': 'Zum Festlegen der Spaltenbezeichnungen hierher ziehen',
    'es-ES': 'Arrastra aquí para establecer las etiquetas de columna',
    'es-MX': 'Arrastra aquí para configurar las etiquetas de columnas',
    'fr-BE': 'Faire glisser ici pour définir les étiquettes des colonnes',
    'fr-CA': 'Faites glisser ici pour définir les étiquettes des colonnes',
    'fr-FR': 'Faire glisser ici pour définir les étiquettes des colonnes',
    'gu-IN': 'કોલમ લેબલ્સ સેટ કરવા માટે અહીં ખેંચો',
    'hi-IN': 'कॉलम लेबल सेट करने के लिए यहां ड्रैग करें',
    'it-IT': 'Trascina qui per impostare le etichette delle colonne',
    'ja-JP': 'ここにドラッグして列のラベルを設定',
    'kn-IN': 'ಕಾಲಮ್ ಲೇಬಲ್‌ಗಳನ್ನು ಹೊಂದಿಸಲು ಇಲ್ಲಿ ಎಳೆಯಿರಿ',
    'ko-KR': '열 라벨을 설정하려면 여기로 드래그',
    'ml-IN': 'കോളം ലേബലുകൾ സജ്ജീകരിക്കാൻ ഇവിടെ വലിച്ചിടുക',
    'mr-IN': 'स्तंभ लेबल सेट करण्यासाठी येथे ड्रॅग करा',
    'nl-BE': 'Sleep hierheen om kolometiketten in te stellen',
    'nl-NL': 'Sleep hier om kolomlabels in te stellen',
    'pl-PL': 'Przeciągnij tutaj, aby ustawić etykiety kolumn',
    'pt-BR': 'Arraste aqui para definir etiquetas de coluna',
    'pt-PT': 'Arraste para aqui para definir etiquetas de coluna',
    'sv-SE': 'Dra hit för att ange kolumnetiketter',
    'ta-IN': 'நெடுவரிசை லேபிள்களை அமைக்க இங்கே இழுக்கவும்',
    'te-IN': 'ఇక్కడికి లాగడం ద్వారా కాలమ్ లేబుల్‌లను సెట్ చేయండి',
    'th-TH': 'ลากมาที่นี่เพื่อตั้งค่าฉลากคอลัมน์',
    'tr-TR': 'Sütun etiketlerini ayarlamak için buraya sürükleyin',
    'vi-VN': 'Kéo vào đây để đặt nhãn cột',
    'zh-CN': '拖至此处设置列标签',
    'zh-TW': '拖曳至此處以設定資料欄標籤',
  },
  'ag-group': {
    'en-US': 'Group',
    'ar-AE': 'المجموعة',
    'bn-IN': 'গ্রুপ',
    'de-DE': 'Gruppe',
    'es-ES': 'Grupo',
    'es-MX': 'Grupo',
    'fr-BE': 'Grouper',
    'fr-CA': 'Grouper',
    'fr-FR': 'Groupe',
    'gu-IN': 'ગ્રૂપ',
    'hi-IN': 'ग्रुप',
    'it-IT': 'Gruppo',
    'ja-JP': 'グループ',
    'kn-IN': 'ಗುಂಪು',
    'ko-KR': '그룹',
    'ml-IN': 'ഗ്രൂപ്പ്',
    'mr-IN': 'ग्रुप',
    'nl-BE': 'Groep',
    'nl-NL': 'Groep',
    'pl-PL': 'Grupa',
    'pt-BR': 'Grupo',
    'pt-PT': 'Agrupar',
    'sv-SE': 'Grupp',
    'ta-IN': 'குரூப்',
    'te-IN': 'గ్రూప్',
    'th-TH': 'กลุ่ม',
    'tr-TR': 'Grup',
    'vi-VN': 'Nhóm',
    'zh-CN': '组',
    'zh-TW': '群組',
  },
  'ag-rowDragRows': {
    'en-US': 'rows',
    'ar-AE': 'الصفوف',
    'bn-IN': 'সারি',
    'de-DE': 'Zeilen',
    'es-ES': 'filas',
    'es-MX': 'filas',
    'fr-BE': 'lignes',
    'fr-CA': 'rangées',
    'fr-FR': 'lignes',
    'gu-IN': 'પંક્તિઓ',
    'hi-IN': 'पंक्तियां',
    'it-IT': 'righe',
    'ja-JP': '行',
    'kn-IN': 'ಸಾಲುಗಳು',
    'ko-KR': '행',
    'ml-IN': 'റോകൾ',
    'mr-IN': 'ओळी',
    'nl-BE': 'rijen',
    'nl-NL': 'rijen',
    'pl-PL': 'wiersze',
    'pt-BR': 'linhas',
    'pt-PT': 'linhas',
    'sv-SE': 'rader',
    'ta-IN': 'வரிசைகள்',
    'te-IN': 'అడ్డు వరుసలు',
    'th-TH': 'แถว',
    'tr-TR': 'satırlar',
    'vi-VN': 'hàng',
    'zh-CN': '行',
    'zh-TW': '列',
  },
  'ag-loadingOoo': {
    'en-US': 'Loading...',
    'ar-AE': 'جارٍ التحميل...',
    'bn-IN': 'লোড করা হচ্ছে...',
    'de-DE': 'Wird geladen...',
    'en-GB': 'Loading…',
    'es-ES': 'Cargando...',
    'es-MX': 'Cargando…',
    'fr-BE': 'Chargement...',
    'fr-CA': 'Chargement en cours...',
    'fr-FR': 'Chargement...',
    'gu-IN': 'લોડ કરી રહ્યું છે...',
    'hi-IN': 'लोड हो रहा है...',
    'it-IT': 'Caricamento in corso...',
    'ja-JP': '読み込み中...',
    'kn-IN': 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    'ko-KR': '로드 중...',
    'ml-IN': 'ലോഡ് ചെയ്യുന്നു...',
    'mr-IN': 'लोड करत आहे...',
    'nl-BE': 'Bezig met laden...',
    'nl-NL': 'Laden...',
    'pl-PL': 'Wczytywanie...',
    'pt-BR': 'Carregando...',
    'pt-PT': 'A carregar...',
    'sv-SE': 'Läser in ...',
    'ta-IN': 'லோட் செய்யப்படுகிறது...',
    'te-IN': 'లోడ్ అవుతోంది...',
    'th-TH': 'กำลังโหลด...',
    'tr-TR': 'Yükleniyor...',
    'vi-VN': 'Đang tải...',
    'zh-CN': '正在加载……',
    'zh-TW': '正在載入...',
  },
  'ag-noRowsToShow': {
    'en-US': 'No Rows To Show',
    'ar-AE': 'لا توجد صفوف لإظهارها',
    'bn-IN': 'প্রদর্শন করার মত কোনও সারি নেই',
    'de-DE': 'Keine anzuzeigenden Zeilen',
    'en-AU': 'No rows to show',
    'en-GB': 'No rows to show',
    'en-ZA': 'No rows to show',
    'es-ES': 'No hay filas que mostrar',
    'es-MX': 'No hay filas que mostrar',
    'fr-BE': 'Aucune ligne à afficher',
    'fr-CA': 'Aucune ligne à afficher',
    'fr-FR': 'Aucune ligne à afficher',
    'gu-IN': 'બતાવવા માટે કોઈ પંક્તિઓ નથી',
    'hi-IN': 'दिखाने के लिए कोई पंक्ति नहीं',
    'it-IT': 'Nessuna riga da mostrare',
    'ja-JP': '表示する行がありません',
    'kn-IN': 'ತೋರಿಸಲು ಸಾಲುಗಳು ಇಲ್ಲ',
    'ko-KR': '표시할 행 없음',
    'ml-IN': 'കാണിക്കാൻ റോകളില്ല',
    'mr-IN': 'दाखवण्यासाठी ओळी नाहीत',
    'nl-BE': 'Geen rijen om weer te geven',
    'nl-NL': 'Geen rijen om weer te geven',
    'pl-PL': 'Brak wierszy do wyświetlenia',
    'pt-BR': 'Nenhuma linha para mostrar',
    'pt-PT': 'Sem linhas para apresentar',
    'sv-SE': 'Inga rader att visa',
    'ta-IN': 'காண்பிக்க வரிசைகள் எதுவும் இல்லை',
    'te-IN': 'చూపాల్సిన అడ్డు వరుసలు లేవు',
    'th-TH': 'ไม่มีแถวที่จะแสดง',
    'tr-TR': 'Gösterilecek satır yok',
    'vi-VN': 'Không có hàng để hiển thị',
    'zh-CN': '没有可显示的行',
    'zh-TW': '沒有可顯示的列',
  },
  'ag-enabled': {
    'en-US': 'Enabled',
    'ar-AE': 'تم التمكين',
    'bn-IN': 'চালু করা হয়েছে',
    'de-DE': 'Aktiviert',
    'es-ES': 'Activado',
    'es-MX': 'Activado',
    'fr-BE': 'Activé',
    'fr-CA': 'Activé',
    'fr-FR': 'Activé',
    'gu-IN': 'સક્ષમ કરેલું છે',
    'hi-IN': 'चालू किया गया',
    'it-IT': 'Abilitato',
    'ja-JP': '有効',
    'kn-IN': 'ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ',
    'ko-KR': '활성화됨',
    'ml-IN': 'പ്രവർത്തനക്ഷമമാക്കി',
    'mr-IN': 'सक्षम केले',
    'nl-BE': 'Ingeschakeld',
    'nl-NL': 'Ingeschakeld',
    'pl-PL': 'Włączone',
    'pt-BR': 'Ativado',
    'pt-PT': 'Ativado',
    'sv-SE': 'Aktiverad',
    'ta-IN': 'இயக்கப்பட்டது',
    'te-IN': 'ప్రారంభించబడింది',
    'th-TH': 'เปิดใช้งานแล้ว',
    'tr-TR': 'Etkin',
    'vi-VN': 'Đã bật',
    'zh-CN': '已启用',
    'zh-TW': '啟用',
  },
  'ag-pinColumn': {
    'en-US': 'Pin Column',
    'ar-AE': 'تثبيت العمود',
    'bn-IN': 'কলামটিকে পিন করুন',
    'de-DE': 'Spalte anheften',
    'en-AU': 'Pin column',
    'en-GB': 'Pin column',
    'en-ZA': 'Pin column',
    'es-ES': 'Fijar columna',
    'es-MX': 'Fijar columna',
    'fr-BE': 'Épingler la colonne',
    'fr-CA': 'Épingler la colonne',
    'fr-FR': 'Épingler la colonne',
    'gu-IN': 'કોલમને પિન કરો',
    'hi-IN': 'पिन कॉलम',
    'it-IT': 'PIN colonna',
    'ja-JP': '列をピン固定',
    'kn-IN': 'ಕಾಲಂ ಪಿನ್ ಮಾಡಿ',
    'ko-KR': '열 고정',
    'ml-IN': 'കോളം പിൻ ചെയ്യുക',
    'mr-IN': 'स्तंभ पिन करा',
    'nl-BE': 'Pinkolom',
    'nl-NL': 'Kolom vastzetten',
    'pl-PL': 'Przypnij kolumnę',
    'pt-BR': 'Fixar coluna',
    'pt-PT': 'Fixar coluna',
    'sv-SE': 'Nåla fast kolumn',
    'ta-IN': 'பின் நெடுவரிசை',
    'te-IN': 'పిన్ కాలమ్',
    'th-TH': 'ปักหมุดคอลัมน์',
    'tr-TR': 'Pin sütunu',
    'vi-VN': 'Ghim cột',
    'zh-CN': '固定柱状图',
    'zh-TW': '釘選資料欄',
  },
  'ag-pinLeft': {
    'en-US': 'Pin Left',
    'ar-AE': 'التثبيت في جهة اليسار',
    'bn-IN': 'বামে পিন করুন',
    'de-DE': 'Links anheften',
    'en-AU': 'Pin left',
    'en-GB': 'Pin left',
    'en-ZA': 'Pin left',
    'es-ES': 'Bloquear a la izquierda',
    'es-MX': 'Fijar a la izquierda',
    'fr-BE': 'Épingler à gauche',
    'fr-CA': 'Épingler à gauche',
    'fr-FR': 'Épingler à gauche',
    'gu-IN': 'પિન લેફ્ટ',
    'hi-IN': 'बाईं ओर पिन करें',
    'it-IT': 'PIN a sinistra',
    'ja-JP': '左をピン固定',
    'kn-IN': 'ಎಡಕ್ಕೆ ಪಿನ್ ಮಾಡಿ',
    'ko-KR': '왼쪽에 고정',
    'ml-IN': 'ഇടത്തേക്ക് പിൻ ചെയ്യുക',
    'mr-IN': 'डावीकडे पिन करा',
    'nl-BE': 'Pin links',
    'nl-NL': 'Links vastmaken',
    'pl-PL': 'Przypnij po lewej',
    'pt-BR': 'Fixar à esquerda',
    'pt-PT': 'Fixar à esquerda',
    'sv-SE': 'Nåla fast vänster',
    'ta-IN': 'மீதமுள்ள பின்',
    'te-IN': 'పిన్ ఎడమవైపు',
    'th-TH': 'ปักหมุดซ้าย',
    'tr-TR': 'Sol pin',
    'vi-VN': 'Ghim trái',
    'zh-CN': '固定在左侧',
    'zh-TW': '釘選於左側',
  },
  'ag-pinRight': {
    'en-US': 'Pin Right',
    'ar-AE': 'التثبيت في جهة اليمين',
    'bn-IN': 'ডানদিকে পিন করুন',
    'de-DE': 'Rechts anheften',
    'en-AU': 'Pin right',
    'en-GB': 'Pin right',
    'en-ZA': 'Pin right',
    'es-ES': 'Bloquear a la derecha',
    'es-MX': 'Fijar a la derecha',
    'fr-BE': 'Épingler à droite',
    'fr-CA': 'Épingler à droite',
    'fr-FR': 'Épingler à droite',
    'gu-IN': 'પિન રાઇટ',
    'hi-IN': 'दाईं ओर पिन करें',
    'it-IT': 'Blocca a destra',
    'ja-JP': '右をピン',
    'kn-IN': 'ಬಲಕ್ಕೆ ಪಿನ್ ಮಾಡಿ',
    'ko-KR': '오른쪽에 고정',
    'ml-IN': 'വലത് പിൻ ചെയ്യുക',
    'mr-IN': 'उजवीकडे पिन करा',
    'nl-BE': 'Rechts vastmaken',
    'nl-NL': 'Rechts vastzetten',
    'pl-PL': 'Przypnij po prawej',
    'pt-BR': 'Fixar à direita',
    'pt-PT': 'Fixar à direita',
    'sv-SE': 'Nåla fast höger',
    'ta-IN': 'பின் ரைட்',
    'te-IN': 'పిన్ కుడి వైపు',
    'th-TH': 'ปักหมุดขวา',
    'tr-TR': 'Sağ pin',
    'vi-VN': 'Ghim bên phải',
    'zh-CN': '固定在右侧',
    'zh-TW': '釘選於右側',
  },
  'ag-noPin': {
    'en-US': 'No Pin',
    'ar-AE': 'لا يوجد تثبيت',
    'bn-IN': 'পিন নেই',
    'de-DE': 'Nichts anheften',
    'en-AU': 'No pin',
    'en-GB': 'No pin',
    'en-ZA': 'No pin',
    'es-ES': 'No hay bloqueos',
    'es-MX': 'Sin elementos fijados',
    'fr-BE': 'Aucune épingle',
    'fr-CA': 'Pas d’épingle',
    'fr-FR': 'Absence d’épingles',
    'gu-IN': 'કોઈ પિન નથી',
    'hi-IN': 'कोई पिन नहीं है',
    'it-IT': 'Nessun blocco',
    'ja-JP': 'ピンなし',
    'kn-IN': 'ಪಿನ್ ಇಲ್ಲ',
    'ko-KR': '고정 안 함',
    'ml-IN': 'പിൻ ഇല്ല',
    'mr-IN': 'पिन नाही',
    'nl-BE': 'Geen pincode',
    'nl-NL': 'Geen pincode',
    'pl-PL': 'Bez przypinania',
    'pt-BR': 'Não fixar',
    'pt-PT': 'Sem fixação',
    'sv-SE': 'Ingen nål',
    'ta-IN': 'பின் இல்லை',
    'te-IN': 'పిన్ లేదు',
    'th-TH': 'ไม่มีหมุด',
    'tr-TR': 'Pin yok',
    'vi-VN': 'Không có mã PIN',
    'zh-CN': '不固定',
    'zh-TW': '無釘選',
  },
  'ag-valueAggregation': {
    'en-US': 'Value Aggregation',
    'ar-AE': 'تجميع القيمة',
    'bn-IN': 'মান একত্রিকরণ',
    'de-DE': 'Aggregation von Werten',
    'en-AU': 'Value aggregation',
    'en-GB': 'Value aggregation',
    'en-ZA': 'Value aggregation',
    'es-ES': 'Agregación de valores',
    'es-MX': 'Agregación de valores',
    'fr-BE': 'Valeur groupée',
    'fr-CA': 'Agrégation de la valeur',
    'fr-FR': 'Agrégation de valeurs',
    'gu-IN': 'મૂલ્ય એકંદર કરો',
    'hi-IN': 'वैल्यू एग्रीगेशन',
    'it-IT': 'Aggregazione dei valori',
    'ja-JP': '値の総計',
    'kn-IN': 'ಮೌಲ್ಯ ಒಟ್ಟುಗೂಡಿಸುವಿಕೆ',
    'ko-KR': '값 집계',
    'ml-IN': 'മൂല്യ സമാഹരണം',
    'mr-IN': 'व्हॅल्यूची बेरीज',
    'nl-BE': 'Waardeaggregatie',
    'nl-NL': 'Waardeaggregatie',
    'pl-PL': 'Agregacja wartości',
    'pt-BR': 'Agregação de valor',
    'pt-PT': 'Agregação de valor',
    'sv-SE': 'Värdeaggregering',
    'ta-IN': 'வேல்யூ ஒருங்கிணைப்பு',
    'te-IN': 'విలువ సమగ్రత',
    'th-TH': 'การรวมค่า',
    'tr-TR': 'Değer toplama',
    'vi-VN': 'Tổng hợp giá trị',
    'zh-CN': '值汇总',
    'zh-TW': '值彙總',
  },
  'ag-autosizeThiscolumn': {
    'en-US': 'Autosize This Column',
    'ar-AE': 'تغيير حجم هذا العمود تلقائيًا',
    'bn-IN': 'এই কলামটিকে স্বয়ংক্রিয়ভাবে সাইজ করুন',
    'de-DE': 'Spaltenbreite automatisch anpassen',
    'en-AU': 'Autosize this column',
    'en-GB': 'Autosize this column',
    'en-ZA': 'Autosize this column',
    'es-ES': 'Ajustar automáticamente esta columna',
    'es-MX': 'Ajustar automáticamente el tamaño de esta columna',
    'fr-BE': 'Ajuster automatiquement la taille de cette colonne',
    'fr-CA': 'Dimensionner automatiquement cette colonne',
    'fr-FR': 'Dimensionner automatiquement cette colonne',
    'gu-IN': 'આ કોલમની આપમેળે સાઇઝ કરો',
    'hi-IN': 'इस कॉलम का साइज़ अपने-आप बदलें',
    'it-IT': 'Dimensione automatica di questa colonna',
    'ja-JP': 'この列のサイズを自動調整',
    'kn-IN': 'ಈ ಕಾಲಮ್ ಅನ್ನು ಆಟೋಸೈಜ್ ಮಾಡಿ',
    'ko-KR': '이 열 크기 자동 조정',
    'ml-IN': 'ഈ കോളം സ്വയമേവ വലുപ്പം മാറ്റുക',
    'mr-IN': 'हा स्तंभ ऑटोसाइज करा',
    'nl-BE': 'Deze kolomgroote automatisch aanpassen',
    'nl-NL': 'Grootte van deze kolom automatisch instellen',
    'pl-PL': 'Automatycznie dopasuj rozmiar tej kolumny',
    'pt-BR': 'Tamanho automático desta coluna',
    'pt-PT': 'Dimensionar automaticamente esta coluna',
    'sv-SE': 'Anpassa storlek automatiskt för den här kolumnen',
    'ta-IN': 'இந்த நெடுவரிசையை ஆட்டோசைஸ் செய்யவும்',
    'te-IN': 'ఈ కాలమ్ సైజ్‌ను ఆటోమేటిక్‌గా సర్దుబాటు చేయండి',
    'th-TH': 'ปรับขนาดคอลัมน์นี้โดยอัตโนมัติ',
    'tr-TR': 'Bu sütunu otomatik boyutlandır',
    'vi-VN': 'Tự động chỉnh kích thước cột này',
    'zh-CN': '自动调整此列',
    'zh-TW': '自動調整此資料欄大小',
  },
  'ag-autosizeAllColumns': {
    'en-US': 'Autosize All Columns',
    'ar-AE': 'تغيير حجم كل الأعمدة تلقائيًا',
    'bn-IN': 'সবকটি কলাম স্বয়ংক্রিয়ভাবে সাইজ করুন',
    'de-DE': 'Alle Spalten automatisch anpassen',
    'en-AU': 'Autosize all columns',
    'en-GB': 'Autosize all columns',
    'en-ZA': 'Autosize all columns',
    'es-ES': 'Ajustar automáticamente todas las columnas',
    'es-MX': 'Ajustar automáticamente el tamaño de todas las columnas',
    'fr-BE': 'Ajuster automatiquement la taille de toutes les colonnes',
    'fr-CA': 'Dimensionnement automatique de toutes les colonnes',
    'fr-FR': 'Dimensionner automatiquement toutes les colonnes',
    'gu-IN': 'બધી કોલમની આપમેળે સાઇઝ કરો',
    'hi-IN': 'सभी कॉलम का साइज़ अपने-आप बदलें',
    'it-IT': 'Ridimensiona automaticamente tutte le colonne',
    'ja-JP': 'すべての列のサイズを自動調整',
    'kn-IN': 'ಎಲ್ಲ ಕಾಲಮ್‌ಗಳನ್ನು ಆಟೋಸೈಜ್ ಮಾಡಿ',
    'ko-KR': '모든 열 크기 자동 조정',
    'ml-IN': 'എല്ലാ കോളങ്ങളും സ്വയമേവ വലുപ്പം മാറ്റുക',
    'mr-IN': 'सर्व स्तंभ ऑटोसाइज करा',
    'nl-BE': 'Alle kolomgrootten automatisch aanpassen',
    'nl-NL': 'Grootte van alle kolommen automatisch instellen',
    'pl-PL': 'Automatycznie dopasuj rozmiar wszystkich kolumn',
    'pt-BR': 'Tamanho automático de todas as colunas',
    'pt-PT': 'Dimensionar automaticamente todas as colunas',
    'sv-SE': 'Anpassa storlek automatiskt för alla kolumner',
    'ta-IN': 'அனைத்து நெடுவரிசைகளையும் ஆட்டோசைஸ் செய்யவும்',
    'te-IN': 'అన్ని కాలమ్‌లు ఆటోసైజ్ చేయండి',
    'th-TH': 'ปรับขนาดคอลัมน์ทั้งหมดโดยอัตโนมัติ',
    'tr-TR': 'Tüm sütunları otomatik boyutlandır',
    'vi-VN': 'Tự động chỉnh kích thước tất cả các cột',
    'zh-CN': '自动调整所有列',
    'zh-TW': '自動調整所有資料欄大小',
  },
  'ag-groupBy': {
    'en-US': 'Group by',
    'ar-AE': 'تجميع حسب',
    'bn-IN': 'যিনি গ্রুপ করেছেন',
    'de-DE': 'Gruppieren nach',
    'es-ES': 'Agrupar por',
    'es-MX': 'Agrupar por',
    'fr-BE': 'Regrouper par',
    'fr-CA': 'Grouper par',
    'fr-FR': 'Regrouper par',
    'gu-IN': 'આના દ્વારા ગ્રૂપ',
    'hi-IN': 'इसके अनुसार ग्रुप करें',
    'it-IT': 'Raggruppa per',
    'ja-JP': 'グループ化',
    'kn-IN': 'ಈ ಪ್ರಕಾರ ಗುಂಪು ಮಾಡಿ',
    'ko-KR': '그룹화 기준',
    'ml-IN': 'ഇപ്രകാരം ഗ്രൂപ്പ് ചെയ്യുക',
    'mr-IN': 'यानुसार ग्रुप करा',
    'nl-BE': 'Groeperen op',
    'nl-NL': 'Groeperen op',
    'pl-PL': 'Grupuj według',
    'pt-BR': 'Agrupar por',
    'pt-PT': 'Agrupar por',
    'sv-SE': 'Gruppera enligt',
    'ta-IN': 'இவ்வாரியாக குரூப் செய்க',
    'te-IN': 'ఇలా వర్గీకరించండి',
    'th-TH': 'จัดกลุ่มตาม',
    'tr-TR': 'Gruplandırma ölçütü',
    'vi-VN': 'Nhóm theo',
    'zh-CN': '分组条件',
    'zh-TW': '分組依據',
  },
  'ag-ungroupBy': {
    'en-US': 'Un-Group by',
    'ar-AE': 'إلغاء التجميع حسب',
    'bn-IN': 'যিনি গ্রুপ থেকে বের করেছেন',
    'de-DE': 'Gruppierung auflösen nach',
    'en-AU': 'Ungroup by',
    'en-GB': 'Un-group by',
    'en-ZA': 'Un-group by',
    'es-ES': 'Desagrupar por',
    'es-MX': 'Desagrupar por',
    'fr-BE': 'Dégrouper par',
    'fr-CA': 'Dégrouper par',
    'fr-FR': 'Dissocier le groupe par',
    'gu-IN': 'આના દ્વારા અન-ગ્રૂપ',
    'hi-IN': 'इस आधार पर अन-ग्रुप करें',
    'it-IT': 'Rimuovi il gruppo per',
    'ja-JP': 'グループ化の解除',
    'kn-IN': 'ಈ ಪ್ರಕಾರ ಅನ್-ಗ್ರೂಪ್ ಮಾಡಿ',
    'ko-KR': '그룹화 해제 기준',
    'ml-IN': 'ഇപ്രകാരം അൺ-ഗ്രൂപ്പ് ചെയ്യുക',
    'mr-IN': 'यानुसार अन-ग्रुप करा',
    'nl-BE': 'Groep ontbinden per',
    'nl-NL': 'Groeperen op opheffen',
    'pl-PL': 'Rozgrupuj według',
    'pt-BR': 'Desagrupar por',
    'pt-PT': 'Desagrupar por',
    'sv-SE': 'Avgruppera enligt',
    'ta-IN': 'இவ்வாரியாக அன்-குரூப் செய்க',
    'te-IN': 'ఈ విధంగా వర్గీకరణను తీసివేయండి',
    'th-TH': 'ยกเลิกการจัดกลุ่มตาม',
    'tr-TR': 'Şuna göre gruptan çıkar:',
    'vi-VN': 'Tách nhóm theo',
    'zh-CN': '取消分组依据',
    'zh-TW': '取消群組依據',
  },
  'ag-addToValues': {
    'en-US': 'Add ${variable} to values',
    'ar-AE': 'إضافة ${variable} إلى القيم',
    'bn-IN': 'মানগুলিতে ${variable} যোগ করুন',
    'de-DE': '${variable} zu den Werten hinzufügen',
    'es-ES': 'Añadir ${variable} a valores',
    'es-MX': 'Agregar ${variable} a los valores',
    'fr-BE': 'Ajouter la variable ${variable} aux valeurs',
    'fr-CA': 'Ajouter ${variable} aux valeurs',
    'fr-FR': 'Ajouter ${variable} aux valeurs',
    'gu-IN': '${variable} મૂલ્યોમાં ઉમેરો',
    'hi-IN': 'वैल्यू में ${variable} ऐड करें',
    'it-IT': 'Aggiungi ${variable} ai valori',
    'ja-JP': '値に${variable}を追加',
    'kn-IN': 'ಮೌಲ್ಯಗಳಿಗೆ ${variable} ಸೇರಿಸಿ',
    'ko-KR': '값에 ${variable} 추가',
    'ml-IN': '${variable} മൂല്യങ്ങളിലേക്ക് ചേർക്കുക',
    'mr-IN': 'व्हॅल्यूमध्ये ${variable} जोडा',
    'nl-BE': '${variable} toevoegen aan waarden',
    'nl-NL': '${variable} toevoegen aan waarden',
    'pl-PL': 'Dodaj ${variable} do wartości',
    'pt-BR': 'Adicionar ${variable} aos valores',
    'pt-PT': 'Adicionar ${variable} aos valores',
    'sv-SE': 'Lägg till ${variable} i värden',
    'ta-IN': 'வேல்யூக்களில் ${variable} ஐச் சேர்க்கவும்',
    'te-IN': 'విలువలకు ${variable}ని జోడించండి',
    'th-TH': 'เพิ่ม ${variable} ลงในค่า',
    'tr-TR': 'Değerlere şunu ekle: ${variable}',
    'vi-VN': 'Thêm ${variable} vào giá trị',
    'zh-CN': '将 ${variable} 添加至值',
    'zh-TW': '新增 ${variable} 至值',
  },
  'ag-removeFromValues': {
    'en-US': 'Remove ${variable} from values',
    'ar-AE': 'إزالة ${variable} من القيم',
    'bn-IN': 'মানগুলি থেকে ${variable} অপসারণ করুন',
    'de-DE': '${variable} aus den Werten entfernen',
    'es-ES': 'Eliminar ${variable} de los valores',
    'es-MX': 'Eliminar ${variable} de los valores',
    'fr-BE': 'Retirer la variable ${variable} des valeurs',
    'fr-CA': 'Supprimer ${variable} des valeurs',
    'fr-FR': 'Supprimer ${variable} des valeurs',
    'gu-IN': '${variable} મૂલ્યોમાંથી દૂર કરો',
    'hi-IN': 'वैल्यू से ${variable} रिमूव करें',
    'it-IT': 'Rimuovi ${variable} dai valori',
    'ja-JP': '値から${variable}を削除',
    'kn-IN': '${variable} ಮೌಲ್ಯಗಳಿಂದ ತೆಗೆದುಹಾಕಿ',
    'ko-KR': '값에서 ${variable} 제거',
    'ml-IN': '${variable} മൂല്യങ്ങളിൽ നിന്ന് നീക്കംചെയ്യുക',
    'mr-IN': 'व्हॅल्यूमधून ${variable} काढून टाका',
    'nl-BE': '${variable} verwijderen uit waarden',
    'nl-NL': '${variable} verwijderen uit waarden',
    'pl-PL': 'Usuń ${variable} z wartości',
    'pt-BR': 'Remover ${variable} dos valores',
    'pt-PT': 'Remover ${variable} dos valores',
    'sv-SE': 'Ta bort ${variable} från värden',
    'ta-IN': 'வேல்யூக்களிலிருந்து ${variable} ஐ நீக்கவும்',
    'te-IN': 'విలువల నుండి ${variable}ని తీసివేయండి',
    'th-TH': 'ลบ ${variable} ออกจากค่า',
    'tr-TR': 'Değerlerden şunu kaldır: ${variable}',
    'vi-VN': 'Xóa ${variable} khỏi giá trị',
    'zh-CN': '将 ${variable} 从值中移除',
    'zh-TW': '從值中移除 ${variable}',
  },
  'ag-addToLabels': {
    'en-US': 'Add ${variable} to labels',
    'ar-AE': 'إضافة ${variable} إلى الملصقات',
    'bn-IN': 'লেবেলগুলিতে ${variable} যোগ করুন',
    'de-DE': '${variable} zu den Etiketten hinzufügen',
    'es-ES': 'Añadir ${variable} a etiquetas',
    'es-MX': 'Agregar ${variable} a las etiquetas',
    'fr-BE': 'Ajouter la variable ${variable} aux étiquettes',
    'fr-CA': 'Ajouter ${variable} aux étiquettes',
    'fr-FR': 'Ajouter ${variable} aux étiquettes',
    'gu-IN': '${variable} લેબલ્સમાં ઉમેરો',
    'hi-IN': 'लेबल में ${variable} ऐड करें',
    'it-IT': 'Aggiungi ${variable} alle etichette',
    'ja-JP': 'ラベルに${variable}を追加',
    'kn-IN': 'ಲೇಬಲ್‌ಗಳಿಗೆ ${variable} ಸೇರಿಸಿ',
    'ko-KR': '라벨에 ${variable} 추가',
    'ml-IN': '${variable} ലേബലുകളിലേക്ക് ചേർക്കുക',
    'mr-IN': 'लेबलमध्ये ${variable} जोडा',
    'nl-BE': '${variable} toevoegen aan etiketten',
    'nl-NL': '${variable} toevoegen aan etiketten',
    'pl-PL': 'Dodaj ${variable} do etykiet',
    'pt-BR': 'Adicionar ${variable} às etiquetas',
    'pt-PT': 'Adicionar ${variable} aos rótulos',
    'sv-SE': 'Lägg till ${variable} i etiketter',
    'ta-IN': 'லேபிள்களில் ${variable} ஐச் சேர்க்கவும்',
    'te-IN': '${variable} లేబుల్‌లకు జోడించండి',
    'th-TH': 'เพิ่ม ${variable} ลงในฉลาก',
    'tr-TR': 'Etiketlere şunu ekle: ${variable}',
    'vi-VN': 'Thêm ${variable} vào nhãn',
    'zh-CN': '将 ${variable} 添加至标签',
    'zh-TW': '新增 ${variable} 至標籤',
  },
  'ag-removeFromLabels': {
    'en-US': 'Remove ${variable} from labels',
    'ar-AE': 'إزالة ${variable} من الملصقات',
    'bn-IN': 'লেবেলগুলি থেকে ${variable} অপসারণ করুন',
    'de-DE': '${variable} von den Etiketten entfernen',
    'es-ES': 'Eliminar ${variable} de las etiquetas',
    'es-MX': 'Eliminar ${variable} de las etiquetas',
    'fr-BE': 'Retirer la variable ${variable} des étiquettes',
    'fr-CA': 'Supprimer ${variable} des étiquettes',
    'fr-FR': 'Retirer ${variable} des étiquettes',
    'gu-IN': '${variable} લેબલ્સમાંથી દૂર કરો',
    'hi-IN': 'लेबल से ${variable} रिमूव करें',
    'it-IT': 'Rimuovi ${variable} dalle etichette',
    'ja-JP': 'ラベルから${variable}を削除',
    'kn-IN': '${variable} ಇಂದ ಲೇಬಲ್‌ಗಳನ್ನು ತೆಗೆದುಹಾಕಿ',
    'ko-KR': '라벨에서 ${variable} 제거',
    'ml-IN': '${variable} ലേബലുകളിൽ നിന്ന് നീക്കംചെയ്യുക',
    'mr-IN': 'लेबलमधून ${variable} काढून टाका',
    'nl-BE': '${variable} verwijderen van etiketten',
    'nl-NL': '${variable} verwijderen uit etiketten',
    'pl-PL': 'Usuń ${variable} z etykiet',
    'pt-BR': 'Remover ${variable} das etiquetas',
    'pt-PT': 'Remover ${variable} dos rótulos',
    'sv-SE': 'Ta bort ${variable} från etiketter',
    'ta-IN': 'லேபிள்களிலிருந்து ${variable} ஐ நீக்கவும்',
    'te-IN': 'లేబుల్‌ల నుండి ${variable}ని తీసివేయండి',
    'th-TH': 'ลบ ${variable} ออกจากฉลาก',
    'tr-TR': 'Etiketlerden şunu kaldır: ${variable}',
    'vi-VN': 'Xóa ${variable} khỏi nhãn',
    'zh-CN': '将 ${variable} 从标签中移除',
    'zh-TW': '從標籤中移除 ${variable}',
  },
  'ag-resetColumns': {
    'en-US': 'Reset Columns',
    'ar-AE': 'إعادة ضبط الأعمدة',
    'bn-IN': 'কলাম রিসেট করুন',
    'de-DE': 'Spalten zurücksetzen',
    'en-AU': 'Reset columns',
    'en-GB': 'Reset columns',
    'en-ZA': 'Reset columns',
    'es-ES': 'Restablecer columnas',
    'es-MX': 'Restablecer columnas',
    'fr-BE': 'Réinitialiser les colonnes',
    'fr-CA': 'Réinitialiser les colonnes',
    'fr-FR': 'Réinitialiser les colonnes',
    'gu-IN': 'કોલમ રીસેટ કરો',
    'hi-IN': 'कॉलम रीसेट करें',
    'it-IT': 'Reimposta colonne',
    'ja-JP': '列をリセット',
    'kn-IN': 'ಕಾಲಮ್‌ಗಳನ್ನು ಮರುಹೊಂದಿಸಿ',
    'ko-KR': '열 리셋',
    'ml-IN': 'കോളങ്ങൾ റീസെറ്റ് ചെയ്യുക',
    'mr-IN': 'स्तंभ रीसेट करा',
    'nl-BE': 'Kolommen opnieuw instellen',
    'nl-NL': 'Kolommen opnieuw instellen',
    'pl-PL': 'Resetuj kolumny',
    'pt-BR': 'Redefinir colunas',
    'pt-PT': 'Redefinir Colunas',
    'sv-SE': 'Återställ kolumner',
    'ta-IN': 'நெடுவரிசையை ரீசெட் செய்க',
    'te-IN': 'నిలువు వరుసలను రీసెట్ చేయండి',
    'th-TH': 'รีเซ็ตคอลัมน์',
    'tr-TR': 'Sütunları sıfırla',
    'vi-VN': 'Đặt lại cột',
    'zh-CN': '重置列',
    'zh-TW': '重設資料欄',
  },
  'ag-expandAll': {
    'en-US': 'Expand All',
    'ar-AE': 'توسيع الكل',
    'bn-IN': 'সবগুলি বিস্তৃত করুন',
    'de-DE': 'Alle einblenden',
    'en-AU': 'Expand all',
    'en-GB': 'Expand all',
    'en-ZA': 'Expand all',
    'es-ES': 'Desplegar todo',
    'es-MX': 'Expandir todo',
    'fr-BE': 'Tout développer',
    'fr-CA': 'Développer tout',
    'fr-FR': 'Afficher tout',
    'gu-IN': 'બધું મોટું કરો',
    'hi-IN': 'सभी का विस्तार करें',
    'it-IT': 'Espandi tutto',
    'ja-JP': 'すべて展開',
    'kn-IN': 'ಎಲ್ಲವನ್ನು ವಿಸ್ತರಿಸಿ',
    'ko-KR': '모두 확장',
    'ml-IN': 'എല്ലാം വികസിപ്പിക്കുക',
    'mr-IN': 'सर्व विस्तार करा',
    'nl-BE': 'Alles uitvouwen',
    'nl-NL': 'Alles uitvouwen',
    'pl-PL': 'Rozwiń wszystkie',
    'pt-BR': 'Expandir tudo',
    'pt-PT': 'Expandir tudo',
    'sv-SE': 'Expandera alla',
    'ta-IN': 'எல்லாவற்றையும் விரிவாக்கு',
    'te-IN': 'అన్నీ విస్తరించు',
    'th-TH': 'ขยายทั้งหมด',
    'tr-TR': 'Tümünü genişlet',
    'vi-VN': 'Mở rộng tất cả',
    'zh-CN': '全部展开',
    'zh-TW': '全部展開',
  },
  'ag-collapseAll': {
    'en-US': 'Close All',
    'ar-AE': 'إغلاق الكل',
    'bn-IN': 'সব বন্ধ করুন',
    'de-DE': 'Alle schließen',
    'en-AU': 'Close all',
    'en-GB': 'Close all',
    'en-ZA': 'Close all',
    'es-ES': 'Cerrar todo',
    'es-MX': 'Cerrar todo',
    'fr-BE': 'Fermer tout',
    'fr-CA': 'Fermer tout',
    'fr-FR': 'Fermer tout',
    'gu-IN': 'બધું બંધ કરો',
    'hi-IN': 'सभी बंद करें',
    'it-IT': 'Chiudi tutto',
    'ja-JP': 'すべて閉じる',
    'kn-IN': 'ಎಲ್ಲ ಮುಚ್ಚಿ',
    'ko-KR': '모두 닫기',
    'ml-IN': 'എല്ലാം അടയ്ക്കുക',
    'mr-IN': 'सर्व बंद करा',
    'nl-BE': 'Alles sluiten',
    'nl-NL': 'Alles sluiten',
    'pl-PL': 'Zamknij wszystkie',
    'pt-BR': 'Fechar tudo',
    'pt-PT': 'Fechar tudo',
    'sv-SE': 'Stäng alla',
    'ta-IN': 'அனைத்தையும் மூடு',
    'te-IN': 'అన్నీ మూసివేయండి',
    'th-TH': 'ปิดทั้งหมด',
    'tr-TR': 'Tümünü kapat',
    'vi-VN': 'Đóng tất cả',
    'zh-CN': '全部关闭',
    'zh-TW': '全部關閉',
  },
  'ag-copy': {
    'en-US': 'Copy',
    'ar-AE': 'نسخ',
    'bn-IN': 'কপি করুন',
    'de-DE': 'Kopieren',
    'es-ES': 'Copiar',
    'es-MX': 'Copiar',
    'fr-BE': 'Copier',
    'fr-CA': 'Copier',
    'fr-FR': 'Copier',
    'gu-IN': 'કોપિ કરો',
    'hi-IN': 'कॉपी करें',
    'it-IT': 'Copia',
    'ja-JP': 'コピー',
    'kn-IN': 'ನಕಲಿಸಿ',
    'ko-KR': '복사',
    'ml-IN': 'പകർത്തുക',
    'mr-IN': 'कॉपी करा',
    'nl-BE': 'Kopiëren',
    'nl-NL': 'Kopiëren',
    'pl-PL': 'Kopiuj',
    'pt-BR': 'Copiar',
    'pt-PT': 'Copiar',
    'sv-SE': 'Kopiera',
    'ta-IN': 'நகலெடு',
    'te-IN': 'కాపీ చేయండి',
    'th-TH': 'คัดลอก',
    'tr-TR': 'Kopyala',
    'vi-VN': 'Sao chép',
    'zh-CN': '复制',
    'zh-TW': '複製',
  },
  'ag-ctrlC': {
    'en-US': 'Ctrl+C',
    'de-DE': 'Strg+C',
  },
  'ag-copyWithHeaders': {
    'en-US': 'Copy With Headers',
    'ar-AE': 'النسخ باستخدام العناوين',
    'bn-IN': 'হেডার সহ কপি করুন',
    'de-DE': 'Mit Überschriften kopieren',
    'en-AU': 'Copy with headers',
    'en-GB': 'Copy with headers',
    'en-ZA': 'Copy with headers',
    'es-ES': 'Copiar con encabezados',
    'es-MX': 'Copiar con encabezados',
    'fr-BE': 'Copier avec des en-têtes',
    'fr-CA': 'Copier avec les en-têtes',
    'fr-FR': 'Copier avec des en-têtes',
    'gu-IN': 'હેડર્સ સાથે કોપિ કરો',
    'hi-IN': 'हेडर के साथ कॉपी करें',
    'it-IT': 'Copia con intestazioni',
    'ja-JP': 'ヘッダー付きコピー',
    'kn-IN': 'ಶೀರ್ಷಿಕೆಗಳು ಜೊತೆಗೆ ನಕಲಿಸಿ',
    'ko-KR': '헤더와 함께 복사',
    'ml-IN': 'തലക്കെട്ടുകൾക്കൊപ്പം പകർത്തുക',
    'mr-IN': 'हेडरसह कॉपी करा',
    'nl-BE': 'Kopiëren met kopteksten',
    'nl-NL': 'Kopiëren met kopteksten',
    'pl-PL': 'Kopiuj z nagłówkami',
    'pt-BR': 'Copiar com cabeçalhos',
    'pt-PT': 'Copiar com cabeçalhos',
    'sv-SE': 'Kopiera med rubriker',
    'ta-IN': 'ஹெட்டர்களுடன் நகல் எடுக்கவும்',
    'te-IN': 'శీర్షికలతో కాపీ చేయండి',
    'th-TH': 'คัดลอกพร้อมส่วนหัว',
    'tr-TR': 'Başlıklarla kopyala',
    'vi-VN': 'Sao chép bằng tiêu đề',
    'zh-CN': '复制（包括标题）',
    'zh-TW': '含標頭複製',
  },
  'ag-copyWithGroupHeaders': {
    'en-US': 'Copy with Group Headers',
    'ar-AE': 'النسخ باستخدام عناوين المجموعة',
    'bn-IN': 'গ্রুপ হেডার সহ কপি করুন',
    'de-DE': 'Mit Gruppenüberschriften kopieren',
    'en-AU': 'Copy with group headers',
    'en-GB': 'Copy with group headers',
    'en-ZA': 'Copy with group headers',
    'es-ES': 'Copiar con encabezados de grupo',
    'es-MX': 'Copiar con encabezados de grupo',
    'fr-BE': 'Copier avec des en-têtes de groupe',
    'fr-CA': 'Copier avec les en-têtes de groupe',
    'fr-FR': 'Copier avec des en-têtes de groupe',
    'gu-IN': 'ગ્રૂપ હેડર્સ સાથે કોપિ કરો',
    'hi-IN': 'ग्रुप हेडर के साथ कॉपी करें',
    'it-IT': 'Copia con Intestazioni di gruppo',
    'ja-JP': 'グループヘッダー付きコピー',
    'kn-IN': 'ಗುಂಪು ಶೀರ್ಷಿಕೆಯೊಂದಿಗೆ ನಕಲಿಸಿ',
    'ko-KR': '그룹 헤더와 함께 복사',
    'ml-IN': 'ഗ്രൂപ്പ് തലക്കെട്ടുകൾക്കൊപ്പം പകർത്തുക',
    'mr-IN': 'ग्रुप हेडर्ससह कॉपी करा',
    'nl-BE': 'Kopiëren met groepkoppen',
    'nl-NL': 'Kopiëren met groepskopteksten',
    'pl-PL': 'Kopiuj z nagłówkami grup',
    'pt-BR': 'Copiar com cabeçalhos de grupo',
    'pt-PT': 'Copiar com cabeçalhos de grupo',
    'sv-SE': 'Kopiera med grupprubriker',
    'ta-IN': 'குழுத் தலைப்புகளுடன் நகலெடுக்கவும்',
    'te-IN': 'గ్రూప్ శీర్షికలతో కాపీ చేయండి',
    'th-TH': 'คัดลอกพร้อมส่วนหัวของกลุ่ม',
    'tr-TR': 'Grup başlıklarıyla kopyala',
    'vi-VN': 'Sao chép với tiêu đề nhóm',
    'zh-CN': '复制（包括组标题）',
    'zh-TW': '含群組標頭複製',
  },
  'ag-paste': {
    'en-US': 'Paste',
    'ar-AE': 'لصق',
    'bn-IN': 'পেস্ট',
    'de-DE': 'Einfügen',
    'es-ES': 'Pegar',
    'es-MX': 'Pegar',
    'fr-BE': 'Coller',
    'fr-CA': 'Coller',
    'fr-FR': 'Coller',
    'gu-IN': 'પેસ્ટ કરો',
    'hi-IN': 'पेस्ट करें',
    'it-IT': 'Incolla',
    'ja-JP': 'ペースト',
    'kn-IN': 'ಅಂಟಿಸಿ',
    'ko-KR': '붙여 넣기',
    'ml-IN': 'ഒട്ടിക്കുക',
    'mr-IN': 'पेस्ट करा',
    'nl-BE': 'Plakken',
    'nl-NL': 'Plakken',
    'pl-PL': 'Wklej',
    'pt-BR': 'Colar',
    'pt-PT': 'Colar',
    'sv-SE': 'Klistra in',
    'ta-IN': 'பேஸ்ட்',
    'te-IN': 'అతికించండి',
    'th-TH': 'วาง',
    'tr-TR': 'Yapıştır',
    'vi-VN': 'Dán',
    'zh-CN': '粘贴',
    'zh-TW': '貼上',
  },
  'ag-ctrlV': {
    'en-US': 'Ctrl+V',
    'de-DE': 'Strg+V',
  },
  'ag-export': {
    'en-US': 'Export',
    'ar-AE': 'تصدير',
    'bn-IN': 'এক্সপোর্ট করুন',
    'de-DE': 'Exportieren',
    'es-ES': 'Exportar',
    'es-MX': 'Exportar',
    'fr-BE': 'Exporter',
    'fr-CA': 'Exporter',
    'fr-FR': 'Exporter',
    'gu-IN': 'એક્સપોર્ટ કરો',
    'hi-IN': 'एक्सपोर्ट करें',
    'it-IT': 'Esportazione',
    'ja-JP': 'エクスポート',
    'kn-IN': 'ರಫ್ತು ಮಾಡಿ',
    'ko-KR': '내보내기',
    'ml-IN': 'എക്‌സ്‌പോർട്ട് ചെയ്യുക',
    'mr-IN': 'एक्सपोर्ट',
    'nl-NL': 'Exporteren',
    'pl-PL': 'Eksport',
    'pt-BR': 'Exportar',
    'pt-PT': 'Exportar',
    'sv-SE': 'Exportera',
    'ta-IN': 'எக்ஸ்போர்ட்',
    'te-IN': 'ఎగుమతి చేయండి',
    'th-TH': 'การส่งออก',
    'tr-TR': 'Dışa aktar',
    'vi-VN': 'Xuất',
    'zh-CN': '导出',
    'zh-TW': '匯出',
  },
  'ag-csvExport': {
    'en-US': 'CSV Export',
    'ar-AE': 'تصدير CSV',
    'bn-IN': 'CSV এক্সপোর্ট করুন',
    'de-DE': 'CSV-Export',
    'en-AU': 'CSV export',
    'en-GB': 'CSV export',
    'en-ZA': 'CSV export',
    'es-ES': 'Exportar en CSV',
    'es-MX': 'Exportar a CSV',
    'fr-BE': 'Exportation CSV',
    'fr-CA': 'Exportation CSV',
    'fr-FR': 'Exportation CSV',
    'gu-IN': 'CSV એક્સપોર્ટ',
    'hi-IN': 'CSV एक्सपोर्ट',
    'it-IT': 'Esporta in formato CSV',
    'ja-JP': 'CSVエクスポート',
    'kn-IN': 'CSV ಎಕ್ಸ್‌ಪೋರ್ಟ್‌',
    'ko-KR': 'CSV 내보내기',
    'ml-IN': 'CSV എക്‌സ്‌പോർട്ട്',
    'mr-IN': 'CSV एक्सपोर्ट',
    'nl-BE': 'CSV-export',
    'nl-NL': 'CSV-export',
    'pl-PL': 'Eksport do CSV',
    'pt-BR': 'Exportação CSV',
    'pt-PT': 'Exportar para CSV',
    'sv-SE': 'CSV-export',
    'ta-IN': 'CSV எக்ஸ்போர்ட்',
    'te-IN': 'CSV ఎగుమతి చేయండి',
    'th-TH': 'การส่งออก CSV',
    'tr-TR': 'CSV dışa aktarımı',
    'vi-VN': 'Xuất tệp CSV',
    'zh-CN': 'CSV 导出',
    'zh-TW': 'CSV 匯出',
  },
  'ag-excelExport': {
    'en-US': 'Excel Export',
    'ar-AE': 'تصدير من برنامج Excel',
    'bn-IN': 'Excel-এ এক্সপোর্ট করুন',
    'de-DE': 'Excel-Export',
    'en-AU': 'Excel export',
    'en-GB': 'Excel export',
    'en-ZA': 'Excel export',
    'es-ES': 'Exportar en Excel',
    'es-MX': 'Exportar a Excel',
    'fr-BE': 'Exportation depuis Excel',
    'fr-CA': 'Exportation Excel',
    'fr-FR': 'Exportation d’Excel',
    'gu-IN': 'Excel પર એક્સપોર્ટ કરો',
    'hi-IN': 'Excel एक्सपोर्ट',
    'it-IT': 'Esporta Excel',
    'ja-JP': 'Excelエクスポート',
    'kn-IN': 'Excel ಎಕ್ಸ್‌ಪೋರ್ಟ್‌',
    'ko-KR': 'Excel 내보내기',
    'ml-IN': 'Excel എക്സ്പോർട്ട്',
    'mr-IN': 'Excel एक्सपोर्ट',
    'nl-BE': 'Excel-export',
    'nl-NL': 'Excel-export',
    'pl-PL': 'Eksport do formatu Excel',
    'pt-BR': 'Exportação do Excel',
    'pt-PT': 'Exportar para Excel',
    'sv-SE': 'Excel-export',
    'ta-IN': 'Excel எக்ஸ்போர்ட்',
    'te-IN': 'Excel ఎగుమతి',
    'th-TH': 'การส่งออก Excel',
    'tr-TR': 'Excel dışa aktarımı',
    'vi-VN': 'Xuất tệp Excel',
    'zh-CN': 'Excel 导出',
    'zh-TW': 'Excel 匯出',
  },
  'ag-sum': {
    'en-US': 'Sum',
    'ar-AE': 'مجموع',
    'bn-IN': 'সমষ্টি',
    'de-DE': 'Addieren',
    'es-ES': 'Suma',
    'es-MX': 'Suma',
    'fr-BE': 'Somme',
    'fr-CA': 'Somme',
    'fr-FR': 'Somme',
    'gu-IN': 'સરવાળો',
    'hi-IN': 'योग',
    'it-IT': 'Somma',
    'ja-JP': '合計',
    'kn-IN': 'ಮೊತ್ತ',
    'ko-KR': '합계',
    'ml-IN': 'തുക',
    'mr-IN': 'बेरीज',
    'nl-BE': 'Som',
    'nl-NL': 'Som',
    'pl-PL': 'Suma',
    'pt-BR': 'Soma',
    'pt-PT': 'Soma',
    'sv-SE': 'Summa',
    'ta-IN': 'கூட்டல்',
    'te-IN': 'కూడిక',
    'th-TH': 'รวม',
    'tr-TR': 'Toplam',
    'vi-VN': 'Tổng',
    'zh-CN': '总计',
    'zh-TW': '總和',
  },
  'ag-min': {
    'en-US': 'Min',
    'ar-AE': 'الحد الأدنى',
    'bn-IN': 'সর্বনিম্ন',
    'de-DE': 'min.',
    'es-ES': 'Mín.',
    'es-MX': 'Mín.',
    'fr-BE': 'Min.',
    'fr-CA': 'Min.',
    'fr-FR': 'Min.',
    'gu-IN': 'ન્યૂનતમ',
    'hi-IN': 'न्यूनतम',
    'it-IT': 'Minimo',
    'ja-JP': '最小',
    'kn-IN': 'ನಿಮಿಷ',
    'ko-KR': '최소',
    'ml-IN': 'മിനിമം',
    'mr-IN': 'किमान',
    'pl-PL': 'Min.',
    'pt-BR': 'Mín.',
    'pt-PT': 'Mín.',
    'ta-IN': 'குறைந்தபட்சம்',
    'te-IN': 'నిమిషం',
    'th-TH': 'ต่ำสุด',
    'tr-TR': 'Minimum',
    'vi-VN': 'Tối thiểu',
    'zh-CN': '最小值',
    'zh-TW': '最小',
  },
  'ag-max': {
    'en-US': 'Max',
    'ar-AE': 'الحد الأقصى',
    'bn-IN': 'সর্বোচ্চ',
    'de-DE': 'max.',
    'es-ES': 'Máx.',
    'es-MX': 'Máx.',
    'fr-BE': 'Max.',
    'fr-CA': 'Max.',
    'fr-FR': 'Max.',
    'gu-IN': 'મહત્તમ',
    'hi-IN': 'अधिकतम',
    'it-IT': 'Massimo',
    'ja-JP': '最大',
    'kn-IN': 'ಗರಿಷ್ಠ',
    'ko-KR': '최대',
    'ml-IN': 'പരമാവധി',
    'mr-IN': 'कमाल',
    'pl-PL': 'Maks.',
    'pt-BR': 'Máx.',
    'pt-PT': 'Máx.',
    'ta-IN': 'அதிகபட்சம்',
    'te-IN': 'గరిష్ఠం',
    'th-TH': 'สูงสุด',
    'tr-TR': 'Maksimum',
    'vi-VN': 'Tối đa',
    'zh-CN': '最大值',
    'zh-TW': '最大',
  },
  'ag-none': {
    'en-US': 'None',
    'ar-AE': 'لا يوجد',
    'bn-IN': 'কোনোটিই নয়',
    'de-DE': 'Keine',
    'es-ES': 'Ninguno',
    'es-MX': 'Ninguno',
    'fr-BE': 'Aucun',
    'fr-CA': 'Aucun',
    'fr-FR': 'Aucun',
    'gu-IN': 'કોઈ નહીં',
    'hi-IN': 'कुछ भी नहीं',
    'it-IT': 'Nessuno',
    'ja-JP': 'なし',
    'kn-IN': 'ಯಾವುದೂ ಇಲ್ಲ',
    'ko-KR': '없음',
    'ml-IN': 'ഒന്നുമില്ല',
    'mr-IN': 'काहीही नाही',
    'nl-BE': 'Geen',
    'nl-NL': 'Geen',
    'pl-PL': 'Brak',
    'pt-BR': 'Nenhum',
    'pt-PT': 'Nenhum',
    'sv-SE': 'Ingen',
    'ta-IN': 'எதுவுமில்லை',
    'te-IN': 'ఏదీ లేదు',
    'th-TH': 'ไม่มี',
    'tr-TR': 'Hiçbiri',
    'vi-VN': 'Không có',
    'zh-CN': '无',
    'zh-TW': '無',
  },
  'ag-count': {
    'en-US': 'Count',
    'ar-AE': 'العدد',
    'bn-IN': 'গণনা',
    'de-DE': 'Anzahl',
    'es-ES': 'Recuento',
    'es-MX': 'Cantidad',
    'fr-BE': 'Quantité',
    'fr-CA': 'Compte',
    'fr-FR': 'Nombre',
    'gu-IN': 'ગણતરી',
    'hi-IN': 'काउंट',
    'it-IT': 'Unità',
    'ja-JP': '個数',
    'kn-IN': 'ಲೆಕ್ಕ ಮಾಡಿ',
    'ko-KR': '개수',
    'ml-IN': 'എണ്ണം',
    'mr-IN': 'गणना',
    'nl-BE': 'Aantal',
    'nl-NL': 'Aantal',
    'pl-PL': 'Liczba',
    'pt-BR': 'Contagem',
    'pt-PT': 'Contagem',
    'sv-SE': 'Räkna',
    'ta-IN': 'கவுண்ட்',
    'te-IN': 'లెక్కింపు',
    'th-TH': 'นับ',
    'tr-TR': 'Adet',
    'vi-VN': 'Số lượng',
    'zh-CN': '计数',
    'zh-TW': '計數',
  },
  'ag-avg': {
    'en-US': 'Average',
    'ar-AE': 'المتوسط',
    'bn-IN': 'গড়পড়তা',
    'de-DE': 'Durchschnitt',
    'es-ES': 'Regular',
    'es-MX': 'Promedio',
    'fr-BE': 'Moyen',
    'fr-CA': 'Moyen',
    'fr-FR': 'Moyenne',
    'gu-IN': 'સરેરાશ',
    'hi-IN': 'औसत',
    'it-IT': 'Medio',
    'ja-JP': '普通',
    'kn-IN': 'ಸರಾಸರಿ',
    'ko-KR': '평균',
    'ml-IN': 'ശരാശരി',
    'mr-IN': 'सरासरी',
    'nl-BE': 'Gemiddelde',
    'nl-NL': 'Gemiddeld',
    'pl-PL': 'Średni',
    'pt-BR': 'Média',
    'pt-PT': 'Média',
    'sv-SE': 'Genomsnitt',
    'ta-IN': 'சராசரி',
    'te-IN': 'సగటు',
    'th-TH': 'เฉลี่ย',
    'tr-TR': 'Ortalama',
    'vi-VN': 'Trung bình',
    'zh-CN': '一般',
    'zh-TW': '平均',
  },
  'ag-filteredRows': {
    'en-US': 'Filtered',
    'ar-AE': 'تمت التصفية',
    'bn-IN': 'ফিল্টার করা হয়েছে',
    'de-DE': 'Gefiltert',
    'es-ES': 'Filtrado',
    'es-MX': 'Filtrado',
    'fr-BE': 'Filtré',
    'fr-CA': 'Filtré',
    'fr-FR': 'Filtré',
    'gu-IN': 'ફિલ્ટર કરેલ',
    'hi-IN': 'फ़िल्टर किया गया',
    'it-IT': 'Filtrato',
    'ja-JP': 'フィルター済み',
    'kn-IN': 'ಫಿಲ್ಟರ್ ಮಾಡಲಾಗಿದೆ',
    'ko-KR': '필터링됨',
    'ml-IN': 'ഫിൽട്ടർ ചെയ്തു',
    'mr-IN': 'फिल्टर केलेले',
    'nl-BE': 'Gefilterd',
    'nl-NL': 'Gefilterd',
    'pl-PL': 'Filtrowane',
    'pt-BR': 'Filtrado',
    'pt-PT': 'Filtrado',
    'sv-SE': 'Filtrerad',
    'ta-IN': 'வடிகட்டப்பட்டது',
    'te-IN': 'ఫిల్టర్ చేసినది',
    'th-TH': 'กรองแล้ว',
    'tr-TR': 'Filtrelenmiş',
    'vi-VN': 'Đã lọc',
    'zh-CN': '已筛选',
    'zh-TW': '已篩選',
  },
  'ag-selectedRows': {
    'en-US': 'Selected',
    'ar-AE': 'تم التحديد',
    'bn-IN': 'নির্বাচিত হয়েছে',
    'de-DE': 'Ausgewählt',
    'es-ES': 'Seleccionado',
    'es-MX': 'Seleccionado',
    'fr-BE': 'Sélectionné',
    'fr-CA': 'Sélectionné',
    'fr-FR': 'Sélectionné',
    'gu-IN': 'પસંદ કરેલ',
    'hi-IN': 'चुना गया',
    'it-IT': 'Selezionato',
    'ja-JP': '選択済み',
    'kn-IN': 'ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ',
    'ko-KR': '선택됨',
    'ml-IN': 'തിരഞ്ഞെടുത്തു',
    'mr-IN': 'निवडलेले',
    'nl-BE': 'Geselecteerd',
    'nl-NL': 'Geselecteerd',
    'pl-PL': 'Wybrane',
    'pt-BR': 'Selecionado',
    'pt-PT': 'Selecionado',
    'sv-SE': 'Vald',
    'ta-IN': 'தேர்ந்தெடுக்கப்பட்டது',
    'te-IN': 'ఎంపిక చేయబడింది',
    'th-TH': 'เลือกแล้ว',
    'tr-TR': 'Seçildi',
    'vi-VN': 'Đã chọn',
    'zh-CN': '选定',
    'zh-TW': '已選取',
  },
  'ag-totalRows': {
    'en-US': 'Total Rows',
    'ar-AE': 'إجمالي الصفوف',
    'bn-IN': 'মোট সারি',
    'de-DE': 'Zeilen insgesamt',
    'en-AU': 'Total rows',
    'en-GB': 'Total rows',
    'en-ZA': 'Total rows',
    'es-ES': 'Total de filas',
    'es-MX': 'Total de filas',
    'fr-BE': 'Total des lignes',
    'fr-CA': 'Nombre total de rangées',
    'fr-FR': 'Total des lignes',
    'gu-IN': 'કુલ પંક્તિઓ',
    'hi-IN': 'कुल पंक्तियां',
    'it-IT': 'Totale righe',
    'ja-JP': '合計行数',
    'kn-IN': 'ಒಟ್ಟು ಸಾಲುಗಳು',
    'ko-KR': '행 총합',
    'ml-IN': 'മൊത്തം റോകൾ',
    'mr-IN': 'एकूण ओळी',
    'nl-BE': 'Totaal aantal rijen',
    'nl-NL': 'Totaal aantal rijen',
    'pl-PL': 'Łączna liczba wierszy',
    'pt-BR': 'Total de linhas',
    'pt-PT': 'Total de linhas',
    'sv-SE': 'Totalt antal rader',
    'ta-IN': 'மொத்த வரிசைகள்',
    'te-IN': 'మొత్తం వరుసలు',
    'th-TH': 'แถวทั้งหมด',
    'tr-TR': 'Toplam satır',
    'vi-VN': 'Tổng số hàng',
    'zh-CN': '总行数',
    'zh-TW': '總列數',
  },
  'ag-totalAndFilteredRows': {
    'en-US': 'Rows',
    'ar-AE': 'الصفوف',
    'bn-IN': 'সারি',
    'de-DE': 'Zeilen',
    'es-ES': 'Filas',
    'es-MX': 'Filas',
    'fr-BE': 'Lignes',
    'fr-CA': 'Rangées',
    'fr-FR': 'Lignes',
    'gu-IN': 'પંક્તિઓ',
    'hi-IN': 'पंक्तियां',
    'it-IT': 'Righe',
    'ja-JP': '行',
    'kn-IN': 'ಸಾಲುಗಳು',
    'ko-KR': '행',
    'ml-IN': 'റോകൾ',
    'mr-IN': 'ओळी',
    'nl-BE': 'Rijen',
    'nl-NL': 'Rijen',
    'pl-PL': 'Wiersze',
    'pt-BR': 'Linhas',
    'pt-PT': 'Linhas',
    'sv-SE': 'Rader',
    'ta-IN': 'வரிசைகள்',
    'te-IN': 'అడ్డు వరుసలు',
    'th-TH': 'แถว',
    'tr-TR': 'Satırlar',
    'vi-VN': 'Hàng',
    'zh-CN': '行数',
    'zh-TW': '列',
  },
  'ag-more': {
    'en-US': 'More',
    'ar-AE': 'المزيد',
    'bn-IN': 'আরও',
    'de-DE': 'Mehr',
    'es-ES': 'Más',
    'es-MX': 'Más',
    'fr-BE': 'Plus',
    'fr-CA': 'Plus',
    'fr-FR': 'Plus',
    'gu-IN': 'વધુ',
    'hi-IN': 'ज़्यादा',
    'it-IT': 'Altro',
    'ja-JP': '詳細',
    'kn-IN': 'ಇನ್ನಷ್ಟು',
    'ko-KR': '더 보기',
    'ml-IN': 'കൂടുതൽ',
    'mr-IN': 'अधिक',
    'nl-BE': 'Meer',
    'nl-NL': 'Meer',
    'pl-PL': 'Więcej',
    'pt-BR': 'Mais',
    'pt-PT': 'Mais',
    'sv-SE': 'Mer',
    'ta-IN': 'மேலும்',
    'te-IN': 'మరిన్ని',
    'th-TH': 'เพิ่มเติม',
    'tr-TR': 'Daha fazla',
    'vi-VN': 'Thêm',
    'zh-CN': '更多',
    'zh-TW': '更多',
  },
  'ag-to': {
    'en-US': 'to',
    'ar-AE': 'إلى',
    'bn-IN': 'পর্যন্ত',
    'de-DE': 'bis',
    'es-ES': 'hasta',
    'es-MX': 'hasta',
    'fr-BE': 'à',
    'fr-CA': 'à',
    'fr-FR': 'par',
    'gu-IN': 'પ્રતિ',
    'hi-IN': 'से',
    'it-IT': 'a',
    'ja-JP': 'から',
    'kn-IN': 'ಗೆ',
    'ko-KR': '다음까지',
    'ml-IN': 'ഇതിലേക്ക്',
    'mr-IN': 'प्रति',
    'nl-BE': 'tot',
    'nl-NL': 'aan',
    'pl-PL': 'do',
    'pt-BR': 'a',
    'pt-PT': 'para',
    'sv-SE': 'till',
    'ta-IN': 'இதுவரை',
    'te-IN': 'దీనికి',
    'th-TH': 'ถึง',
    'tr-TR': 'bitiş:',
    'vi-VN': 'đến',
    'zh-CN': '至',
    'zh-TW': '至',
  },
  'ag-of': {
    'en-US': 'of',
    'ar-AE': 'من',
    'bn-IN': 'এর',
    'de-DE': 'von',
    'es-ES': 'de',
    'es-MX': 'de',
    'fr-BE': 'sur',
    'fr-CA': 'de',
    'fr-FR': 'de',
    'gu-IN': 'આની',
    'hi-IN': 'का',
    'it-IT': 'di',
    'ja-JP': '/',
    'kn-IN': 'ನ',
    'ko-KR': '/',
    'ml-IN': '/',
    'mr-IN': 'याचे',
    'nl-BE': 'van',
    'nl-NL': 'van',
    'pl-PL': 'z',
    'pt-BR': 'de',
    'pt-PT': 'de',
    'sv-SE': 'av',
    'ta-IN': '/',
    'te-IN': 'వీటిలో',
    'th-TH': 'จาก',
    'tr-TR': '/',
    'vi-VN': 'trong số',
    'zh-CN': '/',
    'zh-TW': '的',
  },
  'ag-page': {
    'en-US': 'Page',
    'ar-AE': 'صفحة',
    'bn-IN': 'পৃষ্ঠা',
    'de-DE': 'Seite',
    'es-ES': 'Página',
    'es-MX': 'Página',
    'gu-IN': 'પેજ',
    'hi-IN': 'पेज',
    'it-IT': 'Pagina',
    'ja-JP': 'ページ',
    'kn-IN': 'ಪುಟ',
    'ko-KR': '페이지',
    'ml-IN': 'പേജ്',
    'mr-IN': 'पृष्ठ',
    'nl-BE': 'Pagina',
    'nl-NL': 'Pagina',
    'pl-PL': 'Strona',
    'pt-BR': 'Página',
    'pt-PT': 'Página',
    'sv-SE': 'Sida',
    'ta-IN': 'பக்கம்',
    'te-IN': 'పేజీ',
    'th-TH': 'หน้า',
    'tr-TR': 'Sayfa',
    'vi-VN': 'Trang',
    'zh-CN': '页面',
    'zh-TW': '頁面',
  },
  'ag-nextPage': {
    'en-US': 'Next Page',
    'ar-AE': 'الصفحة التالية',
    'bn-IN': 'পরবর্তী পৃষ্ঠা',
    'de-DE': 'Nächste Seite',
    'en-AU': 'Next page',
    'en-GB': 'Next page',
    'en-ZA': 'Next page',
    'es-ES': 'Página siguiente',
    'es-MX': 'Página siguiente',
    'fr-BE': 'Page suivante',
    'fr-CA': 'Page suivante',
    'fr-FR': 'Page suivante',
    'gu-IN': 'આગળનું પેજ',
    'hi-IN': 'अगला पेज',
    'it-IT': 'Pagina successiva',
    'ja-JP': '次のページ',
    'kn-IN': 'ಮುಂದಿನ ಪುಟ',
    'ko-KR': '다음 페이지',
    'ml-IN': 'അടുത്ത പേജ്',
    'mr-IN': 'पुढील पृष्ठ',
    'nl-BE': 'Volgende pagina',
    'nl-NL': 'Volgende pagina',
    'pl-PL': 'Następna strona',
    'pt-BR': 'Próxima página',
    'pt-PT': 'Página seguinte',
    'sv-SE': 'Nästa sida',
    'ta-IN': 'அடுத்த பக்கம்',
    'te-IN': 'తదుపరి పేజీ',
    'th-TH': 'หน้าถัดไป',
    'tr-TR': 'Sonraki sayfa',
    'vi-VN': 'Trang tiếp theo',
    'zh-CN': '下一页',
    'zh-TW': '下一頁',
  },
  'ag-lastPage': {
    'en-US': 'Last Page',
    'ar-AE': 'الصفحة الأخيرة',
    'bn-IN': 'শেষ পৃষ্ঠা',
    'de-DE': 'Letzte Seite',
    'en-AU': 'Last page',
    'en-GB': 'Last page',
    'en-ZA': 'Last page',
    'es-ES': 'Última página',
    'es-MX': 'Última página',
    'fr-BE': 'Dernière page',
    'fr-CA': 'Dernière page',
    'fr-FR': 'Dernière page',
    'gu-IN': 'છેલ્લું પેજ',
    'hi-IN': 'आखिरी पेज',
    'it-IT': 'Ultima pagina',
    'ja-JP': '最後のページ',
    'kn-IN': 'ಕೊನೆಯ ಪುಟ',
    'ko-KR': '마지막 페이지',
    'ml-IN': 'അവസാന പേജ്',
    'mr-IN': 'शेवटचे पृष्ठ',
    'nl-BE': 'Laatste pagina',
    'nl-NL': 'Laatste pagina',
    'pl-PL': 'Ostatnia strona',
    'pt-BR': 'Última página',
    'pt-PT': 'Última página',
    'sv-SE': 'Sista sidan',
    'ta-IN': 'கடைசிப் பக்கம்',
    'te-IN': 'చివరి పేజీ',
    'th-TH': 'หน้าสุดท้าย',
    'tr-TR': 'Son sayfa',
    'vi-VN': 'Trang cuối cùng',
    'zh-CN': '最后一页',
    'zh-TW': '最後一頁',
  },
  'ag-firstPage': {
    'en-US': 'First Page',
    'ar-AE': 'الصفحة الأولى',
    'bn-IN': 'প্রথম পৃষ্ঠা',
    'de-DE': 'Erste Seite',
    'en-AU': 'First page',
    'en-GB': 'First page',
    'en-ZA': 'First page',
    'es-ES': 'Primera página',
    'fr-BE': 'Première page',
    'fr-CA': 'Première page',
    'fr-FR': 'Première page',
    'gu-IN': 'પ્રથમ પેજ',
    'hi-IN': 'पहला पेज',
    'it-IT': 'Prima pagina',
    'ja-JP': '最初のページ',
    'kn-IN': 'ಮೊದಲ ಪುಟ',
    'ko-KR': '첫 페이지',
    'ml-IN': 'ആദ്യ പേജ്',
    'mr-IN': 'पहिले पृष्ठ',
    'nl-BE': 'Eerste pagina',
    'nl-NL': 'Eerste pagina',
    'pl-PL': 'Pierwsza strona',
    'pt-BR': 'Primeira página',
    'pt-PT': 'Primeira página',
    'sv-SE': 'Första sidan',
    'ta-IN': 'முதல் பக்கம்',
    'te-IN': 'మొదటి పేజీ',
    'th-TH': 'หน้าแรก',
    'tr-TR': 'İlk sayfa',
    'vi-VN': 'Trang đầu tiên',
    'zh-CN': '首页',
    'zh-TW': '第一頁',
  },
  'ag-previousPage': {
    'en-US': 'Previous Page',
    'ar-AE': 'الصفحة السابقة',
    'bn-IN': 'পূর্ববর্তী পৃষ্ঠা',
    'de-DE': 'Vorige Seite',
    'en-AU': 'Previous page',
    'en-GB': 'Previous page',
    'en-ZA': 'Previous page',
    'es-ES': 'Página anterior',
    'es-MX': 'Página anterior',
    'fr-BE': 'Page précédente',
    'fr-CA': 'Page précédente',
    'fr-FR': 'Page précédente',
    'gu-IN': 'અગાઉનું પેજ',
    'hi-IN': 'पिछला पेज',
    'it-IT': 'Pagina precedente',
    'ja-JP': '前のページ',
    'kn-IN': 'ಹಿಂದಿನ ಪುಟ',
    'ko-KR': '이전 페이지',
    'ml-IN': 'മുമ്പത്തെ പേജ്',
    'mr-IN': 'मागील पृष्ठ',
    'nl-BE': 'Vorige pagina',
    'nl-NL': 'Vorige pagina',
    'pl-PL': 'Poprzednia strona',
    'pt-BR': 'Página anterior',
    'pt-PT': 'Página anterior',
    'sv-SE': 'Föregående sida',
    'ta-IN': 'முந்தைய பக்கம்',
    'te-IN': 'మునుపటి పేజీ',
    'th-TH': 'หน้าก่อน',
    'tr-TR': 'Önceki sayfa',
    'vi-VN': 'Trang trước',
    'zh-CN': '上一页',
    'zh-TW': '上一頁',
  },
  'ag-pivotColumnGroupTotals': {
    'en-US': 'Total',
    'ar-AE': 'الإجمالي',
    'bn-IN': 'মোট',
    'de-DE': 'Gesamt',
    'gu-IN': 'કુલ',
    'hi-IN': 'कुल',
    'it-IT': 'Totale',
    'ja-JP': '合計',
    'kn-IN': 'ಒಟ್ಟು',
    'ko-KR': '총계',
    'ml-IN': 'ആകെ',
    'mr-IN': 'एकूण',
    'nl-BE': 'Totaal',
    'nl-NL': 'Totaal',
    'pl-PL': 'Suma',
    'sv-SE': 'Totalt',
    'ta-IN': 'மொத்தம்',
    'te-IN': 'మొత్తం',
    'th-TH': 'รวม',
    'tr-TR': 'Toplam',
    'vi-VN': 'Tổng cộng',
    'zh-CN': '总计',
    'zh-TW': '總計',
  },
  'ag-pivotChartAndPivotMode': {
    'en-US': 'Pivot Chart & Pivot Mode',
    'ar-AE': 'الرسم البياني المحوري والوضع المحوري',
    'bn-IN': 'পিভট চার্ট ও পিভট মোড',
    'de-DE': 'Pivot-Tabelle und Pivot-Modus',
    'en-AU': 'Pivot chart and pivot mode',
    'en-GB': 'Pivot chart & Pivot mode',
    'en-ZA': 'Pivot chart & Pivot Mode',
    'es-ES': 'Gráfico dinámico y modo dinámico',
    'es-MX': 'Gráfico dinámico y modo dinámico',
    'fr-BE': 'Graphique croisé dynamique et Mode croisé dynamique',
    'fr-CA': 'Diagramme croisé et mode pivot',
    'fr-FR': 'Graphique croisé dynamique et Mode croisé dynamique',
    'gu-IN': 'પિવોટ ચાર્ટ અને પિવોટ મોડ',
    'hi-IN': 'पिवट चार्ट और पिवट मोड',
    'it-IT': 'Tabella pivot e modalità pivot',
    'ja-JP': 'ピボットチャート&ピボットモード',
    'kn-IN': 'ಪಿವೋಟ್ ಚಾರ್ಟ್ ಮತ್ತು ಪಿವೋಟ್ ಮೋಡ್',
    'ko-KR': '피벗 차트 및 피벗 모드',
    'ml-IN': 'പിവറ്റ് ചാർട്ടും പിവറ്റ് മോഡും',
    'mr-IN': 'पायव्होट चार्ट आणि पायव्होट मोड',
    'nl-BE': 'Draaitabel en draaimodus',
    'nl-NL': 'Draaidiagram en draaimodus',
    'pl-PL': 'Wykres przestawny i tryb przestawny',
    'pt-BR': 'Gráfico dinâmico e modo de tabela dinâmica',
    'pt-PT': 'Gráfico dinâmico e Modo dinâmico',
    'sv-SE': 'Pivottabell och pivotläge',
    'ta-IN': 'பிவோட் விளக்கப்படம் மற்றும் பிவோட் பயன்முறை',
    'te-IN': 'పివోట్ చార్ట్ మరియు పివోట్ మోడ్',
    'th-TH': 'แผนภูมิ Pivot และโหมด Pivot',
    'tr-TR': 'Pivot tablosu ve pivot modu',
    'vi-VN': 'Biểu đồ Pivot & Chế độ Pivot',
    'zh-CN': '透视图和透视模式',
    'zh-TW': '樞紐分析圖和樞紐模式',
  },
  'ag-pivotChart': {
    'en-US': 'Pivot Chart',
    'ar-AE': 'الرسم البياني المحوري',
    'bn-IN': 'পিভট চার্ট',
    'de-DE': 'Pivot-Tabelle',
    'en-AU': 'Pivot chart',
    'en-GB': 'Pivot chart',
    'en-ZA': 'Pivot chart',
    'es-ES': 'Gráfico dinámico',
    'es-MX': 'Gráfico dinámico',
    'fr-BE': 'Graphique croisé dynamique',
    'fr-CA': 'Graphique croisé',
    'fr-FR': 'Graphique croisé dynamique',
    'gu-IN': 'પિવોટ ચાર્ટ',
    'hi-IN': 'पिवट चार्ट',
    'it-IT': 'Tabella pivot',
    'ja-JP': 'ピボットチャート',
    'kn-IN': 'ಪಿವೋಟ್ ಚಾರ್ಟ್',
    'ko-KR': '피벗 차트',
    'ml-IN': 'പിവറ്റ് ചാർട്ട്',
    'mr-IN': 'पायव्होट चार्ट',
    'nl-BE': 'Draaitabel',
    'nl-NL': 'Draaidiagram',
    'pl-PL': 'Wykres przestawny',
    'pt-BR': 'Tabela dinâmica',
    'pt-PT': 'Gráfico dinâmico',
    'sv-SE': 'Pivottabell',
    'ta-IN': 'பிவோட் விளக்கப்படம்',
    'te-IN': 'పివోట్ చార్ట్',
    'th-TH': 'แผนภูมิ Pivot',
    'tr-TR': 'Pivot tablosu',
    'vi-VN': 'Biểu đồ pivot',
    'zh-CN': '透视图',
    'zh-TW': '樞紐分析圖',
  },
  'ag-chartRange': {
    'en-US': 'Chart Range',
    'ar-AE': 'نطاق الرسم البياني',
    'bn-IN': 'চার্টের রেঞ্জ',
    'de-DE': 'Tabellenbereich',
    'en-AU': 'Chart range',
    'en-GB': 'Chart range',
    'en-ZA': 'Chart range',
    'es-ES': 'Rango del gráfico',
    'es-MX': 'Rango del gráfico',
    'fr-BE': 'Plage du graphique',
    'fr-CA': 'Plage du graphique',
    'fr-FR': 'Plage de graphiques',
    'gu-IN': 'ચાર્ટ રેન્જ',
    'hi-IN': 'चार्ट रेंज',
    'it-IT': 'Intervallo grafico',
    'ja-JP': 'チャートの範囲',
    'kn-IN': 'ಚಾರ್ಟ್ ಶ್ರೇಣಿ',
    'ko-KR': '차트 범위',
    'ml-IN': 'ചാർട്ട് ശ്രേണി',
    'mr-IN': 'चार्ट रेंज',
    'nl-BE': 'Bereik van grafiek',
    'nl-NL': 'Bereik van grafiek',
    'pl-PL': 'Zakres wykresu',
    'pt-BR': 'Faixa de gráfico',
    'pt-PT': 'Intervalo do gráfico',
    'sv-SE': 'Diagramintervall',
    'ta-IN': 'விளக்கப்பட ரேஞ்ச்',
    'te-IN': 'చార్ట్ పరిధి',
    'th-TH': 'ช่วงแผนภูมิ',
    'tr-TR': 'Tablo aralığı',
    'vi-VN': 'Phạm vi biểu đồ',
    'zh-CN': '图表范围',
    'zh-TW': '圖表範圍',
  },
  'ag-columnChart': {
    'en-US': 'Column',
    'ar-AE': 'العمود',
    'bn-IN': 'কলাম',
    'de-DE': 'Spalte',
    'es-ES': 'Columna',
    'es-MX': 'Columna',
    'fr-BE': 'Colonne',
    'fr-CA': 'Colonne',
    'fr-FR': 'Colonne',
    'gu-IN': 'કોલમ',
    'hi-IN': 'कॉलम',
    'it-IT': 'Colonna',
    'ja-JP': '項目',
    'kn-IN': 'ಕಾಲಮ್‌',
    'ko-KR': '열',
    'ml-IN': 'കോളം',
    'mr-IN': 'स्‍तंभ',
    'nl-BE': 'Kolom',
    'nl-NL': 'Kolom',
    'pl-PL': 'Kolumnowy',
    'pt-BR': 'Coluna',
    'pt-PT': 'Coluna',
    'sv-SE': 'Kolumn',
    'ta-IN': 'நெடுவரிசை',
    'te-IN': 'కాలమ్',
    'th-TH': 'คอลัมน์',
    'tr-TR': 'Sütun',
    'vi-VN': 'Cột',
    'zh-CN': '列',
    'zh-TW': '資料欄',
  },
  'ag-groupedColumn': {
    'en-US': 'Grouped',
    'ar-AE': 'مُجمعة',
    'bn-IN': 'গ্রুপ করা হয়েছে',
    'de-DE': 'Gruppiert',
    'es-ES': 'Agrupado',
    'es-MX': 'Agrupados',
    'fr-BE': 'Regroupé',
    'fr-CA': 'Groupé',
    'fr-FR': 'Regrouper',
    'gu-IN': 'જૂથબદ્ધ',
    'hi-IN': 'ग्रुप किया गया',
    'it-IT': 'Raggruppato',
    'ja-JP': 'グループ化',
    'kn-IN': 'ಗುಂಪು ಮಾಡಲಾಗಿದೆ',
    'ko-KR': '그룹화됨',
    'ml-IN': 'ഗ്രൂപ്പ് ചെയ്തു',
    'mr-IN': 'ग्रुप केले',
    'nl-BE': 'Gegroepeerd',
    'nl-NL': 'Gegroepeerd',
    'pl-PL': 'Zgrupowane',
    'pt-BR': 'Agrupado',
    'pt-PT': 'Agrupado',
    'sv-SE': 'Grupperad',
    'ta-IN': 'குரூப் செய்யப்பட்டது',
    'te-IN': 'వర్గీకరించినవి',
    'th-TH': 'จัดกลุ่มแล้ว',
    'tr-TR': 'Gruplanmış',
    'vi-VN': 'Đã nhóm',
    'zh-CN': '已分组',
    'zh-TW': '已分組',
  },
  'ag-stackedColumn': {
    'en-US': 'Stacked',
    'ar-AE': 'مُتكدس',
    'bn-IN': 'স্ট্যাক করা হয়েছে',
    'de-DE': 'Gestapelt',
    'es-ES': 'Apilado',
    'es-MX': 'Apilados',
    'fr-BE': 'Empilé',
    'fr-CA': 'Compilé',
    'fr-FR': 'En attente',
    'gu-IN': 'સ્ટેક્ડ',
    'hi-IN': 'स्टैक किया गया',
    'it-IT': 'Impilato',
    'ja-JP': '積み重ね済み',
    'kn-IN': 'ಜೋಡಿಸಲಾಗಿದೆ',
    'ko-KR': '스택',
    'ml-IN': 'അടുക്കിയിരിക്കുന്നു',
    'mr-IN': 'स्टॅक केले',
    'nl-BE': 'Gestapeld',
    'nl-NL': 'Gestapeld',
    'pl-PL': 'Skumulowany',
    'pt-BR': 'Empilhados',
    'pt-PT': 'Empilhado',
    'sv-SE': 'Staplade',
    'ta-IN': 'ஸ்டாக் செய்யப்பட்டது',
    'te-IN': 'వరుసలో ఉంచినది',
    'th-TH': 'เรียงซ้อน',
    'tr-TR': 'İstiflenmiş',
    'vi-VN': 'Xếp chồng',
    'zh-CN': '堆叠图',
    'zh-TW': '堆疊',
  },
  'ag-normalizedColumn': {
    'en-US': '100% Stacked',
    'ar-AE': 'مكدسة بنسبة 100%',
    'bn-IN': '100% স্ট্যাক করা হয়েছে',
    'de-DE': '100 % gestapelt',
    'en-AU': '100% stacked',
    'en-GB': '100% stacked',
    'en-ZA': '100% stacked',
    'es-ES': '100 % apilado',
    'es-MX': '100 % apilado',
    'fr-BE': '100 % empilés',
    'fr-CA': 'Compilé à 100 %',
    'fr-FR': '100 % en attente',
    'gu-IN': '100% સ્ટેક્ડ',
    'hi-IN': '100% स्टैक किया गया',
    'it-IT': 'Impilati al 100%',
    'ja-JP': '100%積み重ね済み',
    'kn-IN': '100% ಜೋಡಿಸಲಾಗಿದೆ',
    'ko-KR': '100% 스택',
    'ml-IN': '100% അടുക്കിയിരിക്കുന്നു',
    'mr-IN': '100% स्टॅक केले',
    'nl-BE': '100% gestapeld',
    'nl-NL': '100% gestapeld',
    'pl-PL': '100% skumulowany',
    'pt-BR': '100% empilhados',
    'pt-PT': '100% empilhado',
    'sv-SE': '100 % staplade',
    'ta-IN': '100% அடுக்கப்பட்டது',
    'te-IN': '100% పేర్చినది',
    'th-TH': 'เรียงซ้อน 100%',
    'tr-TR': '%100 istiflenmiş',
    'vi-VN': 'Xếp chồng 100%',
    'zh-CN': '100% 堆叠',
    'zh-TW': '100% 堆疊',
  },
  'ag-barChart': {
    'en-US': 'Bar',
    'ar-AE': 'شريط',
    'bn-IN': 'বার',
    'de-DE': 'Sperren',
    'es-ES': 'Barra',
    'es-MX': 'Barra',
    'fr-BE': 'Barre',
    'fr-CA': 'Barre',
    'fr-FR': 'Barre',
    'gu-IN': 'બાર',
    'hi-IN': 'बार',
    'it-IT': 'Standard',
    'ja-JP': 'バー',
    'kn-IN': 'ಬಾರ್',
    'ko-KR': '바',
    'ml-IN': 'ബാർ',
    'mr-IN': 'बार',
    'nl-BE': 'Drempel',
    'nl-NL': 'Balk',
    'pl-PL': 'Słupkowy',
    'pt-BR': 'Barra',
    'pt-PT': 'Barra',
    'sv-SE': 'Nivå',
    'ta-IN': 'பார்',
    'te-IN': 'బార్',
    'th-TH': 'บาร์',
    'tr-TR': 'Çubuk',
    'vi-VN': 'Thanh',
    'zh-CN': '条形图',
    'zh-TW': '條狀',
  },
  'ag-groupedBar': {
    'en-US': 'Grouped',
    'ar-AE': 'مُجمعة',
    'bn-IN': 'গ্রুপ করা হয়েছে',
    'de-DE': 'Gruppiert',
    'es-ES': 'Agrupado',
    'es-MX': 'Agrupados',
    'fr-BE': 'Regroupé',
    'fr-CA': 'Groupé',
    'fr-FR': 'Regrouper',
    'gu-IN': 'જૂથબદ્ધ',
    'hi-IN': 'ग्रुप किया गया',
    'it-IT': 'Raggruppato',
    'ja-JP': 'グループ化',
    'kn-IN': 'ಗುಂಪು ಮಾಡಲಾಗಿದೆ',
    'ko-KR': '그룹화됨',
    'ml-IN': 'ഗ്രൂപ്പ് ചെയ്തു',
    'mr-IN': 'ग्रुप केले',
    'nl-BE': 'Gegroepeerd',
    'nl-NL': 'Gegroepeerd',
    'pl-PL': 'Zgrupowane',
    'pt-BR': 'Agrupado',
    'pt-PT': 'Agrupado',
    'sv-SE': 'Grupperad',
    'ta-IN': 'குரூப் செய்யப்பட்டது',
    'te-IN': 'వర్గీకరించినవి',
    'th-TH': 'จัดกลุ่มแล้ว',
    'tr-TR': 'Gruplanmış',
    'vi-VN': 'Đã nhóm',
    'zh-CN': '已分组',
    'zh-TW': '已分組',
  },
  'ag-stackedBar': {
    'en-US': 'Stacked',
    'ar-AE': 'مُتكدس',
    'bn-IN': 'স্ট্যাক করা হয়েছে',
    'de-DE': 'Gestapelt',
    'es-ES': 'Apilado',
    'es-MX': 'Apilados',
    'fr-BE': 'Empilé',
    'fr-CA': 'Compilé',
    'fr-FR': 'En attente',
    'gu-IN': 'સ્ટેક્ડ',
    'hi-IN': 'स्टैक किया गया',
    'it-IT': 'Impilato',
    'ja-JP': '積み重ね済み',
    'kn-IN': 'ಜೋಡಿಸಲಾಗಿದೆ',
    'ko-KR': '스택',
    'ml-IN': 'അടുക്കിയിരിക്കുന്നു',
    'mr-IN': 'स्टॅक केले',
    'nl-BE': 'Gestapeld',
    'nl-NL': 'Gestapeld',
    'pl-PL': 'Skumulowany',
    'pt-BR': 'Empilhados',
    'pt-PT': 'Empilhado',
    'sv-SE': 'Staplade',
    'ta-IN': 'ஸ்டாக் செய்யப்பட்டது',
    'te-IN': 'వరుసలో ఉంచినది',
    'th-TH': 'เรียงซ้อน',
    'tr-TR': 'İstiflenmiş',
    'vi-VN': 'Xếp chồng',
    'zh-CN': '堆叠图',
    'zh-TW': '堆疊',
  },
  'ag-normalizedBar': {
    'en-US': '100% Stacked',
    'ar-AE': 'مكدسة بنسبة 100%',
    'bn-IN': '100% স্ট্যাক করা হয়েছে',
    'de-DE': '100 % gestapelt',
    'en-AU': '100% stacked',
    'en-GB': '100% stacked',
    'en-ZA': '100% stacked',
    'es-ES': '100 % apilado',
    'es-MX': '100 % apilado',
    'fr-BE': '100 % empilés',
    'fr-CA': 'Compilé à 100 %',
    'fr-FR': '100 % en attente',
    'gu-IN': '100% સ્ટેક્ડ',
    'hi-IN': '100% स्टैक किया गया',
    'it-IT': 'Impilati al 100%',
    'ja-JP': '100%積み重ね済み',
    'kn-IN': '100% ಜೋಡಿಸಲಾಗಿದೆ',
    'ko-KR': '100% 스택',
    'ml-IN': '100% അടുക്കിയിരിക്കുന്നു',
    'mr-IN': '100% स्टॅक केले',
    'nl-BE': '100% gestapeld',
    'nl-NL': '100% gestapeld',
    'pl-PL': '100% skumulowany',
    'pt-BR': '100% empilhados',
    'pt-PT': '100% empilhado',
    'sv-SE': '100 % staplade',
    'ta-IN': '100% அடுக்கப்பட்டது',
    'te-IN': '100% పేర్చినది',
    'th-TH': 'เรียงซ้อน 100%',
    'tr-TR': '%100 istiflenmiş',
    'vi-VN': 'Xếp chồng 100%',
    'zh-CN': '100% 堆叠',
    'zh-TW': '100% 堆疊',
  },
  'ag-pieChart': {
    'en-US': 'Pie',
    'ar-AE': 'شكل دائري',
    'bn-IN': 'পাই',
    'de-DE': 'Torte',
    'es-ES': 'Circular',
    'es-MX': 'Circular',
    'fr-BE': 'Circulaire',
    'fr-CA': 'Tarte',
    'fr-FR': 'Pâté',
    'gu-IN': 'પાઇ',
    'hi-IN': 'पाई',
    'it-IT': 'A torta',
    'ja-JP': 'パイ',
    'kn-IN': 'ಪೈ',
    'ko-KR': '파이',
    'ml-IN': 'പൈ',
    'mr-IN': 'पाय',
    'nl-BE': 'Taart',
    'nl-NL': 'Cirkel',
    'pl-PL': 'Kołowy',
    'pt-BR': 'Pizza',
    'pt-PT': 'Circular',
    'sv-SE': 'Paj',
    'ta-IN': 'பை',
    'te-IN': 'పైయ్',
    'th-TH': 'วงกลม',
    'tr-TR': 'Pasta',
    'vi-VN': 'Tròn',
    'zh-CN': '饼图',
    'zh-TW': '圓餅',
  },
  'ag-pie': {
    'en-US': 'Pie',
    'ar-AE': 'شكل دائري',
    'bn-IN': 'পাই',
    'de-DE': 'Torte',
    'es-ES': 'Circular',
    'es-MX': 'Circular',
    'fr-BE': 'Circulaire',
    'fr-CA': 'Tarte',
    'fr-FR': 'Pâté',
    'gu-IN': 'પાઇ',
    'hi-IN': 'पाई',
    'it-IT': 'A torta',
    'ja-JP': 'パイ',
    'kn-IN': 'ಪೈ',
    'ko-KR': '파이',
    'ml-IN': 'പൈ',
    'mr-IN': 'पाय',
    'nl-BE': 'Taart',
    'nl-NL': 'Cirkel',
    'pl-PL': 'Kołowy',
    'pt-BR': 'Pizza',
    'pt-PT': 'Circular',
    'sv-SE': 'Paj',
    'ta-IN': 'பை',
    'te-IN': 'పైయ్',
    'th-TH': 'วงกลม',
    'tr-TR': 'Pasta',
    'vi-VN': 'Tròn',
    'zh-CN': '饼图',
    'zh-TW': '圓餅',
  },
  'ag-doughnut': {
    'en-US': 'Doughnut',
    'ar-AE': 'حلقة دونات',
    'bn-IN': 'ডোনাট',
    'de-DE': 'Donut',
    'es-ES': 'Anillo',
    'es-MX': 'De anillos',
    'fr-BE': 'Beignets',
    'fr-CA': 'Beigne',
    'fr-FR': 'Anneau',
    'gu-IN': 'ડોનટ',
    'hi-IN': 'डोनट',
    'it-IT': 'a ciambella',
    'ja-JP': 'ドーナッツ',
    'kn-IN': 'ಡೋನಟ್',
    'ko-KR': '도넛',
    'ml-IN': 'ഡോണട്ട്',
    'mr-IN': 'डोनट',
    'nl-BE': 'Donut',
    'nl-NL': 'Ring',
    'pl-PL': 'Pierścieniowy',
    'pt-BR': 'Rosca',
    'pt-PT': 'Anel',
    'sv-SE': 'Donut',
    'ta-IN': 'டௌநட்',
    'te-IN': 'డోనట్',
    'th-TH': 'โดนัท',
    'tr-TR': 'Halka',
    'vi-VN': 'Bánh vìng',
    'zh-CN': '环形图',
    'zh-TW': '環圈',
  },
  'ag-line': {
    'en-US': 'Line',
    'ar-AE': 'الخط',
    'bn-IN': 'লাইন',
    'de-DE': 'Zeile',
    'es-ES': 'Línea',
    'es-MX': 'Línea',
    'fr-BE': 'Linéaire',
    'fr-CA': 'Ligne',
    'fr-FR': 'Ligne',
    'gu-IN': 'લાઇન',
    'hi-IN': 'लाइन',
    'it-IT': 'Riga',
    'ja-JP': '行',
    'kn-IN': 'ಸಾಲು',
    'ko-KR': '줄',
    'ml-IN': 'ലൈൻ',
    'mr-IN': 'ओळ',
    'nl-BE': 'Regel',
    'nl-NL': 'Regel',
    'pl-PL': 'Liniowy',
    'pt-BR': 'Linha',
    'pt-PT': 'Linha',
    'sv-SE': 'Rad',
    'ta-IN': 'வரி',
    'te-IN': 'పంక్తి',
    'th-TH': 'บรรทัด',
    'tr-TR': 'Satır',
    'vi-VN': 'Dòng',
    'zh-CN': '行',
    'zh-TW': '線條',
  },
  'ag-xyChart': {
    'en-US': 'X Y (Scatter)',
    'ar-AE': 'X Y (مبعثر)',
    'bn-IN': 'X Y (স্ক্যাটার)',
    'de-DE': 'X Y (Streuung)',
    'en-AU': 'X Y (scatter)',
    'es-ES': 'X Y (dispersión)',
    'es-MX': 'X Y (dispersión)',
    'fr-BE': 'X Y (Éparpiller)',
    'fr-CA': 'X Y (Dispersion)',
    'fr-FR': 'X Y (répartition)',
    'gu-IN': 'X Y (સ્કેટર)',
    'hi-IN': 'X Y (स्कैटर)',
    'it-IT': 'X Y (Disperdi)',
    'ja-JP': 'X Y（散布図）',
    'kn-IN': 'X Y (ಸ್ಕ್ಯಾಟರ್)',
    'ko-KR': 'X Y(스캐터)',
    'ml-IN': 'X Y (സ്‌കാറ്റർ)',
    'mr-IN': 'X Y (स्कॅटर)',
    'nl-BE': 'X Y (spreiding)',
    'nl-NL': 'X Y (spreiden)',
    'pl-PL': 'X Y (punktowy)',
    'pt-BR': 'X Y (Desagrupar)',
    'pt-PT': 'X Y (Dispersão)',
    'sv-SE': 'X Y (sprid)',
    'ta-IN': 'X Y (ஸ்காட்டர்)',
    'te-IN': 'X Y (స్కాటర్)',
    'th-TH': 'X Y (กระจาย)',
    'tr-TR': 'X Y (dağılım)',
    'vi-VN': 'X Y (Phân tán)',
    'zh-CN': 'X Y（散点图）',
    'zh-TW': 'X Y (散佈)',
  },
  'ag-scatter': {
    'en-US': 'Scatter',
    'ar-AE': 'مبعثر',
    'bn-IN': 'স্ক্যাটার',
    'de-DE': 'Streuung',
    'es-ES': 'Dispersión',
    'es-MX': 'Dispersión',
    'fr-BE': 'Éparpiller',
    'fr-CA': 'Disperser',
    'fr-FR': 'Répartition',
    'gu-IN': 'સ્કેટર',
    'hi-IN': 'स्कैटर',
    'it-IT': 'Disperdi',
    'ja-JP': '散布図',
    'kn-IN': 'ಸ್ಕ್ಯಾಟರ್',
    'ko-KR': '스캐터',
    'ml-IN': 'സ്‌കാറ്റർ ചെയ്യുക',
    'mr-IN': 'स्कॅटर',
    'nl-BE': 'Verspreiden',
    'nl-NL': 'Verspreiden',
    'pl-PL': 'Punktowy',
    'pt-BR': 'Desagrupar',
    'pt-PT': 'Dispersão',
    'sv-SE': 'Sprid',
    'ta-IN': 'ஸ்காட்டர்',
    'te-IN': 'చెల్లాచెదరు',
    'th-TH': 'กระจาย',
    'tr-TR': 'Dağılım',
    'vi-VN': 'Phân tán',
    'zh-CN': '散点图',
    'zh-TW': '散佈',
  },
  'ag-bubble': {
    'en-US': 'Bubble',
    'ar-AE': 'المفرقعة',
    'bn-IN': 'বাবল',
    'de-DE': 'Luftpolsterfolie',
    'es-ES': 'Globo',
    'fr-BE': 'Bulle',
    'fr-CA': 'Bulle',
    'fr-FR': 'Papier-bulles',
    'gu-IN': 'બબલ',
    'hi-IN': 'बबल',
    'it-IT': 'A bolle',
    'ja-JP': 'エアキャップ',
    'kn-IN': 'ಬಬಲ್',
    'ko-KR': '버블',
    'ml-IN': 'ബബിൾ',
    'mr-IN': 'बबल',
    'nl-BE': 'Ballon',
    'nl-NL': 'Bel',
    'pl-PL': 'Bąbelkowy',
    'pt-BR': 'Bolha',
    'pt-PT': 'Balão',
    'sv-SE': 'Bubbla',
    'ta-IN': 'பபுள்',
    'te-IN': 'బబుల్',
    'th-TH': 'ฟอง',
    'tr-TR': 'Kabarcık',
    'vi-VN': 'Xốp hơi',
    'zh-CN': '气泡图',
    'zh-TW': '泡泡',
  },
  'ag-areaChart': {
    'en-US': 'Area',
    'ar-AE': 'المنطقة',
    'bn-IN': 'এলাকা',
    'de-DE': 'Fläche',
    'es-ES': 'Área',
    'es-MX': 'Área',
    'fr-BE': 'Superficie',
    'fr-CA': 'Superficie',
    'fr-FR': 'Zone',
    'gu-IN': 'વિસ્તાર',
    'hi-IN': 'एरिया',
    'it-IT': 'Superficie',
    'ja-JP': '地区',
    'kn-IN': 'ಪ್ರದೇಶ',
    'ko-KR': '영역',
    'ml-IN': 'പ്രദേശം',
    'mr-IN': 'क्षेत्र',
    'nl-BE': 'Gebied',
    'nl-NL': 'Gebied',
    'pl-PL': 'Warstwowy',
    'pt-BR': 'Área',
    'pt-PT': 'Área',
    'sv-SE': 'Område',
    'ta-IN': 'பகுதி',
    'te-IN': 'వైశాల్యం',
    'th-TH': 'พื้นที่',
    'tr-TR': 'Alan',
    'vi-VN': 'Khu vực',
    'zh-CN': '面积图',
    'zh-TW': '區域',
  },
  'ag-area': {
    'en-US': 'Area',
    'ar-AE': 'المنطقة',
    'bn-IN': 'এলাকা',
    'de-DE': 'Fläche',
    'es-ES': 'Área',
    'es-MX': 'Área',
    'fr-BE': 'Superficie',
    'fr-CA': 'Superficie',
    'fr-FR': 'Zone',
    'gu-IN': 'વિસ્તાર',
    'hi-IN': 'एरिया',
    'it-IT': 'Superficie',
    'ja-JP': '地区',
    'kn-IN': 'ಪ್ರದೇಶ',
    'ko-KR': '영역',
    'ml-IN': 'പ്രദേശം',
    'mr-IN': 'क्षेत्र',
    'nl-BE': 'Gebied',
    'nl-NL': 'Gebied',
    'pl-PL': 'Warstwowy',
    'pt-BR': 'Área',
    'pt-PT': 'Área',
    'sv-SE': 'Område',
    'ta-IN': 'பகுதி',
    'te-IN': 'వైశాల్యం',
    'th-TH': 'พื้นที่',
    'tr-TR': 'Alan',
    'vi-VN': 'Khu vực',
    'zh-CN': '面积图',
    'zh-TW': '區域',
  },
  'ag-stackedArea': {
    'en-US': 'Stacked',
    'ar-AE': 'مُتكدس',
    'bn-IN': 'স্ট্যাক করা হয়েছে',
    'de-DE': 'Gestapelt',
    'es-ES': 'Apilado',
    'es-MX': 'Apilados',
    'fr-BE': 'Empilé',
    'fr-CA': 'Compilé',
    'fr-FR': 'En attente',
    'gu-IN': 'સ્ટેક્ડ',
    'hi-IN': 'स्टैक किया गया',
    'it-IT': 'Impilato',
    'ja-JP': '積み重ね済み',
    'kn-IN': 'ಜೋಡಿಸಲಾಗಿದೆ',
    'ko-KR': '스택',
    'ml-IN': 'അടുക്കിയിരിക്കുന്നു',
    'mr-IN': 'स्टॅक केले',
    'nl-BE': 'Gestapeld',
    'nl-NL': 'Gestapeld',
    'pl-PL': 'Skumulowany',
    'pt-BR': 'Empilhados',
    'pt-PT': 'Empilhado',
    'sv-SE': 'Staplade',
    'ta-IN': 'ஸ்டாக் செய்யப்பட்டது',
    'te-IN': 'వరుసలో ఉంచినది',
    'th-TH': 'เรียงซ้อน',
    'tr-TR': 'İstiflenmiş',
    'vi-VN': 'Xếp chồng',
    'zh-CN': '堆叠图',
    'zh-TW': '堆疊',
  },
  'ag-normalizedArea': {
    'en-US': '100% Stacked',
    'ar-AE': 'مكدسة بنسبة 100%',
    'bn-IN': '100% স্ট্যাক করা হয়েছে',
    'de-DE': '100 % gestapelt',
    'en-AU': '100% stacked',
    'en-GB': '100% stacked',
    'en-ZA': '100% stacked',
    'es-ES': '100 % apilado',
    'es-MX': '100 % apilado',
    'fr-BE': '100 % empilés',
    'fr-CA': 'Compilé à 100 %',
    'fr-FR': '100 % en attente',
    'gu-IN': '100% સ્ટેક્ડ',
    'hi-IN': '100% स्टैक किया गया',
    'it-IT': 'Impilati al 100%',
    'ja-JP': '100%積み重ね済み',
    'kn-IN': '100% ಜೋಡಿಸಲಾಗಿದೆ',
    'ko-KR': '100% 스택',
    'ml-IN': '100% അടുക്കിയിരിക്കുന്നു',
    'mr-IN': '100% स्टॅक केले',
    'nl-BE': '100% gestapeld',
    'nl-NL': '100% gestapeld',
    'pl-PL': '100% skumulowany',
    'pt-BR': '100% empilhados',
    'pt-PT': '100% empilhado',
    'sv-SE': '100 % staplade',
    'ta-IN': '100% அடுக்கப்பட்டது',
    'te-IN': '100% పేర్చినది',
    'th-TH': 'เรียงซ้อน 100%',
    'tr-TR': '%100 istiflenmiş',
    'vi-VN': 'Xếp chồng 100%',
    'zh-CN': '100% 堆叠',
    'zh-TW': '100% 堆疊',
  },
  'ag-histogramChart': {
    'en-US': 'Histogram',
    'ar-AE': 'مدرج إحصائي',
    'bn-IN': 'হিস্টোগ্রাম',
    'de-DE': 'Histogramm',
    'es-ES': 'Histograma',
    'es-MX': 'Histograma',
    'fr-BE': 'Histogramme',
    'fr-CA': 'Histogramme',
    'fr-FR': 'Histogramme',
    'gu-IN': 'હિસ્ટોગ્રામ',
    'hi-IN': 'हिस्टोग्राम',
    'it-IT': 'Istogramma',
    'ja-JP': 'ヒストグラム',
    'kn-IN': 'ಹಿಸ್ಟೋಗ್ರಾಮ್',
    'ko-KR': '히스토그램',
    'ml-IN': 'ഹിസ്റ്റോഗ്രാം',
    'mr-IN': 'हिस्टोग्राम',
    'pt-BR': 'Histograma',
    'pt-PT': 'Histograma',
    'ta-IN': 'ஹிஸ்டோகிராம்',
    'te-IN': 'హిస్టోగ్రామ్',
    'th-TH': 'ฮิสโทแกรม',
    'vi-VN': 'Biểu đồ tần suất',
    'zh-CN': '直方图',
    'zh-TW': '直方圖',
  },
  'ag-combinationChart': {
    'en-US': 'Combination',
    'ar-AE': 'الجمع',
    'bn-IN': 'কম্বিনেশন',
    'de-DE': 'Kombination',
    'es-ES': 'Combinación',
    'es-MX': 'Combinación',
    'fr-BE': 'Combinaison',
    'fr-CA': 'Combinaison',
    'fr-FR': 'Combinaison',
    'gu-IN': 'કોમ્બિનેશન',
    'hi-IN': 'कॉम्बिनेशन',
    'it-IT': 'Combinazione',
    'ja-JP': '組み合わせ',
    'kn-IN': 'ಕಾಂಬಿನೇಶನ್',
    'ko-KR': '조합',
    'ml-IN': 'കോമ്പിനേഷൻ',
    'mr-IN': 'कॉंबिनेशन',
    'nl-BE': 'Combinatie',
    'nl-NL': 'Combinatie',
    'pl-PL': 'Kombinacja',
    'pt-BR': 'Combinação',
    'pt-PT': 'Combinação',
    'sv-SE': 'Kombination',
    'ta-IN': 'சேர்க்கை',
    'te-IN': 'కాంబినేషన్',
    'th-TH': 'การรวม',
    'tr-TR': 'Kombinasyon',
    'vi-VN': 'Kết hợp',
    'zh-CN': '组合',
    'zh-TW': '組合',
  },
  'ag-columnLineCombo': {
    'en-US': 'Column & Line',
    'ar-AE': 'العمود والسطر',
    'bn-IN': 'কলাম ও লাইন',
    'de-DE': 'Spalte und Zeile',
    'en-AU': 'Column and line',
    'en-ZA': 'Column & line',
    'es-ES': 'Columna y línea',
    'es-MX': 'Columna y línea',
    'fr-BE': 'Colonne et ligne',
    'fr-CA': 'Colonne et ligne',
    'fr-FR': 'Colonne et ligne',
    'gu-IN': 'કોલમ અને રેખા',
    'hi-IN': 'कॉलम और लाइन',
    'it-IT': 'Colonna e riga',
    'ja-JP': '列&行',
    'kn-IN': 'ಕಾಲಮ್ ಮತ್ತು ಸಾಲು',
    'ko-KR': '열 및 줄',
    'ml-IN': 'കോളവും ലൈനും',
    'mr-IN': 'स्तंभ आणि ओळी',
    'nl-BE': 'Kolom en regel',
    'nl-NL': 'Kolom en lijn',
    'pl-PL': 'Kolumnowy i liniowy',
    'pt-BR': 'Coluna e linha',
    'pt-PT': 'Coluna e Linha',
    'sv-SE': 'Kolumn och rad',
    'ta-IN': 'நெடுவரிசை மற்றும் வரி',
    'te-IN': 'కాలమ్ మరియు లైన్',
    'th-TH': 'คอลัมน์และบรรทัด',
    'tr-TR': 'Sütun ve satır',
    'vi-VN': 'Cột & Dòng',
    'zh-CN': '列和行',
    'zh-TW': '資料欄和線條',
  },
  'ag-AreaColumnCombo': {
    'en-US': 'Area & Column',
    'ar-AE': 'المنطقة والعمود',
    'bn-IN': 'এলাকা ও কলাম',
    'de-DE': 'Fläche und Spalte',
    'en-AU': 'Area and column',
    'en-ZA': 'Area & column',
    'es-ES': 'Área y columna',
    'es-MX': 'Área y columna',
    'fr-BE': 'Zone et colonne',
    'fr-CA': 'Zone et colonne',
    'fr-FR': 'Zone et colonne',
    'gu-IN': 'વિસ્તાર અને કોલમ',
    'hi-IN': 'एरिया और कॉलम',
    'it-IT': 'Area e colonna',
    'ja-JP': 'エリア&列',
    'kn-IN': 'ಪ್ರದೇಶ ಮತ್ತು ಕಾಲಮ್',
    'ko-KR': '영역 및 열',
    'ml-IN': 'ഏരിയയും കോളവും',
    'mr-IN': 'क्षेत्र आणि स्तंभ',
    'nl-BE': 'Gebied en kolom',
    'nl-NL': 'Gebied en kolom',
    'pl-PL': 'Warstwowy i kolumnowy',
    'pt-BR': 'Área e coluna',
    'pt-PT': 'Área e Coluna',
    'sv-SE': 'Område och kolumn',
    'ta-IN': 'பகுதி மற்றும் நெடுவரிசை',
    'te-IN': 'ఏరియా మరియు కాలమ్',
    'th-TH': 'พื้นที่และคอลัมน์',
    'tr-TR': 'Alan ve sütun',
    'vi-VN': 'Khu vực & Cột',
    'zh-CN': '面积图和柱状图',
    'zh-TW': '區域和資料欄',
  },
  'ag-pivotChartTitle': {
    'en-US': 'Pivot Chart',
    'ar-AE': 'الرسم البياني المحوري',
    'bn-IN': 'পিভট চার্ট',
    'de-DE': 'Pivot-Tabelle',
    'en-AU': 'Pivot chart',
    'en-GB': 'Pivot chart',
    'en-ZA': 'Pivot chart',
    'es-ES': 'Gráfico dinámico',
    'es-MX': 'Gráfico dinámico',
    'fr-BE': 'Graphique croisé dynamique',
    'fr-CA': 'Graphique croisé',
    'fr-FR': 'Graphique croisé dynamique',
    'gu-IN': 'પિવોટ ચાર્ટ',
    'hi-IN': 'पिवट चार्ट',
    'it-IT': 'Tabella pivot',
    'ja-JP': 'ピボットチャート',
    'kn-IN': 'ಪಿವೋಟ್ ಚಾರ್ಟ್',
    'ko-KR': '피벗 차트',
    'ml-IN': 'പിവറ്റ് ചാർട്ട്',
    'mr-IN': 'पायव्होट चार्ट',
    'nl-BE': 'Draaitabel',
    'nl-NL': 'Draaidiagram',
    'pl-PL': 'Wykres przestawny',
    'pt-BR': 'Tabela dinâmica',
    'pt-PT': 'Gráfico dinâmico',
    'sv-SE': 'Pivottabell',
    'ta-IN': 'பிவோட் விளக்கப்படம்',
    'te-IN': 'పివోట్ చార్ట్',
    'th-TH': 'แผนภูมิ Pivot',
    'tr-TR': 'Pivot tablosu',
    'vi-VN': 'Biểu đồ pivot',
    'zh-CN': '透视图',
    'zh-TW': '樞紐分析圖',
  },
  'ag-rangeChartTitle': {
    'en-US': 'Range Chart',
    'ar-AE': 'الرسم البياني للنطاق',
    'bn-IN': 'রেঞ্জ চার্ট',
    'de-DE': 'Bereichstabelle',
    'en-AU': 'Range chart',
    'en-GB': 'Range chart',
    'en-ZA': 'Range chart',
    'es-ES': 'Gráfico de rango',
    'es-MX': 'Gráfico de líneas',
    'fr-BE': 'Graphique par plage',
    'fr-CA': 'Diagramme des plages',
    'fr-FR': 'Graphique de plage',
    'gu-IN': 'રેન્જ ચાર્ટ',
    'hi-IN': 'रेंज चार्ट',
    'it-IT': 'Tabella intervalli',
    'ja-JP': 'レンジチャート',
    'kn-IN': 'ರೇಂಜ್ ಚಾರ್ಟ್',
    'ko-KR': '범위 차트',
    'ml-IN': 'റേഞ്ച് ചാർട്ട്',
    'mr-IN': 'रेंज चार्ट',
    'nl-BE': 'Bereikdiagram',
    'nl-NL': 'Bereikdiagram',
    'pl-PL': 'Wykres zakresu',
    'pt-BR': 'Gráfico de faixa',
    'pt-PT': 'Gráfico de intervalo',
    'sv-SE': 'Intervallstabell',
    'ta-IN': 'ரேஞ்ச் விளக்கப்படம்',
    'te-IN': 'పరిధి చార్ట్',
    'th-TH': 'แผนภูมิช่วง',
    'tr-TR': 'Aralık tablosu',
    'vi-VN': 'Biểu đồ phạm vi',
    'zh-CN': '区间图',
    'zh-TW': '範圍圖表',
  },
  'ag-settings': {
    'en-US': 'Settings',
    'ar-AE': 'الإعدادات',
    'bn-IN': 'সেটিংস',
    'de-DE': 'Einstellungen',
    'es-ES': 'Configuración',
    'es-MX': 'Configuración',
    'fr-BE': 'Paramètres',
    'fr-CA': 'Paramètres',
    'fr-FR': 'Paramètres',
    'gu-IN': 'સેટિંગ્સ',
    'hi-IN': 'सेटिंग',
    'it-IT': 'Impostazioni',
    'ja-JP': '設定',
    'kn-IN': 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    'ko-KR': '설정',
    'ml-IN': 'ക്രമീകരണം',
    'mr-IN': 'सेटिंग्ज',
    'nl-BE': 'Instellingen',
    'nl-NL': 'Instellingen',
    'pl-PL': 'Ustawienia',
    'pt-BR': 'Configurações',
    'pt-PT': 'Definições',
    'sv-SE': 'Inställningar',
    'ta-IN': 'செட்டிங்குகள்',
    'te-IN': 'సెట్టింగ్‌లు',
    'th-TH': 'การตั้งค่า',
    'tr-TR': 'Ayarlar',
    'vi-VN': 'Cài đặt',
    'zh-CN': '设置',
    'zh-TW': '設定',
  },
  'ag-data': {
    'en-US': 'Data',
    'ar-AE': 'البيانات',
    'bn-IN': 'ডেটা',
    'de-DE': 'Daten',
    'es-ES': 'Datos',
    'es-MX': 'Datos',
    'fr-BE': 'Données',
    'fr-CA': 'Données',
    'fr-FR': 'Données',
    'gu-IN': 'ડેટા',
    'hi-IN': 'डेटा',
    'it-IT': 'Dati',
    'ja-JP': 'データ',
    'kn-IN': 'ಡೇಟಾ',
    'ko-KR': '데이터',
    'ml-IN': 'ഡാറ്റ',
    'mr-IN': 'डेटा',
    'nl-BE': 'Gegevens',
    'nl-NL': 'Gegevens',
    'pl-PL': 'Dane',
    'pt-BR': 'Dados',
    'pt-PT': 'Dados',
    'ta-IN': 'தரவு',
    'te-IN': 'డేటా',
    'th-TH': 'ข้อมูล',
    'tr-TR': 'Veri',
    'vi-VN': 'Dữ liệu',
    'zh-CN': '数据',
    'zh-TW': '資料',
  },
  'ag-format': {
    'en-US': 'Format',
    'ar-AE': 'الصيغة',
    'bn-IN': 'ফরম্যাট',
    'es-ES': 'Formato',
    'es-MX': 'Formato',
    'gu-IN': 'ફોર્મેટ',
    'hi-IN': 'फ़ॉर्मेट',
    'it-IT': 'Formato',
    'ja-JP': 'フォーマット',
    'kn-IN': 'ಫಾರ್ಮ್ಯಾಟ್',
    'ko-KR': '형식',
    'ml-IN': 'ഫോർമാറ്റ്',
    'mr-IN': 'फॉरमॅट',
    'nl-BE': 'Formaat',
    'nl-NL': 'Formaat',
    'pt-BR': 'Formato',
    'pt-PT': 'Formato',
    'ta-IN': 'ஃபார்மேட்',
    'te-IN': 'ఫార్మాట్',
    'th-TH': 'รูปแบบ',
    'tr-TR': 'Biçim',
    'vi-VN': 'Định dạng',
    'zh-CN': '格式',
    'zh-TW': '格式',
  },
  'ag-categories': {
    'en-US': 'Categories',
    'ar-AE': 'الفئات',
    'bn-IN': 'ক্যাটেগরি',
    'de-DE': 'Kategorien',
    'es-ES': 'Categorías',
    'es-MX': 'Categorías',
    'fr-BE': 'Catégories',
    'fr-CA': 'Catégories',
    'fr-FR': 'Catégories',
    'gu-IN': 'કેટેગરીઝ',
    'hi-IN': 'कैटेगरी',
    'it-IT': 'Categorie',
    'ja-JP': 'カテゴリー',
    'kn-IN': 'ವರ್ಗಗಳು',
    'ko-KR': '카테고리',
    'ml-IN': 'വിഭാഗങ്ങൾ',
    'mr-IN': 'कॅटेगरीज',
    'nl-BE': 'Categorieën',
    'nl-NL': 'Categorieën',
    'pl-PL': 'Kategorie',
    'pt-BR': 'Categorias',
    'pt-PT': 'Categorias',
    'sv-SE': 'Kategorier',
    'ta-IN': 'கேட்டகரிகள்',
    'te-IN': 'కేటగిరీలు',
    'th-TH': 'หมวดหมู่',
    'tr-TR': 'Kategoriler',
    'vi-VN': 'Danh mục',
    'zh-CN': '分类',
    'zh-TW': '品類',
  },
  'ag-defaultCategory': {
    'en-US': '(None)',
    'ar-AE': '(لا شيء)',
    'bn-IN': '(কোনোটিই নয়)',
    'de-DE': '(Keine)',
    'es-ES': '(Ninguno)',
    'es-MX': '(Ninguno)',
    'fr-BE': '(Aucun)',
    'fr-CA': '(Aucun)',
    'fr-FR': '(Aucun)',
    'gu-IN': '(કંઈ નહીં)',
    'hi-IN': '(कुछ भी नहीं)',
    'it-IT': '(Nessuno)',
    'ja-JP': '（なし）',
    'kn-IN': '(ಯಾವುದೂ ಇಲ್ಲ)',
    'ko-KR': '(없음)',
    'ml-IN': '(ഒന്നുമില്ല)',
    'mr-IN': '(काहीच नाही)',
    'nl-BE': '(Geen)',
    'nl-NL': '(Geen)',
    'pl-PL': '(Brak)',
    'pt-BR': '(Nenhum)',
    'pt-PT': '(Nenhum)',
    'sv-SE': '(Ingen)',
    'ta-IN': '(எதுவுமில்லை)',
    'te-IN': '(ఏదీ వద్దు)',
    'th-TH': '(ไม่มี)',
    'tr-TR': '(Hiçbiri)',
    'vi-VN': '(Không có)',
    'zh-CN': '（无）',
    'zh-TW': '(無)',
  },
  'ag-series': {
    'en-US': 'Series',
    'ar-AE': 'السلسلة',
    'bn-IN': 'সিরিজ',
    'de-DE': 'Serie',
    'es-ES': 'Serie',
    'es-MX': 'Serie',
    'fr-BE': 'Série',
    'fr-CA': 'Série',
    'fr-FR': 'Série',
    'gu-IN': 'સિરીઝ',
    'hi-IN': 'सीरीज़',
    'it-IT': 'Serie',
    'ja-JP': 'シリーズ',
    'kn-IN': 'ಸಿರೀಸ್',
    'ko-KR': '시리즈',
    'ml-IN': 'സീരീസ്',
    'mr-IN': 'सिरीज',
    'nl-BE': 'Serie',
    'nl-NL': 'Serie',
    'pl-PL': 'Seria',
    'pt-BR': 'Série',
    'pt-PT': 'Série',
    'sv-SE': 'Serier',
    'ta-IN': 'சீரிஸ்',
    'te-IN': 'సిరీస్',
    'th-TH': 'ชุดข้อมูล',
    'tr-TR': 'Seri',
    'vi-VN': 'Dãy số biểu thị dưới dạng cột',
    'zh-CN': '系列',
    'zh-TW': '系列',
  },
  'ag-xyValues': {
    'en-US': 'X Y Values',
    'ar-AE': 'القيم X Y',
    'bn-IN': 'X Y মান',
    'de-DE': 'X/Y-Werte',
    'en-AU': 'X Y values',
    'en-GB': 'X Y values',
    'en-ZA': 'X Y values',
    'es-ES': 'Valores X Y',
    'es-MX': 'Valores de X Y',
    'fr-BE': 'Valeurs X Y',
    'fr-CA': 'Valeurs X Y',
    'fr-FR': 'Valeurs X Y',
    'gu-IN': 'X Y મૂલ્યો',
    'hi-IN': 'X Y वैल्यू',
    'it-IT': 'Valori X Y',
    'ja-JP': 'X Yの値',
    'kn-IN': 'X Y ಮೌಲ್ಯಗಳು',
    'ko-KR': 'X Y 값',
    'ml-IN': 'X Y മൂല്യങ്ങൾ',
    'mr-IN': 'X Y व्हॅल्यू',
    'nl-BE': 'X Y-waarden',
    'nl-NL': 'X- en Y-waarden',
    'pl-PL': 'Wartości X Y',
    'pt-BR': 'Valores X Y',
    'pt-PT': 'Valores X Y',
    'sv-SE': 'X Y-värden',
    'ta-IN': 'X Y வேல்யூக்கள்',
    'te-IN': 'X Y విలువలు',
    'th-TH': 'ค่า X Y',
    'tr-TR': 'X Y değerleri',
    'vi-VN': 'Giá trị X Y',
    'zh-CN': 'X Y 值',
    'zh-TW': 'X Y 值',
  },
  'ag-paired': {
    'en-US': 'Paired Mode',
    'ar-AE': 'وضع المقترن',
    'bn-IN': 'পেয়ার্ড মোড',
    'de-DE': 'Gekoppelter Modus',
    'en-AU': 'Paired mode',
    'en-GB': 'Paired mode',
    'es-ES': 'Modo de emparejado',
    'es-MX': 'Modo de emparejamiento',
    'fr-BE': 'Mode associé',
    'fr-CA': 'Mode jumelé',
    'fr-FR': 'Mode apparié',
    'gu-IN': 'પેયર્ડ મોડ',
    'hi-IN': 'पेयर्ड मोड',
    'it-IT': 'Modalità abbinata',
    'ja-JP': 'ペアリング済みモード',
    'kn-IN': 'ಜೋಡಿ ಮಾಡಿದ ಮೋಡ್',
    'ko-KR': '페어링 모드',
    'ml-IN': 'ജോടിയാക്കിയ മോഡ്',
    'mr-IN': 'पेअर केलेला मोड',
    'nl-BE': 'Gekoppelde modus',
    'nl-NL': 'Gekoppelde modus',
    'pl-PL': 'Tryb sparowany',
    'pt-BR': 'Modo emparelhado',
    'pt-PT': 'Modo sincronizado',
    'sv-SE': 'Parkopplat läge',
    'ta-IN': 'இணைசேர்த்த பயன்முறை',
    'te-IN': 'పెయిర్ చేసిన మోడ్',
    'th-TH': 'โหมดจับคู่',
    'tr-TR': 'Eşleştirilmiş mod',
    'vi-VN': 'Chế độ ghép nối',
    'zh-CN': '配对模式',
    'zh-TW': '配對模式',
  },
  'ag-axis': {
    'en-US': 'Axis',
    'ar-AE': 'المحور',
    'bn-IN': 'অ্যাক্সিস',
    'de-DE': 'Achse',
    'es-ES': 'Eje',
    'es-MX': 'Eje',
    'fr-BE': 'Axe',
    'fr-CA': 'Axe',
    'fr-FR': 'Axe',
    'gu-IN': 'એક્સિસ',
    'it-IT': 'Asse',
    'ja-JP': '軸',
    'ko-KR': '축',
    'ml-IN': 'അക്ഷം',
    'mr-IN': 'अक्ष',
    'nl-BE': 'As',
    'nl-NL': 'As',
    'pl-PL': 'Oś',
    'pt-BR': 'Eixo',
    'pt-PT': 'Eixo',
    'sv-SE': 'Axel',
    'ta-IN': 'ஆக்சிஸ்',
    'te-IN': 'అక్షం',
    'th-TH': 'แกน',
    'tr-TR': 'Eksen',
    'vi-VN': 'Trục',
    'zh-CN': '轴',
    'zh-TW': '軸',
  },
  'ag-navigator': {
    'en-US': 'Navigator',
    'ar-AE': 'المتنقل',
    'bn-IN': 'ন‍্যাভিগেটর',
    'es-ES': 'Navegador',
    'es-MX': 'Navegador',
    'fr-BE': 'Navigateur',
    'fr-CA': 'Navigateur',
    'fr-FR': 'Navigateur',
    'gu-IN': 'નેવિગેટર',
    'hi-IN': 'नेविगेटर',
    'it-IT': 'Navigatore',
    'ja-JP': 'ナビゲーター',
    'kn-IN': 'ನ್ಯಾವಿಗೇಟರ್',
    'ko-KR': '내비게이터',
    'ml-IN': 'നാവിഗേറ്റർ',
    'mr-IN': 'नेव्हिगेटर',
    'pl-PL': 'Nawigator',
    'pt-BR': 'Navegador',
    'pt-PT': 'Navegador',
    'sv-SE': 'Navigatör',
    'ta-IN': 'நேவிகேட்டர்',
    'te-IN': 'నావిగేటర్',
    'th-TH': 'ตัวนำทาง',
    'tr-TR': 'Navigasyon',
    'vi-VN': 'Điều hướng',
    'zh-CN': '浏览器',
    'zh-TW': '導覽器',
  },
  'ag-color': {
    'en-US': 'Color',
    'ar-AE': 'اللون',
    'bn-IN': 'রঙ',
    'de-DE': 'Farbe',
    'en-AU': 'Colour',
    'en-CA': 'Colour',
    'en-GB': 'Colour',
    'en-IN': 'Colour',
    'en-SG': 'Colour',
    'en-ZA': 'Colour',
    'fr-BE': 'Couleur',
    'fr-CA': 'Couleur',
    'fr-FR': 'Couleur',
    'gu-IN': 'રંગ',
    'hi-IN': 'रंग',
    'it-IT': 'Colore',
    'ja-JP': 'カラー',
    'kn-IN': 'ಬಣ್ಣ',
    'ko-KR': '색상',
    'ml-IN': 'നിറം',
    'mr-IN': 'रंग',
    'nl-BE': 'Kleur',
    'nl-NL': 'Kleur',
    'pl-PL': 'Kolor',
    'pt-BR': 'Cor',
    'pt-PT': 'Cor',
    'sv-SE': 'Färg',
    'ta-IN': 'நிறம்',
    'te-IN': 'రంగు',
    'th-TH': 'สี',
    'tr-TR': 'Renk',
    'vi-VN': 'Màu',
    'zh-CN': '颜色',
    'zh-TW': '顏色',
  },
  'ag-thickness': {
    'en-US': 'Thickness',
    'ar-AE': 'السُمك',
    'bn-IN': 'পুরুত্ব',
    'de-DE': 'Dicke',
    'es-ES': 'Grosor',
    'es-MX': 'Grosor',
    'fr-BE': 'Épaisseur',
    'fr-CA': 'Épaisseur',
    'fr-FR': 'Épaisseur',
    'gu-IN': 'જાડાઈ',
    'hi-IN': 'मोटाई',
    'it-IT': 'Spessore',
    'ja-JP': '厚さ',
    'kn-IN': 'ದಪ್ಪ',
    'ko-KR': '두께',
    'ml-IN': 'കനം',
    'mr-IN': 'जाडी',
    'nl-BE': 'Dikte',
    'nl-NL': 'Dikte',
    'pl-PL': 'Grubość',
    'pt-BR': 'Espessura',
    'pt-PT': 'Espessura',
    'sv-SE': 'Tjocklek',
    'ta-IN': 'தடிமன்',
    'te-IN': 'మందం',
    'th-TH': 'ความหนา',
    'tr-TR': 'Kalınlık',
    'vi-VN': 'Độ dày',
    'zh-CN': '厚度',
    'zh-TW': '厚度',
  },
  'ag-xType': {
    'en-US': 'X Type',
    'ar-AE': 'النوع X',
    'bn-IN': 'X টাইপ',
    'de-DE': 'X-Typ',
    'en-AU': 'X type',
    'en-GB': 'X type',
    'en-ZA': 'X type',
    'es-ES': 'Tipo X',
    'es-MX': 'Tipo X',
    'fr-BE': 'Type X',
    'fr-CA': 'Type X',
    'fr-FR': 'Type X',
    'gu-IN': 'X પ્રકાર',
    'hi-IN': 'X टाइप',
    'it-IT': 'Tipo X',
    'ja-JP': 'Xタイプ',
    'kn-IN': 'X ವಿಧ',
    'ko-KR': 'X 유형',
    'ml-IN': 'X തരം',
    'mr-IN': 'X प्रकार',
    'nl-BE': 'X-type',
    'nl-NL': 'X-type',
    'pl-PL': 'Typ X',
    'pt-BR': 'Tipo de X',
    'pt-PT': 'Tipo X',
    'sv-SE': 'X-typ',
    'ta-IN': 'X வகை',
    'te-IN': 'X రకం',
    'th-TH': 'ประเภท X',
    'tr-TR': 'X türü',
    'vi-VN': 'Loại X',
    'zh-CN': 'X 类型',
    'zh-TW': 'X 軸類型',
  },
  'ag-automatic': {
    'en-US': 'Automatic',
    'ar-AE': 'تلقائي',
    'bn-IN': 'স্বয়ংক্রিয়',
    'de-DE': 'Automatisch',
    'es-ES': 'Automático',
    'es-MX': 'Automático',
    'fr-BE': 'Automatique',
    'fr-CA': 'Automatique',
    'fr-FR': 'Automatique',
    'gu-IN': 'આપમેળે',
    'hi-IN': 'ऑटोमैटिक',
    'it-IT': 'Automatico',
    'ja-JP': '自動',
    'kn-IN': 'ಸ್ವಯಂಚಾಲಿತ',
    'ko-KR': '자동',
    'ml-IN': 'ഓട്ടോമാറ്റിക്',
    'mr-IN': 'ऑटोमॅटिक',
    'nl-BE': 'Automatisch',
    'nl-NL': 'Automatisch',
    'pl-PL': 'Automatycznie',
    'pt-BR': 'Automático',
    'pt-PT': 'Automático',
    'sv-SE': 'Automatisk',
    'ta-IN': 'ஆட்டோமேட்டிக்',
    'te-IN': 'ఆటోమేటిక్',
    'th-TH': 'อัตโนมัติ',
    'tr-TR': 'Otomatik',
    'vi-VN': 'Tự động',
    'zh-CN': '自动',
    'zh-TW': '自動',
  },
  'ag-category': {
    'en-US': 'Category',
    'ar-AE': 'الفئة',
    'bn-IN': 'ক্যাটাগরি',
    'de-DE': 'Kategorie',
    'es-ES': 'Categoría',
    'es-MX': 'Categoría',
    'fr-BE': 'Catégorie',
    'fr-CA': 'Catégorie',
    'fr-FR': 'Catégorie',
    'gu-IN': 'કેટેગરી',
    'hi-IN': 'कैटेगरी',
    'it-IT': 'Categoria',
    'ja-JP': 'カテゴリー',
    'kn-IN': 'ಕ್ಯಾಟಗರಿ',
    'ko-KR': '카테고리',
    'ml-IN': 'വിഭാഗം',
    'mr-IN': 'कॅटेगरी',
    'nl-BE': 'Categorie',
    'nl-NL': 'Categorie',
    'pl-PL': 'Kategoria',
    'pt-BR': 'Categoria',
    'pt-PT': 'Categoria',
    'sv-SE': 'Kategori',
    'ta-IN': 'கேட்டகரி',
    'te-IN': 'క్యాటగిరీ',
    'th-TH': 'หมวดหมู่',
    'tr-TR': 'Kategori',
    'vi-VN': 'Danh mục',
    'zh-CN': '分类',
    'zh-TW': '品類',
  },
  'ag-number': {
    'en-US': 'Number',
    'ar-AE': 'رقم',
    'bn-IN': 'নম্বর',
    'de-DE': 'Nummer',
    'es-ES': 'Número',
    'es-MX': 'Número',
    'fr-BE': 'Nombre',
    'fr-CA': 'Numéro',
    'fr-FR': 'Numéro',
    'gu-IN': 'નંબર',
    'hi-IN': 'नंबर',
    'it-IT': 'Numero',
    'ja-JP': '番号',
    'kn-IN': 'ನಂಬರ್',
    'ko-KR': '번호',
    'ml-IN': 'സംഖ്യ',
    'mr-IN': 'नंबर',
    'nl-BE': 'Nummer',
    'nl-NL': 'Nummer',
    'pl-PL': 'Liczba',
    'pt-BR': 'Número',
    'pt-PT': 'Número',
    'sv-SE': 'Nummer',
    'ta-IN': 'நம்பர்',
    'te-IN': 'నంబర్',
    'th-TH': 'ตัวเลข',
    'tr-TR': 'Sayı',
    'vi-VN': 'Số',
    'zh-CN': '数字',
    'zh-TW': '數字',
  },
  'ag-time': {
    'en-US': 'Time',
    'ar-AE': 'التوقيت',
    'bn-IN': 'সময়',
    'de-DE': 'Uhrzeit',
    'es-ES': 'Hora',
    'es-MX': 'Hora',
    'fr-BE': 'Heure',
    'fr-CA': 'Heure',
    'fr-FR': 'Heure',
    'gu-IN': 'સમય',
    'hi-IN': 'समय',
    'it-IT': 'Ora',
    'ja-JP': '時間',
    'kn-IN': 'ಸಮಯ',
    'ko-KR': '시간',
    'ml-IN': 'സമയം',
    'mr-IN': 'वेळ',
    'nl-BE': 'Tijd',
    'nl-NL': 'Tijd',
    'pl-PL': 'Czas',
    'pt-BR': 'Horário',
    'pt-PT': 'Hora',
    'sv-SE': 'Tid',
    'ta-IN': 'நேரம்',
    'te-IN': 'సమయం',
    'th-TH': 'เวลา',
    'tr-TR': 'Saat',
    'vi-VN': 'Thời gian',
    'zh-CN': '时间',
    'zh-TW': '時間',
  },
  'ag-autoRotate': {
    'en-US': 'Auto Rotate',
    'ar-AE': 'تدوير تلقائي',
    'bn-IN': 'স্বয়ংক্রিয়ভাবে ঘোরানো',
    'de-DE': 'Automatisch drehen',
    'en-AU': 'Auto-rotate',
    'en-GB': 'Auto rotate',
    'en-ZA': 'Auto rotate',
    'es-ES': 'Rotación automática',
    'es-MX': 'Rotación automática',
    'fr-BE': 'Rotation automatique',
    'fr-CA': 'Rotation automatique',
    'fr-FR': 'Rotation automatique',
    'gu-IN': 'આપમેળે ફેરવો',
    'hi-IN': 'अपने-आप रोटेट करें',
    'it-IT': 'Rotazione automatica',
    'ja-JP': '自動回転',
    'kn-IN': 'ಆಟೋ ತಿರುಗಿಸಿ',
    'ko-KR': '자동 회전',
    'ml-IN': 'സ്വയം തിരിക്കുക',
    'mr-IN': 'ऑटो रोटेट',
    'nl-BE': 'Automatisch roteren',
    'nl-NL': 'Automatisch roteren',
    'pl-PL': 'Automatyczny obrót',
    'pt-BR': 'Girar automaticamente',
    'pt-PT': 'Rotação automática',
    'sv-SE': 'Rotera automatiskt',
    'ta-IN': 'தானியங்கு சுழற்று',
    'te-IN': 'ఆటో రొటేట్ చేయండి',
    'th-TH': 'หมุนอัตโนมัติ',
    'tr-TR': 'Otomatik döndür',
    'vi-VN': 'Xoay tự động',
    'zh-CN': '自动旋转',
    'zh-TW': '自動旋轉',
  },
  'ag-xRotation': {
    'en-US': 'X Rotation',
    'ar-AE': 'دوران X',
    'bn-IN': 'X ঘূর্ণন',
    'de-DE': 'X-Drehung',
    'en-AU': 'X rotation',
    'en-GB': 'X rotation',
    'en-ZA': 'X rotation',
    'es-ES': 'Rotación X',
    'es-MX': 'Rotación X',
    'fr-BE': 'Rotation X',
    'fr-CA': 'Rotation X',
    'fr-FR': 'Rotation X',
    'gu-IN': 'X પરિભ્રમણ',
    'hi-IN': 'X रोटेशन',
    'it-IT': 'Rotazione X',
    'ja-JP': 'X回転',
    'kn-IN': 'X ತಿರುಗುವಿಕೆ',
    'ko-KR': 'X 회전',
    'ml-IN': 'X റൊട്ടേഷൻ',
    'mr-IN': 'X रोटेशन',
    'nl-BE': 'X-rotatie',
    'nl-NL': 'X-rotatie',
    'pl-PL': 'Obrót X',
    'pt-BR': 'Rotação X',
    'pt-PT': 'Rotação X',
    'sv-SE': 'X-rotation',
    'ta-IN': 'X சுழற்சி',
    'te-IN': 'X రొటేషన్',
    'th-TH': 'การหมุน X',
    'tr-TR': 'X dönüşü',
    'vi-VN': 'Xoay ngang',
    'zh-CN': 'X 旋转',
    'zh-TW': 'X 軸旋轉',
  },
  'ag-yRotation': {
    'en-US': 'Y Rotation',
    'ar-AE': 'دوران Y',
    'bn-IN': 'Y ঘূর্ণন',
    'de-DE': 'Y-Drehung',
    'en-AU': 'Y rotation',
    'en-GB': 'Y rotation',
    'en-ZA': 'Y rotation',
    'es-ES': 'Rotación Y',
    'es-MX': 'Rotación Y',
    'fr-BE': 'Rotation Y',
    'fr-CA': 'Rotation Y',
    'fr-FR': 'Rotation Y',
    'gu-IN': 'Y પરિભ્રમણ',
    'hi-IN': 'Y रोटेशन',
    'it-IT': 'Rotazione Y',
    'ja-JP': 'Y回転',
    'kn-IN': 'Y ರೊಟೇಶನ್',
    'ko-KR': 'Y 회전',
    'ml-IN': 'Y റൊട്ടേഷൻ',
    'mr-IN': 'Y रोटेशन',
    'nl-BE': 'Y-rotatie',
    'nl-NL': 'Y-rotatie',
    'pl-PL': 'Obrót Y',
    'pt-BR': 'Rotação Y',
    'pt-PT': 'Rotação Y',
    'sv-SE': 'Y-rotation',
    'ta-IN': 'Y சுழற்சி',
    'te-IN': 'Y రొటేషన్',
    'th-TH': 'การหมุน Y',
    'tr-TR': 'Y dönüşü',
    'vi-VN': 'Xoay dọc',
    'zh-CN': 'Y 旋转',
    'zh-TW': 'Y 軸旋轉',
  },
  'ag-ticks': {
    'en-US': 'Ticks',
    'ar-AE': 'يؤشِّر على',
    'bn-IN': 'টিক',
    'de-DE': 'Haken',
    'es-ES': 'Verificaciones',
    'es-MX': 'Comprobaciones',
    'fr-BE': 'Coches',
    'fr-CA': 'Coches',
    'fr-FR': 'Coches',
    'gu-IN': 'ટીક',
    'hi-IN': 'टिक',
    'it-IT': 'Spunte',
    'ja-JP': 'チェックマーク',
    'kn-IN': 'ಟಿಕ್ಸ್',
    'ko-KR': '틱',
    'ml-IN': 'ടിക്കുകൾ',
    'mr-IN': 'टिक्स',
    'nl-BE': 'Vinkjes',
    'nl-NL': 'Vinkjes',
    'pl-PL': 'Znaczniki osi',
    'pt-BR': 'Marcações',
    'pt-PT': 'Marcações',
    'sv-SE': 'Markerar',
    'ta-IN': 'டிக்ஸ்',
    'te-IN': 'టిక్కులు',
    'th-TH': 'ติ๊ก',
    'tr-TR': 'İşaretler',
    'vi-VN': 'Dấu tick',
    'zh-CN': '刻度',
    'zh-TW': '刻度',
  },
  'ag-width': {
    'en-US': 'Width',
    'ar-AE': 'العرض',
    'bn-IN': 'প্রস্থ',
    'de-DE': 'Breite',
    'es-ES': 'Anchura',
    'es-MX': 'Anchura',
    'fr-BE': 'Largeur',
    'fr-CA': 'Largeur',
    'fr-FR': 'Largeur',
    'gu-IN': 'પહોળાઈ',
    'hi-IN': 'चौड़ाई',
    'it-IT': 'Larghezza',
    'ja-JP': '幅',
    'kn-IN': 'ಅಗಲ',
    'ko-KR': '너비',
    'ml-IN': 'വീതി',
    'mr-IN': 'रुंदी',
    'nl-BE': 'Breedte',
    'nl-NL': 'Breedte',
    'pl-PL': 'Szerokość',
    'pt-BR': 'Largura',
    'pt-PT': 'Largura',
    'sv-SE': 'Bredd',
    'ta-IN': 'அகலம்',
    'te-IN': 'వెడల్పు',
    'th-TH': 'ความกว้าง',
    'tr-TR': 'Genişlik',
    'vi-VN': 'Chiều rộng',
    'zh-CN': '宽度',
    'zh-TW': '寬度',
  },
  'ag-height': {
    'en-US': 'Height',
    'ar-AE': 'الارتفاع',
    'bn-IN': 'উচ্চতা',
    'de-DE': 'Höhe',
    'es-ES': 'Altura',
    'es-MX': 'Altura',
    'fr-BE': 'Hauteur',
    'fr-CA': 'Hauteur',
    'fr-FR': 'Hauteur',
    'gu-IN': 'ઊંચાઈ',
    'hi-IN': 'ऊंचाई',
    'it-IT': 'Altezza',
    'ja-JP': '高さ',
    'kn-IN': 'ಎತ್ತರ',
    'ko-KR': '높이',
    'ml-IN': 'ഉയരം',
    'mr-IN': 'उंची',
    'nl-BE': 'Hoogte',
    'nl-NL': 'Hoogte',
    'pl-PL': 'Wysokość',
    'pt-BR': 'Altura',
    'pt-PT': 'Altura',
    'sv-SE': 'Höjd',
    'ta-IN': 'உயரம்',
    'te-IN': 'ఎత్తు',
    'th-TH': 'ความสูง',
    'tr-TR': 'Yükseklik',
    'vi-VN': 'Chiều cao',
    'zh-CN': '高度',
    'zh-TW': '高度',
  },
  'ag-length': {
    'en-US': 'Length',
    'ar-AE': 'الطول',
    'bn-IN': 'দৈর্ঘ্য',
    'de-DE': 'Länge',
    'es-ES': 'Longitud',
    'es-MX': 'Longitud',
    'fr-BE': 'Longueur',
    'fr-CA': 'Longueur',
    'fr-FR': 'Longueur',
    'gu-IN': 'લંબાઈ',
    'hi-IN': 'लंबाई',
    'it-IT': 'Lunghezza',
    'ja-JP': '長さ',
    'kn-IN': 'ಉದ್ದ',
    'ko-KR': '길이',
    'ml-IN': 'നീളം',
    'mr-IN': 'लांबी',
    'nl-BE': 'Lengte',
    'nl-NL': 'Lengte',
    'pl-PL': 'Długość',
    'pt-BR': 'Comprimento',
    'pt-PT': 'Comprimento',
    'sv-SE': 'Längd',
    'ta-IN': 'நீளம்',
    'te-IN': 'పొడవు',
    'th-TH': 'ความยาว',
    'tr-TR': 'Uzunluk',
    'vi-VN': 'Chiều dài',
    'zh-CN': '长度',
    'zh-TW': '長度',
  },
  'ag-padding': {
    'en-US': 'Padding',
    'ar-AE': 'الحشو',
    'bn-IN': 'প্যাডিং',
    'de-DE': 'Puffer',
    'es-ES': 'Relleno',
    'es-MX': 'Relleno',
    'fr-BE': 'Remplissage',
    'fr-CA': 'Rembourrage',
    'fr-FR': 'Remplissage',
    'gu-IN': 'પેડિંગ',
    'hi-IN': 'पैडिंग',
    'it-IT': 'Riempimento',
    'ja-JP': 'パディング',
    'kn-IN': 'ಪ್ಯಾಡಿಂಗ್',
    'ko-KR': '내부 여백',
    'ml-IN': 'പാഡിംഗ്',
    'mr-IN': 'पॅडिंग',
    'nl-BE': 'Opvulruimte',
    'nl-NL': 'Opvulling',
    'pl-PL': 'Dopełnienie',
    'pt-BR': 'Preenchimento',
    'pt-PT': 'Preenchimento',
    'sv-SE': 'Stoppning',
    'ta-IN': 'பேட்டிங்',
    'te-IN': 'ప్యాడింగ్',
    'th-TH': 'ช่องว่างภายใน',
    'tr-TR': 'Boşluk',
    'vi-VN': 'Khoảng cách giữa nội dung và đường viền',
    'zh-CN': '填充',
    'zh-TW': '邊距',
  },
  'ag-spacing': {
    'en-US': 'Spacing',
    'ar-AE': 'التباعد',
    'bn-IN': 'স্পেসের ব্যবহার',
    'de-DE': 'Abstand',
    'es-ES': 'Espaciado',
    'es-MX': 'Espacio',
    'fr-BE': 'Espacement',
    'fr-CA': 'Espacement',
    'fr-FR': 'Espacement',
    'gu-IN': 'સ્પેસિંગ',
    'hi-IN': 'स्पेसिंग',
    'it-IT': 'Spaziatura',
    'ja-JP': 'スペース',
    'kn-IN': 'ಸ್ಪೇಸಿಂಗ್',
    'ko-KR': '간격',
    'ml-IN': 'സ്പെയ്‌സിംഗ്‌',
    'mr-IN': 'स्पेसिंग',
    'nl-BE': 'Regelafstand',
    'nl-NL': 'Afstand',
    'pl-PL': 'Odstępy',
    'pt-BR': 'Espaçamento',
    'pt-PT': 'Espaçamento',
    'sv-SE': 'Mellanslag',
    'ta-IN': 'இடைவெளி',
    'te-IN': 'అంతరం',
    'th-TH': 'การเว้นระยะ',
    'tr-TR': 'Aralık',
    'vi-VN': 'Khoảng cách',
    'zh-CN': '间距',
    'zh-TW': '間距',
  },
  'ag-chart': {
    'en-US': 'Chart',
    'ar-AE': 'الرسم البياني',
    'bn-IN': 'চার্ট',
    'de-DE': 'Tabelle',
    'es-ES': 'Gráfico',
    'es-MX': 'Gráfico',
    'fr-BE': 'Graphique',
    'fr-CA': 'Diagramme',
    'fr-FR': 'Graphique',
    'gu-IN': 'ચાર્ટ',
    'hi-IN': 'चार्ट',
    'it-IT': 'Tabella',
    'ja-JP': 'チャート',
    'kn-IN': 'ಚಾರ್ಟ್',
    'ko-KR': '차트',
    'ml-IN': 'ചാർട്ട്',
    'mr-IN': 'चार्ट',
    'nl-BE': 'Grafiek',
    'nl-NL': 'Grafiek',
    'pl-PL': 'Wykres',
    'pt-BR': 'Gráfico',
    'pt-PT': 'Gráfico',
    'sv-SE': 'Tabell',
    'ta-IN': 'விளக்கப்படம்',
    'te-IN': 'చార్ట్',
    'th-TH': 'แผนภูมิ',
    'tr-TR': 'Tablo',
    'vi-VN': 'Biểu đồ',
    'zh-CN': '图表',
    'zh-TW': '圖表',
  },
  'ag-title': {
    'en-US': 'Title',
    'ar-AE': 'العنوان',
    'bn-IN': 'টাইটেল',
    'de-DE': 'Titel',
    'es-ES': 'Título',
    'es-MX': 'Título',
    'fr-BE': 'Titre',
    'fr-CA': 'Titre',
    'fr-FR': 'Titre',
    'gu-IN': 'ટાઇટલ',
    'hi-IN': 'टाइटल',
    'it-IT': 'Titolo',
    'ja-JP': 'タイトル',
    'kn-IN': 'ಶೀರ್ಷಿಕೆ',
    'ko-KR': '제목',
    'ml-IN': 'പേര്',
    'mr-IN': 'शीर्षक',
    'nl-BE': 'Titel',
    'nl-NL': 'Titel',
    'pl-PL': 'Tytuł',
    'pt-BR': 'Título',
    'pt-PT': 'Título',
    'sv-SE': 'Titel',
    'ta-IN': 'தலைப்பு',
    'te-IN': 'టైటిల్',
    'th-TH': 'ชื่อ',
    'tr-TR': 'Başlık',
    'vi-VN': 'Tiêu đề',
    'zh-CN': '标题',
    'zh-TW': '標題',
  },
  'ag-titlePlaceholder': {
    'en-US': 'Chart title - double click to edit',
    'ar-AE': 'عنوان الرسم البياني - اضغط مرتين للتحرير',
    'bn-IN': 'চার্টের শিরোনাম - সম্পাদনা করতে ডবল ক্লিক করুন',
    'de-DE': 'Tabellentitel – Doppelklick zum Bearbeiten',
    'en-AU': 'Chart title – double-click to edit',
    'en-GB': 'Chart title – double click to edit',
    'en-ZA': 'Chart title – double-click to edit',
    'es-ES': 'Título del gráfico: haz doble clic para modificar',
    'es-MX': 'Título del gráfico: haz doble clic para modificarlo',
    'fr-BE': 'Titre du graphique - Double-cliquez pour modifier',
    'fr-CA': 'Titre du graphique : double-cliquez pour modifier',
    'fr-FR': 'Titre du graphique : double-cliquez pour modifier',
    'gu-IN': 'ચાર્ટ શીર્ષક - ફેરફાર કરવા માટે ડબલ ક્લિક કરો',
    'hi-IN': 'चार्ट टाइटल - बदलाव करने के लिए डबल क्लिक करें',
    'it-IT': 'Titolo della tabella - doppio clic per modificare',
    'ja-JP': 'チャートのタイトル - ダブルクリックして編集',
    'kn-IN': 'ಚಾರ್ಟ್ ಶೀರ್ಷಿಕೆ - ಎಡಿಟ್ ಮಾಡಲು ಡಬಲ್ ಕ್ಲಿಕ್ ಮಾಡಿ',
    'ko-KR': '차트 타이틀 - 편집하려면 더블 클릭',
    'ml-IN': 'ചാർട്ട് ശീർഷകം - എഡിറ്റ് ചെയ്യാൻ രണ്ടുതവണ ക്ലിക്ക് ചെയ്യുക',
    'mr-IN': 'चार्ट शीर्षक - संपादित करण्यासाठी डबल क्लिक करा',
    'nl-BE': 'Titel diagram - dubbelklik om te bewerken',
    'nl-NL': 'Titel van grafiek - dubbelklik om te bewerken',
    'pl-PL': 'Tytuł wykresu – kliknij dwukrotnie, aby edytować',
    'pt-BR': 'Título do gráfico – clique duas vezes para alterar',
    'pt-PT': 'Título do gráfico - clique duas vezes para editar',
    'sv-SE': 'Diagramtitel – dubbelklicka för att redigera',
    'ta-IN': 'விளக்கப்படத் தலைப்பு - திருத்துவதற்கு இருமுறை கிளிக் செய்யவும்',
    'te-IN': 'చార్ట్ శీర్షిక - సవరించడానికి రెండుసార్లు క్లిక్ చేయండి',
    'th-TH': 'ชื่อแผนภูมิ - ดับเบิลคลิกเพื่อแก้ไข',
    'tr-TR': 'Tablo başlığı - düzenlemek için çift tıklayın',
    'vi-VN': 'Tiêu đề biểu đồ - nhấp hai lần để chỉnh sửa',
    'zh-CN': '图表标题 - 双击可编辑',
    'zh-TW': '圖表標題 - 連點兩次以進行編輯',
  },
  'ag-background': {
    'en-US': 'Background',
    'ar-AE': 'الخلفية',
    'bn-IN': 'ব্যাকগ্রাউন্ড',
    'de-DE': 'Hintergrund',
    'es-ES': 'Fondo',
    'es-MX': 'Fondo',
    'fr-BE': 'Arrière-plan',
    'fr-CA': 'Contexte',
    'fr-FR': 'Arrière-plan',
    'gu-IN': 'બેકગ્રાઉન્ડ',
    'hi-IN': 'बैकग्राउंड',
    'it-IT': 'Sfondo',
    'ja-JP': '背景',
    'kn-IN': 'ಹಿನ್ನೆಲೆ',
    'ko-KR': '배경',
    'ml-IN': 'പശ്ചാത്തലം',
    'mr-IN': 'बॅकग्राउंड',
    'nl-BE': 'Achtergrond',
    'nl-NL': 'Achtergrond',
    'pl-PL': 'Tło',
    'pt-BR': 'Plano de fundo',
    'pt-PT': 'Fundo',
    'sv-SE': 'Bakgrund',
    'ta-IN': 'பின்னணி',
    'te-IN': 'నేపథ్యం',
    'th-TH': 'พื้นหลัง',
    'tr-TR': 'Arka plan',
    'vi-VN': 'Phông nền',
    'zh-CN': '背景',
    'zh-TW': '背景',
  },
  'ag-font': {
    'en-US': 'Font',
    'ar-AE': 'الخط',
    'bn-IN': 'ফন্ট',
    'de-DE': 'Schriftart',
    'es-ES': 'Fuente',
    'es-MX': 'Fuente',
    'fr-BE': 'Police',
    'fr-CA': 'Police',
    'fr-FR': 'Police',
    'gu-IN': 'ફોન્ટ',
    'hi-IN': 'फ़ॉन्ट',
    'ja-JP': 'フォント',
    'kn-IN': 'ಫಾಂಟ್',
    'ko-KR': '글꼴',
    'ml-IN': 'ഫോണ്ട്',
    'mr-IN': 'फॉंट',
    'nl-BE': 'Lettertype',
    'nl-NL': 'Lettertype',
    'pl-PL': 'Czcionka',
    'pt-BR': 'Fonte',
    'pt-PT': 'Fonte',
    'sv-SE': 'Typsnitt',
    'ta-IN': 'எழுத்துரு',
    'te-IN': 'ఫాంట్',
    'th-TH': 'แบบอักษร',
    'tr-TR': 'Yazı tipi',
    'vi-VN': 'Phông chữ',
    'zh-CN': '字体',
    'zh-TW': '字型',
  },
  'ag-top': {
    'en-US': 'Top',
    'ar-AE': 'أعلى',
    'bn-IN': 'শীর্ষ',
    'de-DE': 'Nach oben',
    'es-ES': 'Volver arriba',
    'es-MX': 'Arriba',
    'fr-BE': 'Haut',
    'fr-CA': 'Haut',
    'fr-FR': 'Haut de la page',
    'gu-IN': 'ઉપર',
    'hi-IN': 'ऊपर',
    'it-IT': 'Vai su',
    'ja-JP': 'トップ',
    'kn-IN': 'ಮೇಲೆ',
    'ko-KR': '최상위',
    'ml-IN': 'മികച്ചത്',
    'mr-IN': 'सर्वोत्कृष्ठ',
    'nl-NL': 'Omhoog',
    'pl-PL': 'Do góry',
    'pt-BR': 'Início',
    'pt-PT': 'Início',
    'sv-SE': 'Toppen',
    'ta-IN': 'மேல்புறம்',
    'te-IN': 'పైకి',
    'th-TH': 'ด้านบน',
    'tr-TR': 'Üst',
    'vi-VN': 'Đầu trang',
    'zh-CN': '顶部',
    'zh-TW': '上方',
  },
  'ag-right': {
    'en-US': 'Right',
    'ar-AE': 'اليمين',
    'bn-IN': 'ডানপাশ',
    'de-DE': 'Rechts',
    'es-ES': 'Derecha',
    'es-MX': 'Derecha',
    'fr-BE': 'Droite',
    'fr-CA': 'Droite',
    'fr-FR': 'Droite',
    'gu-IN': 'જમણે',
    'hi-IN': 'दायां',
    'it-IT': 'Destra',
    'ja-JP': '右',
    'kn-IN': 'ಬಲ',
    'ko-KR': '오른쪽',
    'ml-IN': 'വലത്',
    'mr-IN': 'उजवे',
    'nl-BE': 'Rechts',
    'nl-NL': 'Rechts',
    'pl-PL': 'Prawo',
    'pt-BR': 'Direita',
    'pt-PT': 'Direita',
    'sv-SE': 'Höger',
    'ta-IN': 'வலது',
    'te-IN': 'కుడి వైపు',
    'th-TH': 'ขวา',
    'tr-TR': 'Sağ',
    'vi-VN': 'Bên phải',
    'zh-CN': '右',
    'zh-TW': '右',
  },
  'ag-bottom': {
    'en-US': 'Bottom',
    'ar-AE': 'أسفل',
    'bn-IN': 'পাদদেশ',
    'de-DE': 'Unten',
    'es-ES': 'Parte inferior',
    'es-MX': 'Parte inferior',
    'fr-BE': 'Bas',
    'fr-CA': 'Bas',
    'fr-FR': 'Bas',
    'gu-IN': 'સૌથી નીચે',
    'hi-IN': 'नीचे',
    'it-IT': 'Inferiore',
    'ja-JP': '底辺',
    'kn-IN': 'ಕೆಳಗೆ',
    'ko-KR': '하단',
    'ml-IN': 'അടിഭാഗം',
    'mr-IN': 'खालचा भाग',
    'nl-BE': 'Onderkant',
    'nl-NL': 'Onderkant',
    'pl-PL': 'Dół',
    'pt-BR': 'Final',
    'pt-PT': 'Inferior',
    'sv-SE': 'Botten',
    'ta-IN': 'கீழே',
    'te-IN': 'దిగువ',
    'th-TH': 'ด้านล่าง',
    'tr-TR': 'Alt',
    'vi-VN': 'Phía dưới',
    'zh-CN': '底部',
    'zh-TW': '底部',
  },
  'ag-left': {
    'en-US': 'Left',
    'ar-AE': 'يسار',
    'bn-IN': 'বাম',
    'de-DE': 'Links',
    'es-ES': 'Izquierda',
    'es-MX': 'Izquierda',
    'fr-BE': 'Gauche',
    'fr-CA': 'Gauche',
    'fr-FR': 'Gauche',
    'gu-IN': 'ડાબે\n\n',
    'hi-IN': 'बाएं',
    'it-IT': 'Sinistra',
    'ja-JP': '左',
    'kn-IN': 'ಎಡ',
    'ko-KR': '왼쪽',
    'ml-IN': 'ഇടത്',
    'mr-IN': 'डावे',
    'nl-BE': 'Links',
    'nl-NL': 'Links',
    'pl-PL': 'Lewo',
    'pt-BR': 'Esquerda',
    'pt-PT': 'Esquerda',
    'sv-SE': 'Vänster',
    'ta-IN': 'இடது',
    'te-IN': 'ఎడమ',
    'th-TH': 'ซ้าย',
    'tr-TR': 'Sol',
    'vi-VN': 'Bên trái',
    'zh-CN': '左',
    'zh-TW': '左',
  },
  'ag-labels': {
    'en-US': 'Labels',
    'ar-AE': 'الملصقات',
    'bn-IN': 'লেবেল',
    'de-DE': 'Etiketten',
    'es-ES': 'Etiquetas',
    'es-MX': 'Etiquetas',
    'fr-BE': 'Étiquettes',
    'fr-CA': 'Étiquettes',
    'fr-FR': 'Étiquettes',
    'gu-IN': 'લેબલ્સ',
    'hi-IN': 'लेबल',
    'it-IT': 'Etichette',
    'ja-JP': 'ラベル',
    'kn-IN': 'ಲೇಬಲ್‌ಗಳು',
    'ko-KR': '라벨',
    'ml-IN': 'ലേബലുകൾ',
    'mr-IN': 'लेबल',
    'nl-BE': 'Etiketten',
    'nl-NL': 'Etiketten',
    'pl-PL': 'Etykiety',
    'pt-BR': 'Etiquetas',
    'pt-PT': 'Etiquetas',
    'sv-SE': 'Etiketter',
    'ta-IN': 'லேபிள்கள்',
    'te-IN': 'లేబుల్‌లు',
    'th-TH': 'ฉลาก',
    'tr-TR': 'Etiketler',
    'vi-VN': 'Nhãn',
    'zh-CN': '标签',
    'zh-TW': '標籤',
  },
  'ag-size': {
    'en-US': 'Size',
    'ar-AE': 'الحجم',
    'bn-IN': 'সাইজ',
    'de-DE': 'Größe',
    'es-ES': 'Tamaño',
    'es-MX': 'Tamaño',
    'fr-BE': 'Taille',
    'fr-CA': 'Taille',
    'fr-FR': 'Taille',
    'gu-IN': 'સાઈઝ',
    'hi-IN': 'साइज़',
    'it-IT': 'Dimensioni',
    'ja-JP': 'サイズ',
    'kn-IN': 'ಗಾತ್ರ',
    'ko-KR': '크기',
    'ml-IN': 'വലുപ്പം',
    'mr-IN': 'साईझ',
    'nl-BE': 'Grootte',
    'nl-NL': 'Maat',
    'pl-PL': 'Rozmiar',
    'pt-BR': 'Tamanho',
    'pt-PT': 'Tamanho',
    'sv-SE': 'Storlek',
    'ta-IN': 'அளவு',
    'te-IN': 'సైజు',
    'th-TH': 'ขนาด',
    'tr-TR': 'Beden/büyüklük/kapasite',
    'vi-VN': 'Kích cỡ',
    'zh-CN': '尺寸',
    'zh-TW': '尺寸',
  },
  'ag-minSize': {
    'en-US': 'Minimum Size',
    'ar-AE': 'الحد الأدنى للحجم',
    'bn-IN': 'নূন্যতম সাইজ',
    'de-DE': 'Mindestgröße',
    'en-AU': 'Minimum size',
    'en-GB': 'Minimum size',
    'en-ZA': 'Minimum size',
    'es-ES': 'Tamaño mínimo',
    'es-MX': 'Tamaño mínimo',
    'fr-BE': 'Taille minimale',
    'fr-CA': 'Taille minimale',
    'fr-FR': 'Taille minimale',
    'gu-IN': 'ન્યૂનતમ કદ',
    'hi-IN': 'न्यूनतम साइज़',
    'it-IT': 'Dimensioni minime',
    'ja-JP': '最小サイズ',
    'kn-IN': 'ಕನಿಷ್ಠ ಗಾತ್ರ',
    'ko-KR': '최소 크기',
    'ml-IN': 'മിനിമം വലുപ്പം',
    'mr-IN': 'किमान साइझ',
    'nl-BE': 'Minimale grootte',
    'nl-NL': 'Minimale grootte',
    'pl-PL': 'Rozmiar minimalny',
    'pt-BR': 'Tamanho mínimo',
    'pt-PT': 'Tamanho mínimo',
    'sv-SE': 'Minsta storlek',
    'ta-IN': 'குறைந்தபட்ச அளவு',
    'te-IN': 'కనీస సైజ్',
    'th-TH': 'ขนาดขั้นต่ำ',
    'tr-TR': 'Minimum boyut',
    'vi-VN': 'Kích thước tối thiểu',
    'zh-CN': '最小尺寸',
    'zh-TW': '大小下限',
  },
  'ag-maxSize': {
    'en-US': 'Maximum Size',
    'ar-AE': 'الحد الأقصى للحجم',
    'bn-IN': 'সর্বোচ্চ সাইজ',
    'de-DE': 'Maximale Größe:',
    'en-AU': 'Maximum size',
    'en-GB': 'Maximum size',
    'en-ZA': 'Maximum size',
    'es-ES': 'Tamaño máximo',
    'es-MX': 'Tamaño máximo',
    'fr-BE': 'Taille maximale',
    'fr-CA': 'Taille maximale',
    'fr-FR': 'Taille maximale',
    'gu-IN': 'મહત્તમ કદ',
    'hi-IN': 'अधिकतम साइज़',
    'it-IT': 'Dimensione massima',
    'ja-JP': '最大サイズ',
    'kn-IN': 'ಗರಿಷ್ಠ ಗಾತ್ರ',
    'ko-KR': '최대 크기',
    'ml-IN': 'പരമാവധി വലുപ്പം',
    'mr-IN': 'कमाल साइझ',
    'nl-BE': 'Maximale grootte',
    'nl-NL': 'Maximale grootte',
    'pl-PL': 'Rozmiar maksymalny',
    'pt-BR': 'Tamanho máximo',
    'pt-PT': 'Tamanho máximo',
    'sv-SE': 'Maximal storlek',
    'ta-IN': 'அதிகபட்ச அளவு',
    'te-IN': 'గరిష్ట సైజ్',
    'th-TH': 'ขนาดสูงสุด',
    'tr-TR': 'Maksimum boyut',
    'vi-VN': 'Kích thước tối đa',
    'zh-CN': '最大尺寸',
    'zh-TW': '大小上限',
  },
  'ag-legend': {
    'en-US': 'Legend',
    'ar-AE': 'الدليل',
    'bn-IN': 'লিজেন্ড',
    'de-DE': 'Legende',
    'es-ES': 'Leyenda',
    'es-MX': 'Leyenda',
    'fr-BE': 'Légende',
    'fr-CA': 'Légende',
    'fr-FR': 'Légende',
    'gu-IN': 'લિજેન્ડ',
    'hi-IN': 'लीजेंड',
    'it-IT': 'Legenda',
    'ja-JP': '例',
    'kn-IN': 'ಲೆಜೆಂಡ್',
    'ko-KR': '범례',
    'ml-IN': 'ലെജൻഡ്',
    'mr-IN': 'लेजन्ड',
    'nl-BE': 'Legende',
    'nl-NL': 'Legende',
    'pl-PL': 'Legenda',
    'pt-BR': 'Legenda',
    'pt-PT': 'Legenda',
    'sv-SE': 'Teckenförklaring',
    'ta-IN': 'லெஜண்ட்',
    'te-IN': 'లెజెండ్',
    'th-TH': 'คำอธิบาย',
    'tr-TR': 'Açıklamalar',
    'vi-VN': 'Chú giải',
    'zh-CN': '图例',
    'zh-TW': '說明',
  },
  'ag-position': {
    'en-US': 'Position',
    'ar-AE': 'الموضع',
    'bn-IN': 'অবস্থান',
    'es-ES': 'Posición',
    'es-MX': 'Posición',
    'gu-IN': 'પોઝિશન',
    'hi-IN': 'पोज़ीशन',
    'it-IT': 'Posizione',
    'ja-JP': '掲載位置',
    'kn-IN': 'ಪೊಸಿಶನ್',
    'ko-KR': '위치',
    'ml-IN': 'സ്ഥാനം',
    'mr-IN': 'पोझिशन',
    'nl-BE': 'Positie',
    'nl-NL': 'Positie',
    'pl-PL': 'Pozycja',
    'pt-BR': 'Posição',
    'pt-PT': 'Posição',
    'sv-SE': 'Placering',
    'ta-IN': 'நிலை',
    'te-IN': 'పొజిషన్',
    'th-TH': 'ตำแหน่ง',
    'tr-TR': 'Konum',
    'vi-VN': 'Vị trí',
    'zh-CN': '位置',
    'zh-TW': '位置',
  },
  'ag-markerSize': {
    'en-US': 'Marker Size',
    'ar-AE': 'حجم العلامة',
    'bn-IN': 'মার্কার সাইজ',
    'de-DE': 'Marker-Größe',
    'en-AU': 'Marker size',
    'en-GB': 'Marker size',
    'en-ZA': 'Marker size',
    'es-ES': 'Tamaño del marcador',
    'es-MX': 'Tamaño del marcador',
    'fr-BE': 'Taille du marqueur',
    'fr-CA': 'Taille du marqueur',
    'fr-FR': 'Taille du marqueur',
    'gu-IN': 'માર્કર કદ',
    'hi-IN': 'मार्कर साइज़',
    'it-IT': 'Dimensione del pennarello',
    'ja-JP': 'マーカーサイズ',
    'kn-IN': 'ಮಾರ್ಕರ್ ಗಾತ್ರ',
    'ko-KR': '마커 크기',
    'ml-IN': 'മാർക്കർ വലുപ്പം',
    'mr-IN': 'मार्करचा साइज',
    'nl-BE': 'Markeringsgrootte',
    'nl-NL': 'Grootte van markering',
    'pl-PL': 'Rozmiar znacznika',
    'pt-BR': 'Tamanho do marcador',
    'pt-PT': 'Tamanho do marcador',
    'sv-SE': 'Markörstorlek',
    'ta-IN': 'மார்க்கர் அளவு',
    'te-IN': 'మార్కర్ సైజ్',
    'th-TH': 'ขนาดมาร์กเกอร์',
    'tr-TR': 'İşaretçi boyutu',
    'vi-VN': 'Kích thước điểm',
    'zh-CN': '标记尺寸',
    'zh-TW': '標記大小',
  },
  'ag-markerStroke': {
    'en-US': 'Marker Stroke',
    'ar-AE': 'حد العلامة',
    'bn-IN': 'মার্কার স্ট্রোক',
    'de-DE': 'Marker-Strich',
    'en-AU': 'Marker stroke',
    'en-GB': 'Marker stroke',
    'en-ZA': 'Marker stroke',
    'es-ES': 'Trazo del marcador',
    'es-MX': 'Trazo del marcador',
    'fr-BE': 'Trait de marqueur',
    'fr-CA': 'Trait de marqueur',
    'fr-FR': 'Trait du marqueur',
    'gu-IN': 'માર્કર સ્ટ્રોક',
    'hi-IN': 'मार्कर स्ट्रोक',
    'it-IT': 'Tratto evidenziatore',
    'ja-JP': 'マーカーストローク',
    'kn-IN': 'ಮಾರ್ಕರ್ ಸ್ಟ್ರೋಕ್',
    'ko-KR': '마커 스트로크',
    'ml-IN': 'മാർക്കർ സ്ട്രോക്ക്',
    'mr-IN': 'मार्कर स्ट्रोक',
    'nl-BE': 'Markeringsstreek',
    'nl-NL': 'Streek van markering',
    'pl-PL': 'Ślad znacznika',
    'pt-BR': 'Traçado do marcador',
    'pt-PT': 'Traço de marcador',
    'sv-SE': 'Markörlinje',
    'ta-IN': 'மார்க்கர் ஸ்ட்ரோக்',
    'te-IN': 'మార్కర్ స్ట్రోక్',
    'th-TH': 'เส้นมาร์กเกอร์',
    'tr-TR': 'İşaretçi konturu',
    'vi-VN': 'Nét bút dạ',
    'zh-CN': '标记描边',
    'zh-TW': '標記筆劃',
  },
  'ag-markerPadding': {
    'en-US': 'Marker Padding',
    'ar-AE': 'حشو العلامة',
    'bn-IN': 'মার্কার প্যাডিং',
    'de-DE': 'Markerpuffer',
    'en-AU': 'Marker padding',
    'en-GB': 'Marker padding',
    'en-ZA': 'Marker padding',
    'es-ES': 'Relleno del marcador',
    'es-MX': 'Relleno del marcador',
    'fr-BE': 'Remplissage du marqueur',
    'fr-CA': 'Rembourrage du marqueur',
    'fr-FR': 'Remplissage du marqueur',
    'gu-IN': 'માર્કર પેડિંગ',
    'hi-IN': 'मार्कर पैडिंग',
    'it-IT': 'Riempimento con evidenziatore',
    'ja-JP': 'マーカーパディング',
    'kn-IN': 'ಮಾರ್ಕರ್ ಪ್ಯಾಡಿಂಗ್',
    'ko-KR': '마커 내부 여백',
    'ml-IN': 'മാർക്കർ പാഡിംഗ്',
    'mr-IN': 'मार्करचे पॅडिंग',
    'nl-BE': 'Markeringsopvullingen',
    'nl-NL': 'Opvulling van markering',
    'pl-PL': 'Dopełnienie znacznika',
    'pt-BR': 'Preenchimento do marcador',
    'pt-PT': 'Marcação de preenchimento',
    'sv-SE': 'Markörskydd',
    'ta-IN': 'மார்க்கர் பேட்டிங்',
    'te-IN': 'మార్కర్ ప్యాడింగ్',
    'th-TH': 'ช่องว่างภายในมาร์กเกอร์',
    'tr-TR': 'İşaretçi boşluğu',
    'vi-VN': 'Khoảng cách giữa nội dung và điểm',
    'zh-CN': '标记填充',
    'zh-TW': '標記邊距',
  },
  'ag-itemSpacing': {
    'en-US': 'Item Spacing',
    'ar-AE': 'تباعد المنتج',
    'bn-IN': 'দুটি আইটেমের মাঝখানের ফাঁকা জায়গা',
    'de-DE': 'Artikelabstand',
    'en-AU': 'Item spacing',
    'en-GB': 'Item spacing',
    'en-ZA': 'Item spacing',
    'es-ES': 'Espaciado entre elementos',
    'es-MX': 'Espacio de los elementos',
    'fr-BE': 'Espacement des articles',
    'fr-CA': 'Espacement entre les objets',
    'fr-FR': 'Espacement de l’élément',
    'gu-IN': 'આઇટમ સ્પેસિંગ',
    'hi-IN': 'आइटम स्पेसिंग',
    'it-IT': 'Spaziatura articolo',
    'ja-JP': '商品のスペース',
    'kn-IN': 'ಐಟಂ ಸ್ಪೇಸಿಂಗ್',
    'ko-KR': '아이템 간격',
    'ml-IN': 'ഇനത്തിൻ്റെ സ്പേസിംഗ്',
    'mr-IN': 'आयटम स्पेसिंग',
    'nl-BE': 'Regelafstand van item',
    'nl-NL': 'Afstand item',
    'pl-PL': 'Odstępy między elementami',
    'pt-BR': 'Espaçamento de itens',
    'pt-PT': 'Espaçamento do produto',
    'sv-SE': 'Artikelavstånd',
    'ta-IN': 'ஐட்டம் இடைவெளி',
    'te-IN': 'ఐటమ్ అంతరం',
    'th-TH': 'การเว้นวรรครายการ',
    'tr-TR': 'Öğe aralığı',
    'vi-VN': 'Khoảng cách mục',
    'zh-CN': '项目间距',
    'zh-TW': '項目間距',
  },
  'ag-itemPaddingX': {
    'en-US': 'Item Padding X',
    'ar-AE': 'حشو المنتج X',
    'bn-IN': 'আইটেমের প্যাডিং X',
    'de-DE': 'Artikel-Puffer X',
    'en-AU': 'Item padding X',
    'en-GB': 'Item padding X',
    'en-ZA': 'Item padding X',
    'es-ES': 'Relleno del elemento X',
    'es-MX': 'Relleno del elemento X',
    'fr-BE': 'Remplissage de l’article X',
    'fr-CA': 'Rembourrage de l’objet X',
    'fr-FR': 'Remplissage de l’élément X',
    'gu-IN': 'પેડિંગ આઇટમ X',
    'hi-IN': 'आइटम पैडिंग X',
    'it-IT': 'Riempimento articolo X',
    'kn-IN': 'ಐಟಂ ಪ್ಯಾಡಿಂಗ್ X',
    'ko-KR': '아이템 내부 여백 X',
    'ml-IN': 'ഇനം പാഡിംഗ് X',
    'mr-IN': 'आयटम पॅडिंग X',
    'nl-BE': 'Opvulruimte X van item',
    'nl-NL': 'Opvulling item X',
    'pl-PL': 'Dopełnienie X elementu',
    'pt-BR': 'Preenchimento do produto X',
    'pt-PT': 'Preenchimento do produto X',
    'sv-SE': 'Artikelskydd X',
    'ta-IN': 'பொருள் பேட்டிங் X',
    'te-IN': 'ఐటమ్ ప్యాడింగ్ X',
    'th-TH': 'ช่องว่างภายในรายการ X',
    'tr-TR': 'Öğe boşluğu X',
    'vi-VN': 'Khoảng cách giữa các mục theo hàng ngang',
    'zh-CN': '项目填充 X',
    'zh-TW': '項目邊距 X',
  },
  'ag-itemPaddingY': {
    'en-US': 'Item Padding Y',
    'ar-AE': 'حشو المنتج Y',
    'bn-IN': 'আইটেম প্যাডিং Y',
    'de-DE': 'Artikel-Pufer Y',
    'en-AU': 'Item padding Y',
    'en-GB': 'Item padding Y',
    'en-ZA': 'Item padding Y',
    'es-ES': 'Relleno del elemento Y',
    'es-MX': 'Relleno del elemento Y',
    'fr-BE': 'Remplissage de l’article en Y',
    'fr-CA': 'Rembourrage de l’objet Y',
    'fr-FR': 'Remplissage de l’élément Y',
    'gu-IN': 'પેડિંગ આઇટમ Y',
    'hi-IN': 'आइटम पैडिंग Y',
    'it-IT': 'Riempimento Y',
    'kn-IN': 'ಐಟಂ ಪ್ಯಾಡಿಂಗ್ Y',
    'ko-KR': '아이템 내부 여백 Y',
    'ml-IN': 'ഇനം പാഡിംഗ് Y',
    'mr-IN': 'आयटम पॅडिंग Y',
    'nl-BE': 'Itemopvulling Y',
    'nl-NL': 'Opvulling item Y',
    'pl-PL': 'Dopełnienie Y elementu',
    'pt-BR': 'Preenchimento do produto Y',
    'pt-PT': 'Preenchimento do produto Y',
    'sv-SE': 'Artikelskydd Y',
    'ta-IN': 'ஐட்டம் பேட்டிங் Y',
    'te-IN': 'ఐటమ్ ప్యాడింగ్ Y',
    'th-TH': 'ช่องว่างภายในรายการ Y',
    'tr-TR': 'Öğe boşluğu Y',
    'vi-VN': 'Khoảng cách giữa các mục theo hàng dọc',
    'zh-CN': '项目填充 Y',
    'zh-TW': '項目邊距 Y',
  },
  'ag-layoutHorizontalSpacing': {
    'en-US': 'Horizontal Spacing',
    'ar-AE': 'التباعد الأفقي',
    'bn-IN': 'অনুভূমিক ব্যবধান',
    'de-DE': 'Horizontaler Abstand',
    'en-AU': 'Horizontal spacing',
    'en-GB': 'Horizontal spacing',
    'en-ZA': 'Horizontal spacing',
    'es-ES': 'Espaciado horizontal',
    'es-MX': 'Espacio horizontal',
    'fr-BE': 'Espacement horizontal',
    'fr-CA': 'Espacement horizontal',
    'fr-FR': 'Espace horizontal',
    'gu-IN': 'હોરિઝોન્ટલ સ્પેસિંગ',
    'hi-IN': 'हॉरिजॉन्टल स्पेसिंग',
    'it-IT': 'Spaziatura orizzontale',
    'ja-JP': '横の間隔',
    'kn-IN': 'ಅಡ್ಡ ಸ್ಪೇಸಿಂಗ್',
    'ko-KR': '가로 간격',
    'ml-IN': 'തിരശ്ചീന സ്പേസിംഗ്',
    'mr-IN': 'आडवे स्पेसिंग',
    'nl-BE': 'horizontale regelafstand',
    'nl-NL': 'Horizontale afstand',
    'pl-PL': 'Odstępy w poziomie',
    'pt-BR': 'Espaçamento horizontal',
    'pt-PT': 'Espaçamento horizontal',
    'sv-SE': 'Horisontellt avstånd',
    'ta-IN': 'ஹரிசான்டல் இடைவெளி',
    'te-IN': 'సమతల అంతరం',
    'th-TH': 'ระยะห่างแนวนอน',
    'tr-TR': 'Yatay aralık',
    'vi-VN': 'Khoảng cách ngang',
    'zh-CN': '水平间距',
    'zh-TW': '水平間距',
  },
  'ag-layoutVerticalSpacing': {
    'en-US': 'Vertical Spacing',
    'ar-AE': 'تباعد عمودي',
    'bn-IN': 'উল্লম্ব ব্যবধান',
    'de-DE': 'Vertikaler Abstand',
    'en-AU': 'Vertical spacing',
    'en-GB': 'Vertical spacing',
    'en-ZA': 'Vertical spacing',
    'es-ES': 'Espaciado vertical',
    'es-MX': 'Espacio vertical',
    'fr-BE': 'Espacement vertical',
    'fr-CA': 'Espacement vertical',
    'fr-FR': 'Espacement vertical',
    'gu-IN': 'વર્ટિકલ સ્પેસિંગ',
    'hi-IN': 'वर्टीकल स्पेसिंग',
    'it-IT': 'Spaziatura verticale',
    'ja-JP': '縦方向の間隔',
    'kn-IN': 'ಲಂಬ ಸ್ಪೇಸಿಂಗ್',
    'ko-KR': '세로 간격',
    'ml-IN': 'ലംബമായ സ്പേസിംഗ്',
    'mr-IN': 'व्हर्टिकल स्पेसिंग',
    'nl-BE': 'Verticale regelafstand',
    'nl-NL': 'Verticale afstand',
    'pl-PL': 'Odstępy w pionie',
    'pt-BR': 'Espaçamento vertical',
    'pt-PT': 'Espaçamento vertical',
    'sv-SE': 'Vertikalt avstånd',
    'ta-IN': 'வெர்டிகள் இடைவெளி',
    'te-IN': 'నిలుపు ఖాళీ',
    'th-TH': 'ระยะห่างแนวตั้ง',
    'tr-TR': 'Dikey aralık',
    'vi-VN': 'Khoảng cách dọc',
    'zh-CN': '垂直间距',
    'zh-TW': '垂直間距',
  },
  'ag-strokeWidth': {
    'en-US': 'Stroke Width',
    'ar-AE': 'عرض الحد',
    'bn-IN': 'স্ট্রোকের প্রস্থ',
    'de-DE': 'Strichbreite',
    'en-AU': 'Stroke width',
    'en-GB': 'Stroke width',
    'en-ZA': 'Stroke width',
    'es-ES': 'Anchura del trazo',
    'es-MX': 'Ancho del trazo',
    'fr-BE': 'Largeur du trait',
    'fr-CA': 'Largeur du trait',
    'fr-FR': 'Largeur du trait',
    'gu-IN': 'સ્ટ્રોક પહોળાઈ',
    'hi-IN': 'स्ट्रोक की चौड़ाई',
    'it-IT': 'Larghezza tratto',
    'ja-JP': 'ストロークの幅',
    'kn-IN': 'ಸ್ಟ್ರೋಕ್ ಅಗಲ',
    'ko-KR': '스트로크 너비',
    'ml-IN': 'സ്ട്രോക്ക് വീതി',
    'mr-IN': 'स्ट्रोकची रुंदी',
    'nl-BE': 'Breedte van streep',
    'nl-NL': 'Breedte van streek',
    'pl-PL': 'Szerokość śladu',
    'pt-BR': 'Largura do traçado',
    'pt-PT': 'Largura do traço',
    'sv-SE': 'Bredd på linje',
    'ta-IN': 'ஸ்ட்ரோக் அகலம்',
    'te-IN': 'స్ట్రోక్ వెడల్పు',
    'th-TH': 'ความกว้างของเส้น',
    'tr-TR': 'Kontur genişliği',
    'vi-VN': 'Độ dày của nét',
    'zh-CN': '描边宽度',
    'zh-TW': '筆劃寬度',
  },
  'ag-offset': {
    'en-US': 'Offset',
    'ar-AE': 'الإزاحة',
    'bn-IN': 'অফসেট',
    'es-ES': 'Compensación',
    'es-MX': 'Desplazamiento',
    'fr-BE': 'Compensation',
    'fr-CA': 'Décalage',
    'fr-FR': 'Décalage',
    'gu-IN': 'ઓફસેટ',
    'hi-IN': 'ऑफ़सेट',
    'ja-JP': 'オフセット',
    'kn-IN': 'ಆಫ್‌ಸೆಟ್',
    'ko-KR': '오프셋',
    'ml-IN': 'ഓഫ്സെറ്റ്',
    'mr-IN': 'ऑफसेट',
    'pl-PL': 'Przesunięcie',
    'pt-BR': 'Deslocamento',
    'pt-PT': 'Deslocamento',
    'sv-SE': 'Förskjutning',
    'ta-IN': 'ஆஃப்செட்',
    'te-IN': 'ఆఫ్‌సెట్',
    'th-TH': 'ออฟเซ็ต',
    'tr-TR': 'Ofset',
    'vi-VN': 'Hàm tham chiếu',
    'zh-CN': '偏移',
    'zh-TW': '偏移',
  },
  'ag-offsets': {
    'en-US': 'Offsets',
    'ar-AE': 'الإزاحات',
    'bn-IN': 'অফসেট',
    'es-ES': 'Compensaciones',
    'es-MX': 'Desplazamientos',
    'fr-BE': 'Compensations',
    'fr-CA': 'Décalages',
    'fr-FR': 'Décalages',
    'gu-IN': 'ઓફસેટ',
    'hi-IN': 'ऑफ़सेट',
    'it-IT': 'Offset',
    'ja-JP': 'オフセット',
    'kn-IN': 'ಆಫ್‌ಸೆಟ್‌‌ಗಳು',
    'ko-KR': '오프셋',
    'ml-IN': 'ഓഫ്സെറ്റുകൾ',
    'mr-IN': 'ऑफसेट',
    'pl-PL': 'Przesunięcia',
    'pt-BR': 'Deslocamentos',
    'pt-PT': 'Deslocamentos',
    'sv-SE': 'Förskjutningar',
    'ta-IN': 'ஆஃப்செட்கள்',
    'te-IN': 'ఆఫ్‌సెట్‌లు',
    'th-TH': 'ออฟเซ็ต',
    'tr-TR': 'Ofsetler',
    'vi-VN': 'Hàm tham chiếu',
    'zh-CN': '偏移',
    'zh-TW': '偏移',
  },
  'ag-tooltips': {
    'en-US': 'Tooltips',
    'ar-AE': 'تلميحات الأداة',
    'bn-IN': 'টুলটিপস',
    'de-DE': 'Kurzinfo',
    'en-AU': 'Tool tips',
    'es-ES': 'Ayuda contextual',
    'es-MX': 'Descripciones emergentes',
    'fr-BE': 'Infobulles',
    'fr-CA': 'Infobulles',
    'fr-FR': 'Infobulles',
    'gu-IN': 'ટૂલટિપ્સ',
    'hi-IN': 'टूलटिप',
    'it-IT': 'Suggerimenti',
    'ja-JP': 'ツールチップ',
    'kn-IN': 'ಟೂಲ್‌ಟಿಪ್ಸ್',
    'ko-KR': '도구 설명',
    'ml-IN': 'ടൂൾടിപ്പുകൾ',
    'mr-IN': 'टूलटिप्स',
    'nl-NL': 'Knopinfo',
    'pl-PL': 'Etykiety narzędzi',
    'pt-BR': 'Dicas de ferramentas',
    'pt-PT': 'Sugestões',
    'sv-SE': 'Verktygstips',
    'ta-IN': 'டூல்டிப்கள்',
    'te-IN': 'టూల్‌టిప్స్‌',
    'th-TH': 'คำแนะนำเครื่องมือ',
    'tr-TR': 'Araç ipuçları',
    'vi-VN': 'Chú thích đối tượng',
    'zh-CN': '工具提示',
    'zh-TW': '提示',
  },
  'ag-callout': {
    'en-US': 'Callout',
    'ar-AE': 'وسيلة شرح',
    'bn-IN': 'কলআউট',
    'en-AU': 'Call-out',
    'es-ES': 'Cuadro de texto',
    'es-MX': 'Llamada',
    'fr-BE': 'Repère',
    'fr-CA': 'Repère',
    'fr-FR': 'Repère',
    'gu-IN': 'કોલઆઉટ',
    'hi-IN': 'कॉलआउट',
    'it-IT': 'Didascalia',
    'ja-JP': 'コールアウト',
    'kn-IN': 'ಕಾಲ್ಔಟ್',
    'ko-KR': '콜아웃',
    'ml-IN': 'കോളൗട്ട്',
    'mr-IN': 'कॉलआउट',
    'nl-BE': 'Uitschakelen',
    'nl-NL': 'Bijschrift',
    'pl-PL': 'Objaśnienie',
    'pt-BR': 'Chamada',
    'pt-PT': 'Texto destacado',
    'sv-SE': 'Bildtext',
    'ta-IN': 'கால்அவுட்',
    'te-IN': 'కాల్అవుట్',
    'th-TH': 'คำบรรยายภาพ',
    'tr-TR': 'Açıklama balonu',
    'vi-VN': 'Tạo ghi chú',
    'zh-CN': '标注',
    'zh-TW': '註釋',
  },
  'ag-markers': {
    'en-US': 'Markers',
    'ar-AE': 'أقلام تعليم',
    'bn-IN': 'মার্কার',
    'de-DE': 'Marker',
    'es-ES': 'Marcadores',
    'es-MX': 'Marcadores',
    'fr-BE': 'Marqueurs',
    'fr-CA': 'Marqueurs',
    'fr-FR': 'Marqueurs',
    'gu-IN': 'માર્કર્સ',
    'hi-IN': 'मार्कर',
    'it-IT': 'Pennarelli marcatori',
    'ja-JP': 'マーカー',
    'kn-IN': 'ಮಾರ್ಕರ್‌ಗಳು',
    'ko-KR': '마커',
    'ml-IN': 'മാർക്കറുകൾ',
    'mr-IN': 'मार्कर',
    'nl-BE': 'Markeringen',
    'nl-NL': 'Markeringen',
    'pl-PL': 'Znaczniki',
    'pt-BR': 'Marcadores',
    'pt-PT': 'Marcadores',
    'sv-SE': 'Markörer',
    'ta-IN': 'மார்க்கர்கள்',
    'te-IN': 'మార్కర్‌లు',
    'th-TH': 'มาร์กเกอร์',
    'tr-TR': 'İşaretçiler',
    'vi-VN': 'Điểm',
    'zh-CN': '标记',
    'zh-TW': '標記',
  },
  'ag-shadow': {
    'en-US': 'Shadow',
    'ar-AE': 'الظل',
    'bn-IN': 'ছায়া',
    'de-DE': 'Schatten',
    'es-ES': 'Sombra',
    'es-MX': 'Sombra',
    'fr-BE': 'Ombre',
    'fr-CA': 'Ombre',
    'fr-FR': 'Ombre',
    'gu-IN': 'શેડો',
    'hi-IN': 'शैडो',
    'it-IT': 'Ombra',
    'ja-JP': 'シャドー',
    'kn-IN': 'ನೆರಳು',
    'ko-KR': '섀도우',
    'ml-IN': 'നിഴൽ',
    'mr-IN': 'सावली',
    'nl-BE': 'Schaduw',
    'nl-NL': 'Schaduw',
    'pl-PL': 'Cień',
    'pt-BR': 'Sombra',
    'pt-PT': 'Sombra',
    'sv-SE': 'Skugga',
    'ta-IN': 'ஷேடோ',
    'te-IN': 'నీడ',
    'th-TH': 'เงา',
    'tr-TR': 'Gölge',
    'vi-VN': 'Đổ bóng',
    'zh-CN': '阴影',
    'zh-TW': '陰影',
  },
  'ag-blur': {
    'en-US': 'Blur',
    'ar-AE': 'ضبابي',
    'bn-IN': 'অস্পষ্ট',
    'de-DE': 'Unschärfe',
    'es-ES': 'Difuminar',
    'es-MX': 'Desenfoque',
    'fr-BE': 'Flou',
    'fr-CA': 'Estomper',
    'fr-FR': 'Flou',
    'gu-IN': 'બ્લર',
    'hi-IN': 'धुंधला',
    'it-IT': 'Sfocatura',
    'ja-JP': 'ブラー',
    'kn-IN': 'ಮಸುಕು',
    'ko-KR': '흐림',
    'ml-IN': 'മങ്ങിക്കുക',
    'mr-IN': 'ब्लर',
    'nl-BE': 'Wazig',
    'nl-NL': 'Vervagen',
    'pl-PL': 'Rozmycie',
    'pt-BR': 'Desfocar',
    'pt-PT': 'Texto desfocado',
    'sv-SE': 'Oskärpa',
    'ta-IN': 'மங்கலான',
    'te-IN': 'అస్పష్టత',
    'th-TH': 'เบลอ',
    'tr-TR': 'Bulanıklaştırma',
    'vi-VN': 'Làm mờ',
    'zh-CN': '模糊',
    'zh-TW': '模糊',
  },
  'ag-xOffset': {
    'en-US': 'X Offset',
    'ar-AE': 'الإزاحة X',
    'bn-IN': 'X অফসেট',
    'de-DE': 'X-Offset',
    'en-AU': 'X offset',
    'en-ZA': 'X offset',
    'es-ES': 'Desplazamiento X',
    'es-MX': 'Desplazamiento X',
    'fr-BE': 'Compensation de X',
    'fr-CA': 'X Décalé',
    'fr-FR': 'Décalage X',
    'gu-IN': 'X ઓફસેટ',
    'hi-IN': 'X ऑफ़सेट',
    'it-IT': 'Offset X',
    'ja-JP': 'Xオフセット',
    'kn-IN': 'X ಆಫ್‌ಸೆಟ್',
    'ko-KR': 'X 오프셋',
    'ml-IN': 'X ഓഫ്സെറ്റ്',
    'mr-IN': 'X ऑफसेट',
    'nl-BE': 'X-offset',
    'nl-NL': 'X-offset',
    'pl-PL': 'Przesunięcie X',
    'pt-BR': 'Deslocamento X',
    'pt-PT': 'Deslocamento X',
    'ta-IN': 'X ஆஃப்செட்',
    'te-IN': 'X ఆఫ్‌సెట్',
    'th-TH': 'ออฟเซ็ต X',
    'tr-TR': 'X ofseti',
    'vi-VN': 'Hàm tham chiếu theo hàng ngang',
    'zh-CN': 'X 偏移',
    'zh-TW': 'X 軸偏移',
  },
  'ag-yOffset': {
    'en-US': 'Y Offset',
    'ar-AE': 'إزاحة Y',
    'bn-IN': 'Y অফসেট',
    'de-DE': 'Y-Offset',
    'en-AU': 'Y offset',
    'en-GB': 'Y offset',
    'en-ZA': 'Y offset',
    'es-ES': 'Compensación Y',
    'es-MX': 'Desplazamiento Y',
    'fr-BE': 'Compensation de Y',
    'fr-CA': 'Décalage Y',
    'fr-FR': 'Décalage Y',
    'gu-IN': 'Y ઓફસેટ',
    'hi-IN': 'Y ऑफ़सेट',
    'it-IT': 'Offset Y',
    'ja-JP': 'Yオフセット',
    'kn-IN': 'Y ಆಫ್ಸೆಟ್',
    'ko-KR': 'Y 오프셋',
    'ml-IN': 'Y ഓഫ്സെറ്റ്',
    'mr-IN': 'Y ऑफसेट',
    'nl-BE': 'Y-offset',
    'nl-NL': 'Y-offset',
    'pl-PL': 'Przesunięcie Y',
    'pt-BR': 'Deslocamento Y',
    'pt-PT': 'Deslocamento Y',
    'sv-SE': 'Y-förskjutning',
    'ta-IN': 'Y ஆஃப்செட்',
    'te-IN': 'Y ఆఫ్‌సెట్',
    'th-TH': 'ออฟเซ็ต Y',
    'tr-TR': 'Y ofseti',
    'vi-VN': 'Hàm tham chiếu theo hàng dọc',
    'zh-CN': 'Y 偏移',
    'zh-TW': 'Y 軸偏移',
  },
  'ag-lineWidth': {
    'en-US': 'Line Width',
    'ar-AE': 'عرض الخط',
    'bn-IN': 'রেখার প্রস্থ',
    'de-DE': 'Linienstärke',
    'en-AU': 'Line width',
    'en-GB': 'Line width',
    'en-ZA': 'Line width',
    'es-ES': 'Anchura de línea',
    'es-MX': 'Anchura de línea',
    'fr-BE': 'Largeur de la ligne',
    'fr-CA': 'Largeur de ligne',
    'fr-FR': 'Largeur de la ligne',
    'gu-IN': 'રેખાની પહોળાઈ',
    'hi-IN': 'लाइन की चौड़ाई',
    'it-IT': 'Larghezza linea',
    'ja-JP': '行の幅',
    'kn-IN': 'ಸಾಲಿನ ಸ್ಪೇಸಿಂಗ್',
    'ko-KR': '줄 너비',
    'ml-IN': 'ലൈൻ വീതി',
    'mr-IN': 'ओळीची रुंदी',
    'nl-BE': 'Regelbreedte',
    'nl-NL': 'Lijndikte',
    'pl-PL': 'Szerokość linii',
    'pt-BR': 'Largura da linha',
    'pt-PT': 'Largura da linha',
    'sv-SE': 'Radbredd',
    'ta-IN': 'வரி அகலம்',
    'te-IN': 'లైన్ వెడల్పు',
    'th-TH': 'ความกว้างของเส้น',
    'tr-TR': 'Satır genişliği',
    'vi-VN': 'Độ đậm của nét',
    'zh-CN': '线条宽度',
    'zh-TW': '線寬',
  },
  'ag-normal': {
    'en-US': 'Normal',
    'ar-AE': 'عادي',
    'bn-IN': 'স্বাভাবিক',
    'fr-CA': 'Normale',
    'gu-IN': 'સામાન્ય',
    'hi-IN': 'सामान्य',
    'it-IT': 'Normale',
    'ja-JP': '通常',
    'kn-IN': 'ಸಾಮಾನ್ಯ',
    'ko-KR': '보통',
    'ml-IN': 'സാധാരണം',
    'mr-IN': 'सामान्य',
    'nl-BE': 'Normaal',
    'nl-NL': 'Normaal',
    'pl-PL': 'Normalne',
    'ta-IN': 'இயல்பானது',
    'te-IN': 'సాధారణం',
    'th-TH': 'ปกติ',
    'vi-VN': 'Bình thường',
    'zh-CN': '正常',
    'zh-TW': '正常',
  },
  'ag-bold': {
    'en-US': 'Bold',
    'ar-AE': 'خط غامق',
    'bn-IN': 'বোল্ড',
    'de-DE': 'Fett',
    'es-ES': 'Negrita',
    'es-MX': 'Negrita',
    'fr-BE': 'Gras',
    'fr-CA': 'Gras',
    'fr-FR': 'Gras',
    'gu-IN': 'બોલ્ડ',
    'hi-IN': 'बोल्ड',
    'it-IT': 'Grassetto',
    'ja-JP': '太字',
    'kn-IN': 'ಬೋಲ್ಡ್‌',
    'ko-KR': '볼드',
    'ml-IN': 'ബോൾഡ്',
    'mr-IN': 'बोल्ड',
    'nl-BE': 'Vet',
    'nl-NL': 'Vet',
    'pl-PL': 'Pogrubienie',
    'pt-BR': 'Negrito',
    'pt-PT': 'Negrito',
    'sv-SE': 'Fet',
    'ta-IN': 'போல்டு',
    'te-IN': 'బోల్డ్',
    'th-TH': 'ตัวหนา',
    'tr-TR': 'Kalın',
    'vi-VN': 'In đậm',
    'zh-CN': '加粗',
    'zh-TW': '粗體',
  },
  'ag-italic': {
    'en-US': 'Italic',
    'ar-AE': 'خط مائل',
    'bn-IN': 'ইটালিক',
    'de-DE': 'Kursiv',
    'es-ES': 'Cursiva',
    'es-MX': 'Cursiva',
    'fr-BE': 'Italique',
    'fr-CA': 'Italique',
    'fr-FR': 'Italique',
    'gu-IN': 'ઇટાલિક',
    'hi-IN': 'इटैलिक',
    'it-IT': 'Corsivo',
    'ja-JP': 'イタリック',
    'kn-IN': 'ಇಟಾಲಿಕ್',
    'ko-KR': '기울임꼴',
    'ml-IN': 'ഇറ്റാലിക്',
    'mr-IN': 'आयटॅलिक',
    'nl-BE': 'Cursief',
    'nl-NL': 'Cursief',
    'pl-PL': 'Kursywa',
    'pt-BR': 'Itálico',
    'pt-PT': 'Itálico',
    'sv-SE': 'Kursiv',
    'ta-IN': 'சாய்ந்தது',
    'te-IN': 'ఇటాలిక్',
    'th-TH': 'ตัวเอียง',
    'tr-TR': 'İtalik',
    'vi-VN': 'In nghiêng',
    'zh-CN': '斜体',
    'zh-TW': '斜體',
  },
  'ag-boldItalic': {
    'en-US': 'Bold Italic',
    'ar-AE': 'خط مائل غامق',
    'bn-IN': 'বোল্ড ইটালিক',
    'de-DE': 'Fett Kursiv',
    'en-AU': 'Bold italic',
    'en-GB': 'Bold italic',
    'en-ZA': 'Bold italic',
    'es-ES': 'Cursiva negrita',
    'es-MX': 'Cursiva en negrita',
    'fr-BE': 'Gras Italique',
    'fr-CA': 'Gras italique',
    'fr-FR': 'Gras italique',
    'gu-IN': 'બોલ્ડ ઇટાલિક',
    'hi-IN': 'बोल्ड इटैलिक',
    'it-IT': 'Corsivo grassetto',
    'ja-JP': '太字の斜体',
    'kn-IN': 'ಬೋಲ್ಡ್ ಇಟಾಲಿಕ್',
    'ko-KR': '볼드 기울임꼴',
    'ml-IN': 'ബോൾഡ് ഇറ്റാലിക്',
    'mr-IN': 'बोल्ड आयटॅलिक',
    'nl-BE': 'Vet cursief',
    'nl-NL': 'Vet cursief',
    'pl-PL': 'Pogrubienie i kursywa',
    'pt-BR': 'Itálico negrito',
    'pt-PT': 'Negrito itálico',
    'sv-SE': 'Fet kursiv',
    'ta-IN': 'போல்டு இடாலிக்',
    'te-IN': 'బోల్డ్ ఇటాలిక్',
    'th-TH': 'ตัวหนาและเอียง',
    'tr-TR': 'Kalın italik',
    'vi-VN': 'In đậm và in nghiêng',
    'zh-CN': '粗斜体',
    'zh-TW': '粗斜體',
  },
  'ag-predefined': {
    'en-US': 'Predefined',
    'ar-AE': 'محدد مسبقًا',
    'bn-IN': 'পূর্বনির্ধারিত',
    'de-DE': 'Vordefiniert',
    'en-ZA': 'Pre-defined',
    'es-ES': 'Predefinido',
    'es-MX': 'Predefinido',
    'fr-BE': 'Prédéfini',
    'fr-CA': 'Prédéfini',
    'fr-FR': 'Prédéfini',
    'gu-IN': 'પૂર્વવ્યાખ્યાયિત',
    'hi-IN': 'पहले से तय',
    'it-IT': 'Predefinito',
    'ja-JP': '事前定義済み',
    'kn-IN': 'ಪೂರ್ವನಿರ್ಧರಿತ',
    'ko-KR': '미리 정의됨',
    'ml-IN': 'മുൻകൂട്ടി നിർവചിച്ചത്',
    'mr-IN': 'प्रीडिफाइन केलेले',
    'nl-BE': 'Vooraf gedefinieerd',
    'nl-NL': 'Vooraf gedefinieerd',
    'pl-PL': 'Predefiniowane',
    'pt-BR': 'Predefinido',
    'pt-PT': 'Predefinido',
    'sv-SE': 'Fördefinierad',
    'ta-IN': 'முன்வரையறுத்தது',
    'te-IN': 'ముందే నిర్వచించినది',
    'th-TH': 'กำหนดไว้ล่วงหน้า',
    'tr-TR': 'Önceden tanımlanmış',
    'vi-VN': 'Được xác định trước',
    'zh-CN': '预定义',
    'zh-TW': '預定義',
  },
  'ag-fillOpacity': {
    'en-US': 'Fill Opacity',
    'ar-AE': 'عتامة الملء',
    'bn-IN': 'ফিলের অস্বচ্ছতা',
    'de-DE': 'Flächentransparenz',
    'en-AU': 'Fill opacity',
    'en-GB': 'Fill opacity',
    'en-ZA': 'Fill opacity',
    'es-ES': 'Opacidad de relleno',
    'es-MX': 'Opacidad de relleno',
    'fr-BE': 'Remplir l’opacité',
    'fr-CA': 'Opacité du remplissage',
    'fr-FR': 'Opacité du remplissage',
    'gu-IN': 'અસ્પષ્ટતા દૂર કરો',
    'hi-IN': 'फ़िल ओपेसिटी',
    'it-IT': 'Opacità di riempimento',
    'kn-IN': 'ಅಪಾರದರ್ಶಕತೆ ತುಂಬಿರಿ',
    'ko-KR': '칠 불투명도',
    'ml-IN': 'ഫിൽ അതാര്യത',
    'mr-IN': 'फिल ओपेसिटी',
    'nl-BE': 'Ondoorzichtigheid vullen',
    'nl-NL': 'Ondoorzichtigheid van vulling',
    'pl-PL': 'Nieprzezroczystość wypełnienia',
    'pt-BR': 'Opacidade de preenchimento',
    'pt-PT': 'Opacidade de preenchimento',
    'sv-SE': 'Täckningsgrad',
    'ta-IN': 'நிரப்பு ஒளிபுகாத்தன்மை',
    'te-IN': 'అపారదర్శకతను నింపండి',
    'th-TH': 'ความทึบของการเติม',
    'tr-TR': 'Dolgu opaklığı',
    'vi-VN': 'Độ trong suốt của màu',
    'zh-CN': '填充不透明度',
    'zh-TW': '填滿不透明度',
  },
  'ag-strokeOpacity': {
    'en-US': 'Line Opacity',
    'ar-AE': 'عتامة الخط',
    'bn-IN': 'লাইনের অস্বচ্ছতা',
    'de-DE': 'Linientransparenz',
    'en-AU': 'Line opacity',
    'en-GB': 'Line opacity',
    'en-ZA': 'Line opacity',
    'es-ES': 'Opacidad de la línea',
    'es-MX': 'Opacidad de línea',
    'fr-BE': 'Opacité de la ligne',
    'fr-CA': 'Opacité des lignes',
    'fr-FR': 'Opacité de ligne',
    'gu-IN': 'રેખા અસ્પષ્ટતા',
    'hi-IN': 'लाइन ओपेसिटी',
    'it-IT': 'Opacità linea',
    'kn-IN': 'ಸಾಲು ಅಪಾರದರ್ಶಕತೆ',
    'ko-KR': '줄 불투명도',
    'ml-IN': 'ലൈൻ അതാര്യത',
    'mr-IN': 'ओळींची ओपेसिटी',
    'nl-BE': 'Regelondoorzichtigheid',
    'nl-NL': 'Ondoorzichtigheid lijn',
    'pl-PL': 'Nieprzezroczystość linii',
    'pt-BR': 'Opacidade da linha',
    'pt-PT': 'Opacidade da linha',
    'sv-SE': 'Täckningsgrad för linje',
    'ta-IN': 'லைன் ஒளிபுகாத்தன்மை',
    'te-IN': 'లైన్ అపారదర్శకత',
    'th-TH': 'ความทึบของเส้น',
    'tr-TR': 'Satır opaklığı',
    'vi-VN': 'Độ trong suốt của đường',
    'zh-CN': '线条不透明度',
    'zh-TW': '線條不透明度',
  },
  'ag-histogramBinCount': {
    'en-US': 'Bin count',
    'ar-AE': 'عدد الحاويات',
    'bn-IN': 'বিনের সংখ্যা',
    'de-DE': 'Bin-Anzahl',
    'es-ES': 'Recuento de contenedores',
    'es-MX': 'Recuento de contenedores',
    'fr-BE': 'Valeur de l’intervalle',
    'fr-CA': 'Nombre de bacs',
    'fr-FR': 'Nombre de cases',
    'gu-IN': 'બિનની ગણતરી',
    'hi-IN': 'बिन की संख्या',
    'it-IT': 'Unità cestino',
    'ja-JP': 'ビンの数',
    'kn-IN': 'ಬಿನ್ ಎಣಿಕೆ',
    'ko-KR': '빈 개수',
    'ml-IN': 'ബിൻ എണ്ണം',
    'mr-IN': 'बिन गणना',
    'nl-BE': 'Aantal bakken',
    'nl-NL': 'Aantal containers',
    'pl-PL': 'Liczba przedziałów',
    'pt-BR': 'Contagem de compartimentos',
    'pt-PT': 'Contagem de bins',
    'sv-SE': 'Bin-räknare',
    'ta-IN': 'பின் கவுண்ட்',
    'te-IN': 'బిన్ సంఖ్య',
    'th-TH': 'จำนวนแท่งกราฟ',
    'tr-TR': 'Bin sayısı',
    'vi-VN': 'Hàm đếm Bin',
    'zh-CN': 'Bin 计数',
    'zh-TW': '區間計數',
  },
  'ag-columnGroup': {
    'en-US': 'Column',
    'ar-AE': 'العمود',
    'bn-IN': 'কলাম',
    'de-DE': 'Spalte',
    'es-ES': 'Columna',
    'es-MX': 'Columna',
    'fr-BE': 'Colonne',
    'fr-CA': 'Colonne',
    'fr-FR': 'Colonne',
    'gu-IN': 'કોલમ',
    'hi-IN': 'कॉलम',
    'it-IT': 'Colonna',
    'ja-JP': '項目',
    'kn-IN': 'ಕಾಲಮ್‌',
    'ko-KR': '열',
    'ml-IN': 'കോളം',
    'mr-IN': 'स्‍तंभ',
    'nl-BE': 'Kolom',
    'nl-NL': 'Kolom',
    'pl-PL': 'Kolumnowy',
    'pt-BR': 'Coluna',
    'pt-PT': 'Coluna',
    'sv-SE': 'Kolumn',
    'ta-IN': 'நெடுவரிசை',
    'te-IN': 'కాలమ్',
    'th-TH': 'คอลัมน์',
    'tr-TR': 'Sütun',
    'vi-VN': 'Cột',
    'zh-CN': '列',
    'zh-TW': '資料欄',
  },
  'ag-barGroup': {
    'en-US': 'Bar',
    'ar-AE': 'شريط',
    'bn-IN': 'বার',
    'de-DE': 'Sperren',
    'es-ES': 'Barra',
    'es-MX': 'Barra',
    'fr-BE': 'Barre',
    'fr-CA': 'Barre',
    'fr-FR': 'Barre',
    'gu-IN': 'બાર',
    'hi-IN': 'बार',
    'it-IT': 'Standard',
    'ja-JP': 'バー',
    'kn-IN': 'ಬಾರ್',
    'ko-KR': '바',
    'ml-IN': 'ബാർ',
    'mr-IN': 'बार',
    'nl-BE': 'Drempel',
    'nl-NL': 'Balk',
    'pl-PL': 'Słupkowy',
    'pt-BR': 'Barra',
    'pt-PT': 'Barra',
    'sv-SE': 'Nivå',
    'ta-IN': 'பார்',
    'te-IN': 'బార్',
    'th-TH': 'บาร์',
    'tr-TR': 'Çubuk',
    'vi-VN': 'Thanh',
    'zh-CN': '条形图',
    'zh-TW': '條狀',
  },
  'ag-pieGroup': {
    'en-US': 'Pie',
    'ar-AE': 'شكل دائري',
    'bn-IN': 'পাই',
    'de-DE': 'Torte',
    'es-ES': 'Circular',
    'es-MX': 'Circular',
    'fr-BE': 'Circulaire',
    'fr-CA': 'Tarte',
    'fr-FR': 'Pâté',
    'gu-IN': 'પાઇ',
    'hi-IN': 'पाई',
    'it-IT': 'A torta',
    'ja-JP': 'パイ',
    'kn-IN': 'ಪೈ',
    'ko-KR': '파이',
    'ml-IN': 'പൈ',
    'mr-IN': 'पाय',
    'nl-BE': 'Taart',
    'nl-NL': 'Cirkel',
    'pl-PL': 'Kołowy',
    'pt-BR': 'Pizza',
    'pt-PT': 'Circular',
    'sv-SE': 'Paj',
    'ta-IN': 'பை',
    'te-IN': 'పైయ్',
    'th-TH': 'วงกลม',
    'tr-TR': 'Pasta',
    'vi-VN': 'Tròn',
    'zh-CN': '饼图',
    'zh-TW': '圓餅',
  },
  'ag-lineGroup': {
    'en-US': 'Line',
    'ar-AE': 'الخط',
    'bn-IN': 'লাইন',
    'de-DE': 'Zeile',
    'es-ES': 'Línea',
    'es-MX': 'Línea',
    'fr-BE': 'Linéaire',
    'fr-CA': 'Ligne',
    'fr-FR': 'Ligne',
    'gu-IN': 'લાઇન',
    'hi-IN': 'लाइन',
    'it-IT': 'Riga',
    'ja-JP': '行',
    'kn-IN': 'ಸಾಲು',
    'ko-KR': '줄',
    'ml-IN': 'ലൈൻ',
    'mr-IN': 'ओळ',
    'nl-BE': 'Regel',
    'nl-NL': 'Regel',
    'pl-PL': 'Liniowy',
    'pt-BR': 'Linha',
    'pt-PT': 'Linha',
    'sv-SE': 'Rad',
    'ta-IN': 'வரி',
    'te-IN': 'పంక్తి',
    'th-TH': 'บรรทัด',
    'tr-TR': 'Satır',
    'vi-VN': 'Dòng',
    'zh-CN': '行',
    'zh-TW': '線條',
  },
  'ag-scatterGroup': {
    'en-US': 'X Y (Scatter)',
    'ar-AE': 'X Y (مبعثر)',
    'bn-IN': 'X Y (স্ক্যাটার)',
    'de-DE': 'X Y (Streuung)',
    'en-AU': 'X Y (scatter)',
    'es-ES': 'X Y (dispersión)',
    'es-MX': 'X Y (dispersión)',
    'fr-BE': 'X Y (Éparpiller)',
    'fr-CA': 'X Y (Dispersion)',
    'fr-FR': 'X Y (répartition)',
    'gu-IN': 'X Y (સ્કેટર)',
    'hi-IN': 'X Y (स्कैटर)',
    'it-IT': 'X Y (Disperdi)',
    'ja-JP': 'X Y（散布図）',
    'kn-IN': 'X Y (ಸ್ಕ್ಯಾಟರ್)',
    'ko-KR': 'X Y(스캐터)',
    'ml-IN': 'X Y (സ്‌കാറ്റർ)',
    'mr-IN': 'X Y (स्कॅटर)',
    'nl-BE': 'X Y (spreiding)',
    'nl-NL': 'X Y (spreiden)',
    'pl-PL': 'X Y (punktowy)',
    'pt-BR': 'X Y (Desagrupar)',
    'pt-PT': 'X Y (Dispersão)',
    'sv-SE': 'X Y (sprid)',
    'ta-IN': 'X Y (ஸ்காட்டர்)',
    'te-IN': 'X Y (స్కాటర్)',
    'th-TH': 'X Y (กระจาย)',
    'tr-TR': 'X Y (dağılım)',
    'vi-VN': 'X Y (Phân tán)',
    'zh-CN': 'X Y（散点图）',
    'zh-TW': 'X Y (散佈)',
  },
  'ag-areaGroup': {
    'en-US': 'Area',
    'ar-AE': 'المنطقة',
    'bn-IN': 'এলাকা',
    'de-DE': 'Fläche',
    'es-ES': 'Área',
    'es-MX': 'Área',
    'fr-BE': 'Superficie',
    'fr-CA': 'Superficie',
    'fr-FR': 'Zone',
    'gu-IN': 'વિસ્તાર',
    'hi-IN': 'एरिया',
    'it-IT': 'Superficie',
    'ja-JP': '地区',
    'kn-IN': 'ಪ್ರದೇಶ',
    'ko-KR': '영역',
    'ml-IN': 'പ്രദേശം',
    'mr-IN': 'क्षेत्र',
    'nl-BE': 'Gebied',
    'nl-NL': 'Gebied',
    'pl-PL': 'Warstwowy',
    'pt-BR': 'Área',
    'pt-PT': 'Área',
    'sv-SE': 'Område',
    'ta-IN': 'பகுதி',
    'te-IN': 'వైశాల్యం',
    'th-TH': 'พื้นที่',
    'tr-TR': 'Alan',
    'vi-VN': 'Khu vực',
    'zh-CN': '面积图',
    'zh-TW': '區域',
  },
  'ag-histogramGroup': {
    'en-US': 'Histogram',
    'ar-AE': 'مدرج إحصائي',
    'bn-IN': 'হিস্টোগ্রাম',
    'de-DE': 'Histogramm',
    'es-ES': 'Histograma',
    'es-MX': 'Histograma',
    'fr-BE': 'Histogramme',
    'fr-CA': 'Histogramme',
    'fr-FR': 'Histogramme',
    'gu-IN': 'હિસ્ટોગ્રામ',
    'hi-IN': 'हिस्टोग्राम',
    'it-IT': 'Istogramma',
    'ja-JP': 'ヒストグラム',
    'kn-IN': 'ಹಿಸ್ಟೋಗ್ರಾಮ್',
    'ko-KR': '히스토그램',
    'ml-IN': 'ഹിസ്റ്റോഗ്രാം',
    'mr-IN': 'हिस्टोग्राम',
    'pt-BR': 'Histograma',
    'pt-PT': 'Histograma',
    'ta-IN': 'ஹிஸ்டோகிராம்',
    'te-IN': 'హిస్టోగ్రామ్',
    'th-TH': 'ฮิสโทแกรม',
    'vi-VN': 'Biểu đồ tần suất',
    'zh-CN': '直方图',
    'zh-TW': '直方圖',
  },
  'ag-combinationGroup': {
    'en-US': 'Combination',
    'ar-AE': 'الجمع',
    'bn-IN': 'কম্বিনেশন',
    'de-DE': 'Kombination',
    'es-ES': 'Combinación',
    'es-MX': 'Combinación',
    'fr-BE': 'Combinaison',
    'fr-CA': 'Combinaison',
    'fr-FR': 'Combinaison',
    'gu-IN': 'કોમ્બિનેશન',
    'hi-IN': 'कॉम्बिनेशन',
    'it-IT': 'Combinazione',
    'ja-JP': '組み合わせ',
    'kn-IN': 'ಕಾಂಬಿನೇಶನ್',
    'ko-KR': '조합',
    'ml-IN': 'കോമ്പിനേഷൻ',
    'mr-IN': 'कॉंबिनेशन',
    'nl-BE': 'Combinatie',
    'nl-NL': 'Combinatie',
    'pl-PL': 'Kombinacja',
    'pt-BR': 'Combinação',
    'pt-PT': 'Combinação',
    'sv-SE': 'Kombination',
    'ta-IN': 'சேர்க்கை',
    'te-IN': 'కాంబినేషన్',
    'th-TH': 'การรวม',
    'tr-TR': 'Kombinasyon',
    'vi-VN': 'Kết hợp',
    'zh-CN': '组合',
    'zh-TW': '組合',
  },
  'ag-groupedColumnTooltip': {
    'en-US': 'Grouped',
    'ar-AE': 'مُجمعة',
    'bn-IN': 'গ্রুপ করা হয়েছে',
    'de-DE': 'Gruppiert',
    'es-ES': 'Agrupado',
    'es-MX': 'Agrupados',
    'fr-BE': 'Regroupé',
    'fr-CA': 'Groupé',
    'fr-FR': 'Regrouper',
    'gu-IN': 'જૂથબદ્ધ',
    'hi-IN': 'ग्रुप किया गया',
    'it-IT': 'Raggruppato',
    'ja-JP': 'グループ化',
    'kn-IN': 'ಗುಂಪು ಮಾಡಲಾಗಿದೆ',
    'ko-KR': '그룹화됨',
    'ml-IN': 'ഗ്രൂപ്പ് ചെയ്തു',
    'mr-IN': 'ग्रुप केले',
    'nl-BE': 'Gegroepeerd',
    'nl-NL': 'Gegroepeerd',
    'pl-PL': 'Zgrupowane',
    'pt-BR': 'Agrupado',
    'pt-PT': 'Agrupado',
    'sv-SE': 'Grupperad',
    'ta-IN': 'குரூப் செய்யப்பட்டது',
    'te-IN': 'వర్గీకరించినవి',
    'th-TH': 'จัดกลุ่มแล้ว',
    'tr-TR': 'Gruplanmış',
    'vi-VN': 'Đã nhóm',
    'zh-CN': '已分组',
    'zh-TW': '已分組',
  },
  'ag-stackedColumnTooltip': {
    'en-US': 'Stacked',
    'ar-AE': 'مُتكدس',
    'bn-IN': 'স্ট্যাক করা হয়েছে',
    'de-DE': 'Gestapelt',
    'es-ES': 'Apilado',
    'es-MX': 'Apilados',
    'fr-BE': 'Empilé',
    'fr-CA': 'Compilé',
    'fr-FR': 'En attente',
    'gu-IN': 'સ્ટેક્ડ',
    'hi-IN': 'स्टैक किया गया',
    'it-IT': 'Impilato',
    'ja-JP': '積み重ね済み',
    'kn-IN': 'ಜೋಡಿಸಲಾಗಿದೆ',
    'ko-KR': '스택',
    'ml-IN': 'അടുക്കിയിരിക്കുന്നു',
    'mr-IN': 'स्टॅक केले',
    'nl-BE': 'Gestapeld',
    'nl-NL': 'Gestapeld',
    'pl-PL': 'Skumulowany',
    'pt-BR': 'Empilhados',
    'pt-PT': 'Empilhado',
    'sv-SE': 'Staplade',
    'ta-IN': 'ஸ்டாக் செய்யப்பட்டது',
    'te-IN': 'వరుసలో ఉంచినది',
    'th-TH': 'เรียงซ้อน',
    'tr-TR': 'İstiflenmiş',
    'vi-VN': 'Xếp chồng',
    'zh-CN': '堆叠图',
    'zh-TW': '堆疊',
  },
  'ag-normalizedColumnTooltip': {
    'en-US': '100% Stacked',
    'ar-AE': 'مكدسة بنسبة 100%',
    'bn-IN': '100% স্ট্যাক করা হয়েছে',
    'de-DE': '100 % gestapelt',
    'en-AU': '100% stacked',
    'en-GB': '100% stacked',
    'en-ZA': '100% stacked',
    'es-ES': '100 % apilado',
    'es-MX': '100 % apilado',
    'fr-BE': '100 % empilés',
    'fr-CA': 'Compilé à 100 %',
    'fr-FR': '100 % en attente',
    'gu-IN': '100% સ્ટેક્ડ',
    'hi-IN': '100% स्टैक किया गया',
    'it-IT': 'Impilati al 100%',
    'ja-JP': '100%積み重ね済み',
    'kn-IN': '100% ಜೋಡಿಸಲಾಗಿದೆ',
    'ko-KR': '100% 스택',
    'ml-IN': '100% അടുക്കിയിരിക്കുന്നു',
    'mr-IN': '100% स्टॅक केले',
    'nl-BE': '100% gestapeld',
    'nl-NL': '100% gestapeld',
    'pl-PL': '100% skumulowany',
    'pt-BR': '100% empilhados',
    'pt-PT': '100% empilhado',
    'sv-SE': '100 % staplade',
    'ta-IN': '100% அடுக்கப்பட்டது',
    'te-IN': '100% పేర్చినది',
    'th-TH': 'เรียงซ้อน 100%',
    'tr-TR': '%100 istiflenmiş',
    'vi-VN': 'Xếp chồng 100%',
    'zh-CN': '100% 堆叠',
    'zh-TW': '100% 堆疊',
  },
  'ag-groupedBarTooltip': {
    'en-US': 'Grouped',
    'ar-AE': 'مُجمعة',
    'bn-IN': 'গ্রুপ করা হয়েছে',
    'de-DE': 'Gruppiert',
    'es-ES': 'Agrupado',
    'es-MX': 'Agrupados',
    'fr-BE': 'Regroupé',
    'fr-CA': 'Groupé',
    'fr-FR': 'Regrouper',
    'gu-IN': 'જૂથબદ્ધ',
    'hi-IN': 'ग्रुप किया गया',
    'it-IT': 'Raggruppato',
    'ja-JP': 'グループ化',
    'kn-IN': 'ಗುಂಪು ಮಾಡಲಾಗಿದೆ',
    'ko-KR': '그룹화됨',
    'ml-IN': 'ഗ്രൂപ്പ് ചെയ്തു',
    'mr-IN': 'ग्रुप केले',
    'nl-BE': 'Gegroepeerd',
    'nl-NL': 'Gegroepeerd',
    'pl-PL': 'Zgrupowane',
    'pt-BR': 'Agrupado',
    'pt-PT': 'Agrupado',
    'sv-SE': 'Grupperad',
    'ta-IN': 'குரூப் செய்யப்பட்டது',
    'te-IN': 'వర్గీకరించినవి',
    'th-TH': 'จัดกลุ่มแล้ว',
    'tr-TR': 'Gruplanmış',
    'vi-VN': 'Đã nhóm',
    'zh-CN': '已分组',
    'zh-TW': '已分組',
  },
  'ag-stackedBarTooltip': {
    'en-US': 'Stacked',
    'ar-AE': 'مُتكدس',
    'bn-IN': 'স্ট্যাক করা হয়েছে',
    'de-DE': 'Gestapelt',
    'es-ES': 'Apilado',
    'es-MX': 'Apilados',
    'fr-BE': 'Empilé',
    'fr-CA': 'Compilé',
    'fr-FR': 'En attente',
    'gu-IN': 'સ્ટેક્ડ',
    'hi-IN': 'स्टैक किया गया',
    'it-IT': 'Impilato',
    'ja-JP': '積み重ね済み',
    'kn-IN': 'ಜೋಡಿಸಲಾಗಿದೆ',
    'ko-KR': '스택',
    'ml-IN': 'അടുക്കിയിരിക്കുന്നു',
    'mr-IN': 'स्टॅक केले',
    'nl-BE': 'Gestapeld',
    'nl-NL': 'Gestapeld',
    'pl-PL': 'Skumulowany',
    'pt-BR': 'Empilhados',
    'pt-PT': 'Empilhado',
    'sv-SE': 'Staplade',
    'ta-IN': 'ஸ்டாக் செய்யப்பட்டது',
    'te-IN': 'వరుసలో ఉంచినది',
    'th-TH': 'เรียงซ้อน',
    'tr-TR': 'İstiflenmiş',
    'vi-VN': 'Xếp chồng',
    'zh-CN': '堆叠图',
    'zh-TW': '堆疊',
  },
  'ag-normalizedBarTooltip': {
    'en-US': '100% Stacked',
    'ar-AE': 'مكدسة بنسبة 100%',
    'bn-IN': '100% স্ট্যাক করা হয়েছে',
    'de-DE': '100 % gestapelt',
    'en-AU': '100% stacked',
    'en-GB': '100% stacked',
    'en-ZA': '100% stacked',
    'es-ES': '100 % apilado',
    'es-MX': '100 % apilado',
    'fr-BE': '100 % empilés',
    'fr-CA': 'Compilé à 100 %',
    'fr-FR': '100 % en attente',
    'gu-IN': '100% સ્ટેક્ડ',
    'hi-IN': '100% स्टैक किया गया',
    'it-IT': 'Impilati al 100%',
    'ja-JP': '100%積み重ね済み',
    'kn-IN': '100% ಜೋಡಿಸಲಾಗಿದೆ',
    'ko-KR': '100% 스택',
    'ml-IN': '100% അടുക്കിയിരിക്കുന്നു',
    'mr-IN': '100% स्टॅक केले',
    'nl-BE': '100% gestapeld',
    'nl-NL': '100% gestapeld',
    'pl-PL': '100% skumulowany',
    'pt-BR': '100% empilhados',
    'pt-PT': '100% empilhado',
    'sv-SE': '100 % staplade',
    'ta-IN': '100% அடுக்கப்பட்டது',
    'te-IN': '100% పేర్చినది',
    'th-TH': 'เรียงซ้อน 100%',
    'tr-TR': '%100 istiflenmiş',
    'vi-VN': 'Xếp chồng 100%',
    'zh-CN': '100% 堆叠',
    'zh-TW': '100% 堆疊',
  },
  'ag-pieTooltip': {
    'en-US': 'Pie',
    'ar-AE': 'شكل دائري',
    'bn-IN': 'পাই',
    'de-DE': 'Torte',
    'es-ES': 'Circular',
    'es-MX': 'Circular',
    'fr-BE': 'Circulaire',
    'fr-CA': 'Tarte',
    'fr-FR': 'Pâté',
    'gu-IN': 'પાઇ',
    'hi-IN': 'पाई',
    'it-IT': 'A torta',
    'ja-JP': 'パイ',
    'kn-IN': 'ಪೈ',
    'ko-KR': '파이',
    'ml-IN': 'പൈ',
    'mr-IN': 'पाय',
    'nl-BE': 'Taart',
    'nl-NL': 'Cirkel',
    'pl-PL': 'Kołowy',
    'pt-BR': 'Pizza',
    'pt-PT': 'Circular',
    'sv-SE': 'Paj',
    'ta-IN': 'பை',
    'te-IN': 'పైయ్',
    'th-TH': 'วงกลม',
    'tr-TR': 'Pasta',
    'vi-VN': 'Tròn',
    'zh-CN': '饼图',
    'zh-TW': '圓餅',
  },
  'ag-doughnutTooltip': {
    'en-US': 'Doughnut',
    'ar-AE': 'حلقة دونات',
    'bn-IN': 'ডোনাট',
    'de-DE': 'Donut',
    'es-ES': 'Anillo',
    'es-MX': 'De anillos',
    'fr-BE': 'Beignets',
    'fr-CA': 'Beigne',
    'fr-FR': 'Anneau',
    'gu-IN': 'ડોનટ',
    'hi-IN': 'डोनट',
    'it-IT': 'a ciambella',
    'ja-JP': 'ドーナッツ',
    'kn-IN': 'ಡೋನಟ್',
    'ko-KR': '도넛',
    'ml-IN': 'ഡോണട്ട്',
    'mr-IN': 'डोनट',
    'nl-BE': 'Donut',
    'nl-NL': 'Ring',
    'pl-PL': 'Pierścieniowy',
    'pt-BR': 'Rosca',
    'pt-PT': 'Anel',
    'sv-SE': 'Donut',
    'ta-IN': 'டௌநட்',
    'te-IN': 'డోనట్',
    'th-TH': 'โดนัท',
    'tr-TR': 'Halka',
    'vi-VN': 'Bánh vìng',
    'zh-CN': '环形图',
    'zh-TW': '環圈',
  },
  'ag-lineTooltip': {
    'en-US': 'Line',
    'ar-AE': 'الخط',
    'bn-IN': 'লাইন',
    'de-DE': 'Zeile',
    'es-ES': 'Línea',
    'es-MX': 'Línea',
    'fr-BE': 'Linéaire',
    'fr-CA': 'Ligne',
    'fr-FR': 'Ligne',
    'gu-IN': 'લાઇન',
    'hi-IN': 'लाइन',
    'it-IT': 'Riga',
    'ja-JP': '行',
    'kn-IN': 'ಸಾಲು',
    'ko-KR': '줄',
    'ml-IN': 'ലൈൻ',
    'mr-IN': 'ओळ',
    'nl-BE': 'Regel',
    'nl-NL': 'Regel',
    'pl-PL': 'Liniowy',
    'pt-BR': 'Linha',
    'pt-PT': 'Linha',
    'sv-SE': 'Rad',
    'ta-IN': 'வரி',
    'te-IN': 'పంక్తి',
    'th-TH': 'บรรทัด',
    'tr-TR': 'Satır',
    'vi-VN': 'Dòng',
    'zh-CN': '行',
    'zh-TW': '線條',
  },
  'ag-groupedAreaTooltip': {
    'en-US': 'Area',
    'ar-AE': 'المنطقة',
    'bn-IN': 'এলাকা',
    'de-DE': 'Fläche',
    'es-ES': 'Área',
    'es-MX': 'Área',
    'fr-BE': 'Superficie',
    'fr-CA': 'Superficie',
    'fr-FR': 'Zone',
    'gu-IN': 'વિસ્તાર',
    'hi-IN': 'एरिया',
    'it-IT': 'Superficie',
    'ja-JP': '地区',
    'kn-IN': 'ಪ್ರದೇಶ',
    'ko-KR': '영역',
    'ml-IN': 'പ്രദേശം',
    'mr-IN': 'क्षेत्र',
    'nl-BE': 'Gebied',
    'nl-NL': 'Gebied',
    'pl-PL': 'Warstwowy',
    'pt-BR': 'Área',
    'pt-PT': 'Área',
    'sv-SE': 'Område',
    'ta-IN': 'பகுதி',
    'te-IN': 'వైశాల్యం',
    'th-TH': 'พื้นที่',
    'tr-TR': 'Alan',
    'vi-VN': 'Khu vực',
    'zh-CN': '面积图',
    'zh-TW': '區域',
  },
  'ag-stackedAreaTooltip': {
    'en-US': 'Stacked',
    'ar-AE': 'مُتكدس',
    'bn-IN': 'স্ট্যাক করা হয়েছে',
    'de-DE': 'Gestapelt',
    'es-ES': 'Apilado',
    'es-MX': 'Apilados',
    'fr-BE': 'Empilé',
    'fr-CA': 'Compilé',
    'fr-FR': 'En attente',
    'gu-IN': 'સ્ટેક્ડ',
    'hi-IN': 'स्टैक किया गया',
    'it-IT': 'Impilato',
    'ja-JP': '積み重ね済み',
    'kn-IN': 'ಜೋಡಿಸಲಾಗಿದೆ',
    'ko-KR': '스택',
    'ml-IN': 'അടുക്കിയിരിക്കുന്നു',
    'mr-IN': 'स्टॅक केले',
    'nl-BE': 'Gestapeld',
    'nl-NL': 'Gestapeld',
    'pl-PL': 'Skumulowany',
    'pt-BR': 'Empilhados',
    'pt-PT': 'Empilhado',
    'sv-SE': 'Staplade',
    'ta-IN': 'ஸ்டாக் செய்யப்பட்டது',
    'te-IN': 'వరుసలో ఉంచినది',
    'th-TH': 'เรียงซ้อน',
    'tr-TR': 'İstiflenmiş',
    'vi-VN': 'Xếp chồng',
    'zh-CN': '堆叠图',
    'zh-TW': '堆疊',
  },
  'ag-normalizedAreaTooltip': {
    'en-US': '100% Stacked',
    'ar-AE': 'مكدسة بنسبة 100%',
    'bn-IN': '100% স্ট্যাক করা হয়েছে',
    'de-DE': '100 % gestapelt',
    'en-AU': '100% stacked',
    'en-GB': '100% stacked',
    'en-ZA': '100% stacked',
    'es-ES': '100 % apilado',
    'es-MX': '100 % apilado',
    'fr-BE': '100 % empilés',
    'fr-CA': 'Compilé à 100 %',
    'fr-FR': '100 % en attente',
    'gu-IN': '100% સ્ટેક્ડ',
    'hi-IN': '100% स्टैक किया गया',
    'it-IT': 'Impilati al 100%',
    'ja-JP': '100%積み重ね済み',
    'kn-IN': '100% ಜೋಡಿಸಲಾಗಿದೆ',
    'ko-KR': '100% 스택',
    'ml-IN': '100% അടുക്കിയിരിക്കുന്നു',
    'mr-IN': '100% स्टॅक केले',
    'nl-BE': '100% gestapeld',
    'nl-NL': '100% gestapeld',
    'pl-PL': '100% skumulowany',
    'pt-BR': '100% empilhados',
    'pt-PT': '100% empilhado',
    'sv-SE': '100 % staplade',
    'ta-IN': '100% அடுக்கப்பட்டது',
    'te-IN': '100% పేర్చినది',
    'th-TH': 'เรียงซ้อน 100%',
    'tr-TR': '%100 istiflenmiş',
    'vi-VN': 'Xếp chồng 100%',
    'zh-CN': '100% 堆叠',
    'zh-TW': '100% 堆疊',
  },
  'ag-scatterTooltip': {
    'en-US': 'Scatter',
    'ar-AE': 'مبعثر',
    'bn-IN': 'স্ক্যাটার',
    'de-DE': 'Streuung',
    'es-ES': 'Dispersión',
    'es-MX': 'Dispersión',
    'fr-BE': 'Éparpiller',
    'fr-CA': 'Disperser',
    'fr-FR': 'Répartition',
    'gu-IN': 'સ્કેટર',
    'hi-IN': 'स्कैटर',
    'it-IT': 'Disperdi',
    'ja-JP': '散布図',
    'kn-IN': 'ಸ್ಕ್ಯಾಟರ್',
    'ko-KR': '스캐터',
    'ml-IN': 'സ്‌കാറ്റർ ചെയ്യുക',
    'mr-IN': 'स्कॅटर',
    'nl-BE': 'Verspreiden',
    'nl-NL': 'Verspreiden',
    'pl-PL': 'Punktowy',
    'pt-BR': 'Desagrupar',
    'pt-PT': 'Dispersão',
    'sv-SE': 'Sprid',
    'ta-IN': 'ஸ்காட்டர்',
    'te-IN': 'చెల్లాచెదరు',
    'th-TH': 'กระจาย',
    'tr-TR': 'Dağılım',
    'vi-VN': 'Phân tán',
    'zh-CN': '散点图',
    'zh-TW': '散佈',
  },
  'ag-bubbleTooltip': {
    'en-US': 'Bubble',
    'ar-AE': 'المفرقعة',
    'bn-IN': 'বাবল',
    'de-DE': 'Luftpolsterfolie',
    'es-ES': 'Globo',
    'fr-BE': 'Bulle',
    'fr-CA': 'Bulle',
    'fr-FR': 'Papier-bulles',
    'gu-IN': 'બબલ',
    'hi-IN': 'बबल',
    'it-IT': 'A bolle',
    'ja-JP': 'エアキャップ',
    'kn-IN': 'ಬಬಲ್',
    'ko-KR': '버블',
    'ml-IN': 'ബബിൾ',
    'mr-IN': 'बबल',
    'nl-BE': 'Ballon',
    'nl-NL': 'Bel',
    'pl-PL': 'Bąbelkowy',
    'pt-BR': 'Bolha',
    'pt-PT': 'Balão',
    'sv-SE': 'Bubbla',
    'ta-IN': 'பபுள்',
    'te-IN': 'బబుల్',
    'th-TH': 'ฟอง',
    'tr-TR': 'Kabarcık',
    'vi-VN': 'Xốp hơi',
    'zh-CN': '气泡图',
    'zh-TW': '泡泡',
  },
  'ag-histogramTooltip': {
    'en-US': 'Histogram',
    'ar-AE': 'مدرج إحصائي',
    'bn-IN': 'হিস্টোগ্রাম',
    'de-DE': 'Histogramm',
    'es-ES': 'Histograma',
    'es-MX': 'Histograma',
    'fr-BE': 'Histogramme',
    'fr-CA': 'Histogramme',
    'fr-FR': 'Histogramme',
    'gu-IN': 'હિસ્ટોગ્રામ',
    'hi-IN': 'हिस्टोग्राम',
    'it-IT': 'Istogramma',
    'ja-JP': 'ヒストグラム',
    'kn-IN': 'ಹಿಸ್ಟೋಗ್ರಾಮ್',
    'ko-KR': '히스토그램',
    'ml-IN': 'ഹിസ്റ്റോഗ്രാം',
    'mr-IN': 'हिस्टोग्राम',
    'pt-BR': 'Histograma',
    'pt-PT': 'Histograma',
    'ta-IN': 'ஹிஸ்டோகிராம்',
    'te-IN': 'హిస్టోగ్రామ్',
    'th-TH': 'ฮิสโทแกรม',
    'vi-VN': 'Biểu đồ tần suất',
    'zh-CN': '直方图',
    'zh-TW': '直方圖',
  },
  'ag-columnLineComboTooltip': {
    'en-US': 'Column & Line',
    'ar-AE': 'العمود والسطر',
    'bn-IN': 'কলাম ও লাইন',
    'de-DE': 'Spalte und Zeile',
    'en-AU': 'Column and line',
    'en-ZA': 'Column & line',
    'es-ES': 'Columna y línea',
    'es-MX': 'Columna y línea',
    'fr-BE': 'Colonne et ligne',
    'fr-CA': 'Colonne et ligne',
    'fr-FR': 'Colonne et ligne',
    'gu-IN': 'કોલમ અને રેખા',
    'hi-IN': 'कॉलम और लाइन',
    'it-IT': 'Colonna e riga',
    'ja-JP': '列&行',
    'kn-IN': 'ಕಾಲಮ್ ಮತ್ತು ಸಾಲು',
    'ko-KR': '열 및 줄',
    'ml-IN': 'കോളവും ലൈനും',
    'mr-IN': 'स्तंभ आणि ओळी',
    'nl-BE': 'Kolom en regel',
    'nl-NL': 'Kolom en lijn',
    'pl-PL': 'Kolumnowy i liniowy',
    'pt-BR': 'Coluna e linha',
    'pt-PT': 'Coluna e Linha',
    'sv-SE': 'Kolumn och rad',
    'ta-IN': 'நெடுவரிசை மற்றும் வரி',
    'te-IN': 'కాలమ్ మరియు లైన్',
    'th-TH': 'คอลัมน์และบรรทัด',
    'tr-TR': 'Sütun ve satır',
    'vi-VN': 'Cột & Dòng',
    'zh-CN': '列和行',
    'zh-TW': '資料欄和線條',
  },
  'ag-areaColumnComboTooltip': {
    'en-US': 'Area & Column',
    'ar-AE': 'المنطقة والعمود',
    'bn-IN': 'এলাকা ও কলাম',
    'de-DE': 'Fläche und Spalte',
    'en-AU': 'Area and column',
    'en-ZA': 'Area & column',
    'es-ES': 'Área y columna',
    'es-MX': 'Área y columna',
    'fr-BE': 'Zone et colonne',
    'fr-CA': 'Zone et colonne',
    'fr-FR': 'Zone et colonne',
    'gu-IN': 'વિસ્તાર અને કોલમ',
    'hi-IN': 'एरिया और कॉलम',
    'it-IT': 'Area e colonna',
    'ja-JP': 'エリア&列',
    'kn-IN': 'ಪ್ರದೇಶ ಮತ್ತು ಕಾಲಮ್',
    'ko-KR': '영역 및 열',
    'ml-IN': 'ഏരിയയും കോളവും',
    'mr-IN': 'क्षेत्र आणि स्तंभ',
    'nl-BE': 'Gebied en kolom',
    'nl-NL': 'Gebied en kolom',
    'pl-PL': 'Warstwowy i kolumnowy',
    'pt-BR': 'Área e coluna',
    'pt-PT': 'Área e Coluna',
    'sv-SE': 'Område och kolumn',
    'ta-IN': 'பகுதி மற்றும் நெடுவரிசை',
    'te-IN': 'ఏరియా మరియు కాలమ్',
    'th-TH': 'พื้นที่และคอลัมน์',
    'tr-TR': 'Alan ve sütun',
    'vi-VN': 'Khu vực & Cột',
    'zh-CN': '面积图和柱状图',
    'zh-TW': '區域和資料欄',
  },
  'ag-customComboTooltip': {
    'en-US': 'Custom Combination',
    'ar-AE': 'مجموعة مخصصة',
    'bn-IN': 'কাস্টম কম্বিনেশন',
    'de-DE': 'Benutzerdefinierte Kombination',
    'en-AU': 'Custom combination',
    'en-GB': 'Custom combination',
    'en-ZA': 'Custom combination',
    'es-ES': 'Combinación personalizada',
    'es-MX': 'Combinación personalizada',
    'fr-BE': 'Combinaison personnalisée',
    'fr-CA': 'Combinaison personnalisée',
    'fr-FR': 'Combinaison personnalisée',
    'gu-IN': 'કસ્ટમ કોમ્બિનેશન',
    'hi-IN': 'कस्टम कॉम्बिनेशन',
    'it-IT': 'Combinazione personalizzata',
    'ja-JP': 'カスタムコンビネーション',
    'kn-IN': 'ಕಸ್ಟಮ್ ಕಾಂಬಿನೇಶನ್',
    'ko-KR': '사용자 지정 조합',
    'ml-IN': 'ഇഷ്‌ടാനുസൃത കോമ്പിനേഷൻ',
    'mr-IN': 'कस्टम कॉंबिनेशन',
    'nl-BE': 'Aangepaste combinatie',
    'nl-NL': 'Aangepaste combinatie',
    'pl-PL': 'Niestandardowa kombinacja',
    'pt-BR': 'Combinação personalizada',
    'pt-PT': 'Combinação personalizada',
    'sv-SE': 'Anpassad kombination',
    'ta-IN': 'தனிப்பயன் சேர்க்கை',
    'te-IN': 'అనుకూల కాంబినేషన్',
    'th-TH': 'การรวมกันแบบกำหนดเอง',
    'tr-TR': 'Özel kombinasyon',
    'vi-VN': 'Kết hợp tùy chỉnh',
    'zh-CN': '自定义组合',
    'zh-TW': '自訂組合',
  },
  'ag-noDataToChart': {
    'en-US': 'No data available to be charted.',
    'ar-AE': 'لا تتوفر بيانات ليتم إدراجها في الرسم البياني.',
    'bn-IN': 'চার্ট তৈরি করার জন্য কোনো ডেটা উপলব্ধ নেই।',
    'de-DE': 'Keine Daten für die Tabelle vorhanden.',
    'es-ES': 'No hay datos disponibles para el gráfico.',
    'es-MX': 'No hay datos disponibles para el gráfico.',
    'fr-BE': 'Aucune donnée disponible pour la création d’un graphique.',
    'fr-CA': 'Il n’y a pas de données disponibles pour établir un graphique.',
    'fr-FR': 'Aucune donnée disponible pour établir un graphique.',
    'gu-IN': 'ચાર્ટ બનાવવા માટે કોઈ ડેટા ઉપલબ્ધ નથી.',
    'hi-IN': 'चार्ट बनाने के लिए कोई डेटा उपलब्ध नहीं है.',
    'it-IT': 'Non sono disponibili dati da tracciare.',
    'ja-JP': 'グラフ化できるデータがありません。',
    'kn-IN': 'ಚಾರ್ಟ್ ಮಾಡಲು ಯಾವುದೇ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ.',
    'ko-KR': '차트로 표시할 데이터가 없습니다.',
    'ml-IN': 'ചാർട്ട് ചെയ്യാൻ ഡാറ്റകളൊന്നും ലഭ്യമല്ല.',
    'mr-IN': 'चार्ट करण्यासाठी डेटा उपलब्ध नाही.',
    'nl-BE': 'Er zijn geen gegevens beschikbaar om in kaart te brengen.',
    'nl-NL': 'Er zijn geen gegevens beschikbaar om in kaart te brengen.',
    'pl-PL': 'Brak danych dostępnych do prezentacji na wykresie.',
    'pt-BR': 'Nenhum dado disponível para ser mapeado.',
    'pt-PT': 'Não há dados disponíveis para representação em gráfico.',
    'sv-SE': 'Inga data tillgängliga att kartlägga.',
    'ta-IN': 'விளக்கப்பட தரவு எதுவும் இல்லை.',
    'te-IN': 'చార్ట్ చేయడానికి డేటా ఏదీ అందుబాటులో లేదు.',
    'th-TH': 'ไม่มีข้อมูลให้สร้างแผนภูมิ',
    'tr-TR': 'Tablo haline getirilecek veri yok.',
    'vi-VN': 'Không có dữ liệu nào có sẵn để tạo biểu đồ.',
    'zh-CN': '没有可绘制图表的数据。',
    'zh-TW': '沒有可用於繪製圖表的資料。',
  },
  'ag-pivotChartRequiresPivotMode': {
    'en-US': 'Pivot Chart requires Pivot Mode enabled.',
    'ar-AE': 'يتطلب الرسم البياني المحوري تمكين الوضع المحوري.',
    'bn-IN': 'পিভট চার্টের জন্য পিভট মোড সক্রিয় থাকতে হবে।',
    'de-DE': 'Für Pivot-Tabellen muss der Pivot-Modus aktiviert sein.',
    'en-AU': 'Pivot chart requires pivot mode to be enabled.',
    'en-ZA': 'Pivot chart requires Pivot Mode enabled.',
    'es-ES': 'El gráfico dinámico requiere activar el modo dinámico.',
    'es-MX': 'El gráfico dinámico requiere que el modo dinámico esté activado.',
    'fr-BE':
      'Le graphique croisé dynamique nécessite l’activation du mode croisé dynamique.',
    'fr-CA': "Le graphique croisé nécessite l'activation du mode pivot.",
    'fr-FR':
      'Le graphique croisé dynamique nécessite l’activation du mode croisé dynamique.',
    'gu-IN': 'પિવોટ ચાર્ટને પિવોટ મોડ સક્ષમ કરવાની જરૂર છે.',
    'hi-IN': 'पिवट चार्ट के लिए पिवट मोड चालू होना ज़रूरी है.',
    'it-IT': 'La tabella pivot richiede la modalità pivot abilitata.',
    'ja-JP': 'ピボットチャートは、ピボットモードを有効にする必要があります。',
    'kn-IN': 'ಪಿವೋಟ್ ಚಾರ್ಟ್‌ಗೆ ಪಿವೋಟ್ ಮೋಡ್ ಅನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಬೇಕಿದೆ.',
    'ko-KR': '피벗 차트를 사용하려면 피벗 모드를 활성화해야 합니다.',
    'ml-IN': 'പിവട്ട് ചാർട്ടിന്, പിവട്ട് മോഡ് പ്രവർത്തനക്ഷമമാക്കേണ്ടതുണ്ട്.',
    'mr-IN': 'पायव्होट चार्टसाठी पायव्होट मोड सक्रिय असावा लागतो.',
    'nl-BE': 'Draagdiagram vereist dat de draaimodus is ingeschakeld.',
    'nl-NL': 'Voor het draaidiagram moet de draaimodus ingeschakeld zijn.',
    'pl-PL': 'Wykres przestawny wymaga włączenia trybu przestawnego.',
    'pt-BR': 'O gráfico dinâmico exige o modo Tabela dinâmica ativado.',
    'pt-PT': 'O Gráfico dinâmico requer o Modo dinâmico ativado.',
    'sv-SE': 'Pivottabell kräver att pivotläget är aktiverat.',
    'ta-IN': 'பிவோட் விளக்கப்படத்தில் பிவோட் முறை இயக்கப்பட்டிருக்க வேண்டும்.',
    'te-IN': 'పివోట్ చార్ట్ కోసం పివోట్ మోడ్‌ను తప్పకుండా ప్రారంభించాలి.',
    'th-TH': 'แผนภูมิ Pivot ต้องเปิดใช้งานโหมด Pivot',
    'tr-TR': 'Pivot tablosu için pivot modunun etkinleştirilmesi gerekir.',
    'vi-VN': 'Biểu đồ Pivot yêu cầu bật Chế độ Pivot.',
    'zh-CN': '透视图需要启用透视模式。',
    'zh-TW': '樞紐分析表需要啟用樞紐分析模式。',
  },
  'ag-chartSettingsToolbarTooltip': {
    'en-US': 'Menu',
    'ar-AE': 'القائمة',
    'bn-IN': 'মেনু',
    'de-DE': 'Menü',
    'es-ES': 'Menú',
    'es-MX': 'Menú',
    'gu-IN': 'મેનૂ',
    'hi-IN': 'मेन्यू',
    'ja-JP': 'メニュー',
    'kn-IN': 'ಮೆನು',
    'ko-KR': '메뉴',
    'ml-IN': 'മെനു',
    'mr-IN': 'मेनू',
    'sv-SE': 'Meny',
    'ta-IN': 'மெனு',
    'te-IN': 'మెను',
    'th-TH': 'เมนู',
    'tr-TR': 'Menü',
    'vi-VN': 'Trình đơn',
    'zh-CN': '菜单',
    'zh-TW': '選單',
  },
  'ag-chartLinkToolbarTooltip': {
    'en-US': 'Linked to Grid',
    'ar-AE': 'مرتبط بالشبكة',
    'bn-IN': 'গ্রিডের সাথে লিংক করা রয়েছে',
    'de-DE': 'Mit dem Gitter verknüpft',
    'en-AU': 'Linked to grid',
    'en-GB': 'Linked to grid',
    'en-ZA': 'Linked to grid',
    'es-ES': 'Vinculado a la cuadrícula',
    'es-MX': 'Vinculado a la cuadrícula',
    'fr-BE': 'Associé à la Grille',
    'fr-CA': 'Lié à la grille',
    'fr-FR': 'Associé à la Grille',
    'gu-IN': 'ગ્રીડ સાથે લિંક કરેલ',
    'hi-IN': 'ग्रिड से लिंक किया गया',
    'it-IT': 'Collegato a griglia',
    'ja-JP': 'グリッドにリンク',
    'kn-IN': 'ಗ್ರಿಡ್‌ಗೆ ಲಿಂಕ್ ಮಾಡಲಾಗಿದೆ',
    'ko-KR': '그리드에 연결됨',
    'ml-IN': 'ഗ്രിഡിലേക്ക് ലിങ്ക് ചെയ്‌തു',
    'mr-IN': 'ग्रीडशी लिंक केले',
    'nl-BE': 'Gekoppeld aan raster',
    'nl-NL': 'Gekoppeld aan raster',
    'pl-PL': 'Połączone z siatką',
    'pt-BR': 'Vinculado à grade',
    'pt-PT': 'Associado à grelha',
    'sv-SE': 'Länkad till nätet',
    'ta-IN': 'கிரிட் உடன் இணைக்கப்பட்டது',
    'te-IN': 'గ్రిడ్‌కి లింక్ అయింది',
    'th-TH': 'เชื่อมโยงกับตาราง',
    'tr-TR': 'Izgaraya bağlandı.',
    'vi-VN': 'Đã liên kết đến Lưới',
    'zh-CN': '已链接至网格',
    'zh-TW': '連結至資料格',
  },
  'ag-chartUnlinkToolbarTooltip': {
    'en-US': 'Unlinked from Grid',
    'ar-AE': 'إلغاء الربط بالشبكة',
    'bn-IN': 'গ্রিড থেকে লিংক অপসারণ করা হয়েছে',
    'de-DE': 'Nicht mit dem Gitter verknüpft',
    'en-AU': 'Unlinked from grid',
    'en-GB': 'Unlinked from grid',
    'en-ZA': 'Unlinked from grid',
    'es-ES': 'Desvinculado de la cuadrícula',
    'es-MX': 'Desvinculado de la cuadrícula',
    'fr-BE': 'Dissocié de la grille',
    'fr-CA': 'Non lié à la grille',
    'fr-FR': 'Dissocié de la grille',
    'gu-IN': 'ગ્રીડમાંથી અનલિંક કર્યું',
    'hi-IN': 'ग्रिड से अनलिंक किया गया',
    'it-IT': 'Scollegato dalla griglia',
    'ja-JP': 'グリッドからリンク解除',
    'kn-IN': 'ಗ್ರಿಡ್‌ನಿಂದ ಲಿಂಕ್ ಮಾಡಲಾಗಿಲ್ಲ',
    'ko-KR': '그리드에서 연결 해제됨',
    'ml-IN': 'ഗ്രിഡിൽ നിന്ന് അൺലിങ്ക് ചെയ്‌തു',
    'mr-IN': 'ग्रिडमधून अनलिंक केले',
    'nl-BE': 'Ontkoppeld van raster',
    'nl-NL': 'Ontkoppeld van raster',
    'pl-PL': 'Niepołączone z siatką',
    'pt-BR': 'Desvinculado da grade',
    'pt-PT': 'Desassociado da grelha',
    'sv-SE': 'Olänkad från nät',
    'ta-IN': 'கிரிட்டில் இருந்து இணைப்பு நீக்கப்பட்டது',
    'te-IN': 'గ్రిడ్ నుండి అన్‌లింక్ చేయబడింది',
    'th-TH': 'ยกเลิกการเชื่อมโยงจากตาราง',
    'tr-TR': 'Izgarayla bağlantısı kaldırıldı.',
    'vi-VN': 'Đã bỏ liên kết khỏi lưới',
    'zh-CN': '已与网格取消链接',
    'zh-TW': '取消連結至網格',
  },
  'ag-chartDownloadToolbarTooltip': {
    'en-US': 'Download Chart',
    'ar-AE': 'تنزيل الرسم البياني',
    'bn-IN': 'চার্ট ডাউনলোড করুন',
    'de-DE': 'Tabelle herunterladen',
    'en-AU': 'Download chart',
    'en-GB': 'Download chart',
    'en-ZA': 'Download chart',
    'es-ES': 'Descargar gráfico',
    'es-MX': 'Descargar gráfico',
    'fr-BE': 'Télécharger le graphique',
    'fr-CA': 'Télécharger le graphique',
    'fr-FR': 'Télécharger le graphique',
    'gu-IN': 'ચાર્ટ ડાઉનલોડ કરો',
    'hi-IN': 'चार्ट डाउनलोड करें',
    'it-IT': 'Scarica tabella',
    'ja-JP': 'チャートをダウンロード',
    'kn-IN': 'ಚಾರ್ಟ್ ಡೌನ್‌ಲೊಡ್‌ ಮಾಡಿ',
    'ko-KR': '차트 다운로드',
    'ml-IN': 'ചാർട്ട് ഡൗൺലോഡ് ചെയ്യുക',
    'mr-IN': 'चार्ट डाउनलोड करा',
    'nl-BE': 'Grafiek downloaden',
    'nl-NL': 'Grafiek downloaden',
    'pl-PL': 'Pobierz wykres',
    'pt-BR': 'Fazer download do gráfico',
    'pt-PT': 'Transferir gráfico',
    'sv-SE': 'Ladda ner tabell',
    'ta-IN': 'விளக்கப்படத்தை டவுன்லோடு செய்யவும்',
    'te-IN': 'చార్ట్‌ను డౌన్‌లోడ్ చేయండి',
    'th-TH': 'ดาวน์โหลดแผนภูมิ',
    'tr-TR': 'Tabloyu indir',
    'vi-VN': 'Tải xuống biểu đồ',
    'zh-CN': '下载图表',
    'zh-TW': '下載圖表',
  },
  'ag-seriesChartType': {
    'en-US': 'Series Chart Type',
    'ar-AE': 'نوع الرسم البياني للسلسلة',
    'bn-IN': 'সিরিজ চার্টের ধরন',
    'de-DE': 'Serientabellen-Typ',
    'en-AU': 'Series chart type',
    'en-GB': 'Series chart type',
    'en-ZA': 'Series chart type',
    'es-ES': 'Tipo de gráfico de serie',
    'es-MX': 'Tipo de gráfico de la serie',
    'fr-BE': 'Graphique de type en série',
    'fr-CA': 'Type de diagramme en série',
    'fr-FR': 'Type de graphique en série',
    'gu-IN': 'સિરીઝ ચાર્ટ પ્રકાર',
    'hi-IN': 'सीरीज़ चार्ट टाइप',
    'it-IT': 'Tipo di tabella serie',
    'ja-JP': 'シリーズチャートの種類',
    'kn-IN': 'ಸಿರೀಸ್ ಚಾರ್ಟ್‌ ಟೈಪ್',
    'ko-KR': '시리즈 차트 유형',
    'ml-IN': 'സീരീസ് ചാർട്ട് തരം',
    'mr-IN': 'सिरीज चार्ट प्रकार',
    'nl-BE': 'Type seriekaart',
    'nl-NL': 'Type seriekaart',
    'pl-PL': 'Typ wykresu serii',
    'pt-BR': 'Tipo de gráfico de série',
    'pt-PT': 'Tipo de gráfico de série',
    'sv-SE': 'Typ av serietabell',
    'ta-IN': 'தொடர் விளக்கப்பட வகை',
    'te-IN': 'సిరీస్ చార్ట్ రకం',
    'th-TH': 'ประเภทแผนภูมิชุดข้อมูล',
    'tr-TR': 'Seri tablo türü',
    'vi-VN': 'Loại dãy số biểu thị dưới dạng cột trong biểu đồ',
    'zh-CN': '系列图表类型',
    'zh-TW': '系列圖表類型',
  },
  'ag-seriesType': {
    'en-US': 'Series Type',
    'ar-AE': 'نوع السلسلة',
    'bn-IN': 'সিরিজের ধরন',
    'de-DE': 'Serientyp',
    'en-AU': 'Series type',
    'en-GB': 'Series type',
    'en-ZA': 'Series type',
    'es-ES': 'Tipo de serie',
    'es-MX': 'Tipo de serie',
    'fr-BE': 'Type de série',
    'fr-CA': 'Type de série',
    'fr-FR': 'Type de série',
    'gu-IN': 'સિરીઝનો પ્રકાર',
    'hi-IN': 'सीरीज़ टाइप',
    'it-IT': 'Tipo di serie',
    'ja-JP': 'シリーズタイプ',
    'kn-IN': 'ಸಿರೀಸ್ ಟೈಪ್',
    'ko-KR': '시리즈 유형',
    'ml-IN': 'സീരീസ് തരം',
    'mr-IN': 'सिरीज प्रकार',
    'nl-BE': 'Serietype',
    'nl-NL': 'Serietype',
    'pl-PL': 'Typ serii',
    'pt-BR': 'Tipo de série',
    'pt-PT': 'Tipo de série',
    'sv-SE': 'Serietyp',
    'ta-IN': 'சீரிஸ் வகை',
    'te-IN': 'సిరీస్ రకం',
    'th-TH': 'ประเภทชุดข้อมูล',
    'tr-TR': 'Seri türü',
    'vi-VN': 'Loại dãy số biểu thị dưới dạng cột',
    'zh-CN': '系列类型',
    'zh-TW': '系列類型',
  },
  'ag-secondaryAxis': {
    'en-US': 'Secondary Axis',
    'ar-AE': 'المحور الثانوي',
    'bn-IN': 'সেকেন্ডারি অ্যাক্সিস',
    'de-DE': 'Sekundäre Achse',
    'en-AU': 'Secondary axis',
    'en-GB': 'Secondary axis',
    'en-ZA': 'Secondary axis',
    'es-ES': 'Eje secundario',
    'es-MX': 'Eje secundario',
    'fr-BE': 'Axe secondaire',
    'fr-CA': 'Axe secondaire',
    'fr-FR': 'Axe secondaire',
    'gu-IN': 'ગૌણ એક્સિસ',
    'hi-IN': 'सेकेंडरी Axis',
    'it-IT': 'Asse secondario',
    'ja-JP': '2番目の軸',
    'kn-IN': 'ಸೆಕೆಂಡರಿ ಆಕ್ಸಿಸ್',
    'ko-KR': '2차 축',
    'ml-IN': 'ദ്വിതീയ അക്ഷം',
    'mr-IN': 'सेकंडरी अक्ष',
    'nl-BE': 'Secundaire as',
    'nl-NL': 'Secundaire as',
    'pl-PL': 'Oś pomocnicza',
    'pt-BR': 'Eixo secundário',
    'pt-PT': 'Eixo secundário',
    'sv-SE': 'Sekundär axel',
    'ta-IN': 'செகண்டரி ஆக்சிஸ்',
    'te-IN': 'ద్వితీయ అక్షం',
    'th-TH': 'แกนทุติยภูมิ',
    'tr-TR': 'İkincil eksen',
    'vi-VN': 'Trục phụ',
    'zh-CN': '次轴',
    'zh-TW': '次要軸',
  },
  'ag-ariaChecked': {
    'en-US': 'checked',
    'ar-AE': 'تم التحقق منه',
    'bn-IN': 'চেক করা হয়েছে',
    'de-DE': 'geprüft',
    'en-AU': 'ticked',
    'en-GB': 'ticked',
    'es-ES': 'comprobación completada',
    'es-MX': 'comprobado',
    'fr-BE': 'vérifié',
    'fr-CA': 'coché',
    'fr-FR': 'vérifié',
    'gu-IN': 'ચેક કરેલ',
    'hi-IN': 'चेक किया गया',
    'it-IT': 'verificato',
    'ja-JP': 'チェック済み',
    'kn-IN': 'ಪರಿಶೀಲಿಸಲಾಗಿದೆ',
    'ko-KR': '확인됨',
    'ml-IN': 'പരിശോധിച്ചു',
    'mr-IN': 'चेक केलेले',
    'nl-BE': 'gecontroleerd',
    'nl-NL': 'aangevinkt',
    'pl-PL': 'zaznaczone',
    'pt-BR': 'marcado',
    'pt-PT': 'verificado',
    'sv-SE': 'markerad',
    'ta-IN': 'தேர்வு செய்யப்பட்டது',
    'te-IN': 'ఎంచుకోబడింది',
    'th-TH': 'ตรวจสอบแล้ว',
    'tr-TR': 'kontrol edildi',
    'vi-VN': 'đã kiểm tra',
    'zh-CN': '已选中',
    'zh-TW': '已勾選',
  },
  'ag-ariaColumn': {
    'en-US': 'Column',
    'ar-AE': 'العمود',
    'bn-IN': 'কলাম',
    'de-DE': 'Spalte',
    'es-ES': 'Columna',
    'es-MX': 'Columna',
    'fr-BE': 'Colonne',
    'fr-CA': 'Colonne',
    'fr-FR': 'Colonne',
    'gu-IN': 'કોલમ',
    'hi-IN': 'कॉलम',
    'it-IT': 'Colonna',
    'ja-JP': '項目',
    'kn-IN': 'ಕಾಲಮ್‌',
    'ko-KR': '열',
    'ml-IN': 'കോളം',
    'mr-IN': 'स्‍तंभ',
    'nl-BE': 'Kolom',
    'nl-NL': 'Kolom',
    'pl-PL': 'Kolumnowy',
    'pt-BR': 'Coluna',
    'pt-PT': 'Coluna',
    'sv-SE': 'Kolumn',
    'ta-IN': 'நெடுவரிசை',
    'te-IN': 'కాలమ్',
    'th-TH': 'คอลัมน์',
    'tr-TR': 'Sütun',
    'vi-VN': 'Cột',
    'zh-CN': '列',
    'zh-TW': '資料欄',
  },
  'ag-ariaColumnGroup': {
    'en-US': 'Column Group',
    'ar-AE': 'مجموعة الأعمدة',
    'bn-IN': 'কলাম গ্রুপ',
    'de-DE': 'Spaltengruppe',
    'en-AU': 'Column group',
    'en-GB': 'Column group',
    'en-ZA': 'Column group',
    'es-ES': 'Grupo de columnas',
    'es-MX': 'Grupo de columnas',
    'fr-BE': 'Groupe de colonnes',
    'fr-CA': 'Groupe de colonnes',
    'fr-FR': 'Groupe de colonnes',
    'gu-IN': 'કોલમ ગ્રૂપ',
    'hi-IN': 'कॉलम ग्रुप',
    'it-IT': 'Gruppo di colonne',
    'ja-JP': '列グループ',
    'kn-IN': 'ಕಾಲಮ್ ಗುಂಪು',
    'ko-KR': '열 그룹',
    'ml-IN': 'കോളം ഗ്രൂപ്പ്',
    'mr-IN': 'स्तंभ ग्रुप',
    'nl-BE': 'Kolomgroep',
    'nl-NL': 'Kolommengroep',
    'pl-PL': 'Grupa kolumn',
    'pt-BR': 'Grupo de colunas',
    'pt-PT': 'Grupo de colunas',
    'sv-SE': 'Kolumngrupp',
    'ta-IN': 'நெடுவரிசைக் குழு',
    'te-IN': 'కాలమ్ గ్రూమ్',
    'th-TH': 'กลุ่มคอลัมน์',
    'tr-TR': 'Sütun grubu',
    'vi-VN': 'Nhóm cột',
    'zh-CN': '列组',
    'zh-TW': '資料欄群組',
  },
  'ag-ariaColumnList': {
    'en-US': 'Column List',
    'ar-AE': 'قائمة الأعمدة',
    'bn-IN': 'কলাম তালিকা',
    'de-DE': 'Spaltenliste',
    'en-AU': 'Column list',
    'en-GB': 'Column list',
    'en-ZA': 'Column list',
    'es-ES': 'Lista de columnas',
    'es-MX': 'Lista de columnas',
    'fr-BE': 'Liste des colonnes',
    'fr-CA': 'Liste des colonnes',
    'fr-FR': 'Liste des colonnes',
    'gu-IN': 'કોલમ લિસ્ટ',
    'hi-IN': 'कॉलम लिस्ट',
    'it-IT': 'Elenco colonne',
    'ja-JP': '列リスト',
    'kn-IN': 'ಕಾಲಮ್ ಪಟ್ಟಿ',
    'ko-KR': '열 목록',
    'ml-IN': 'കോളം ലിസ്റ്റ്',
    'mr-IN': 'स्तंभ लिस्ट',
    'nl-BE': 'Kolomlijst',
    'nl-NL': 'Kolommenlijst',
    'pl-PL': 'Lista kolumn',
    'pt-BR': 'Lista de colunas',
    'pt-PT': 'Lista de colunas',
    'sv-SE': 'Kolumnlista',
    'ta-IN': 'நெடுவரிசை லிஸ்ட்',
    'te-IN': 'కాలమ్ జాబితా',
    'th-TH': 'รายการคอลัมน์',
    'tr-TR': 'Sütun listesi',
    'vi-VN': 'Danh sách cột',
    'zh-CN': '列列表',
    'zh-TW': '資料欄清單',
  },
  'ag-ariaColumnSelectAll': {
    'en-US': 'Toggle Select All Columns',
    'ar-AE': 'تبديل تحديد كافة الأعمدة',
    'bn-IN': 'সব কলাম নির্বাচনের জন্য টগল করুন',
    'de-DE': '"Alle Spalten auswählen" umschalten',
    'en-AU': 'Toggle Select all columns',
    'en-GB': 'Toggle select all columns',
    'en-ZA': 'Toggle Select all columns',
    'es-ES': 'Botón Seleccionar todas las columnas',
    'es-MX': 'Activar la selección de todas las columnas',
    'fr-BE': 'Activer Sélectionner toutes les colonnes',
    'fr-CA': 'Basculer la sélection de toutes les colonnes',
    'fr-FR': 'Activer Sélectionner toutes les colonnes',
    'gu-IN': 'ટોગલ બધી કોલમ પસંદ કરો',
    'hi-IN': "'सभी कॉलम चुनें' टॉगल करें",
    'it-IT': 'Attiva/disattiva Seleziona tutte le colonne',
    'ja-JP': 'すべての列を選択を切り替える',
    'kn-IN': 'ಎಲ್ಲ ಕಾಲಮ್‌ಗಳನ್ನು ಟಾಗಲ್ ಸೆಲೆಕ್ಟ್ ಮಾಡಿ',
    'ko-KR': '모든 열 선택 전환',
    'ml-IN': 'എല്ലാ കോളങ്ങളും തിരഞ്ഞെടുക്കുക ടോഗിൾ ചെയ്യുക',
    'mr-IN': 'सर्व स्तंभ निवडा टॉगल करा',
    'nl-BE': 'Alle kolommen selecteren aanpassen',
    'nl-NL': 'Alle kolommen selecteren/deselecteren',
    'pl-PL': 'Przełącz wybór wszystkich kolumn',
    'pt-BR': 'Alternar para selecionar todas as colunas',
    'pt-PT': 'Alternar Selecionar todas as colunas',
    'sv-SE': 'Växla mellan markera alla kolumner',
    'ta-IN': 'அனைத்து நெடுவரிசைகளையும் தேர்ந்தெடுப்பதை மாற்றவும்',
    'te-IN': 'అన్ని కాలమ్‌లను ఎంపిక చేయి ఎంచుకోండి',
    'th-TH': 'สลับเพื่อเลือกคอลัมน์ทั้งหมด',
    'tr-TR': 'Tüm sütunları seçmeyi aç/kapat',
    'vi-VN': 'Chuyển đổi Chọn tất cả các cột',
    'zh-CN': '切换“选择所有列”',
    'zh-TW': '切換選取所有資料欄',
  },
  'ag-ariaDateFilterInput': {
    'en-US': 'Date Filter Input',
    'ar-AE': 'إدخال عامل تصفية التاريخ',
    'bn-IN': 'তারিখ ফিল্টারের ইনপুট',
    'de-DE': 'Datumsfilter-Eingabe',
    'en-AU': 'Date filter input',
    'en-GB': 'Date filter input',
    'en-ZA': 'Date filter input',
    'es-ES': 'Filtrar por fecha',
    'es-MX': 'Entrada de filtro de fecha',
    'fr-BE': 'Saisissez le filtre par date',
    'fr-CA': 'Entrée du filtre de date',
    'fr-FR': 'Saisir le filtre de date',
    'gu-IN': 'તારીખ ફિલ્ટર ઇનપુટ',
    'hi-IN': 'तारीख फ़िल्टर इनपुट',
    'it-IT': 'Inserimento del filtro data',
    'ja-JP': '日付フィルターの入力',
    'kn-IN': 'ದಿನಾಂಕ ಫಿಲ್ಟರ್ ಇನ್‌ಪುಟ್',
    'ko-KR': '날짜 필터 입력값',
    'ml-IN': 'തീയതി ഫിൽട്ടർ ഇൻപുട്ട്',
    'mr-IN': 'तारीख फिल्टर इनपुट',
    'nl-BE': 'Invoer op datum filteren',
    'nl-NL': 'Datumfilterinvoer',
    'pl-PL': 'Dane filtra daty',
    'pt-BR': 'Entrada do filtro de data',
    'pt-PT': 'Entrada de filtro de data',
    'sv-SE': 'Inmatning av datumfilter',
    'ta-IN': 'தேதி வடிகட்டி இன்புட்',
    'te-IN': 'తేదీ ఫిల్టర్ ఇన్‌పుట్',
    'th-TH': 'อินพุตตัวกรองวันที่',
    'tr-TR': 'Tarih filtresi girişi',
    'vi-VN': 'Lọc ngày dữ lliệu đầu vào',
    'zh-CN': '日期筛选条件输入',
    'zh-TW': '日期篩選條件輸入',
  },
  'ag-ariaDefaultListName': {
    'en-US': 'List',
    'ar-AE': 'قائمة',
    'bn-IN': 'তালিকা',
    'de-DE': 'Anbieten',
    'es-ES': 'Publicar',
    'es-MX': 'Lista',
    'fr-BE': 'Liste',
    'fr-CA': 'Liste',
    'fr-FR': 'Liste',
    'gu-IN': 'લિસ્ટ',
    'hi-IN': 'लिस्ट',
    'it-IT': 'Lista',
    'ja-JP': 'リスト',
    'kn-IN': 'ಪಟ್ಟಿ',
    'ko-KR': '목록',
    'ml-IN': 'ലിസ്‌റ്റ്',
    'mr-IN': 'लिस्ट',
    'nl-BE': 'Lijst',
    'nl-NL': 'Lijst',
    'pl-PL': 'Lista',
    'pt-BR': 'Lista',
    'pt-PT': 'Lista',
    'sv-SE': 'Lista',
    'ta-IN': 'லிஸ்ட்',
    'te-IN': 'జాబితా',
    'th-TH': 'รายการ',
    'tr-TR': 'Liste',
    'vi-VN': 'Danh sách',
    'zh-CN': '列表',
    'zh-TW': '清單',
  },
  'ag-ariaFilterColumnsInput': {
    'en-US': 'Filter Columns Input',
    'ar-AE': 'تصفية إدخال الأعمدة',
    'bn-IN': 'ফিল্টার কলামের ইনপুট',
    'de-DE': 'Spalteneingabe filtern',
    'en-AU': 'Filter columns input',
    'en-GB': 'Filter columns input',
    'en-ZA': 'Filter columns input',
    'es-ES': 'Filtrar columnas',
    'es-MX': 'Filtrar entradas de columnas',
    'fr-BE': 'Filtrer les colonnes par entrée',
    'fr-CA': 'Filtrer les entrées des colonnes',
    'fr-FR': 'Filtrer les colonnes en entrée',
    'gu-IN': 'ફિલ્ટર ઇનપુટ કોલમ',
    'hi-IN': 'फ़िल्टर कॉलम इनपुट',
    'it-IT': 'Filtra colonne input',
    'ja-JP': 'フィルター列の入力',
    'kn-IN': 'ಕಾಲಮ್‌ಗಳ ಇನ್ಪುಟ್ ಫಿಲ್ಟರ್ ಮಾಡಿ',
    'ko-KR': '열 필터 입력값',
    'ml-IN': 'കോളങ്ങളിലെ ഇൻപുട്ട് ഫിൽട്ടർ ചെയ്യുക',
    'mr-IN': 'स्तंभ इनपूट फिल्टर करा',
    'nl-BE': 'Kolominvoer filteren',
    'nl-NL': 'Kolominvoer filteren',
    'pl-PL': 'Dane filtra kolumn',
    'pt-BR': 'Filtrar entrada de colunas',
    'pt-PT': 'Filtrar entrada de colunas',
    'sv-SE': 'Filtrera kolumninmatning',
    'ta-IN': 'வடிகட்டி நெடுவரிசைகள் இன்புட்',
    'te-IN': 'కాలమ్‌ల ఇన్‌పుట్‌ను ఫిల్టర్ చేయండి',
    'th-TH': 'กรองอินพุตคอลัมน์',
    'tr-TR': 'Sütun girişlerini filtrele',
    'vi-VN': 'Lọc cột dữ liệu đầu vào',
    'zh-CN': '筛选列输入',
    'zh-TW': '篩選資料欄輸入',
  },
  'ag-ariaFilterFromValue': {
    'en-US': 'Filter from value',
    'ar-AE': 'التصفية من القيمة',
    'bn-IN': 'মান থেকে ফিল্টার করুন',
    'de-DE': 'Ab Wert filtern',
    'es-ES': 'Filtrar valor',
    'es-MX': 'Filtrar por valor',
    'fr-BE': 'Filtrer à partir d’une valeur',
    'fr-CA': 'Filtrer à partir de la valeur',
    'fr-FR': 'Filtrer à partir d’une valeur',
    'gu-IN': 'મૂલ્યમાંથી ફિલ્ટર કરો',
    'hi-IN': 'फ़िल्टर करने के लिए शुरुआती वैल्यू',
    'it-IT': 'Filtra valore in base',
    'ja-JP': '値から絞り込む',
    'kn-IN': 'ಮೌಲ್ಯದಿಂದ ಫಿಲ್ಟರ್ ಮಾಡಿ',
    'ko-KR': '값 기준 필터링',
    'ml-IN': 'മൂല്യത്തിൽ നിന്ന് ഫിൽട്ടർ ചെയ്യുക',
    'mr-IN': 'व्हॅल्यूमधून फिल्टर करा',
    'nl-BE': 'Filteren van waarde',
    'nl-NL': 'Filteren op basis van waarde',
    'pl-PL': 'Wartość „filtruj od”',
    'pt-BR': 'Filtrar do valor',
    'pt-PT': 'Filtrar a partir do valor',
    'sv-SE': 'Filtrera från värde',
    'ta-IN': 'வேல்யூக்களில் இருந்து வடிகட்டு',
    'te-IN': 'విలువ నుండి ఫిల్టర్ చేయండి',
    'th-TH': 'กรองจากค่า',
    'tr-TR': 'Başlangıç değerini filtrele',
    'vi-VN': 'Lọc từ giá trị',
    'zh-CN': '筛选“从”值',
    'zh-TW': '從值篩選',
  },
  'ag-ariaFilterInput': {
    'en-US': 'Filter Input',
    'ar-AE': 'عامل تصفية الإدخال',
    'bn-IN': 'ফিল্টার ইনপুট',
    'de-DE': 'Filtereingabe',
    'en-AU': 'Filter input',
    'en-GB': 'Filter input',
    'en-ZA': 'Filter input',
    'es-ES': 'Filtrar entrada',
    'es-MX': 'Filtrar entrada',
    'fr-BE': 'Filtrer par entrée',
    'fr-CA': 'Entrée du filtre',
    'fr-FR': 'Filtrer la saisie',
    'gu-IN': 'ફિલ્ટર ઇનપુટ',
    'hi-IN': 'फ़िल्टर इनपुट',
    'it-IT': 'Filtra input',
    'ja-JP': '入力を絞り込む',
    'kn-IN': 'ಇನ್ಪುಟ್ ಫಿಲ್ಟರ್ ಮಾಡಿ',
    'ko-KR': '필터 입력값',
    'ml-IN': 'ഇൻപുട്ട് ഫിൽട്ടർ ചെയ്യുക',
    'mr-IN': 'फिल्टर इनपुट',
    'nl-BE': 'Invoer filteren',
    'nl-NL': 'Invoer filteren',
    'pl-PL': 'Dane filtra',
    'pt-BR': 'Filtrar entrada',
    'pt-PT': 'Filtrar entrada',
    'sv-SE': 'Filtrera indata',
    'ta-IN': 'வடிகட்டி இன்புட்',
    'te-IN': 'ఇన్‌పుట్‌ను ఫిల్టర్ చేయండి',
    'th-TH': 'อินพุตตัวกรอง',
    'tr-TR': 'Girişi filtrele',
    'vi-VN': 'Lọc dữ lliệu đầu vào',
    'zh-CN': '筛选条件输入',
    'zh-TW': '篩選條件輸入',
  },
  'ag-ariaFilterList': {
    'en-US': 'Filter List',
    'ar-AE': 'تصفية القائمة',
    'bn-IN': 'ফিল্টারের তালিকা',
    'de-DE': 'Liste filtern',
    'en-AU': 'Filter list',
    'en-GB': 'Filter list',
    'en-ZA': 'Filter list',
    'es-ES': 'Filtrar lista',
    'es-MX': 'Lista de filtros',
    'fr-BE': 'Filtrer la liste',
    'fr-CA': 'Liste des filtres',
    'fr-FR': 'Filtrer la liste',
    'gu-IN': 'ફિલ્ટર લિસ્ટ',
    'hi-IN': 'फ़िल्टर लिस्ट',
    'it-IT': 'Filtra elenco',
    'ja-JP': '絞り込みリスト',
    'kn-IN': 'ಫಿಲ್ಟರ್ ಪಟ್ಟಿ',
    'ko-KR': '필터 목록',
    'ml-IN': 'ഫിൽട്ടർ ലിസ്റ്റ്',
    'mr-IN': 'फिल्टर लिस्ट',
    'nl-BE': 'Filterlijst',
    'nl-NL': 'Filterlijst',
    'pl-PL': 'Lista filtrów',
    'pt-BR': 'Filtrar lista',
    'pt-PT': 'Filtrar lista',
    'sv-SE': 'Filtrera lista',
    'ta-IN': 'ஃபில்ட்டர் லிஸ்ட்',
    'te-IN': 'లిస్ట్‌ను ఫిల్టర్ చేయండి',
    'th-TH': 'รายการตัวกรอง',
    'tr-TR': 'Listeyi filtrele',
    'vi-VN': 'Danh sách lọc',
    'zh-CN': '筛选列表',
    'zh-TW': '篩選條件清單',
  },
  'ag-ariaFilterToValue': {
    'en-US': 'Filter to value',
    'ar-AE': 'تصفية للقيمة',
    'bn-IN': 'মানগুলিতে প্রযোজ্য ফিল্টার',
    'de-DE': 'Bis Wert filtern',
    'es-ES': 'Filtrar por valor',
    'es-MX': 'Filtrar por valor',
    'fr-BE': 'Filtrer sur la valeur',
    'fr-CA': 'Filtrer à la valeur',
    'fr-FR': 'Filtrer jusqu’à une valeur',
    'gu-IN': 'મૂલ્ય માટે ફિલ્ટર કરો',
    'hi-IN': 'फ़िल्टर करने के लिए आखिरी वैल्यू',
    'it-IT': 'Filtra per valore',
    'ja-JP': '値を絞り込む',
    'kn-IN': 'ಮೌಲ್ಯಕ್ಕೆ ಫಿಲ್ಟರ್ ಮಾಡಿ',
    'ko-KR': '값으로 필터링',
    'ml-IN': 'മൂല്യത്തിലേക്ക് ഫിൽട്ടർ ചെയ്യുക',
    'mr-IN': 'व्हॅल्यूमध्ये फिल्टर करा',
    'nl-BE': 'Filteren naar waarde',
    'nl-NL': 'Filteren naar waarde',
    'pl-PL': 'Wartość „filtruj do”',
    'pt-BR': 'Filtrar para valor',
    'pt-PT': 'Filtrar por valor',
    'sv-SE': 'Filtrera till värde',
    'ta-IN': 'வேல்யூவிற்கு ஃபில்ட்டர் செய்',
    'te-IN': 'విలువకు ఫిల్టర్ చేయండి',
    'th-TH': 'กรองเป็นค่า',
    'tr-TR': 'Bitiş değerini filtrele',
    'vi-VN': 'Lọc theo giá trị',
    'zh-CN': '筛选“至”值',
    'zh-TW': '篩選至值',
  },
  'ag-ariaFilterValue': {
    'en-US': 'Filter Value',
    'ar-AE': 'تصفية القيمة',
    'bn-IN': 'মান ফিল্টার করুন',
    'de-DE': 'Filterwert',
    'en-AU': 'Filter value',
    'en-GB': 'Filter value',
    'en-ZA': 'Filter value',
    'es-ES': 'Valor del filtro',
    'es-MX': 'Valor del filtro',
    'fr-BE': 'Filtrer par valeur',
    'fr-CA': 'Valeur du filtre',
    'fr-FR': 'Filtrer la valeur',
    'gu-IN': 'ફિલ્ટર મૂલ્ય',
    'hi-IN': 'फ़िल्टर वैल्यू',
    'it-IT': 'Valore filtro',
    'ja-JP': 'フィルターの値',
    'kn-IN': 'ಫಿಲ್ಟರ್ ಮೌಲ್ಯ',
    'ko-KR': '필터 값',
    'ml-IN': 'മൂല്യം ഫിൽട്ടർ ചെയ്യുക',
    'mr-IN': 'व्हॅल्यू फिल्ट करा',
    'nl-BE': 'Waarde filteren',
    'nl-NL': 'Waarde filteren',
    'pl-PL': 'Wartość filtra',
    'pt-BR': 'Valor do filtro',
    'pt-PT': 'Valor do filtro',
    'sv-SE': 'Filtrera värde',
    'ta-IN': 'ஃபில்ட்டர் வேல்யூ',
    'te-IN': 'విలువను ఫిల్టర్ చేయండి',
    'th-TH': 'กรองค่า',
    'tr-TR': 'Değeri filtrele',
    'vi-VN': 'Giá trị lọc',
    'zh-CN': '筛选值',
    'zh-TW': '篩選值',
  },
  'ag-ariaFilteringOperator': {
    'en-US': 'Filtering Operator',
    'ar-AE': 'عامل التصفية',
    'bn-IN': 'ফিল্টারিং অপারেটর',
    'de-DE': 'Filter-Operator',
    'en-AU': 'Filtering operator',
    'en-GB': 'Filtering operator',
    'en-ZA': 'Filtering operator',
    'es-ES': 'Operador de filtrado',
    'es-MX': 'Operador de filtro',
    'fr-BE': 'Opérateur de filtrage',
    'fr-CA': 'Opérateur de filtrage',
    'fr-FR': 'Opérateur de filtrage',
    'gu-IN': 'ફિલ્ટરિંગ ઓપરેટર',
    'hi-IN': 'ऑपरेटर फ़िल्टर किया जा रहा है',
    'it-IT': 'Operatore filtri',
    'kn-IN': 'ಫಿಲ್ಟರಿಂಗ್ ಆಪರೇಟರ್',
    'ko-KR': '운영자 필터링',
    'ml-IN': 'ഫിൽട്ടറിംഗ് ഓപ്പറേറ്റർ',
    'mr-IN': 'ऑपरेटर फिल्टर करणे',
    'nl-BE': 'Operator filteren',
    'nl-NL': 'Filteroperator',
    'pl-PL': 'Operator filtrowania',
    'pt-BR': 'Operador de filtragem',
    'pt-PT': 'Operador de filtragem',
    'sv-SE': 'Filtreringsfunktion',
    'ta-IN': 'வடிகட்டுதல் ஆபரேட்டர்',
    'te-IN': 'ఫిల్టర్ చేసే ఆపరేటర్',
    'th-TH': 'ตัวดำเนินการกรอง',
    'tr-TR': 'Filtreleme operatörü',
    'vi-VN': 'Toán tử lọc',
    'zh-CN': '筛选运算符',
    'zh-TW': '篩選運算子',
  },
  'ag-ariaHidden': {
    'en-US': 'hidden',
    'ar-AE': 'مخفي',
    'bn-IN': 'লুকানো',
    'de-DE': 'ausgeblendet',
    'es-ES': 'oculto',
    'es-MX': 'oculto',
    'fr-BE': 'masqué',
    'fr-CA': 'caché',
    'fr-FR': 'masqué',
    'gu-IN': 'છુપાવેલ',
    'hi-IN': 'छिपा हुआ',
    'it-IT': 'nascosto',
    'ja-JP': '非表示',
    'kn-IN': 'ಮರೆಮಾಡಲಾಗಿದೆ',
    'ko-KR': '숨겨짐',
    'ml-IN': 'മറച്ചിരിക്കുന്നു',
    'mr-IN': 'लपवलेले',
    'nl-BE': 'verborgen',
    'nl-NL': 'verborgen',
    'pl-PL': 'ukryte',
    'pt-BR': 'oculto',
    'pt-PT': 'oculto',
    'sv-SE': 'dold',
    'ta-IN': 'மறைக்கப்பட்டது',
    'te-IN': 'దాచివని',
    'th-TH': 'ซ่อนอยู่',
    'tr-TR': 'gizli',
    'vi-VN': 'bị ẩn',
    'zh-CN': '已隐藏',
    'zh-TW': '隱藏',
  },
  'ag-ariaIndeterminate': {
    'en-US': 'indeterminate',
    'ar-AE': 'غير محدد',
    'bn-IN': 'অনির্ণীত',
    'de-DE': 'unbestimmt',
    'es-ES': 'indeterminado',
    'es-MX': 'indeterminado',
    'fr-BE': 'non déterminé',
    'fr-CA': 'indéterminé',
    'fr-FR': 'indéterminé',
    'gu-IN': 'અનિશ્ચિત',
    'hi-IN': 'तय नहीं किया गया',
    'it-IT': 'indeterminato',
    'ja-JP': '不確定',
    'kn-IN': 'ಅನಿರ್ದಿಷ್ಟ',
    'ko-KR': '불확정',
    'ml-IN': 'അനിശ്ചിതത്വം',
    'mr-IN': 'इनडिटर्मिनेट',
    'nl-BE': 'onbepaald',
    'nl-NL': 'onbepaald',
    'pl-PL': 'nieokreślone',
    'pt-BR': 'indeterminado',
    'pt-PT': 'indeterminado',
    'sv-SE': 'obestämd',
    'ta-IN': 'உறுதி அற்றது',
    'te-IN': 'అనిర్దిష్టం',
    'th-TH': 'ไม่กำหนด',
    'tr-TR': 'belirsiz',
    'vi-VN': 'không xác định',
    'zh-CN': '不确定',
    'zh-TW': '未定',
  },
  'ag-ariaInputEditor': {
    'en-US': 'Input Editor',
    'ar-AE': 'محرر الإدخال',
    'bn-IN': 'ইনপুট এডিটর',
    'de-DE': 'Eingabe-Editor',
    'en-AU': 'Input editor',
    'en-GB': 'Input editor',
    'en-ZA': 'Input editor',
    'es-ES': 'Editor de entrada',
    'es-MX': 'Editor de entrada',
    'fr-BE': 'Éditeur d’entrée',
    'fr-CA': 'Éditeur d’entrée',
    'fr-FR': 'Éditeur d’entrée',
    'gu-IN': 'ઇનપુટ એડિટર',
    'hi-IN': 'इनपुट एडिटर',
    'it-IT': 'Editor di input',
    'ja-JP': '入力エディター',
    'kn-IN': 'ಇನ್ಪುಟ್ ಎಡಿಟರ್',
    'ko-KR': '입력값 편집기',
    'ml-IN': 'ഇൻപുട്ട് എഡിറ്റർ',
    'mr-IN': 'इनपुट एडिटर',
    'nl-BE': 'Invoereditor',
    'nl-NL': 'Invoereditor',
    'pl-PL': 'Edytor danych',
    'pt-BR': 'Editor de entrada',
    'pt-PT': 'Editor de entrada',
    'sv-SE': 'Inmatningsredigerare',
    'ta-IN': 'இன்புட் எடிட்டர்',
    'te-IN': 'ఇన్‌పుట్ ఎడిటర్',
    'th-TH': 'ตัวแก้ไขอินพุต',
    'tr-TR': 'Giriş düzenleyici',
    'vi-VN': 'Trình chỉnh sửa nguồn dữ liệu đầu vào',
    'zh-CN': '输入编辑器',
    'zh-TW': '輸入編輯器',
  },
  'ag-ariaMenuColumn': {
    'en-US': 'Press CTRL ENTER to open column menu.',
    'ar-AE': 'اضغط على CTRL ENTER لفتح قائمة العمود.',
    'bn-IN': 'কলাম মেনু খুলতে CTRL ENTER টিপুন।',
    'de-DE': 'Öffnen Sie das Spaltenmenü mit STRG+ENTER.',
    'es-ES': 'Pulsa CTRL INTRO para abrir el menú de columnas.',
    'es-MX': 'Pulsa CTRL + INTRO para abrir el menú de columnas.',
    'fr-BE':
      'Appuyez sur la touche CTRL ENTRÉE pour ouvrir le menu des colonnes.',
    'fr-CA':
      'Appuyez sur la touche CTRL ENTRÉE pour ouvrir le menu de la colonne.',
    'fr-FR':
      'Appuyez sur les touches CTRL ENTRÉE pour ouvrir le menu des colonnes.',
    'gu-IN': 'કોલમ મેનૂ ખોલવા માટે CTRL એન્ટર દબાવો.',
    'hi-IN': 'कॉलम मेन्यू खोलने के लिए CTRL ENTER दबाएं.',
    'it-IT': 'Premi CTRL INVIO per aprire il menu a colonna.',
    'ja-JP': 'CTRL ENTERキーを押して列メニューを開く',
    'kn-IN': 'ಕಾಲಮ್ ಮೆನು ತೆರೆಯಲು CTRL ENTER ಒತ್ತಿರಿ.',
    'ko-KR': '열 메뉴를 열려면 CTRL ENTER를 누르십시오.',
    'ml-IN': 'കോളം മെനു തുറക്കാൻ CTRL ENTER അമർത്തുക.',
    'mr-IN': 'स्तंत्र मेनू उघडण्यासाठी CTRL एंटर प्रेस करा.',
    'nl-BE': 'Druk op CTRL ENTER om het kolommenu te openen.',
    'nl-NL': 'Druk op CTRL ENTER om het kolommenu te openen.',
    'pl-PL': 'Naciśnij CTRL ENTER, aby otworzyć menu kolumny.',
    'pt-BR': 'Pressione CTRL ENTER para abrir o menu da coluna.',
    'pt-PT': 'Prima CTRL + ENTER para abrir o menu da coluna.',
    'sv-SE': 'Tryck på CTRL ENTER för att öppna kolumnmenyn.',
    'ta-IN': 'நெடுவரிசை மெனுவைத் திறக்க CTRL ENTER ஐ அழுத்தவும்.',
    'te-IN': 'కాలమ్ మెనుని తెరవడానికి CTRL ENTER నొక్కండి.',
    'th-TH': 'กด CTRL ENTER เพื่อเปิดเมนูคอลัมน์',
    'tr-TR': 'Sütun menüsünü açmak için Ctrl Enter tuşlarına basın.',
    'vi-VN': 'Nhấn phím CTRL ENTER để mở trình đơn cột.',
    'zh-CN': '按 CTRL ENTER 打开列菜单。',
    'zh-TW': '按下 CTRL ENTER 鍵以開啟資料欄選單。',
  },
  'ag-ariaRowDeselect': {
    'en-US': 'Press SPACE to deselect this row',
    'ar-AE': 'اضغط على SPACE لإلغاء تحديد هذا الصف',
    'bn-IN': 'নির্বাচন থেকে এই সারিটি বাদ দিতে SPACE টিপুন',
    'de-DE': 'Wählen Sie diese Zeile über die LEERTASTE ab',
    'es-ES': 'Pulsa ESPACIO para anular la selección de esta fila',
    'es-MX': 'Pulsa ESPACIO para anular la selección de esta fila',
    'fr-BE': 'Appuyez sur ESPACE pour désélectionner cette ligne',
    'fr-CA': 'Appuyez sur ESPACE pour désélectionner cette ligne',
    'fr-FR': 'Appuyez sur ESPACE pour désélectionner cette ligne',
    'gu-IN': 'આ પંક્તિને નાપસંદ કરવા માટે સ્પેસ દબાવો',
    'hi-IN': 'इस पंक्ति का सेलेक्शन रिमूव करने के लिए स्पेस दबाएं',
    'it-IT': 'Premi SPAZIO per deselezionare questa riga',
    'ja-JP': 'SPACEキーを押してこの行の選択を解除する',
    'kn-IN': 'ಈ ಸಾಲಿನ ಆಯ್ಕೆ ರದ್ದುಗೊಳಿಸಲು SPACE ಒತ್ತಿರಿ',
    'ko-KR': '이 행을 선택 취소하려면 SPACE를 누르십시오.',
    'ml-IN': 'ഈ റോ തിരഞ്ഞെടുത്തത് മാറ്റാൻ SPACE അമർത്തുക',
    'mr-IN': 'ही ओळ डीसिलेक्ट करण्यासाठी स्पेस प्रेस करा',
    'nl-BE': 'Druk op SPATIE om deze rij te deselecteren',
    'nl-NL': 'Druk op SPATIE om deze rij te deselecteren',
    'pl-PL': 'Naciśnij SPACJĘ, aby anulować wybór tego wiersza',
    'pt-BR': 'Pressione ESPAÇO para desmarcar esta linha',
    'pt-PT': 'Prima ESPAÇO para cancelar a seleção desta linha',
    'sv-SE': 'Tryck på SPACE för att avmarkera den här raden',
    'ta-IN': 'இந்த வரிசையைத் தேர்வுநீக்க SPACE ஐ அழுத்தவும்',
    'te-IN': 'ఈ అడ్డు వరుస ఎంపికను తీసివేయడానికి SPACE కీని నొక్కండి',
    'th-TH': 'กด SPACE เพื่อยกเลิกการเลือกแถวนี้',
    'tr-TR': 'Bu satırın seçimini kaldırmak için boşluk tuşuna basın',
    'vi-VN': 'Nhấn DẤU CÁCH để bỏ chọn hàng này',
    'zh-CN': '按空格键取消选择此行',
    'zh-TW': '按下空白鍵以取消選取此列',
  },
  'ag-ariaRowSelectAll': {
    'en-US': 'Press Space to toggle all rows selection',
    'ar-AE': 'اضغط على مسافة لتبديل كل اختيار الصفوف',
    'bn-IN': 'সব সারি নির্বাচনের বিকল্প টগল করতে Space টিপুন',
    'de-DE': 'Schalten Sie mit der Leertaste die Auswahl aller Zeilen um',
    'en-IN': 'Press SPACE to toggle all rows selection',
    'es-ES': 'Pulsa Espacio para cambiar la selección de todas las filas',
    'es-MX': 'Pulsa Espacio para cambiar la selección de todas las filas',
    'fr-BE':
      'Appuyez sur Espace pour activer la sélection de toutes les lignes',
    'fr-CA':
      'Appuyez sur Espace pour activer la sélection de toutes les lignes',
    'fr-FR':
      'Appuyez sur Espace pour basculer sur la sélection de toutes les lignes',
    'gu-IN': 'બધી પંક્તિઓની પસંદગીને ટોગલ કરવા માટે સ્પેસ પર દબાવો',
    'hi-IN': 'पंक्तियों के सभी सेलेक्शन को टॉगल करने के लिए स्पेस दबाएं',
    'it-IT':
      'Premi lo spazio per attivare/disattivare la selezione di tutte le righe',
    'ja-JP': 'スペースキーを押して行の選択をすべて切り替える',
    'kn-IN': 'ಎಲ್ಲಾ ಸಾಲುಗಳ ಆಯ್ಕೆಯನ್ನು ಟಾಗಲ್ ಮಾಡಲು ಸ್ಪೇಸ್ ಒತ್ತಿರಿ',
    'ko-KR': '모든 행 선택을 전환하려면 Space를 누르십시오.',
    'ml-IN': 'എല്ലാ റോകളുടെയും തിരഞ്ഞെടുപ്പ് ടോഗിൾ ചെയ്യാൻ Space അമർത്തുക',
    'mr-IN': 'सर्व स्तंभांच्या निवडीत टॉगल करण्यासाठी स्पेस प्रेस करा',
    'nl-BE': 'Druk op spatie om alle rijen te selecteren',
    'nl-NL': 'Druk op Spatie om alle rijen te selecteren of te deselecteren',
    'pl-PL': 'Naciśnij spację, aby przełączyć wybór wszystkich wierszy',
    'pt-BR': 'Pressione Espaço para alternar a seleção de todas as linhas',
    'pt-PT': 'Prima Espaço para alternar a seleção de todas as linhas',
    'sv-SE': 'Tryck på mellanslag för att växla mellan alla rader',
    'ta-IN': 'அனைத்து வரிசைகள் தேர்வையும் மாற்ற Space ஐ அழுத்தவும்',
    'te-IN': 'అన్ని అడ్డు వరుసల ఎంపికను టోగుల్ చేయడానికి Space కీ నొక్కండి',
    'th-TH': 'กด Space เพื่อสลับการเลือกแถวทั้งหมด',
    'tr-TR': 'Tüm satır seçimini değiştirmek için boşluk tuşuna basın',
    'vi-VN': 'Nhấn Dấu cách để chuyển đổi tất cả các lựa chọn hàng',
    'zh-CN': '按空格键切换全部所选行',
    'zh-TW': '按下空白鍵以切換所有列選擇',
  },
  'ag-ariaRowToggleSelection': {
    'en-US': 'Press Space to toggle row selection',
    'ar-AE': 'اضغط على مفتاح المسافة لتبديل تحديد الصف',
    'bn-IN': 'সারি নির্বাচনের বিকল্প টগল করতে Space টিপুন',
    'de-DE': 'Schalten Sie mit der Leertaste die Zeilenauswahl um',
    'en-IN': 'Press SPACE to toggle row selection',
    'es-ES': 'Pulsa Espacio para cambiar la selección de filas',
    'es-MX': 'Pulsa Espacio para cambiar la selección de filas',
    'fr-BE': 'Appuyez sur Espace pour activer la sélection des lignes',
    'fr-CA': 'Appuyez sur Espace pour basculer la sélection de ligne',
    'fr-FR': 'Appuyez sur Espace pour basculer sur la sélection de ligne',
    'gu-IN': 'પંક્તિ પસંદગી ટોગલ કરવા માટે સ્પેસ દબાવો',
    'hi-IN': 'पंक्ति का सेलेक्शन टॉगल करने के लिए स्पेस दबाएं',
    'it-IT': 'Premi lo spazio per attivare/disattivare la selezione della riga',
    'ja-JP': 'スペースキーを押して行の選択を切り替える',
    'kn-IN': 'ಸಾಲು ಆಯ್ಕೆಯನ್ನು ಟಾಗಲ್ ಮಾಡಲು ಸ್ಪೇಸ್ ಒತ್ತಿರಿ',
    'ko-KR': '행 선택을 전환하려면 Space를 누르십시오.',
    'ml-IN': 'റോ തിരഞ്ഞെടുപ്പ് ടോഗിൾ ചെയ്യാൻ Space അമർത്തുക',
    'mr-IN': 'ओळीच्या निवडीत टॉगल करण्यासाठी स्पेस प्रेस करा',
    'nl-BE': 'Druk op spatie om rij te selecteren',
    'nl-NL': 'Druk op spatie om de rij te selecteren/deselecteren',
    'pl-PL': 'Naciśnij spację, aby przełączyć wybór wiersza',
    'pt-BR': 'Pressione Espaço para alternar a seleção de linhas',
    'pt-PT': 'Prima Espaço para alternar a seleção da linha',
    'sv-SE': 'Tryck på mellanslag för att växla mellan rader',
    'ta-IN': 'வரிசைகள் தேர்வையும் மாற்ற Space ஐ அழுத்தவும்',
    'te-IN': 'అడ్డు వరుస ఎంపికను టోగుల్ చేయడానికి స్పేస్ నొక్కండి',
    'th-TH': 'กด Space เพื่อสลับการเลือกแถว',
    'tr-TR': 'Satır seçimini değiştirmek için boşluk tuşuna basın',
    'vi-VN': 'Nhấn dấu cách để chuyển đổi lựa chọn hàng',
    'zh-CN': '按空格键切换所选行',
    'zh-TW': '按下空白鍵以切換列選取',
  },
  'ag-ariaRowSelect': {
    'en-US': 'Press SPACE to select this row',
    'ar-AE': 'اضغط على SPACE لتحديد هذا الصف',
    'bn-IN': 'এই সারিটি নির্বাচন করতে SPACE টিপুন',
    'de-DE': 'Wählen Sie mit LEERZEICHEN diese Zeile aus',
    'es-ES': 'Pulsa ESPACIO para seleccionar esta fila',
    'es-MX': 'Pulsa ESPACIO para seleccionar esta fila',
    'fr-BE': 'Appuyez sur ESPACE pour sélectionner cette ligne',
    'fr-CA': 'Appuyez sur ESPACE pour sélectionner cette ligne',
    'fr-FR': 'Appuyez sur ESPACE pour sélectionner cette ligne',
    'gu-IN': 'આ પંક્તિ પસંદ કરવા માટે સ્પેસ દબાવો',
    'hi-IN': 'इस पंक्ति को चुनने के लिए स्पेस दबाएं',
    'it-IT': 'Premi SPAZIO per selezionare questa riga',
    'ja-JP': 'SPACEキーを押してこの行を選択する',
    'kn-IN': 'ಈ ಸಾಲನ್ನು ಆಯ್ಕೆ ಮಾಡಲು SPACE ಒತ್ತಿರಿ',
    'ko-KR': '이 행을 선택하려면 SPACE를 누르십시오.',
    'ml-IN': 'ഈ റോ തിരഞ്ഞെടുക്കാൻ SPACE അമർത്തുക',
    'mr-IN': 'ही ओळ निवडण्यासाठी स्पेस प्रेस करा',
    'nl-BE': 'Druk op SPATIE om deze rij te selecteren',
    'nl-NL': 'Druk op SPATIE om deze rij te selecteren',
    'pl-PL': 'Naciśnij SPACJĘ, aby wybrać ten wiersz',
    'pt-BR': 'Pressione ESPAÇO para selecionar esta linha',
    'pt-PT': 'Prima ESPAÇO para selecionar esta linha',
    'sv-SE': 'Tryck på SPACE för att välja den här raden',
    'ta-IN': 'இந்த வரிசையைத் தேர்ந்தெடுக்க SPACE ஐ அழுத்தவும்',
    'te-IN': 'ఈ అడ్డు వరుసను ఎంచుకోవడానికి SPACE కీ నొక్కండి',
    'th-TH': 'กด SPACE เพื่อเลือกแถวนี้',
    'tr-TR': 'Bu satırı seçmek için boşluk tuşuna basın.',
    'vi-VN': 'Nhấn DẤU CÁCH để chọn hàng này',
    'zh-CN': '按空格键选择此行',
    'zh-TW': '按下空白鍵以選取此列',
  },
  'ag-ariaSearch': {
    'en-US': 'Search',
    'ar-AE': 'بحث',
    'bn-IN': 'অনুসন্ধান করুন',
    'de-DE': 'Suchen',
    'es-ES': 'Buscar',
    'es-MX': 'Buscar',
    'fr-BE': 'Rechercher',
    'fr-CA': 'Rechercher',
    'fr-FR': 'Rechercher',
    'gu-IN': 'શોધો',
    'hi-IN': 'सर्च करें',
    'it-IT': 'Cerca',
    'ja-JP': '検索',
    'kn-IN': 'ಸರ್ಚ್ ಮಾಡಿ',
    'ko-KR': '검색',
    'ml-IN': 'തിരയുക',
    'mr-IN': 'शोधा',
    'nl-BE': 'Zoeken',
    'nl-NL': 'Zoeken',
    'pl-PL': 'Szukaj',
    'pt-BR': 'Pesquisar',
    'pt-PT': 'Pesquisar',
    'sv-SE': 'Sök',
    'ta-IN': 'சர்ச்',
    'te-IN': 'వెతకండి',
    'th-TH': 'ค้นหา',
    'tr-TR': 'Ara',
    'vi-VN': 'Tìm kiếm',
    'zh-CN': '搜索',
    'zh-TW': '搜尋',
  },
  'ag-ariaSortableColumn': {
    'en-US': 'Press ENTER to sort',
    'ar-AE': 'اضغط على ENTER للفرز',
    'bn-IN': 'সাজানোর জন্য ENTER টিপুন',
    'de-DE': 'Zum Sortieren ENTER drücken',
    'es-ES': 'Pulsa INTRO para ordenar',
    'es-MX': 'Pulsa INTRO para ordenar',
    'fr-BE': 'Appuyez sur ENTRÉE pour trier',
    'fr-CA': 'Appuyez sur ENTRÉE pour trier',
    'fr-FR': 'Appuyez sur ENTRÉE pour trier',
    'gu-IN': 'સૉર્ટ કરવા માટે એન્ટર દબાવો',
    'hi-IN': 'सॉर्ट करने के लिए ENTER दबाएं',
    'it-IT': 'Premi INVIO per ordinare',
    'ja-JP': 'ENTERキーを押して並べ替える',
    'kn-IN': 'ವಿಂಗಡಿಸಲು ENTER ಒತ್ತಿರಿ',
    'ko-KR': '정렬하려면 ENTER를 누르십시오.',
    'ml-IN': 'അടുക്കാൻ ENTER അമർത്തുക',
    'mr-IN': 'सॉर्ट करण्यासाठी एंटर प्रेस करा',
    'nl-BE': 'Druk op ENTER om te sorteren',
    'nl-NL': 'Druk op ENTER om te sorteren',
    'pl-PL': 'Naciśnij ENTER, aby posortować',
    'pt-BR': 'Pressione ENTER para classificar',
    'pt-PT': 'Prima ENTER para ordenar',
    'sv-SE': 'Tryck på ENTER för att sortera',
    'ta-IN': 'வரிசைப்படுத்த ENTER ஐ அழுத்தவும்',
    'te-IN': 'సార్ట్ చేయడానికి ఎంటర్ నొక్కండి',
    'th-TH': 'กด ENTER เพื่อจัดเรียง',
    'tr-TR': 'Sıralamak için Enter tuşuna basın.',
    'vi-VN': 'Nhấn ENTER để sắp xếp',
    'zh-CN': '按 ENTER 排序',
    'zh-TW': '按下 Enter 鍵進行排序',
  },
  'ag-ariaToggleVisibility': {
    'en-US': 'Press SPACE to toggle visibility',
    'ar-AE': 'اضغط على SPACE لتبديل الرؤية',
    'bn-IN': 'দৃশ্যমানতা টগল করতে SPACE চাপুন',
    'de-DE': 'Sichtbarkeit mit LEERZEICHEN umschalten',
    'es-ES': 'Pulsa ESPACIO para cambiar la visibilidad',
    'es-MX': 'Pulsa ESPACIO para cambiar la visibilidad',
    'fr-BE': 'Appuyez sur ESPACE pour activer la visibilité',
    'fr-CA': 'Appuyez sur ESPACE pour alterner la visibilité',
    'fr-FR': 'Appuyez sur ESPACE pour basculer sur la visibilité',
    'gu-IN': 'દૃશ્યતાને ટોગલ કરવા માટે સ્પેસ દબાવો',
    'hi-IN': 'विज़िबिलिटी टॉगल करने के लिए SPACE दबाएं',
    'it-IT':
      'Premi la barra spaziatrice per attivare/disattivare la visibilità',
    'ja-JP': 'SPACEキーを押して表示を切り替える',
    'kn-IN': 'ಗೋಚರತೆಯನ್ನು ಟಾಗಲ್ ಮಾಡಲು SPACE ಒತ್ತಿ',
    'ko-KR': '표시를 전환하려면 SPACE를 누르십시오.',
    'ml-IN': 'ദൃശ്യപരത ടോഗിൾ ചെയ്യാൻ SPACE അമർത്തുക',
    'mr-IN': 'दृश्यात्मकता टॉगल करण्यासाठी स्पेस प्रेस करा',
    'nl-BE': 'Druk op SPATIE om de zichtbaarheid aan te passen',
    'nl-NL': 'Druk op SPATIE om zichtbaarheid in of uit te schakelen',
    'pl-PL': 'Naciśnij SPACJĘ, aby przełączyć widoczność',
    'pt-BR': 'Pressione ESPAÇO para alternar a visibilidade',
    'pt-PT': 'Prima ESPAÇO para alternar a visibilidade',
    'sv-SE': 'Tryck på SPACE för att växla synlighet',
    'ta-IN': 'தெரிவுநிலையை மாற்ற SPACE ஐ அழுத்தவும்',
    'te-IN': 'దృశ్యతను టోగుల్ చేయడానికి స్పేస్ నొక్కండి',
    'th-TH': 'กด SPACE เพื่อสลับการมองเห็น',
    'tr-TR': 'Görünürlüğü değiştirmek için boşluk tuşuna basın.',
    'vi-VN': 'Nhấn DẤU CÁCH để chuyển chế độ hiển thị',
    'zh-CN': '按空格键切换可见性',
    'zh-TW': '按下空白鍵以切換可見性',
  },
  'ag-ariaUnchecked': {
    'en-US': 'unchecked',
    'ar-AE': 'غير محدد',
    'bn-IN': 'চেক করা হয়নি',
    'de-DE': 'Nicht aktiviert',
    'en-AU': 'unticked',
    'en-GB': 'unticked',
    'es-ES': 'desmarcado',
    'es-MX': 'no comprobado',
    'fr-BE': 'décochées',
    'fr-CA': 'non coché',
    'fr-FR': 'décoché',
    'gu-IN': 'ચેક કર્યા વગરનું',
    'hi-IN': 'अनचेक किया गया',
    'it-IT': 'non selezionato',
    'ja-JP': 'チェックなし',
    'kn-IN': 'ಅನ್‌ಚೆಕ್ ಮಾಡಿರುವುದು',
    'ko-KR': '선택되지 않음',
    'ml-IN': 'അൺചെക്ക് ചെയ്തു',
    'mr-IN': 'अनचेक्ड',
    'nl-BE': 'niet aangevinkt',
    'nl-NL': 'niet aangevinkt',
    'pl-PL': 'niezaznaczone',
    'pt-BR': 'desmarcada',
    'pt-PT': 'não selecionado',
    'sv-SE': 'omarkerad',
    'ta-IN': 'தேர்வு செய்யாதது',
    'te-IN': 'ఎంపిక చేయనివి',
    'th-TH': 'ยกเลิกการเลือกแล้ว',
    'tr-TR': 'kontrol edilmemiş',
    'vi-VN': 'không chọn',
    'zh-CN': '未选中',
    'zh-TW': '取消勾選',
  },
  'ag-ariaVisible': {
    'en-US': 'visible',
    'ar-AE': 'مرئي',
    'bn-IN': 'দৃশ্যমান',
    'de-DE': 'sichtbar',
    'gu-IN': 'દૃશ્યમાન',
    'hi-IN': 'विज़िबल',
    'it-IT': 'visibile',
    'ja-JP': '表示',
    'kn-IN': 'ಗೋಚರ',
    'ko-KR': '표시됨',
    'ml-IN': 'ദൃശ്യം',
    'mr-IN': 'दृश्यमान',
    'nl-BE': 'zichtbaar',
    'nl-NL': 'zichtbaar',
    'pl-PL': 'widoczne',
    'pt-BR': 'visível',
    'pt-PT': 'visível',
    'sv-SE': 'synlig',
    'ta-IN': 'புலப்படும்',
    'te-IN': 'కనిపిస్తుంది',
    'th-TH': 'มองเห็นได้',
    'tr-TR': 'görünür',
    'vi-VN': 'hiển thị',
    'zh-CN': '可见',
    'zh-TW': '可見',
  },
  'ag-ariaSearchFilterValues': {
    'en-US': 'Search filter values',
    'ar-AE': 'البحث عن قيم التصفية',
    'bn-IN': 'ফিল্টারের মান অনুসন্ধান করুন',
    'de-DE': 'Filterwerte suchen',
    'es-ES': 'Valores de filtro de búsqueda',
    'es-MX': 'Buscar valores de filtrado',
    'fr-BE': 'Rechercher les valeurs de filtre',
    'fr-CA': 'Rechercher les valeurs des filtres',
    'fr-FR': 'Valeurs du filtre de recherche',
    'gu-IN': 'ફિલ્ટર મૂલ્યો શોધો',
    'hi-IN': 'सर्च फ़िल्टर वैल्यू',
    'it-IT': 'Cerca valori filtro',
    'ja-JP': '検索フィルターの値',
    'kn-IN': 'ಫಿಲ್ಟರ್ ಮೌಲ್ಯಗಳನ್ನು ಹುಡುಕಿ',
    'ko-KR': '검색 필터 값',
    'ml-IN': 'ഫിൽട്ടർ മൂല്യങ്ങൾ തിരയുക',
    'mr-IN': 'फिल्टर व्हॅल्यू शोधा',
    'nl-BE': 'Filterwaarden zoeken',
    'nl-NL': 'Filterwaarden zoeken',
    'pl-PL': 'Wartości filtra wyszukiwania',
    'pt-BR': 'Pesquisar valores do filtro',
    'pt-PT': 'Valores do filtro de pesquisa',
    'sv-SE': 'Sök filtervärden',
    'ta-IN': 'ஃபில்ட்டர் வேல்யூக்களை சர்ச் செய்யவும்',
    'te-IN': 'ఫిల్టర్ విలువలను సెర్చ్ చేయండి',
    'th-TH': 'ค่าของตัวกรองการค้นหา',
    'tr-TR': 'Filtre değerleri ara',
    'vi-VN': 'Tìm kiếm giá trị bộ lọc',
    'zh-CN': '搜索筛选条件值',
    'zh-TW': '搜尋篩選條件值',
  },
  'ag-ariaRowGroupDropZonePanelLabel': {
    'en-US': 'Row Groups',
    'ar-AE': 'مجموعات الصف',
    'bn-IN': 'সারির গ্রুপ',
    'de-DE': 'Zeilengruppen',
    'en-AU': 'Row groups',
    'en-GB': 'Row groups',
    'en-ZA': 'Row groups',
    'es-ES': 'Grupos de fila',
    'es-MX': 'Grupos de filas',
    'fr-BE': 'Groupes de lignes',
    'fr-CA': 'Groupes de rangées',
    'fr-FR': 'Groupes de lignes',
    'gu-IN': 'પંક્તિ ગ્રૂપ',
    'hi-IN': 'पंक्ति के ग्रुप',
    'it-IT': 'Gruppi di riga',
    'ja-JP': '行グループ',
    'kn-IN': 'ಸಾಲು ಗುಂಪುಗಳು',
    'ko-KR': '행 그룹',
    'ml-IN': 'റോ ഗ്രൂപ്പുകൾ',
    'mr-IN': 'ओळींचे ग्रुप',
    'nl-BE': 'Rijgroepen',
    'nl-NL': 'Rijgroepen',
    'pl-PL': 'Grupy wierszy',
    'pt-BR': 'Grupos de linhas',
    'pt-PT': 'Grupos de linhas',
    'sv-SE': 'Radgrupper',
    'ta-IN': 'வரிசை குரூப்கள்',
    'te-IN': 'అడ్డు వరుస గ్రూప్‌లు',
    'th-TH': 'กลุ่มแถว',
    'tr-TR': 'Satır grupları',
    'vi-VN': 'Nhóm hàng',
    'zh-CN': '行组',
    'zh-TW': '列群組',
  },
  'ag-ariaValuesDropZonePanelLabel': {
    'en-US': 'Values',
    'ar-AE': 'القيم',
    'bn-IN': 'মান',
    'de-DE': 'Werte',
    'es-ES': 'Valores',
    'es-MX': 'Valores',
    'fr-BE': 'Valeurs',
    'fr-CA': 'Valeurs',
    'fr-FR': 'Valeurs',
    'gu-IN': 'મૂલ્યો',
    'hi-IN': 'वैल्यू',
    'it-IT': 'Valori',
    'ja-JP': '値',
    'kn-IN': 'ಮೌಲ್ಯಗಳು',
    'ko-KR': '값',
    'ml-IN': 'മൂല്യങ്ങൾ',
    'mr-IN': 'व्हॅल्यू',
    'nl-BE': 'Waarden',
    'nl-NL': 'Waarden',
    'pl-PL': 'Wartości',
    'pt-BR': 'Valores',
    'pt-PT': 'Valores',
    'sv-SE': 'Värden',
    'ta-IN': 'வேல்யூக்கள்',
    'te-IN': 'విలువలు',
    'th-TH': 'ค่า',
    'tr-TR': 'Değerler',
    'vi-VN': 'Giá trị',
    'zh-CN': '值',
    'zh-TW': '值',
  },
  'ag-ariaPivotDropZonePanelLabel': {
    'en-US': 'Column Labels',
    'ar-AE': 'ملصقات الأعمدة',
    'bn-IN': 'কলামের লেবেল',
    'de-DE': 'Spaltenbezeichnungen',
    'en-AU': 'Column labels',
    'en-GB': 'Column labels',
    'en-ZA': 'Column labels',
    'es-ES': 'Etiquetas de columna',
    'es-MX': 'Etiquetas de columnas',
    'fr-BE': 'Étiquettes de colonne',
    'fr-CA': 'Étiquettes de colonne',
    'fr-FR': 'Étiquettes de colonne',
    'gu-IN': 'કોલમ લેબલ્સ',
    'hi-IN': 'कॉलम लेबल',
    'it-IT': 'Etichette colonne',
    'ja-JP': '列ラベル',
    'kn-IN': 'ಕಾಲಂ ಲೇಬಲ್‌ಗಳು',
    'ko-KR': '열 라벨',
    'ml-IN': 'കോളം ലേബലുകൾ',
    'mr-IN': 'स्तंभ लेबल',
    'nl-BE': 'Kolometiketten',
    'nl-NL': 'Kolomlabels',
    'pl-PL': 'Etykiety kolumn',
    'pt-BR': 'Etiquetas de coluna',
    'pt-PT': 'Etiquetas de coluna',
    'sv-SE': 'Kolumnetiketter',
    'ta-IN': 'நெடுவரிசை லேபிள்கள்',
    'te-IN': 'కాలమ్ లేబుల్‌లు',
    'th-TH': 'ฉลากคอลัมน์',
    'tr-TR': 'Sütun etiketleri',
    'vi-VN': 'Nhãn cột',
    'zh-CN': '列标签',
    'zh-TW': '資料欄標籤',
  },
  'ag-ariaDropZoneColumnComponentDescription': {
    'en-US': 'Press DELETE to remove',
    'ar-AE': 'اضغط على DELETE للإزالة',
    'bn-IN': 'মুছে ফেলার জন্য DELETE চাপুন',
    'de-DE': 'Entfernen Sie das Angebot mit ENTF',
    'es-ES': 'Pulsa SUPRIMIR para eliminar',
    'es-MX': 'Pulsa SUPRIMIR para eliminar',
    'fr-BE': 'Appuyez sur SUPPRIMER pour retirer',
    'fr-CA': 'Appuyez sur SUPPRIMER pour supprimer',
    'fr-FR': 'Appuyez sur SUPPRIMER pour supprimer',
    'gu-IN': 'દૂર કરવા માટે ડિલીટ કરો પર દબાવો',
    'hi-IN': 'रिमूव करने के लिए DELETE दबाएं',
    'it-IT': 'Premi ELIMINA per rimuovere',
    'ja-JP': 'DELETEキーを押して削除する',
    'kn-IN': 'ತೆಗೆದುಹಾಕಲು DELETE ಒತ್ತಿರಿ',
    'ko-KR': '삭제하려면 DELETE를 누르십시오.',
    'ml-IN': 'നീക്കം ചെയ്യാൻ DELETE അമർത്തുക',
    'mr-IN': 'काढून टाकण्यासाठी डिलीट प्रेस करा',
    'nl-BE': 'Druk op VERWIJDEREN om te verwijderen',
    'nl-NL': 'Druk op VERWIJDEREN om te verwijderen',
    'pl-PL': 'Naciśnij DELETE, aby usunąć',
    'pt-BR': 'Pressione DELETE para excluir',
    'pt-PT': 'Prima APAGAR para remover',
    'sv-SE': 'Tryck på DELETE för att ta bort',
    'ta-IN': 'நீக்க DELETE ஐ அழுத்தவும்',
    'te-IN': 'తీసివేయడానికి తొలగించు నొక్కండి',
    'th-TH': 'กด DELETE เพื่อนำออก',
    'tr-TR': 'Kaldırmak için Delete tuşuna basın.',
    'vi-VN': 'Nhấn XÓA để loại bỏ',
    'zh-CN': '按 DELETE 删除',
    'zh-TW': '按下「刪除」以移除',
  },
  'ag-ariaDropZoneColumnValueItemDescription': {
    'en-US': 'Press ENTER to change the aggregation type',
    'ar-AE': 'اضغط على ENTER لتغيير نوع التجميع',
    'bn-IN': 'একত্রীকরণের ধরন পরিবর্তন করতে ENTER টিপুন',
    'de-DE': 'Den Aggregationstyp mit ENTER ändern',
    'es-ES': 'Pulsa INTRO para cambiar el tipo de agregación',
    'es-MX': 'Pulsa INTRO para cambiar el tipo de agregación',
    'fr-BE': 'Appuyez sur ENTRÉE pour modifier le type de groupement',
    'fr-CA': 'Appuyez sur ENTRÉE pour changer le type d’agrégation',
    'fr-FR': 'Appuyez sur ENTRÉE pour modifier le type d’agrégation',
    'gu-IN': 'એકંદરનો પ્રકાર બદલવા માટે એન્ટર દબાવો',
    'hi-IN': 'एग्रीगेशन टाइप बदलने के लिए ENTER दबाएं',
    'it-IT': 'Premi INVIO per modificare il tipo di aggregazione',
    'ja-JP': 'ENTERキーを押して集計タイプを変更する',
    'kn-IN': 'ಒಟ್ಟುಗೂಡಿಸುವಿಕೆಯ ಪ್ರಕಾರವನ್ನು ಬದಲಾಯಿಸಲು ENTER ಒತ್ತಿರಿ',
    'ko-KR': '집계 유형을 변경하려면 ENTER를 누르십시오.',
    'ml-IN': 'സമാഹരണ തരം മാറ്റാൻ ENTER അമർത്തുക',
    'mr-IN': 'बेरजेचा प्रकार बदलण्यासाठी एंटर प्रेस करा',
    'nl-BE': 'Druk op ENTER om het samenvoegingstype te wijzigen',
    'nl-NL': 'Druk op ENTER om het samenvoegingstype te wijzigen',
    'pl-PL': 'Naciśnij ENTER, aby zmienić typ agregacji',
    'pt-BR': 'Pressione ENTER para alterar o tipo de agregação',
    'pt-PT': 'Prima ENTER para alterar o tipo de agregação',
    'sv-SE': 'Tryck på ENTER för att ändra aggregeringstypen',
    'ta-IN': 'திரட்டல் வகையை மாற்ற, ENTER ஐ அழுத்தவும்',
    'te-IN': 'సమగ్రత రకాన్ని మార్చడానికి ఎంటర్ నొక్కండి',
    'th-TH': 'กด ENTER เพื่อเปลี่ยนประเภทการรวมกลุ่ม',
    'tr-TR': 'Toplama türünü değiştirmek için Enter tuşuna basın.',
    'vi-VN': 'Nhấn ENTER để thay đổi loại tổng hợp',
    'zh-CN': '按 ENTER 更改汇总类型',
    'zh-TW': '按下 ENTER 鍵以變更彙總類型',
  },
  'ag-ariaLabelColumnMenu': {
    'en-US': 'Column Menu',
    'ar-AE': 'قائمة العمود',
    'bn-IN': 'কলাম মেনু',
    'de-DE': 'Spaltenmenü',
    'en-AU': 'Column menu',
    'en-GB': 'Column menu',
    'en-ZA': 'Column menu',
    'es-ES': 'Menú de columnas',
    'es-MX': 'Menú de columna',
    'fr-BE': 'Menu Colonne',
    'fr-CA': 'Menu de la colonne',
    'fr-FR': 'Menu Colonne',
    'gu-IN': 'કોલમ મેનૂ',
    'hi-IN': 'कॉलम मेन्यू',
    'it-IT': 'Menu Colonna',
    'ja-JP': '列メニュー',
    'kn-IN': 'ಕಾಲಮ್ ಮೆನು',
    'ko-KR': '열 메뉴',
    'ml-IN': 'കോളം മെനു',
    'mr-IN': 'स्तंभ मेनू',
    'nl-BE': 'Kolommenu',
    'nl-NL': 'Kolommenu',
    'pl-PL': 'Menu kolumny',
    'pt-BR': 'Menu Coluna',
    'pt-PT': 'Menu de coluna',
    'sv-SE': 'Kolumnmeny',
    'ta-IN': 'நெடுவரிசை மெனு',
    'te-IN': 'కాలమ్ మెను',
    'th-TH': 'เมนูคอลัมน์',
    'tr-TR': 'Sütun menüsü',
    'vi-VN': 'Trình đơn cột',
    'zh-CN': '列菜单',
    'zh-TW': '資料欄選單',
  },
  'ag-ariaLabelCellEditor': {
    'en-US': 'Cell Editor',
    'ar-AE': 'محرر الخلايا',
    'bn-IN': 'সেল এডিটর',
    'de-DE': 'Zellen-Editor',
    'en-AU': 'Cell editor',
    'en-GB': 'Cell editor',
    'en-ZA': 'Cell editor',
    'es-ES': 'Editor de celdas',
    'es-MX': 'Editor de celdas',
    'fr-BE': 'Éditeur de cellule',
    'fr-CA': 'Éditeur de cellules',
    'fr-FR': 'Éditeur de cellule',
    'gu-IN': 'સેલ એડિટર',
    'hi-IN': 'सेल एडिटर',
    'it-IT': 'Editor celle',
    'ja-JP': 'セルエディター',
    'kn-IN': 'ಸೆಲ್ ಎಡಿಟರ್',
    'ko-KR': '셀 편집기',
    'ml-IN': 'സെൽ എഡിറ്റർ',
    'mr-IN': 'सेल एडिटर',
    'nl-BE': 'Cel-editor',
    'nl-NL': 'Celeditor',
    'pl-PL': 'Edytor komórek',
    'pt-BR': 'Editor de células',
    'pt-PT': 'Editor de células',
    'sv-SE': 'Cellredigerare',
    'ta-IN': 'செல் எடிட்டர்',
    'te-IN': 'సెల్ ఎడిటర్',
    'th-TH': 'ตัวแก้ไขเซลล์',
    'tr-TR': 'Hücre düzenleyici',
    'vi-VN': 'Trình chỉnh sửa ô',
    'zh-CN': '单元格编辑器',
    'zh-TW': '儲存格編輯器',
  },
  'ag-ariaLabelDialog': {
    'en-US': 'Dialog',
    'ar-AE': 'الحوار',
    'bn-IN': 'ডায়ালগ',
    'de-DE': 'Dialogfeld',
    'en-AU': 'Dialogue',
    'en-GB': 'Dialogue',
    'en-IN': 'Dialogue',
    'en-ZA': 'Dialogue',
    'es-ES': 'Diálogo',
    'es-MX': 'Cuadro de texto',
    'fr-BE': 'Boîte de dialogue',
    'fr-CA': 'Dialogue',
    'fr-FR': 'Boîte de dialogue',
    'gu-IN': 'સંવાદ',
    'hi-IN': 'डायलॉग',
    'it-IT': 'Finestra di dialogo',
    'ja-JP': 'ダイアログ',
    'kn-IN': 'ಡೈಲಾಗ್',
    'ko-KR': '대화',
    'ml-IN': 'ഡയലോഗ്',
    'mr-IN': 'डायलॉग',
    'nl-BE': 'Dialoog',
    'nl-NL': 'Dialoog',
    'pl-PL': 'Okno dialogowe',
    'pt-BR': 'Caixa de diálogo',
    'pt-PT': 'Diálogo',
    'ta-IN': 'டயலாக்',
    'te-IN': 'డైలాగ్',
    'th-TH': 'กล่องโต้ตอบ',
    'tr-TR': 'İletişim kutusu',
    'vi-VN': 'Hộp thoại',
    'zh-CN': '对话框',
    'zh-TW': '對話框',
  },
  'ag-ariaLabelSelectField': {
    'en-US': 'Select Field',
    'ar-AE': 'تحديد حقل',
    'bn-IN': 'ফিল্ড নির্বাচন করুন',
    'de-DE': 'Feld auswählen',
    'en-GB': 'Select field',
    'en-ZA': 'Select field',
    'es-ES': 'Seleccionar campo',
    'es-MX': 'Seleccionar campo',
    'fr-BE': 'Sélectionner un champ',
    'fr-CA': 'Sélectionner un champ',
    'fr-FR': 'Sélectionner un champ',
    'gu-IN': 'ફિલ્ડ પસંદ કરો',
    'hi-IN': 'फ़ील्ड चुनें',
    'it-IT': 'Seleziona campo',
    'ja-JP': '項目を選択',
    'kn-IN': 'ಕ್ಷೇತ್ರವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ',
    'ko-KR': '필드 선택',
    'ml-IN': 'ഫീൽഡ് തിരഞ്ഞെടുക്കുക',
    'mr-IN': 'फील्ड निवडा',
    'nl-BE': 'Veld selecteren',
    'nl-NL': 'Veld selecteren',
    'pl-PL': 'Wybierz pole',
    'pt-BR': 'Selecionar campo',
    'pt-PT': 'Selecionar campo',
    'sv-SE': 'Välj fält',
    'ta-IN': 'புலத்தைத் தேர்ந்தெடுக்கவும்',
    'te-IN': 'ఫీల్డ్‌ను ఎంచుకోండి',
    'th-TH': 'เลือกเขตข้อมูล',
    'tr-TR': 'Alan seçin',
    'vi-VN': 'Chọn trường',
    'zh-CN': '选择字段',
    'zh-TW': '選取欄位',
  },
  'ag-ariaLabelTooltip': {
    'en-US': 'Tooltip',
    'ar-AE': 'تلميح الأداة',
    'bn-IN': 'টুলটিপ',
    'en-AU': 'Tool tip',
    'es-ES': 'Ayuda contextual',
    'es-MX': 'Descripción emergente',
    'fr-BE': 'Infobulle',
    'fr-CA': 'Infobulle',
    'fr-FR': 'Infobulle',
    'gu-IN': 'ટૂલટીપ',
    'hi-IN': 'टूलटिप',
    'it-IT': 'Suggerimento',
    'ja-JP': 'ツールチップ',
    'kn-IN': 'ಟೂಲ್‌ಟಿಪ್',
    'ko-KR': '도구 설명',
    'ml-IN': 'ടൂൾടിപ്പ്',
    'mr-IN': 'टूलटीप',
    'nl-NL': 'Knopinfo',
    'pl-PL': 'Etykieta narzędzia',
    'pt-BR': 'Dica de ferramentas',
    'pt-PT': 'Sugestão',
    'sv-SE': 'Verktygstips',
    'ta-IN': 'டூல்டிப்',
    'te-IN': 'టూల్‌టిప్',
    'th-TH': 'คำแนะนำเครื่องมือ',
    'tr-TR': 'Araç ipucu',
    'vi-VN': 'Chú thích hàm',
    'zh-CN': '工具提示',
    'zh-TW': '提示',
  },
  'ag-ariaLabelContextMenu': {
    'en-US': 'Context Menu',
    'ar-AE': 'قائمة السياق',
    'bn-IN': 'কনটেক্সট মেনু',
    'de-DE': 'Kontextmenü',
    'en-AU': 'Context menu',
    'en-GB': 'Context menu',
    'en-ZA': 'Context menu',
    'es-ES': 'Menú contextual',
    'es-MX': 'Menú contextual',
    'fr-BE': 'Menu contextuel',
    'fr-CA': 'Menu contextuel',
    'fr-FR': 'Menu contextuel',
    'gu-IN': 'સંદર્ભ મેનૂ',
    'hi-IN': 'कॉन्टेक्स्ट मेन्यू',
    'it-IT': 'Menu contestuale',
    'ja-JP': 'コンテキストメニュー',
    'kn-IN': 'ಸಂದರ್ಭ ಮೆನು',
    'ko-KR': '컨텍스트 메뉴',
    'ml-IN': 'സന്ദർഭ മെനു',
    'mr-IN': 'कॉन्टेक्स्ट मेनू',
    'nl-BE': 'Contextmenu',
    'nl-NL': 'Contextmenu',
    'pl-PL': 'Menu kontekstowe',
    'pt-BR': 'Menu de contexto',
    'pt-PT': 'Menu de contexto',
    'sv-SE': 'Kontextmeny',
    'ta-IN': 'சூழல் மெனு',
    'te-IN': 'సందర్భ మెను',
    'th-TH': 'เมนูบริบท',
    'tr-TR': 'Bağlam menüsü',
    'vi-VN': 'Trình đơn ngữ cảnh',
    'zh-CN': '上下文菜单',
    'zh-TW': '操作功能表',
  },
  'ag-ariaLabelSubMenu': {
    'en-US': 'SubMenu',
    'ar-AE': 'القائمة الفرعية',
    'bn-IN': 'সাবমেনু',
    'de-DE': 'Untermenü',
    'en-AU': 'Sub-menu',
    'en-ZA': 'Sub-menu',
    'es-ES': 'Submenú',
    'es-MX': 'Submenú',
    'fr-BE': 'Sous-menu',
    'fr-CA': 'Sous-menu',
    'fr-FR': 'Sous-menu',
    'gu-IN': 'સબમેનૂ',
    'hi-IN': 'सब-मेन्यू',
    'it-IT': 'Sottomenu',
    'ja-JP': 'サブメニュー',
    'kn-IN': 'ಉಪಮೆನು',
    'ko-KR': '하위 메뉴',
    'ml-IN': 'ഉപമെനു',
    'mr-IN': 'सबमेनू',
    'nl-NL': 'Submenu',
    'pl-PL': 'Podmenu',
    'pt-BR': 'Submenu',
    'pt-PT': 'Submenu',
    'sv-SE': 'Undermeny',
    'ta-IN': 'துணைமெனு',
    'te-IN': 'ఉప మెను',
    'th-TH': 'เมนูย่อย',
    'tr-TR': 'Alt menü',
    'vi-VN': 'Trình đơn phụ',
    'zh-CN': '子菜单',
    'zh-TW': '子選單',
  },
  'ag-ariaLabelAggregationFunction': {
    'en-US': 'Aggregation Function',
    'ar-AE': 'وظيفة التجميع',
    'bn-IN': 'একত্রীকরণ ফাংশন',
    'de-DE': 'Aggregierungsfunktion',
    'en-AU': 'Aggregation function',
    'en-GB': 'Aggregation function',
    'en-ZA': 'Aggregation function',
    'es-ES': 'Función de agregación',
    'es-MX': 'Función de agregación',
    'fr-BE': 'Fonction de groupement',
    'fr-CA': 'Fonction d’agrégation',
    'fr-FR': 'Fonction de l’agrégation',
    'gu-IN': 'એકંદર સુવિધા',
    'hi-IN': 'एग्रीगेशन फ़ंक्शन',
    'it-IT': 'Funzione aggregazione',
    'ja-JP': 'アグリゲーション機能',
    'kn-IN': 'ಒಟ್ಟುಗೂಡಿಸುವಿಕೆ ಕಾರ್ಯ',
    'ko-KR': '집계 기능',
    'ml-IN': 'സമാഹരണ പ്രവർത്തനം',
    'mr-IN': 'बेरीज फंक्शन',
    'nl-BE': 'Samenvoegingsfunctie',
    'nl-NL': 'Samenvoegingsfunctie',
    'pl-PL': 'Funkcja agregacji',
    'pt-BR': 'Função de agregação',
    'pt-PT': 'Função de agregação',
    'sv-SE': 'Aggregeringsfunktion',
    'ta-IN': 'திரட்டல் செயல்பாடு',
    'te-IN': 'అగ్రిగేషన్ ఫంక్షన్',
    'th-TH': 'ฟังก์ชันการรวมกลุ่ม',
    'tr-TR': 'Toplama işlevi',
    'vi-VN': 'Chức năng tổng hợp',
    'zh-CN': '汇总函数',
    'zh-TW': '彙總函數',
  },
  'ag-thousandSeparator': {
    'en-US': ',',
    'ar-AE': '،',
    'ja-JP': '、',
    'zh-CN': '，',
    'zh-TW': '，',
  },
  'ag-decimalSeparator': {
    'en-US': '.',
    'bn-IN': '।',
    'zh-CN': '。',
    'zh-TW': '。',
  },
};

export default katTranslator(strings);
